

// ══ DATA ══
const GD={Kidswear:['Sleepers','Rompers','Bodysuits','Sleep Sacks','PJs','T-Shirts','Sweatshirts','Hoodies','Joggers','Beanies','Bibs','Blankets'],Fashion:['Dresses','Trousers','Blazers','Skirts','T-Shirts','Sweatshirts','Hoodies','Joggers','Beanies','Jumpsuits','Sweaters','Underwear','Jackets'],Fitness:['Leggings','Sports Bras','Shorts','Tank Tops','Joggers','Jumpsuits','Sweatshirts','T-Shirts','Hoodies','Swimwear'],Streetwear:['T-Shirts','Sweatshirts','Hoodies','Joggers','Sweat Shorts','Jackets','Sweaters','Denim Jeans','Leggings','Underwear','Caps','Beanies'],Lifestyle:['T-Shirts','Hoodies','Sweatshirts','Joggers','Shorts','Jackets','Sweaters','Underwear','Socks'],Specialty:['Uniforms','Polo Shirts','Work Pants','Hi-Vis Vests','Aprons','Lab Coats','Chef Jackets','Scrubs','Scrub Tops','Scrub Bottoms'],TshirtsHoodies:['T-Shirts','Hoodies','Sweatshirts','Long Sleeves','Tank Tops','Polo Shirts'],Merch:['T-Shirts','Hoodies','Sweatshirts','Joggers','Long Sleeves','Tank Tops','Polo Shirts','Hats','Tote Bags','Fleece Jackets']};
const SD={Kidswear:['Premie','Newborn (NB)','0-3M','3-6M','6-12M','12-18M','18-24M','2T','3T','4T','One Size'],def:['XXS','XS','S','M','L','XL','XXL','XXXL','One Size']}; // XXS and XS are separate; XL and XXL are separate
const FAB_GROUPS={
  'Natural Fibres':['Cotton','Organic Cotton','Linen','Hemp','Wool','Silk'],
  'Regenerated Fibres':['Modal','Bamboo Viscose','Rayon','Lyocell','Tencel'],
  'Synthetic Fibres':['Polyester','Recycled Polyester','Nylon','Acrylic','Spandex','Elastane']
};
// Knits/Wovens are construction types — shown in Step 7 per-fabric, NOT in Step 4
const FAB=Object.values(FAB_GROUPS).flat();
const WOVENS=['Denim','Twill','Poplin/Shirting','Canvas','Satin','Ripstop'];
const KNITS=['Jersey','Rib Knit','French Terry','Fleece','Interlock','Pique'];
const FAB_CONSTRUCTIONS=['Jersey','Rib Knit','French Terry','Fleece','Interlock','Pique','Denim','Twill','Poplin/Shirting','Canvas','Satin','Ripstop'];
const FAB_WEIGHTS=[{k:'light',l:'Light (120–150gsm)'},{k:'mid',l:'Mid (160–200gsm)'},{k:'common',l:'Common (220–280gsm)'},{k:'heavy',l:'Heavy (300–380gsm)'},{k:'lux',l:'Lux (400–500gsm)'}];
const FAB_USAGES=['Self / Body','Lining','Contrast','Rib','Trim'];
function fabKnitWoven(construction){if(!construction||construction==='Unknown')return '';return WOVENS.includes(construction)?'Woven':'Knit';}
function bAddFabric(id){
  const it=B.items.find(i=>i.id===id);if(!it)return;
  if(!it.fabrics)it.fabrics=[{name:it.fab||B.fabrics[0]||'Cotton',usage:'Self / Body',weight:'mid',construction:'Unknown'}];
  it.fabrics.push({name:B.fabrics[0]||'Cotton',usage:'Lining',weight:'light',construction:'Unknown'});
  bRI();
}
function bRemFabric(id,idx){
  const it=B.items.find(i=>i.id===id);if(!it||!it.fabrics)return;
  if(it.fabrics.length<=1){toast('At least one fabric required');return;}
  const usage=it.fabrics[idx].usage||'Self / Body';
  bTouchUsage(it,usage);
  it.fabrics.splice(idx,1);
  const remaining=it.fabrics.filter(f=>(f.usage||'Self / Body')===usage);
  if(!remaining.length&&it.dd){
    // Removing the whole Lining / Contrast / Rib fabric also clears that design detail so it isn't re-suggested.
    const kindOf={Lining:'lining',Contrast:'contrast',Rib:'rib'}[usage];
    if(usage==='Lining')it.dd.lining=[];
    if(usage==='Contrast')it.dd.contrast=[];
    if(usage==='Rib')it.dd.rib=[];
    if(kindOf)it.ddActive=(it.ddActive||[]).filter(k=>k!==kindOf);
  }
  if(remaining.length===1){
    // No longer a blend -- clear any stale blendPct so a future re-blend
    // starts clean instead of silently reusing an old percentage.
    remaining[0].blendPct=null;
  } else {
    bRebalanceGroup(it, usage);
  }
  bFabricSuggest(it);
  bRI();
}
// Redistributes a blend group's percentages proportionally so they sum back
// to exactly 100 -- used after removing a fabric, since the remaining ones
// otherwise keep their old values and leave a gap (e.g. 66/24 after removing
// a 10% fabric, instead of rescaling to 73/27).
function bRebalanceGroup(it, usage){
  const group=it.fabrics.map((of,ofi)=>({of,ofi})).filter(x=>(x.of.usage||'Self / Body')===usage);
  if(group.length<2)return;
  const n=group.length;
  const currents=group.map((x,gi)=>x.of.blendPct!=null?x.of.blendPct:bDefaultBlendPct(n,gi));
  const sum=currents.reduce((s,v)=>s+v,0);
  if(sum===0)return;
  let running=0;
  group.forEach((x,gi)=>{
    if(gi<n-1){
      const scaled=Math.round(currents[gi]/sum*100);
      x.of.blendPct=scaled;
      running+=scaled;
    } else {
      x.of.blendPct=100-running; // last member absorbs rounding remainder
    }
  });
}
// Adds a new fabric as a blend component of the given usage group,
// inheriting that group's shared weight/construction (since a blend is one
// physical fabric) rather than defaulting to generic placeholders, then
// rebalances the whole group to sum back to 100.
// The generic "+ Add Fabric" button must always create a genuinely new row
// (Self/Body, Lining, Contrast, or Rib) -- never silently join an existing
// blend group. Previously hardcoded to 'Lining' regardless of what usages
// were already in play, so if any existing group already used Lining, the
// new fabric joined it instead of starting its own row -- and with no cap
// check there either, could push a group past the 3-fabric limit.
function bAddNewUsageFabric(id, name){
  const it=B.items.find(i=>i.id===id);if(!it)return;
  bEnsureFabrics(it);
  const usedUsages = new Set(it.fabrics.map(f=>f.usage||'Self / Body'));
  const nextUsage = FAB_USAGES.find(u=>!usedUsages.has(u));
  if(!nextUsage){ toast('All fabric usage slots (Self/Body, Lining, Contrast, Rib) are already in use'); return; }
  it.fabrics.push({name, usage:nextUsage, weight:'mid', construction:'Construction'});
  bRI();
}
function bAddBlendFabric(id, usage, name){
  const it=B.items.find(i=>i.id===id);if(!it)return;
  bEnsureFabrics(it);
  if(it.fabrics.filter(f=>(f.usage||'Self / Body')===usage).length>=5){toast('Maximum 5 yarns per blend');return;}
  const existing=it.fabrics.find(f=>(f.usage||'Self / Body')===usage);
  const stretchFibres = ['Spandex','Elastane'];
  const isStretch = stretchFibres.includes(name);
  const newFabric = {
    name,
    usage,
    weight: existing ? (existing.weight||'mid') : 'mid',
    construction: existing ? (existing.construction||'Construction') : 'Construction',
  };
  if (isStretch) {
    // Stretch fibres default to a small 10% blend component, not an even
    // split with the main fabric -- set both explicitly before rebalance
    // so bRebalanceGroup (which respects existing blendPct values) keeps
    // this 90/10 split instead of recomputing an even one.
    newFabric.blendPct = 10;
    if (existing) existing.blendPct = 90;
  }
  // Adding a yarn that currently sits alone on an auto-assigned row elsewhere moves it here.
  const soloElsewhere=u=>it.fabrics.filter(f=>(f.usage||'Self / Body')===u).length===1;
  it.fabrics=it.fabrics.filter(f=>!(f.name===name&&(f.usage||'Self / Body')!==usage&&f.auto&&soloElsewhere(f.usage||'Self / Body')));
  bTouchUsage(it,usage);
  it.fabrics.push(newFabric);
  bRebalanceGroup(it, usage);
  bFabricSuggest(it);
  bRI();
}
function bSetFabric(id,idx,field,val){
  const it=B.items.find(i=>i.id===id);if(!it||!it.fabrics)return;
  const oldUsage=it.fabrics[idx].usage||'Self / Body';
  if(field==='usage'){
    // Cap blend groups at 3 fabrics per usage, to start -- block growing an
    // existing group of 3 any further rather than silently allowing it.
    const existingInGroup=it.fabrics.filter((f,i)=>i!==idx&&(f.usage||'Self / Body')===val).length;
    if(existingInGroup>=4){toast('Maximum 5 yarns per blend');return;}
  }
  it.fabrics[idx][field]=val;
  bTouchUsage(it,oldUsage);bTouchUsage(it,it.fabrics[idx].usage||'Self / Body'); // customer edited it -- no longer auto-managed
  // Keep legacy it.fab in sync with first fabric
  if(idx===0&&field==='name')it.fab=val;
  if(idx===0&&field==='weight')it.wt=val;
  // A blend is ONE physical fabric -- construction/weight are shared across
  // every component, not independently set per component. Propagate so the
  // underlying data stays consistent even though only the header edits it.
  if(field==='construction'||field==='weight'){
    const usage=it.fabrics[idx].usage||'Self / Body';
    it.fabrics.forEach((f,i)=>{if(i!==idx&&(f.usage||'Self / Body')===usage)f[field]=val;});
  }
  if(field==='usage'){
    // Rebalance both the group this fabric just left and the one it joined
    const oldGroup=it.fabrics.filter(f=>(f.usage||'Self / Body')===oldUsage);
    if(oldGroup.length===1) oldGroup[0].blendPct=null;
    else if(oldGroup.length>1) bRebalanceGroup(it, oldUsage);
    bRebalanceGroup(it, val);
  }
  bFabricSuggest(it);
  bRI();
}
// Even default split for a fresh/unedited blend group. Every member
// independently rounding 100/n (e.g. 33/33/33 for a 3-way split) sums to
// 99, not 100 -- the last position absorbs the rounding remainder instead,
// so a brand-new blend is exact from the start, before any manual stepping.
function bDefaultBlendPct(groupSize, position){
  const even = Math.round(100/groupSize);
  if (position === groupSize-1) return 100 - even*(groupSize-1);
  return even;
}
// Lets a percentage be typed directly rather than only stepped by ±1 --
// reuses bStepBlendPct's exact balancing math by computing the
// equivalent delta and calling it, so typing and clicking +/- always
// produce identical teeter-totter behavior between blend components.
function bSetBlendPct(id, idx, newValue){
  const it=B.items.find(i=>i.id===id);if(!it||!it.fabrics)return;
  const f=it.fabrics[idx];
  const usage=f.usage||'Self / Body';
  const group=it.fabrics.map((of,ofi)=>({of,ofi})).filter(x=>(x.of.usage||'Self / Body')===usage);
  const n=group.length;
  const posInGroup=group.findIndex(x=>x.ofi===idx);
  const selfCurrent = f.blendPct!=null ? f.blendPct : bDefaultBlendPct(n,posInGroup);
  newValue = Math.max(0, Math.min(100, isNaN(newValue) ? selfCurrent : newValue));
  const delta = newValue - selfCurrent;
  if (delta !== 0) bStepBlendPct(id, idx, delta);
}
function bStepBlendPct(id,idx,delta){
  const it=B.items.find(i=>i.id===id);if(!it||!it.fabrics)return;
  const f=it.fabrics[idx];
  const usage=f.usage||'Self / Body';
  bTouchUsage(it,usage);
  const group=it.fabrics.map((of,ofi)=>({of,ofi})).filter(x=>(x.of.usage||'Self / Body')===usage);
  const n=group.length;
  const posInGroup=group.findIndex(x=>x.ofi===idx);
  // Neighbor to take from: the next fabric in the group, or the previous
  // one if this is the last fabric (nothing below it to take from).
  const neighborPos = (posInGroup < n-1) ? posInGroup+1 : posInGroup-1;
  if (neighborPos < 0) { // only one fabric in the group -- nothing to balance against
    f.blendPct=Math.max(0,Math.min(100,(f.blendPct!=null?f.blendPct:bDefaultBlendPct(n,posInGroup))+delta));
    bFabricSuggest(it);
    bRI();
    return;
  }
  const neighbor = it.fabrics[group[neighborPos].ofi];
  const selfCurrent = f.blendPct!=null ? f.blendPct : bDefaultBlendPct(n,posInGroup);
  const neighborCurrent = neighbor.blendPct!=null ? neighbor.blendPct : bDefaultBlendPct(n,neighborPos);
  const newSelf = Math.max(0, Math.min(100, selfCurrent+delta));
  let actualDelta = newSelf - selfCurrent;
  let newNeighbor = Math.max(0, Math.min(100, neighborCurrent-actualDelta));
  // If the neighbor couldn't fully absorb the change (hit 0 or 100), limit
  // how much self actually changes too, so the pair still sums correctly.
  if ((neighborCurrent-actualDelta) !== newNeighbor) {
    actualDelta = neighborCurrent - newNeighbor;
  }
  f.blendPct = selfCurrent + actualDelta;
  neighbor.blendPct = neighborCurrent - actualDelta;
  bFabricSuggest(it);
  bRI();
}
// ── Fabric suggestions ───────────────────────────────────────────────────────
// Default assumption: the yarns picked in Step 4 are BLENDED into the Body fabric
// (one fabric, several yarns), never one yarn per garment part. Spandex/Elastane is
// always a ~10% component of a blend, never a fabric on its own. Contrast and Rib
// default to a copy of the Body blend. When a Lining is wanted and the yarn pool mixes
// lining-type yarns (polyester, nylon, viscose...) with others, the lining-type yarns
// move to the Lining and the rest stay in the Body. Rows the system creates carry
// auto:true and are re-suggested as details change; the moment the customer edits a
// usage (yarn, %, weight, construction) that usage is left alone.
const FAB_STRETCH=['Spandex','Elastane'];
const FAB_LINING_SUITED=['Polyester','Recycled Polyester','Nylon','Rayon','Bamboo Viscose','Modal','Lyocell','Tencel','Silk','Acrylic'];
const FAB_GROUPS_SOLO=Object.fromEntries(Object.entries(FAB_GROUPS).map(([g,l])=>[g,l.filter(f=>!FAB_STRETCH.includes(f))]));
const FAB_USAGE_ORDER=['Self / Body','Lining','Contrast','Rib'];
function bFabPool(it){return (B.fabrics&&B.fabrics.length)?B.fabrics.slice():[it.fab||'Cotton'];}
function bBlendRows(yarns,stretch,usage,weight,construction){
  const st=stretch.slice(0,1);                       // one stretch yarn per blend
  let base=yarns.slice(0,Math.max(1,4-st.length));   // blends hold at most 4 yarns
  if(!base.length)base=['Cotton'];
  const rows=base.map(n=>({name:n,usage,weight,construction,auto:true}));
  st.forEach(n=>rows.push({name:n,usage,weight,construction,auto:true}));
  if(rows.length>1){
    const bp=100-(st.length?10:0), each=Math.floor(bp/base.length);
    base.forEach((n,i)=>{rows[i].blendPct=(i===base.length-1)?bp-each*(base.length-1):each;});
    st.forEach((n,i)=>{rows[base.length+i].blendPct=10;});
  }
  return rows;
}
function bTouchUsage(it,usage){
  (it.fabrics||[]).forEach(f=>{if((f.usage||'Self / Body')===usage)delete f.auto;});
}
function bFabricSuggest(it){
  const act=bDDActive(it);
  const need={'Self / Body':true,Lining:act.includes('lining'),Contrast:act.includes('contrast'),Rib:act.includes('rib')};
  const pool=bFabPool(it), stretch=pool.filter(n=>FAB_STRETCH.includes(n)), base=pool.filter(n=>!FAB_STRETCH.includes(n));
  let bodyY=base, linY=base;
  if(need.Lining){
    const L=base.filter(n=>FAB_LINING_SUITED.includes(n)), N=base.filter(n=>!FAB_LINING_SUITED.includes(n));
    if(L.length&&N.length){bodyY=N;linY=L;}
  }
  const rowsOf=u=>(it.fabrics||[]).filter(f=>(f.usage||'Self / Body')===u);
  const isAuto=rs=>rs.length>0&&rs.every(f=>f.auto);
  const sug={};
  const curBody=rowsOf('Self / Body');
  sug['Self / Body']=(curBody.length&&!isAuto(curBody))?null:bBlendRows(bodyY,stretch,'Self / Body','mid','Construction');
  const bodyFinal=sug['Self / Body']||curBody;
  if(need.Lining)sug.Lining=bBlendRows(linY,stretch,'Lining','light','Construction');
  const copyOf=(rows,usage,constr)=>rows.map(f=>{const r={name:f.name,usage,weight:f.weight||'mid',construction:constr||f.construction||'Construction',auto:true};if(f.blendPct!=null)r.blendPct=f.blendPct;return r;});
  if(need.Contrast)sug.Contrast=copyOf(bodyFinal,'Contrast');
  if(need.Rib)sug.Rib=copyOf(bodyFinal,'Rib','Rib Knit');
  const out=[], placed={};
  (it.fabrics||[]).forEach(f=>{
    const u=f.usage||'Self / Body';
    const cur=rowsOf(u);
    let replace=false;
    if(FAB_USAGE_ORDER.includes(u)){
      if(u in sug)replace=(sug[u]!==null&&(cur.length===0||isAuto(cur)));
      else replace=(!need[u]&&u!=='Self / Body'&&isAuto(cur));
    }
    if(!replace){out.push(f);return;}
    if(!placed[u]){
      placed[u]=true;
      if(sug[u]){const colour=cur[0]&&cur[0].colour;sug[u].forEach(r=>{if(colour)r.colour=colour;out.push(r);});}
    }
  });
  FAB_USAGE_ORDER.forEach(u=>{
    if(sug[u]&&!placed[u]&&rowsOf(u).length===0){sug[u].forEach(r=>out.push(r));placed[u]=true;}
  });
  it.fabrics=out;
  const b0=it.fabrics.find(f=>(f.usage||'Self / Body')==='Self / Body');
  if(b0){it.fab=b0.name;if(b0.weight)it.wt=b0.weight;}
}
// "Same as ..." -- copy another usage's blend (yarns + %) into this usage. It is a
// copy, not a link: weight/construction/colour of this usage are kept.

// ── Single blended-fabric pill: one pill, % edited in a popover (bottom sheet on phones) ──
const BL_COL=['#d4a44c','#6fa8dc','#8fbf7a','#c586b3','#b9a58a'];
function bBlLocked(f){return f.locked!==undefined?!!f.locked:FAB_STRETCH.includes(f.name);}
function bBlShort(n){return String(n).replace('Recycled ','Rec. ').replace('Organic ','Org. ').replace('Polyester','Poly').replace('Bamboo Viscose','Bamboo');}
function bBlendPillHtml(it,usage,members){
  const iid=it.id,n=members.length;
  const rows=members.map((m,k)=>({fi:m.fi,f:m.f,pct:m.f.blendPct!=null?m.f.blendPct:bDefaultBlendPct(n,k),col:BL_COL[k%BL_COL.length]}));
  const total=rows.reduce((a,r)=>a+r.pct,0);
  const kind='bl_'+usage;
  const keep=!!(window._ddKeep&&window._ddKeep.id===iid&&window._ddKeep.kind===kind);
  const keepJs="window._ddKeep={id:"+iid+",kind:'"+kind+"'};";
  const all=[];Object.values(FAB_GROUPS).forEach(l=>l.forEach(x=>all.push(x)));
  const optsFor=sel=>(all.includes(sel)?'':'<option selected>'+sel+'</option>')+Object.entries(FAB_GROUPS).map(([g,l])=>'<optgroup label="'+g+'">'+l.map(x=>'<option'+(x===sel?' selected':'')+'>'+x+'</option>').join('')+'</optgroup>').join('');
  const names=rows.map(r=>r.f.name);
  let quick=bFabPool(it).filter(x=>!names.includes(x));
  quick=[...quick.filter(x=>FAB_STRETCH.includes(x)),...quick.filter(x=>!FAB_STRETCH.includes(x))];
  if(!quick.some(x=>FAB_STRETCH.includes(x))&&!names.some(x=>FAB_STRETCH.includes(x)))quick.unshift('Spandex');
  const addSel=n>=5?'':'<select onchange="if(!this.value)return;'+keepJs+'bAddBlendFabric('+iid+",'"+usage+"',this.value)\" style=\"margin-top:10px;width:100%;background:rgba(212,164,76,0.1);border:1px dashed var(--gold);border-radius:20px;color:var(--gold);padding:7px 12px;font-size:12px;outline:none\"><option value=\"\">+ Add yarn to blend ("+(5-n)+" more)</option>"+
    (quick.length?'<optgroup label="Blend in">'+quick.map(x=>'<option>'+x+'</option>').join('')+'</optgroup>':'')+optsFor('')+"</select>";
  const seg=(r)=>'<span data-seg="'+iid+'_'+r.fi+'" style="flex:0 0 '+r.pct+'%;background:'+r.col+'"></span>';
  const rowHtml=rows.map(r=>'<div data-bpr="'+iid+'_'+r.fi+'" style="display:flex;align-items:center;gap:8px;margin-top:10px">'+
    '<span style="width:8px;height:8px;border-radius:50%;background:'+r.col+';flex-shrink:0"></span>'+
    '<select onchange="'+keepJs+'bSetFabric('+iid+','+r.fi+",'name',this.value)\" style=\"flex:0 0 118px;min-width:0;background:rgba(255,255,255,0.07);border:1px solid rgba(255,255,255,0.15);border-radius:16px;color:var(--white);padding:5px 8px;font-size:12px;outline:none\">"+optsFor(r.f.name)+'</select>'+
    '<input type="range" min="0" max="100" value="'+r.pct+'" data-sl="'+iid+'_'+r.fi+'" oninput="bBlSet('+iid+','+r.fi+',+this.value,false)" onchange="bBlSet('+iid+','+r.fi+',+this.value,true)" style="flex:1;min-width:0;accent-color:'+r.col+'">'+
    '<span style="display:flex;align-items:center;gap:1px;flex-shrink:0"><input type="number" min="0" max="100" value="'+r.pct+'" data-nm="'+iid+'_'+r.fi+'" onchange="bBlSet('+iid+','+r.fi+',parseInt(this.value),true)" style="width:40px;background:rgba(255,255,255,0.07);border:1px solid var(--gold);border-radius:8px;color:var(--gold);font-size:12px;font-weight:600;font-family:\'DM Mono\',monospace;text-align:center;padding:3px 0;outline:none;-moz-appearance:textfield"><span style="font-size:11px;color:var(--ink3)">%</span></span>'+
    '<button onclick="bBlLock('+iid+','+r.fi+')" title="'+(bBlLocked(r.f)?'Unlock this %':'Lock this % while adjusting the others')+'" style="background:none;border:none;cursor:pointer;font-size:12px;padding:0 2px;opacity:'+(bBlLocked(r.f)?'1':'0.35')+'">'+(bBlLocked(r.f)?'🔒':'🔓')+'</button>'+
    '<button onclick="'+(n>2?keepJs:'')+'bRemFabric('+iid+','+r.fi+')" title="Remove from blend" style="background:none;border:none;color:rgba(255,255,255,0.55);cursor:pointer;font-size:14px;padding:0 2px;line-height:1">×</button></div>').join('');
  const summary=rows.map(r=>bBlShort(r.f.name)+' '+r.pct).join(' · ');
  const pill='<div class="pill" title="'+rows.map(r=>r.f.name+' '+r.pct+'%').join(' / ')+'" style="position:relative;background:rgba(255,255,255,0.05);border:1px solid var(--gold);cursor:pointer;white-space:nowrap;width:100%;text-align:left;overflow:hidden;display:flex;align-items:center;padding:0 12px;height:30px;box-sizing:border-box;color:var(--white);font-size:12px" onclick="mvfaOpenDD(this)"><span style="overflow:hidden;text-overflow:ellipsis;flex:1;min-width:0">'+summary+'</span><span style="flex-shrink:0;padding-left:6px;color:'+(total===100?'var(--gold)':'#e07a5f')+'">'+(total===100?'▾':'⚠ ▾')+'</span>'+
    '<span data-bar="'+iid+'_'+usage+'" style="position:absolute;left:0;right:0;bottom:0;height:3px;display:flex">'+rows.map(seg).join('')+'</span></div>';
  const pop='<div class="blend-pop" data-bl="'+iid+'|'+usage+'" '+(keep?'data-ddkeep="1" ':'')+'style="display:'+(keep?'block':'none')+';position:absolute;top:100%;left:0;z-index:999;background:#1a1a18;border:1px solid rgba(255,255,255,0.15);border-radius:10px;padding:12px 14px 14px;width:min(360px,86vw);margin-top:4px;box-shadow:0 8px 24px rgba(0,0,0,0.5)">'+
    '<div style="display:flex;justify-content:space-between;align-items:center"><span style="font-size:9px;letter-spacing:.1em;text-transform:uppercase;color:var(--gold)">'+usage+' blend</span><span data-total="'+iid+'_'+usage+'" style="font-size:11px;font-family:\'DM Mono\',monospace;color:'+(total===100?'#7fbf8a':'#e07a5f')+'">'+total+'% '+(total===100?'✓':'')+'</span></div>'+
    '<div style="display:flex;height:6px;border-radius:3px;overflow:hidden;margin-top:8px;background:rgba(255,255,255,0.06)" data-pbar="'+iid+'_'+usage+'">'+rows.map(seg).join('')+'</div>'+
    rowHtml+addSel+
    '<button onclick="mvfaCloseDD(this.closest(\'.blend-pop\'));window._ddKeep=null" style="margin-top:12px;width:100%;background:var(--gold);border:none;border-radius:20px;color:#1a1a18;font-weight:600;font-size:12px;padding:8px;cursor:pointer">Done</button></div>';
  return '<div style="position:relative;width:100%">'+pill+pop+'</div>';
}
function bBlPaint(it,usage,out,mem){
  const iid=it.id;
  mem.forEach((o,k)=>{
    const key=iid+'_'+o.i;
    document.querySelectorAll('[data-nm="'+key+'"]').forEach(e=>{if(document.activeElement!==e)e.value=out[k];});
    document.querySelectorAll('[data-sl="'+key+'"]').forEach(e=>{e.value=out[k];});
    document.querySelectorAll('[data-seg="'+key+'"]').forEach(e=>{e.style.flex='0 0 '+out[k]+'%';});
  });
}
function bBlSet(id,idx,val,commit){
  const it=B.items.find(i=>i.id===id);if(!it||!it.fabrics)return;
  const f=it.fabrics[idx];if(!f)return;
  const usage=f.usage||'Self / Body';
  const mem=it.fabrics.map((x,i)=>({x:x,i:i})).filter(o=>(o.x.usage||'Self / Body')===usage);
  const n=mem.length;
  const cur=mem.map((o,k)=>o.x.blendPct!=null?o.x.blendPct:bDefaultBlendPct(n,k));
  const me=mem.findIndex(o=>o.i===idx);
  const lockedSum=mem.reduce((a,o,k)=>a+((k!==me&&bBlLocked(o.x))?cur[k]:0),0);
  const free=[];mem.forEach((o,k)=>{if(k!==me&&!bBlLocked(o.x))free.push(k);});
  val=Math.round(val);if(isNaN(val))val=cur[me];
  val=Math.max(0,Math.min(100-lockedSum,val));
  if(!free.length)val=100-lockedSum;
  const rem=100-lockedSum-val;
  const out=cur.slice();out[me]=val;
  if(free.length){
    const base=free.reduce((a,k)=>a+cur[k],0);
    const raw=free.map(k=>base>0?rem*cur[k]/base:rem/free.length);
    const fl=raw.map(Math.floor);
    const left=rem-fl.reduce((a,b)=>a+b,0);
    raw.map((r,j)=>[r-fl[j],j]).sort((a,b)=>b[0]-a[0]).slice(0,left).forEach(t=>{fl[t[1]]++;});
    free.forEach((k,j)=>{out[k]=fl[j];});
  }
  mem.forEach((o,k)=>{o.x.blendPct=out[k];});
  bTouchUsage(it,usage);
  if(commit){window._ddKeep={id:id,kind:'bl_'+usage};setTimeout(function(){bFabricSuggest(it);bRI();},0);}
  else bBlPaint(it,usage,out,mem);
}
function bBlLock(id,idx){
  const it=B.items.find(i=>i.id===id);if(!it)return;
  const f=it.fabrics[idx];f.locked=!bBlLocked(f);
  window._ddKeep={id:id,kind:'bl_'+(f.usage||'Self / Body')};
  bRI();
}

// ── Blend as a label line: short reference pill + "45% Polyester · 45% Nylon · 10% Spandex" editor ──
function bBlendRefHtml(it,usage,members){
  const n=members.length;
  const rows=members.map((m,k)=>({f:m.f,pct:m.f.blendPct!=null?m.f.blendPct:bDefaultBlendPct(n,k)})).sort((a,b)=>b.pct-a.pct);
  const total=rows.reduce((a,r)=>a+r.pct,0);
  const short=x=>String(x).replace('Recycled ','Rec. ').replace('Organic ','Org. ').replace('Polyester','Poly').replace('Bamboo Viscose','Bamboo');
  return '<div class="pill" title="'+rows.map(r=>r.f.name+' '+r.pct+'%').join(' / ')+'" style="background:rgba(255,255,255,0.07);white-space:nowrap;width:100%;text-align:left;overflow:hidden;text-overflow:ellipsis;display:flex;align-items:center;padding:0 12px;height:30px;box-sizing:border-box;color:var(--white);font-size:12px;cursor:default"><span style="overflow:hidden;text-overflow:ellipsis">'+rows.map(r=>short(r.f.name)).join(' / ')+'</span>'+(total===100?'':'<span style="color:#e07a5f;padding-left:6px">⚠</span>')+'</div>';
}
function bBlendLineHtml(it,usage,members){
  const iid=it.id,n=members.length;
  const rows=members.map((m,k)=>({fi:m.fi,f:m.f,pct:m.f.blendPct!=null?m.f.blendPct:bDefaultBlendPct(n,k)}));
  const all=[];Object.values(FAB_GROUPS).forEach(l=>l.forEach(x=>all.push(x)));
  const optsFor=sel=>(all.includes(sel)?'':'<option selected>'+sel+'</option>')+Object.entries(FAB_GROUPS).map(([g,l])=>'<optgroup label="'+g+'">'+l.map(x=>'<option'+(x===sel?' selected':'')+'>'+x+'</option>').join('')+'</optgroup>').join('');
  const arrow='background:none;border:none;color:var(--gold);cursor:pointer;font-size:8px;line-height:11px;padding:0 3px;display:block';
  const abbr=nm=>{const m={'Recycled Polyester':'R.Poly','Polyester':'Poly','Spandex':'Spdx','Elastane':'Elast.','Organic Cotton':'Org Cot','Cotton':'Cotton','Bamboo Viscose':'Bamboo','Merino Wool':'Merino'};return m[nm]||(nm.length>8?nm.slice(0,5)+'.':nm);};
  const tight=n>=4;
  const seg=rows.map((r,k)=>{
    return '<span style="display:inline-flex;align-items:center;gap:2px;height:30px;box-sizing:border-box;padding:0 6px 0 '+(k?'10':'12')+'px;'+'">'+
      '<input type="number" min="0" max="100" value="'+r.pct+'" onchange="bBlSet('+iid+','+r.fi+',parseInt(this.value),true)" style="width:24px!important;min-width:0!important;max-width:24px!important;flex:none;box-sizing:content-box;background:none!important;border:none!important;color:var(--gold);font-size:12px;font-weight:600;font-family:\'DM Mono\',monospace;text-align:right;outline:none;padding:0!important;margin:0!important;-moz-appearance:textfield">'+
      '<span style="font-size:11px;color:var(--gold)">%</span>'+
      '<span style="display:inline-flex;flex-direction:column"><button onclick="bBlSet('+iid+','+r.fi+','+(r.pct+1)+',true)" style="'+arrow+'" title="+1%">▲</button><button onclick="bBlSet('+iid+','+r.fi+','+(r.pct-1)+',true)" style="'+arrow+'" title="−1%">▼</button></span>'+
      '<span style="position:relative;display:inline-block;font-size:12px;color:var(--white);white-space:nowrap;padding:0 2px" title="'+r.f.name+'">'+(tight?abbr(r.f.name):r.f.name)+' ▾<select onchange="bSetFabric('+iid+','+r.fi+",'name',this.value)\" style=\"position:absolute;left:0;top:0;width:100%;height:100%;opacity:0;cursor:pointer\">"+optsFor(r.f.name)+'</select></span>'+
      '<button onclick="bRemFabric('+iid+','+r.fi+')" title="Remove from blend" style="background:none;border:none;color:rgba(255,255,255,0.55);cursor:pointer;font-size:14px;padding:0 1px;line-height:1">×</button></span>';
  }).join('');
  const names=rows.map(r=>r.f.name);
  let quick=bFabPool(it).filter(x=>!names.includes(x));
  quick=[...quick.filter(x=>FAB_STRETCH.includes(x)),...quick.filter(x=>!FAB_STRETCH.includes(x))];
  if(!quick.some(x=>FAB_STRETCH.includes(x))&&!names.some(x=>FAB_STRETCH.includes(x)))quick.unshift('Spandex');
  const add=n>=5?'':'<span style="position:relative;display:inline-flex;align-items:center;color:var(--gold);padding:0 12px;height:30px;box-sizing:border-box;font-size:11px;white-space:nowrap">+ Add yarn ▾<select onchange="if(!this.value)return;bAddBlendFabric('+iid+",'"+usage+"',this.value)\" style=\"position:absolute;left:0;top:0;width:100%;height:100%;opacity:0;cursor:pointer\"><option value=\"\">+ Add yarn</option>"+(quick.length?'<optgroup label="Blend in">'+quick.map(x=>'<option>'+x+'</option>').join('')+'</optgroup>':'')+optsFor('')+'</select></span>';
  return '<div style="display:flex;flex-wrap:wrap;align-items:center;max-width:100%;border:1px solid var(--gold);border-radius:18px;background:rgba(255,255,255,0.05)">'+seg+add+'</div>';
}

// ── CAD style reference: pill on the item card + search/carousel picker ──
const CAD_API='https://api.mvfa.ca/mvfa-cad-search.php';
function bCadEsc(x){return String(x==null?'':x).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
function bCadPillHtml(it){
  const has=!!(it.cad&&it.cad.thumb);
  return '<div class="pill'+(has?' sel':'')+'" style="cursor:pointer;'+(has?'':'background:rgba(212,164,76,0.1);border:1px dashed var(--gold);color:var(--gold)')+'" onclick="event.stopPropagation();bOpenCad('+it.id+')">'+(has?'Change CAD ▾':'Select CAD ▾')+'</div>';
}
function bCadCardHtml(it){
  const c=it.cad;if(!(c&&c.thumb))return '';
  return '<span onclick="event.stopPropagation();bOpenCad('+it.id+')" title="'+bCadEsc(c.name)+' — click to change" style="margin-left:auto;margin-right:12px;display:inline-flex;align-items:center;gap:6px;border:1px solid var(--gold);border-radius:10px;background:rgba(255,255,255,0.05);padding:3px 4px 3px 3px;cursor:pointer">'+
    '<img src="'+bCadEsc(c.thumb)+'" alt="" style="width:34px;height:42px;object-fit:contain;background:#fff;border-radius:6px;display:block">'+
    '<button onclick="event.stopPropagation();bCadClear('+it.id+')" title="Remove style CAD" style="background:none;border:none;color:rgba(255,255,255,0.55);cursor:pointer;font-size:13px;padding:0 3px;line-height:1">×</button></span>';
}
function bCadClear(id){const it=B.items.find(i=>i.id===id);if(!it)return;it.cad=null;bRI();}
function bOpenCad(id){
  const it=B.items.find(i=>i.id===id);if(!it)return;
  const old=document.getElementById('cad-overlay');if(old)old.remove();
  const ov=document.createElement('div');ov.id='cad-overlay';
  ov.style.cssText='position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.82)';
  ov.innerHTML='<div style="background:#1a1a18;border:1px solid rgba(255,255,255,0.18);border-radius:14px;width:min(860px,96vw);max-height:90vh;display:flex;flex-direction:column;box-shadow:0 20px 60px rgba(0,0,0,0.6)">'+
    '<div style="display:flex;justify-content:space-between;align-items:center;padding:12px 16px;border-bottom:1px solid rgba(255,255,255,0.08)"><span style="font-size:11px;font-weight:600;color:var(--gold);letter-spacing:.1em;text-transform:uppercase">Choose a style reference</span><button onclick="document.getElementById(\'cad-overlay\').remove()" style="background:none;border:none;color:rgba(255,255,255,0.45);font-size:22px;cursor:pointer;line-height:1">×</button></div>'+
    '<div style="padding:12px 16px"><input id="cad-q" type="search" placeholder="Search — e.g. hoodie, jogger, bomber, crewneck…" value="'+bCadEsc(it.gt||'')+'" style="width:100%;box-sizing:border-box;background:rgba(255,255,255,0.07);border:1px solid rgba(255,255,255,0.18);border-radius:20px;color:var(--white);padding:9px 14px;font-size:13px;outline:none"><div style="font-size:10px;color:var(--ink3);margin-top:6px">Low-resolution previews. Your pick becomes the starting point for your tech pack.</div></div>'+
    '<div id="cad-res" style="padding:4px 16px 18px;overflow-x:auto;overflow-y:hidden;display:flex;gap:12px;min-height:230px;align-items:flex-start;-webkit-overflow-scrolling:touch"></div></div>';
  ov.addEventListener('click',function(e){if(e.target===ov)ov.remove();});
  document.body.appendChild(ov);
  const q=document.getElementById('cad-q');let t=null;
  q.addEventListener('input',function(){clearTimeout(t);t=setTimeout(function(){bCadSearch(id,q.value);},300);});
  bCadSearch(id,q.value);
}
async function bCadSearch(id,q){
  const it=B.items.find(i=>i.id===id);const box=document.getElementById('cad-res');if(!it||!box)return;
  box.innerHTML='<div style="color:var(--ink3);font-size:12px;padding:20px">Searching…</div>';
  try{
    const u=CAD_API+'?action=search&q='+encodeURIComponent(q||'')+'&garment='+encodeURIComponent(it.gt||'')+'&gender='+encodeURIComponent(it.itemGender||'');
    const r=await fetch(u);
    let d=null;try{d=await r.json();}catch(x){}
    if(!r.ok)throw new Error('HTTP '+r.status+((d&&d.error)?' — '+d.error:''));
    if(d&&d.success===false)throw new Error(d.error||'server error');
    const rows=(d&&d.results)||[];
    window._cadRes=rows;
    if(!rows.length){box.innerHTML='<div style="color:var(--ink3);font-size:12px;padding:20px">No matches — try a broader word (e.g. "hoodie").</div>';return;}
    box.innerHTML=rows.map(function(c,i){return '<div onclick="bCadPick('+id+','+i+')" style="flex:0 0 150px;cursor:pointer;border:1px solid '+((it.cad&&it.cad.id===c.id)?'var(--gold)':'rgba(255,255,255,0.12)')+';border-radius:12px;padding:8px;background:rgba(255,255,255,0.03)"><img src="'+bCadEsc(c.thumb)+'" loading="lazy" alt="" style="width:100%;height:170px;object-fit:contain;background:#fff;border-radius:8px"><div style="font-size:11px;color:var(--white);margin-top:6px;line-height:1.3;max-height:30px;overflow:hidden">'+bCadEsc(c.name)+'</div></div>';}).join('');
  }catch(e){box.innerHTML='<div style="color:#e07a5f;font-size:12px;padding:20px">Style library unavailable right now ('+bCadEsc(e&&e.message?e.message:'network')+'). You can continue without a reference.</div>';}
}
function bCadPick(id,i){
  const it=B.items.find(x=>x.id===id);const c=(window._cadRes||[])[i];if(!it||!c)return;
  it.cad={id:c.id,name:c.name,thumb:c.thumb,garment_type:c.garment_type||null};
  const ov=document.getElementById('cad-overlay');if(ov)ov.remove();
  bRI();
}

// ── Reference images / links: merge instead of overwrite, restore in Step 9, show in My Collections ──
function bLeadKey(f){return typeof f==='string'?f:((f&&(f.url||f.name))||JSON.stringify(f));}
function bLeadMerge(a,b){const out=[],seen={};(a||[]).concat(b||[]).forEach(function(f){const k=bLeadKey(f);if(!seen[k]){seen[k]=1;out.push(f);}});return out;}
function bLeadUrl(f){return typeof f==='string'?f:(f&&f.url)||'';}
function bLeadName(f){const u=bLeadUrl(f);return (typeof f==='object'&&f&&f.name)||u.split('/').pop()||'file';}
function bLeadIsImg(f){return /\.(png|jpe?g|gif|webp|avif|bmp)(\?|$)/i.test(bLeadUrl(f))||(typeof f==='object'&&f&&/^image\//.test(f.type||''));}
function bCfRestore(){
  try{cfRenderFiles();}catch(e){}
  const l=document.getElementById('cf-links');
  if(l&&!l.value&&(B.leadRefLinks||[]).length)l.value=B.leadRefLinks.join('\n');
}
function poRenderRefs(){const b=document.getElementById('po-refs');if(b)b.remove();}  // CADs now show inline on each line
function bCopyBlend(id,fromUsage,toUsage){
  const it=B.items.find(i=>i.id===id);if(!it||!it.fabrics)return;
  const src=it.fabrics.filter(f=>(f.usage||'Self / Body')===fromUsage);
  if(!src.length)return;
  const cur=it.fabrics.filter(f=>(f.usage||'Self / Body')===toUsage);
  const weight=cur[0]?(cur[0].weight||'mid'):(src[0].weight||'mid');
  const constr=cur[0]?(cur[0].construction||'Construction'):(toUsage==='Rib'?'Rib Knit':(src[0].construction||'Construction'));
  const colour=cur[0]&&cur[0].colour;
  const rows=src.map(f=>{const r={name:f.name,usage:toUsage,weight,construction:constr};if(f.blendPct!=null)r.blendPct=f.blendPct;if(colour)r.colour=colour;return r;});
  const at=it.fabrics.findIndex(f=>(f.usage||'Self / Body')===toUsage);
  const rest=it.fabrics.filter(f=>(f.usage||'Self / Body')!==toUsage);
  if(at<0)rest.push(...rows);else rest.splice(Math.min(at,rest.length),0,...rows);
  it.fabrics=rest;
  bTouchUsage(it,toUsage);
  bFabricSuggest(it);
  bRI();
}
function bEnsureFabrics(it){
  if(!it.fabrics||!it.fabrics.length){
    // One Body fabric blending every yarn picked in Step 4 (Spandex as a ~10%
    // component). Lining / Contrast / Rib rows appear when those design details
    // are chosen -- see bFabricSuggest.
    it.fabrics=[];
    bFabricSuggest(it);
    if(!it.fabrics.length)it.fabrics=[{name:it.fab||'Cotton',usage:'Self / Body',weight:'mid',construction:'Construction',auto:true}];
    it.fab=it.fabrics[0].name;
  }
}
// Step 5 full list — all design services shown for selection (prices hidden until BoM)
const DSV=['Full Collection','Full Branding','Brand Profile','Design Direction','Logo Design','Label Design','Embroidery','Print Design','Measurement Chart','Digital Pattern'];
const DSP={'Full Collection':5000,'Full Branding':2500,'Brand Profile':250,'Design Direction':250,'Logo Design':250,'Label Design':250,'Embroidery':150,'Print Design':150,'Measurement Chart':150,'Digital Pattern':500,'Tech Pack':500,'Graphic Tech Pack':250,'Garment Tech Pack':500};
// Per-item BoM services (shown on each item card)
const DSV_ITEM=['Logo Design','Label Design','Embroidery','Print Design','Measurement Chart','Digital Pattern','Tech Pack','Graphic Tech Pack','Garment Tech Pack'];
// Additional Design Services (collection-level green section in Step 7)
const ADS_V=['Full Collection','Full Branding','Brand Profile','Design Direction','Tech Pack','Graphic Tech Pack','Garment Tech Pack'];
const ADS_P={'Full Collection':5000,'Full Branding':2500,'Brand Profile':250,'Design Direction':250,'Tech Pack':500,'Graphic Tech Pack':250,'Garment Tech Pack':500};
// Decoration costs — ONLY 'emb' and 'scr' exact keys add cost
// Crest types (crest_embroidery etc) and label types are display-only, no auto-cost
// Decoration cost (screenprint/embroidery) is calculated server-side in calculate()
// from quote_constants — never hardcoded here. The liquid file only displays
// whatever unitPrice/breakdown the server returns.
// Label and Crest types (lbl_*, crest_*) are display/spec-only — Marcus prices these
// per-job since they vary widely by material and supplier, so they intentionally add
// $0 to the live BoM estimate shown in the builder.
// Check if item has active decoration cost (exact key match only)
function itemHasDecor(it,key){return (it.brand||[]).includes(key);}
const DESIGN_FEE=250; // default per-item design fee
// ── QUOTE ENGINE — server-side calculation ────────────────────────────────────
// BOM constants and margin are stored server-side in MySQL (quote_constants table)
// The liquid file never exposes fabric costs, consumption rates, or margin
async function bCalcBoM(item, totalUnits) {
  // Blank (S&S) merch lines are priced server-side by merch_price when added
  // to the cart and carry that price on the item -- never BoM-recalculate them.
  if (item && item.merch) {
    const mp = parseFloat(item.merch.unitPrice != null ? item.merch.unitPrice : item.frozenPrice) || 0;
    return {unitPrice: mp, lineTotal: Math.round(mp*(totalUnits||bQty(item)||1)*100)/100, breakdown: []};
  }
  try {
    const resp = await fetch('https://api.mvfa.ca/mvfa-quote-engine.php?action=calculate', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      mode: 'cors',
      body: JSON.stringify({
        garmentType:   item.gt        || '_default',
        brandCategory: item.category  || B.brand || '_any',
        gender:        item.itemGender|| B.gender || '_any',
        fabric:        (item.fabrics&&item.fabrics.length)?item.fabrics[0].name:(item.fab||'Organic Cotton'),
        weight:        (item.fabrics&&item.fabrics.length)?item.fabrics[0].weight:(item.wt||'mid'),
        construction:  (item.fabrics&&item.fabrics.length&&item.fabrics[0].construction!=='Construction')?item.fabrics[0].construction:'',
        fabrics:       item.fabrics   || [],
        trims:         item.trims     || [],
        trimQty:       item.trimQty   || {},
        labels:        [...(item.lbls||['woven']), ...(item.brand||[]).filter(b=>b.startsWith('lbl_')||b.startsWith('crest_'))],
        totalUnits:    totalUnits     || 120,
        screenprint:   (item.brand||[]).includes('scr'),
        embroidery:    (item.brand||[]).includes('emb'),
        hasCrest:      (item.brand||[]).some(b=>b.startsWith('crest_')),
        screenColours: item.screenColours || 1,
        embStitches:   item.embStitches   || 5000,
        extraDeco:     (item.extraCrests||[]).map(c=>({type:c.type, value:c.value})),
        // Pockets: engine adds pocket CMT ('pocket|_all|<segment>') and pocket fabric
        // consumption per pocket per unit. Design details (lining / contrast / rib)
        // are omitted entirely when nothing is chosen, which keeps legacy pricing.
        pockets:       (item.pockets||[]).map(p=>({type:p.type, qty:p.qty})),
        designDetails: bDDPayload(item),
      })
    });
    if (!resp.ok) throw new Error('HTTP '+resp.status);
    const data = await resp.json();
    if (!data.success) throw new Error(data.error||'Server error');
    // Admin-controlled visibility flag -- same setting applies to every item,
    // so cache it globally rather than per-item. Defaults to hidden (false)
    // until the first successful response, matching the server's own default.
    window._showBom = !!data.showBom;
    return data;
  } catch(e) {
    console.error('Quote engine error:', e.message);
    return {
      success: false,
      _error: e.message,
      breakdown: [],
      unitPrice: 0,
      totalUnits: totalUnits||120,
      lineTotal: 0,
      deposit60: 0,
      balance40: 0,
    };
  }
}
const EP={'WCK-ZLMD001':23.5,'WCK-KHMD002':5,'WCK-KGMD003':21,'WCK-SMMD009':4.5,'WCK-MDL-1201':15.5};
const ED={'WCK-ZLMD001':'ZIPPER SLEEPER','WCK-KHMD002':'KNOTTED HAT','WCK-KGMD003':'KNOTTED GOWN & HAT SET','WCK-SMMD009':'SCRATCH MITTENS','WCK-MDL-1201':'BABY ONESIE SNAP FRONT'};
const CS={'CHARCOAL #155':'#4a4a48','CREAM #571':'#e8dcc8','GREIGE #832':'#c4b89a','GREEN #821':'#6a8c6a','PINK #511':'#d4a0a0','BLUE #095':'#6a90b8','PURPLE #861':'#8a70a8'};
// Canadian sales tax by province/territory — HST where harmonized, else GST (+ PST/QST shown separately on invoice but combined here as a single effective rate)
// Used to populate #po-province when #po-country is set to United
// States -- no tax rates here since US state sales tax isn't calculated
// by this system (see provTaxRate() comment above); this is purely for
// capturing the real ship-to state so Shopify has an accurate address.
const US_STATES = {
  AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',
  CT:'Connecticut',DE:'Delaware',FL:'Florida',GA:'Georgia',HI:'Hawaii',ID:'Idaho',
  IL:'Illinois',IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',
  ME:'Maine',MD:'Maryland',MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',
  MS:'Mississippi',MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',
  NH:'New Hampshire',NJ:'New Jersey',NM:'New Mexico',NY:'New York',
  NC:'North Carolina',ND:'North Dakota',OH:'Ohio',OK:'Oklahoma',OR:'Oregon',
  PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',
  TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',WA:'Washington',
  WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming',DC:'District of Columbia',
};
// Repopulates #po-province's option list based on #po-country -- called
// on country change, and once on page load/whenever a quote is loaded so
// the dropdown always has the right option set before any value gets
// assigned to it. preserveValue lets a caller (loadPO) set the correct
// selected option immediately after repopulating, for a real customer's
// already-known province/state.
function bUpdateProvinceOptions(preserveValue){
  const countryEl = document.getElementById('po-country');
  const provEl = document.getElementById('po-province');
  if (!provEl) return;
  const country = countryEl ? countryEl.value : 'CA';
  let html = '';
  if (country === 'CA') {
    html = Object.keys(PROV_TAX).map(code => {
      const p = PROV_TAX[code];
      const pct = (p.rate*100).toFixed(p.rate*100%1===0?0:3);
      return `<option value="${code}">${p.label} — ${p.name} ${pct}%</option>`;
    }).join('');
  } else if (country === 'US') {
    html = Object.keys(US_STATES).map(code => `<option value="${code}">${US_STATES[code]}</option>`).join('');
  } else {
    html = '<option value="">— not applicable —</option>';
  }
  provEl.innerHTML = html;
  if (preserveValue) provEl.value = preserveValue;
}
const PROV_TAX = {
  'ON':{label:'Ontario',rate:0.13,name:'HST'},
  'NB':{label:'New Brunswick',rate:0.15,name:'HST'},
  'NL':{label:'Newfoundland and Labrador',rate:0.15,name:'HST'},
  'NS':{label:'Nova Scotia',rate:0.14,name:'HST'},
  'PE':{label:'Prince Edward Island',rate:0.15,name:'HST'},
  'BC':{label:'British Columbia',rate:0.12,name:'GST+PST'},
  'MB':{label:'Manitoba',rate:0.12,name:'GST+PST'},
  'SK':{label:'Saskatchewan',rate:0.11,name:'GST+PST'},
  'QC':{label:'Quebec',rate:0.14975,name:'GST+QST'},
  'AB':{label:'Alberta',rate:0.05,name:'GST'},
  'NT':{label:'Northwest Territories',rate:0.05,name:'GST'},
  'NU':{label:'Nunavut',rate:0.05,name:'GST'},
  'YT':{label:'Yukon',rate:0.05,name:'GST'},
};
// country defaults to 'CA' so every existing call site (which only ever
// passed a province code) keeps working unchanged. Non-CA destinations
// are zero-rated for Canadian GST/HST purposes -- this is an export sale
// (see MVFA_Order_Flow_Architecture.md, Section 5). US state tax /
// international VAT are separate questions this system doesn't attempt
// to calculate; MVFA's own accountant determines actual obligations
// (e.g. US economic nexus thresholds) case by case.
function provTaxRate(code, country){
  if (country && country !== 'CA') return 0;
  return (PROV_TAX[code]||PROV_TAX.ON).rate;
}
function provTaxLabel(code){const p=PROV_TAX[code]||PROV_TAX.ON;return `${p.name} (${(p.rate*100).toFixed(p.rate*100%1===0?0:3)}%)`;}

const PSG={adult:['XS','S','M','L','XL','XXL'],baby:['NB','0-3M','3-6M','6-12M','12-18M','18-24M'],os:['OS'],toddler:['2T','3T','4T','5T'],kids:['XS','S','M','L','XL']};

function toast(m){const e=document.getElementById('toast');e.textContent=m;e.classList.add('on');clearTimeout(e._t);e._t=setTimeout(()=>e.classList.remove('on'),3000)}
function fmt(n){n=Number(n)||0;return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',')}
function fmtD(d){return d?new Date(d+'T12:00:00').toLocaleDateString('en-CA',{year:'numeric',month:'short',day:'numeric'}):'—'}

// ══ NAV ══
function goView(v){
  document.querySelectorAll('.view').forEach(e=>e.classList.remove('act'));
  document.querySelectorAll('.ntab').forEach(e=>e.classList.remove('act'));
  document.getElementById('v'+v).classList.add('act');
  document.getElementById('nb-'+v).classList.add('act');
  if(v==='orders')renderOrds();
  if(v==='po'){
    renderCollections();
    // Default to list mode whenever the tab is entered fresh — the editor
    // only shows once a specific draft is actually opened (openOrd).
    document.getElementById('collections-list-wrap').style.display='';
    document.getElementById('po-editor-wrap').style.display='none';
    poRenderGarmentPills();poRenderNextSteps();poUpdateBackButton();
  }
  updBadge();
}
// alias
if(document.getElementById('nb-builder'))document.getElementById('nb-builder').id='nb-builder';

// ══ BUILDER ══
let B={stage:1,brand:null,garments:[],sizes:[],fabrics:[],design:[],fork:null,items:[],approved:false,consent:false,lc:false,ref:null,_costs:{},_collapsed:{},ads:[],genders:[],gender:null};

function adsInit(){
  const el=document.getElementById('ads-pills');
  if(!el)return;
  el.innerHTML=ADS_V.map(v=>`<div class="pill" id="adsp-${v.replace(/\s+/g,'-')}" onclick="bTogADS('${v}',this)">${v}</div>`).join('');
  // Restore selections if any
  (B.ads||[]).forEach(v=>{const p=document.getElementById('adsp-'+v.replace(/\s+/g,'-'));if(p)p.classList.add('sel');});
}

function bTogADS(v,el){
  if(!B.ads)B.ads=[];
  const idx=B.ads.indexOf(v);
  if(idx>=0){B.ads.splice(idx,1);el.classList.remove('sel');}
  else{B.ads.push(v);el.classList.add('sel');}
  const tot=B.ads.reduce((s,d)=>s+(ADS_P[d]||0),0);
  const disp=document.getElementById('ads-total-display');
  if(disp)disp.textContent=tot>0?'$'+tot.toLocaleString():'';
  const lines=document.getElementById('ads-bom-lines');
  if(lines){
    if(B.ads.length){
      lines.innerHTML=
        B.ads.map(d=>`<div class="crow" style="color:rgba(110,207,154,0.85)"><span>${d}</span><span class="cv">$${(ADS_P[d]||0).toLocaleString()}</span></div>`).join('')+
        `<div class="crow" style="border-top:1px solid rgba(45,92,67,0.5);margin-top:5px;padding-top:8px;color:#6ecf9a;font-weight:600"><span>Design Services Total</span><span class="cv">$${tot.toLocaleString()}</span></div>`;
    } else {
      lines.innerHTML='';
    }
  }
}

// Persists in-progress quote state server-side once Step 4 is reached,
// so the customer gets a real resume link (not just sessionStorage,
// which is lost on tab close) and Marcus gets visibility into quotes
// that never convert into a real order.
let _quoteSaveTimer = null;
function bSaveQuoteProgress(){
  // Debounce — only actually save 1.5s after the last call, so rapid
  // navigation/edits don't fire a request on every single change.
  clearTimeout(_quoteSaveTimer);
  _quoteSaveTimer = setTimeout(async () => {
    try {
      const estTotal = bComputeFullOrderTotal(B.items, B._costs);
      B.designLines = poComputeDesignLines();
      const r = await fetch('https://api.mvfa.ca/mvfa-quote-save.php?action=save', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({
          token: window._quoteResumeToken || '',
          state: B,
          step: String(B.stage),
          itemCount: (B.items||[]).length,
          estimatedTotal: estTotal,
        })
      });
      const data = await r.json();
      if (data.success && data.token) {
        window._quoteResumeToken = data.token;
        _rememberToken(data.token);
        bShowResumeLink(data.token);
      }
    } catch(e) { /* silent — saving progress should never block the customer */ }
  }, 1500);
}

function bShowResumeLink(token){
  // Opt-in popup removed (July 7 2026) -- wasn't rendering as a real
  // popup and was pulled rather than debugged further. Kept as a no-op
  // shell since bSaveQuoteProgress() still calls it.
}

// On page load, check for a ?resume= token and load that saved quote
// state back into B, restoring exactly where the customer left off.
async function bCheckResumeToken(){
  const params = new URLSearchParams(window.location.search);
  const token = params.get('resume');
  if (!token) return;
  try {
    const r = await fetch('https://api.mvfa.ca/mvfa-quote-save.php?action=load&token=' + encodeURIComponent(token));
    const data = await r.json();
    if (data.success && data.state) {
      Object.assign(B, data.state);
      bNormalizeLoadedItems(B.items);
      window._quoteResumeToken = token;
      _rememberToken(token);
      // FIX: previously always called openOrd(token), landing EVERY
      // resume link -- including cold-start email inquiries that never
      // touched the builder at all -- on the PO/admin-style order editor.
      // That's the right place once a real collection exists (matches
      // "My Collections to edit and review"), but for a brand-new
      // inquiry with zero items, it showed a confusing admin form with
      // no obvious next step, and the actual way forward (the builder
      // itself) was buried behind a small inline edit button nobody
      // would know to click.
      if (B.brand==='Merch' && B.items && B.items.length > 0) {
        openOrd(token);
      } else if (B.items && B.items.length > 0) {
        // Real progress exists -- Step 7 with the quote already built
        // is the natural place to land, not the PO screen.
        goView('builder');
        bShow(7);
        bRI();
      } else {
        // Cold start -- start them in the builder itself, brand name
        // pre-filled if we already captured it (e.g. via Create Inquiry).
        goView('builder');
        bShow(1);
      }
    }
  } catch(e) { /* silent — if resume fails, customer just starts fresh */ }
}

// Admin editing a customer's quote -- entered via
// ?admin_edit={token}&admin_grant={grant} from the saved-quotes
// dashboard. admin_grant is a short-lived, single-use, per-quote token
// minted server-side by mvfa-saved-quotes.php's mintAdminGrant() the
// moment "Admin Edit Quote" is clicked -- the old static admin_key
// approach was a real security hole (readable by anyone in this
// file's own public source), so it's now checked ONLY server-side in
// mvfa-quote-save.php, and this function just passes the grant through
// and trusts whatever the server's action=load response says via
// is_admin. Reuses the exact same load + Step 7 rendering as a normal
// customer resume, just skips straight to Step 7 with every item visible
// and editable at once (not narrowed to a single line like poEditLine),
// and forces full BOM pricing visibility regardless of the
// customer-facing toggle.
// Deep link used in email replies for low-quantity inquiries:
//   https://mvfa.ca/pages/build-your-collection?merch=1
// Opens the blanks + decoration picker directly (no ?resume= token needed).
function bCheckMerchLink(){
  const params = new URLSearchParams(window.location.search);
  if (params.get('merch') !== '1' || params.get('resume') || params.get('admin_edit')) return;
  B.brand = 'Merch';
  goView('builder');
  bShow('Merch');
  bMerchInit();
}

async function bCheckAdminEdit(){
  const params = new URLSearchParams(window.location.search);
  const token = params.get('admin_edit');
  const grant = params.get('admin_grant');
  if (!token) return;
  try {
    let url = 'https://api.mvfa.ca/mvfa-quote-save.php?action=load&token=' + encodeURIComponent(token);
    if (grant) url += '&adminGrant=' + encodeURIComponent(grant);
    const r = await fetch(url);
    const data = await r.json();
    if (!data.success || !data.state) { toast('Quote not found'); return; }
    // TEMP DIAGNOSTIC -- fabric/trim reported missing on Admin Edit
    // re-entry after a stable fresh-quote flow. Shows exactly what the
    // server returned for these specific fields, plus frozenPrice, the
    // moment the state arrives -- before any recalculation touches it.
    // Remove once found and fixed.
    console.log('[MVFA DIAGNOSTIC] bCheckAdminEdit loaded. is_admin=' + data.is_admin + ' Item detail:\n' + JSON.stringify((data.state.items||[]).map(it => ({
      id: it.id, gt: it.gt, category: it.category, itemGender: it.itemGender, fab: it.fab, fabrics: it.fabrics, colour: it.colour, lbls: it.lbls, brand: it.brand, trims: it.trims, trimQty: it.trimQty, customTrims: it.customTrims, frozenPrice: it.frozenPrice,
    })), null, 2));
    if (!data.is_admin) {
      // A valid admin_edit token but no valid grant (missing, expired,
      // or already used once) -- the server is the sole authority on
      // this, never a client-side check. Surface it clearly rather than
      // silently falling through to a blank/normal view.
      toast('Admin access denied — the access link may have expired or already been used. Go back to Saved Quotes and click "Admin Edit Quote" again for a fresh link.');
      return;
    }
    Object.assign(B, data.state);
    bNormalizeLoadedItems(B.items);
    window._quoteResumeToken = token;
    window._adminMode = true;
    if (B.brand === 'Merch' || B._poSource === 'merch' || B.leadSource === 'merch') {
      // Merch drafts have no Step 7: open the draft quote / PO view directly.
      B.brand = 'Merch'; B._poSource = 'merch';
      try { await openOrd(token); } catch(e) { console.error('admin merch open failed', e); toast('Could not open this merch quote'); }
      return;
    }
    const banner = document.getElementById('admin-mode-banner');
    if (banner) {
      banner.style.display = 'block';
      const brandSpan = document.getElementById('admin-mode-brand');
      if (brandSpan) brandSpan.textContent = (B.brandName || 'this customer') + '\u2019s';
    }
    // Do NOT auto-recalculate on open -- prices should never change just
    // from looking at a quote. Show the stored/frozen price by default;
    // recalculating only happens when "Refresh to Current Rates" is
    // clicked explicitly. Items with no frozen price at all (never
    // submitted, or predate freezing) fall back to a one-time calc so
    // there's at least a real number to look at, not a blank $0.
    if (!B._costs) B._costs = {};
    // Live-fetch every item so the full BoM breakdown (fabric, CMT
    // labour, labels, etc) actually has data to show -- the frozen-price
    // shortcut previously used here only ever supplied a bare unitPrice
    // number with no breakdown array at all, since that detail only
    // comes from a real bCalcBoM() call. This is safe from a drift
    // standpoint: nothing gets PERSISTED just from opening the page --
    // that protection lives in bAdminFinishEdit(), which only ever saves
    // whatever's currently in B._costs at the moment Save is clicked, not
    // a fresh recalculation of everything.
    await Promise.all((B.items||[]).map(async it => {
      const fresh = await bCalcBoM(it, bQty(it)||120);
      if (fresh && fresh.unitPrice > 0) B._costs[it.id] = fresh;
      else if (it.frozenPrice != null) B._costs[it.id] = { unitPrice: it.frozenPrice };
    }));
    goView('builder');
    bShow(7);
    bRI();
    toast('Admin mode — editing ' + (B.brandName||'this customer') + '\u2019s quote. Showing current rates — nothing is saved until you click Save & Send.');
  } catch(e) { console.error('bCheckAdminEdit error:', e); toast('Admin edit failed: ' + (e && e.message ? e.message : String(e))); }
}
// Explicit, deliberate recalculation -- the ONLY way pricing changes for
// a quote already being viewed in Admin Edit. Never happens automatically.
async function bAdminRefreshRates(){
  if (!window._adminMode || !B.items) return;
  toast('Refreshing to current rates…');
  if (!B._costs) B._costs = {};
  await Promise.all(B.items.map(async it => {
    const fresh = await bCalcBoM(it, bQty(it)||120);
    if (fresh && fresh.unitPrice > 0) B._costs[it.id] = fresh;
  }));
  bRI();
  toast('✓ Refreshed to current rates — review before Save & Send');
}
// Saves an admin correction and emails the customer a "your quote has
// been updated" notice, threaded to the same quote_ref as everything
// else sent about this order.
// Shared save step -- writes state to the server and freezes prices.
// Used by both Save & Send (which also emails the customer afterward)
// and Save Only (which doesn't), so the actual save behavior can never
// drift between the two buttons.
async function bAdminSaveState(){
  if (!B.items || !B.items.length) return false;
  if (!B._costs) B._costs = {};
  B.items.forEach(it => {
    const c = B._costs[it.id];
    if (c) it.frozenPrice = parseFloat((c.unitPrice||0).toFixed(2));
  });
  const estTotal = bComputeFullOrderTotal(B.items, B._costs);
  const token = window._quoteResumeToken;
  if (!token) { toast('No quote token — cannot save'); return false; }
  B.designLines = poComputeDesignLines();
  // TEMP DIAGNOSTIC -- matches the load-side log, so the two can be
  // compared directly to see whether fabric/trim data was already
  // missing on load, or present then and lost before this save fires.
  console.log('[MVFA DIAGNOSTIC] bAdminSaveState about to save. Item detail:\n' + JSON.stringify((B.items||[]).map(it => ({
    id: it.id, gt: it.gt, category: it.category, itemGender: it.itemGender, fab: it.fab, fabrics: it.fabrics, colour: it.colour, lbls: it.lbls, brand: it.brand, trims: it.trims, trimQty: it.trimQty, customTrims: it.customTrims, frozenPrice: it.frozenPrice,
  })), null, 2));
  try {
    await fetch('https://api.mvfa.ca/mvfa-quote-save.php?action=save', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({
        token, state: B, step: (B._poSource==='merch' ? 'merch-po' : String(B.stage||7)),
        itemCount: B.items.length, estimatedTotal: estTotal,
      })
    });
  } catch(e) { toast('Save failed — try again'); return false; }
  return true;
}
// Save without notifying the customer -- for research/CMT-updating in
// progress, where the admin wants to persist work without triggering an
// email until the quote is actually ready to go out.
async function bAdminSaveOnly(){
  toast('Saving…');
  B._hasUnsentChanges = true;
  const ok = await bAdminSaveState();
  if (ok) bShowAdminSaveConfirmation('✓ Saved — not sent to customer yet');
  return ok;
}
async function bAdminFinishEdit(){
  toast('Saving corrected quote…');
  B._hasUnsentChanges = false;
  const token = window._quoteResumeToken;
  const ok = await bAdminSaveState();
  if (!ok) return false;
  try {
    const email = (B.customer && B.customer.email) || '';
    const name = (B.customer && (B.customer.contact||B.customer.name)) || 'there';
    // Always ask the server: if the builder state has no email (common in Admin Edit),
    // the server looks up the saved quote's customer email by token.
    const resp = await fetch('https://api.mvfa.ca/mvfa-notify.php?action=send_corrected_quote&key=mvfa-quotes-2026', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ ref: B.ref || '', to: email, name, resumeToken: token })
    });
    const d = await resp.json();
    if (d.success) {
      // The server may have just issued a real quote ref for a draft that had none; keep it on the quote.
      if (d.ref && !B.ref && /^MVFA-\d{4}-\d{4}$/.test(d.ref)) { B.ref = d.ref; try { await bAdminSaveState(); } catch(e) {} }
      bShowAdminSaveConfirmation('✓ Saved and sent' + (email ? ' to ' + email : ' to the customer'));
    } else if (d.error && /No customer email/i.test(d.error)) {
      bShowAdminSaveConfirmation('✓ Saved — no email on file to notify');
    } else {
      toast('✓ Saved, but the email failed: ' + (d.error||'unknown error'));
    }
  } catch(e) { toast('✓ Saved, but the email failed to send'); }
  return true;
}
// Unmissable confirmation that the save/send genuinely completed, then
// returns to Saved Quotes automatically -- a transient toast alone wasn't
// clear enough that the action had actually worked.
function bShowAdminSaveConfirmation(message){
  const old = document.getElementById('admin-save-confirm');
  if (old) old.remove();
  const banner = document.createElement('div');
  banner.id = 'admin-save-confirm';
  banner.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.75);z-index:100010;display:flex;align-items:center;justify-content:center;padding:16px';
  banner.innerHTML = `<div style="background:#1a1a18;border:1px solid #6ecf9a;border-radius:12px;padding:32px;max-width:380px;width:100%;text-align:center">
    <div style="font-size:32px;margin-bottom:10px">✅</div>
    <div style="color:#6ecf9a;font-weight:700;font-size:15px;margin-bottom:8px">${message}</div>
    <div style="font-size:12px;color:var(--ink3)">Returning to Saved Quotes…</div>
  </div>`;
  document.body.appendChild(banner);
  setTimeout(()=>{
    window.location.href = 'https://api.mvfa.ca/mvfa-saved-quotes.php?key=mvfa-quotes-2026';
  }, 1800);
}

function bShow(n){
  document.querySelectorAll('#vbuilder .stage').forEach(s=>s.classList.remove('act'));
  document.getElementById('bs'+n).classList.add('act');
  B.stage=n;
  try{bCfRestore();}catch(e){}
  // Explicit step-number map for the progress bar — stage IDs don't always match
  // their logical step number (e.g. '2b' is logical Step 1, '55' is logical Step 6)
  var _stepMap={1:0,'2b':1,2:2,3:3,4:4,5:5,55:6,6:7,7:7,8:8,9:9,10:10,11:11,12:12,13:9,14:9};
  var _pn = (n in _stepMap) ? _stepMap[n] : parseFloat(n);
  document.getElementById('bprog').style.width=(isNaN(_pn)?100:(_pn/12)*100)+'%';
  window.scrollTo({top:0,left:0,behavior:'auto'});
  document.getElementById('vbuilder').scrollTop=0;
  if(n===7){
    adsInit();
    // Change the button label based on context — editing an existing
    // PO line should say 'Save Changes' not 'Review Quote', since the
    // full quote review/submit flow is irrelevant when just updating a line.
    const btn = document.getElementById('b-step7-next-btn');
    if (btn) btn.textContent = window._adminMode ? 'Save & Send Updated Quote' : ((window._poEditContext || window._poAddContext) ? 'Save Changes ✓' : 'Review Quote →');
    const refreshBtn = document.getElementById('b-admin-refresh-btn');
    if (refreshBtn) refreshBtn.style.display = window._adminMode ? 'inline-block' : 'none';
    const saveOnlyBtn = document.getElementById('b-admin-saveonly-btn');
    if (saveOnlyBtn) saveOnlyBtn.style.display = window._adminMode ? 'inline-block' : 'none';
    const flow3Btn = document.getElementById('b-flow3-consult-btn');
    if (flow3Btn) {
      const _priceAlreadyUnlocked = window._adminMode || !!B.gateEmail || !!(B.customer && B.customer.email);
      const _normalNewQuoteFlow = !window._adminMode && !window._poEditContext && !window._poAddContext;
      flow3Btn.style.display = (_normalNewQuoteFlow && !_priceAlreadyUnlocked) ? 'inline-block' : 'none';
    }
  }
  if(n===1){
    // Pre-fills brand name for cold-start resumes (e.g. an email inquiry
    // where Marcus already captured a brand name via "Create Inquiry")
    // landing here fresh -- matches the existing pattern below for Step
    // 9's contact fields.
    const bn = document.getElementById('b-brandname');
    if (bn && !bn.value && B.brandName) bn.value = B.brandName;
  }
  if(n===9){
    const cfBrand = document.getElementById('cf-brand');
    if (cfBrand && !cfBrand.value) cfBrand.value = B.brandName || '';
    const cfEmail = document.getElementById('cf-email');
    if (cfEmail && !cfEmail.value && B.gateEmail) cfEmail.value = B.gateEmail;
  }
  // Save progress on every step transition past the first screen (which
  // has nothing meaningful to save yet). Previously only fired at n===4,
  // which meant furthest_step and builder_state never reflected anything
  // past Step 4 for ANY customer, no matter how far they actually got --
  // this is why every saved quote showed "Step 4" and why resuming a
  // quote that had progressed further reopened at stale, early data.
  //
  // EXCLUDES admin mode entirely -- bCheckAdminEdit() itself calls
  // bShow(7) just to display the editor, which was silently triggering
  // this auto-save on every single Admin Edit open (and every step
  // change while in it), overwriting the canonical saved record with
  // whatever the live recalculation happened to produce -- even if that
  // recalculation was wrong, and even if the admin never touched Save.
  // Admin mode has its own explicit save path (Save & Send / Save Only,
  // via bAdminSaveState()) and must never persist silently.
  if(n!==1 && !window._adminMode){bSaveQuoteProgress();}
  if(n===8&&B.ref)bBuildQP();
  if(n===9){
    // Pre-fill Step 9 fields from B.customer if they were already
    // captured (via opt-in popup or a previous submission) and the
    // fields are currently blank — prevents the customer from having
    // to re-enter info they already gave when arriving via Edit flow.
    const cust = B.customer || {};
    const parts = (cust.contact||'').split(' ');
    const fn = document.getElementById('cf-fn');
    const ln = document.getElementById('cf-ln');
    const em = document.getElementById('cf-email');
    const ph = document.getElementById('cf-phone');
    const br = document.getElementById('cf-brand');
    if(fn&&!fn.value&&parts[0]) fn.value=parts[0];
    if(ln&&!ln.value&&parts[1]) ln.value=parts.slice(1).join(' ');
    if(em&&!em.value&&cust.email) em.value=cust.email;
    if(ph&&!ph.value&&cust.phone) ph.value=cust.phone;
    if(br&&!br.value&&(B.brandName||cust.name||cust.brand)) br.value=B.brandName||cust.name||cust.brand;
  }
  if(n===10){
    // Pre-fill retail and budget from earlier steps -- but only if the
    // dropdown is still empty. Previously this ran on EVERY bShow(10)
    // call (not just the first time the screen is shown), which meant
    // if the customer manually corrected their selection and then
    // navigated back to this screen for any reason, their choice would
    // be silently overwritten back to whatever B.retail/B.budget last
    // held -- there was never a matching write-back from the dropdown
    // to B.retail/B.budget when the customer changed it themselves.
    var lfr=document.getElementById('lf-retail');
    if(lfr&&B.retail&&!lfr.value){
      for(var i=0;i<lfr.options.length;i++){
        if(lfr.options[i].text.trim()===B.retail.trim()){lfr.selectedIndex=i;break;}
      }
    }
    var lfb=document.getElementById('lf-budget');
    if(lfb&&B.budget&&!lfb.value){
      for(var i=0;i<lfb.options.length;i++){
        if(lfb.options[i].text.trim()===B.budget.trim()){lfb.selectedIndex=i;break;}
      }
    }
  }
  if(n===12){var nc=document.querySelector("#bs12 div[style*=rgba]");if(nc)nc.style.display="none";}
}
async function bNext(f){
  if(f==='2b'){B.genders=bGM('b-gender');if(!B.genders.length){toast('Select at least one gender/segment');return;}
    // Derive primary gender for CMT/consumption lookup: first selection, or 'neutral' if mixed adults
    const adultSels=B.genders.filter(g=>['Mens','Ladies','GenderNeutral'].includes(g));
    const kidsSels=B.genders.filter(g=>['Boys','Girls','Unisex'].includes(g));
    if(B.genders.length===1) B.gender=B.genders[0];
    else if(adultSels.length>1&&adultSels.includes('Mens')&&adultSels.includes('Ladies')) B.gender='GenderNeutral';
    else if(kidsSels.length>1&&kidsSels.includes('Boys')&&kidsSels.includes('Girls')) B.gender='Unisex';
    else B.gender=B.genders[0];
    bPopG();bShow(2);}
  else if(f===2){B.garments=bGM('b-garments');if(!B.garments.length){toast('Select at least one garment');return;}bPopS();bShow(3);}
  else if(f===3){B.sizes=bGM('b-sizes');if(!B.sizes.length){toast('Select at least one size');return;}bPopF();bShow(4);}
  else if(f===4){B.fabrics=bGM('b-fabrics');if(!B.fabrics.length){toast('Select at least one fabric');return;}bPopD();bShow(5);}
  else if(f===5){B.design=bGM('b-design');
    const _bSlider=document.getElementById('b-budget-slider');
    const _bSliderIdx=_bSlider ? parseInt(_bSlider.value) : 2;
    B.budget=BUDGET_VALS[isNaN(_bSliderIdx)?2:_bSliderIdx];
    // Collection-level services chosen at Step 5 (Full Collection, Full Branding,
    // Brand Profile, Design Direction) pre-populate "Additional Design Services"
    // on Step 7 — the customer already answered this, so don't ask again.
    B.ads=(B.design||[]).filter(d=>ADS_V.includes(d));
    bShow(55);}
  else if(f===55){if(!B.retail){toast('Please select a retail price range');return;}bShow(6);}
  else if(f===7){
    // If we're editing an existing PO line via poEditLine(), skip the
    // normal new-quote Review/Submit flow entirely and write changes
    // back to poLines directly.
    if (window._adminMode) { await bAdminFinishEdit(); return; }
    if (window._poEditContext) { await poFinishEdit(); return; }
    if (window._poAddContext) { await poFinishAdd(); return; }
    if(!B.items.length){toast('Add at least one product');return;}if(B.items.find(i=>bQty(i)===0)){toast('Enter quantities for all items');return;}
  if(B.items.find(i=>bQty(i)<120)){toast('Minimum order is 120 units per style');return;}
  // Close the price-gate loophole: reaching Step 8 (Review Quote) implies
  // the customer has actually seen pricing, which should mean they've
  // already given an email via bShowPricingGate(). Previously this check
  // didn't exist, so a customer could click through with prices still
  // masked and land on Step 8/9 as a fully-priced, zero-contact record.
  const _priceUnlocked = window._adminMode || !!B.gateEmail || !!(B.customer && B.customer.email);
  if(!_priceUnlocked){toast('Please unlock your pricing above (🔒 Show Me My Price) before reviewing your quote');bShowPricingGate();return;}
  Promise.all(B.items.map(async it=>{B._costs[it.id]=await bCalcBoM(it,bQty(it)||120);})).then(()=>{bBuildQP();bShow(8);});}
  else if(f===8){if(!B.approved){toast('Please confirm the quote');return;}bShow(9);}
}
function bBack(f){
  if (window._adminMode) {
    window.location.href = 'https://api.mvfa.ca/mvfa-saved-quotes.php?key=mvfa-quotes-2026';
    return;
  }
  const m={'2b':1,2:'2b',3:2,4:3,5:4,55:5,6:55,7:6,8:7,9:8,10:6,Merch2:'Merch'};bShow(m[f]||1);
}
function bFork(c){
  B.fork=c;
  if(c==='build'){
    if(!B.items.length) bInitItems();
    bShow(7);
  } else {
    bShow(10);
    const lfBrand = document.getElementById('lf-brand');
    if (lfBrand && !lfBrand.value) lfBrand.value = B.brandName || '';
  }
}
function bShowPricingGate(){
  const old=document.getElementById('pricing-gate-modal');if(old)old.remove();
  const modal=document.createElement('div');
  modal.id='pricing-gate-modal';
  modal.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,0.7);z-index:100004;display:flex;align-items:center;justify-content:center;padding:16px';
  modal.innerHTML=`<div style="background:#fff;border-radius:14px;padding:32px 28px;max-width:400px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,0.4);text-align:center">
    <div style="font-size:32px;margin-bottom:12px">🎉</div>
    <div style="font-weight:700;font-size:19px;margin-bottom:8px;color:var(--ink)">Your quote is ready!</div>
    <div style="font-size:13px;color:var(--ink2);margin-bottom:22px;line-height:1.5">Enter your details so we can save your pricing and follow up if you have questions.</div>
    <input type="text" id="gate-name" placeholder="First name" style="width:100%;box-sizing:border-box;padding:12px 14px;border-radius:7px;border:1px solid var(--border);font-size:14px;margin-bottom:10px" onkeydown="if(event.key==='Enter')document.getElementById('gate-email').focus()">
    <input type="email" id="gate-email" placeholder="you@yourbrand.com" style="width:100%;box-sizing:border-box;padding:12px 14px;border-radius:7px;border:1px solid var(--border);font-size:14px;margin-bottom:14px" onkeydown="if(event.key==='Enter')bSubmitPricingGate()">
    <div style="display:flex;align-items:flex-start;gap:8px;text-align:left;margin-bottom:20px;cursor:pointer" onclick="bTogGateConsent()">
      <div id="gate-consent-box" style="width:18px;height:18px;border-radius:4px;border:1.5px solid var(--border);flex-shrink:0;margin-top:1px;display:flex;align-items:center;justify-content:center;font-size:11px;color:var(--gold)"></div>
      <div style="font-size:12px;color:var(--ink2);line-height:1.4">Yes, MVFA can email me my quote and contact me about my collection.</div>
    </div>
    ${bMktBoxHTML('mkt-gate')}
    <button onclick="bSubmitPricingGate()" style="background:var(--gold);color:var(--ink);border:none;border-radius:7px;font-size:14px;font-weight:700;cursor:pointer;padding:13px 20px;width:100%;margin-bottom:10px">Yes, Show Me My Quote →</button>
    <button onclick="document.getElementById('pricing-gate-modal').remove()" style="background:none;border:none;color:var(--ink3);font-size:12px;cursor:pointer;padding:6px">← Back</button>
  </div>`;
  document.body.appendChild(modal);
  setTimeout(()=>{const el=document.getElementById('gate-name');if(el)el.focus();},50);
}

// ═══ CASL marketing consent ═══
// "Contact me about my quote" boxes are required (service messages). Marketing is a SEPARATE, optional box that is
// never pre-ticked. Only when a visitor ticks it do we record express consent (wording, page, time) server-side.
const MKT_WORDING = "Yes, I’d also like to receive updates, promotions and special offers from MVFA Design House. I can unsubscribe at any time.";
function bMktBoxHTML(id){
  return `<label class="mkt-consent" style="display:flex;align-items:flex-start;gap:8px;font-size:12px;color:var(--ink2);line-height:1.4;text-align:left;margin:0 0 16px;cursor:pointer"><input type="checkbox" id="${id}" style="margin-top:2px"><span>${MKT_WORDING} <em style="color:var(--ink3);font-style:normal">(Optional)</em></span></label>`;
}
function bMktRecord(boxId, email, name, source){
  try{
    const box=document.getElementById(boxId);
    if(!box || !box.checked || !email || email.indexOf('@')<0) return;
    B.marketingConsent={email:String(email).toLowerCase(), at:new Date().toISOString(), source:source, wording:MKT_WORDING};
    fetch('https://api.mvfa.ca/mvfa-consent.php',{method:'POST',headers:{'Content-Type':'application/json'},mode:'cors',
      body:JSON.stringify({email:email,name:name||'',source:source,wording:MKT_WORDING,page:location.href,ref:B.ref||'',token:window._quoteResumeToken||''})}).catch(()=>{});
  }catch(e){}
}
// Forms whose markup lives in the Shopify liquid get the optional box injected next to a known field.
const MKT_INJECT=[{anchor:'cf-notes',id:'mkt-cf'},{anchor:'lf-notes',id:'mkt-lf'},{anchor:'sample-email',id:'mkt-sample'}];
function bEnsureMktBoxes(){
  MKT_INJECT.forEach(t=>{
    if(document.getElementById(t.id)) return;
    const a=document.getElementById(t.anchor); if(!a) return;
    const host=a.closest('.frow')||a.parentNode; if(!host||!host.parentNode) return;
    const wrap=document.createElement('div'); wrap.style.cssText='margin:12px 0 4px'; wrap.innerHTML=bMktBoxHTML(t.id);
    host.parentNode.insertBefore(wrap, host.nextSibling);
  });
}
setInterval(function(){ try{ bEnsureMktBoxes(); }catch(e){} }, 1500);
function bTogGateConsent(){
  B.gateConsent = !B.gateConsent;
  const box = document.getElementById('gate-consent-box');
  if (box) box.textContent = B.gateConsent ? '✓' : '';
}
function bSubmitPricingGate(){
  const name = document.getElementById('gate-name').value.trim();
  const email = document.getElementById('gate-email').value.trim();
  if (!name) { toast('Please enter your first name'); return; }
  if (!email || !email.includes('@')) { toast('Please enter a valid email'); return; }
  if (!B.gateConsent) { toast('Please confirm you\u2019re okay being contacted'); return; }
  B.gateEmail = email;
  B.gateName = name;
  bMktRecord('mkt-gate', email, name, 'pricing_gate');
  try { localStorage.setItem('mvfa_my_email', email.toLowerCase()); } catch(e){}
  B.customer = Object.assign({}, B.customer||{}, {email: email, contact: name});
  // Persist immediately via the existing opt-in endpoint, so this contact
  // is captured even if they drop off before Step 9 -- the whole point of
  // asking here rather than only later. A token should already exist by
  // this point (auto-saved from Step 4 onward), but this is harmless to
  // skip if one somehow doesn't exist yet -- the local B.gateEmail/gateName
  // still unlock pricing regardless, this call is purely for durability.
  if (window._quoteResumeToken) {
    fetch('https://api.mvfa.ca/mvfa-quote-save.php?action=optin', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ token: window._quoteResumeToken, email: email, firstName: name })
    }).catch(()=>{});
  }
  const modal = document.getElementById('pricing-gate-modal');
  if (modal) modal.remove();
  bRI();
  toast('\u2713 Here\u2019s your live pricing!');
  // Save immediately -- this is the moment a browsing visitor becomes a
  // real, contactable lead, even if they abandon before ever reaching
  // Step 9's full submission.
  bSaveQuoteProgress();
}

function bShowBrandNamePrompt(el,val){
  const old=document.getElementById('brand-name-prompt');if(old)old.remove();
  window._pendingBtype=(el&&val!=null)?{el,val}:null;
  const bn=document.getElementById('b-brandname');
  const cur=(bn&&bn.value?bn.value:'').replace(/"/g,'&quot;');
  const modal=document.createElement('div');
  modal.id='brand-name-prompt';
  modal.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:100003;display:flex;align-items:center;justify-content:center;padding:16px';
  modal.innerHTML=`<div style="background:#fff;border-radius:12px;padding:26px;max-width:380px;width:100%;box-shadow:0 8px 30px rgba(0,0,0,0.3);text-align:center">
    <div style="font-size:28px;margin-bottom:10px">👋</div>
    <div style="font-weight:700;font-size:16px;margin-bottom:8px;color:var(--ink)">Give us a brand name to start building your collection</div>
    <div style="font-size:13px;color:var(--ink2);margin-bottom:16px;line-height:1.5">Don't worry — you can change this later if you're still working on your brand name.</div>
    <input id="brand-name-prompt-input" type="text" value="${cur}" placeholder="e.g. Acme Apparel Co." autocomplete="organization" onkeydown="if(event.key==='Enter')bBrandPromptSubmit()" oninput="this.style.borderColor='#ccc'" style="width:100%;box-sizing:border-box;padding:11px 12px;font-size:14px;margin-bottom:14px;text-align:center;border:1px solid #ccc;border-radius:6px;color:var(--ink);background:#fff;outline:none">
    <button onclick="bBrandPromptSubmit()" style="background:var(--gold);color:var(--ink);border:none;border-radius:6px;font-size:13px;font-weight:600;cursor:pointer;padding:11px 24px;width:100%">Start building</button>
  </div>`;
  modal.addEventListener('click',function(e){if(e.target===modal){modal.remove();window._pendingBtype=null;bFocusBrandName();}});
  document.body.appendChild(modal);
  setTimeout(()=>{const i=document.getElementById('brand-name-prompt-input');if(i)i.focus();},50);
}
// Fills the real brand field from the popup, then carries on with the collection type the
// visitor had just clicked.
function bBrandPromptSubmit(){
  const inp=document.getElementById('brand-name-prompt-input');
  const v=inp?inp.value.trim():'';
  if(!v){if(inp){inp.style.borderColor='#c0392b';inp.focus();}return;}
  const bn=document.getElementById('b-brandname');
  if(bn)bn.value=v;
  B.brandName=v;
  const pend=window._pendingBtype;window._pendingBtype=null;
  const m=document.getElementById('brand-name-prompt');if(m)m.remove();
  if(pend&&pend.el&&document.body.contains(pend.el))selBtype(pend.el,pend.val);
}
function bFocusBrandName(){
  const bn=document.getElementById('b-brandname');
  if(!bn)return;
  bn.focus();
  bn.style.transition='box-shadow .3s, border-color .3s';
  bn.style.boxShadow='0 0 0 3px rgba(212,164,76,0.35)';
  bn.style.borderColor='var(--gold)';
  setTimeout(()=>{bn.style.boxShadow='';bn.style.borderColor='';},2200);
}
function selBtype(el,val){
  const bn = document.getElementById('b-brandname');
  const bnVal = bn ? bn.value.trim() : '';
  if (!bnVal) { bShowBrandNamePrompt(el,val); return; }
  B.brandName = bnVal;
  document.querySelectorAll('#b-btype .btype-card').forEach(c=>c.classList.remove('sel'));
  el.classList.add('sel');
  B.brand=val;
  bPopG();bPopS();
  // Auto-advance — brand identity is the only step that doesn't wait for Continue
  if(B.brand==='Merch'){bShow('Merch');bMerchInit();return;}
  bPopGender();bShow('2b');
}
function selOne(el,g){document.querySelectorAll('#'+g+' .card').forEach(c=>c.classList.remove('sel'));el.classList.add('sel');}
function togCk(el){el.classList.toggle('sel');}
function bG1(g){const e=document.querySelector('#'+g+' .card.sel');return e?e.dataset.val:null;}
function bGM(g){return[...document.querySelectorAll('#'+g+' .cki.sel')].map(e=>e.dataset.val);}
function mkCkList(arr){return arr.map(x=>`<div class="cki" data-val="${x}" onclick="togCk(this)"><div class="ckb"><span class="ckt">✓</span></div><span class="ckl">${x}</span></div>`).join('');}
function bPopG(){document.getElementById('b-garments').innerHTML=mkCkList(GD[B.brand]||GD.Fashion);}
function bPopS(){document.getElementById('b-sizes').innerHTML=mkCkList(B.brand==='Kidswear'?SD.Kidswear:SD.def);}
function bPopGender(){
  // Kidswear only offers Boys/Girls/Unisex; all other brands offer adult genders
  const opts = B.brand==='Kidswear' ? ['Boys','Girls','Unisex'] : ['Mens','Ladies','GenderNeutral'];
  const labels = {GenderNeutral:'Gender Neutral',Unisex:'Unisex / Gender Neutral'};
  document.getElementById('b-gender').innerHTML = opts.map(v=>
    `<div class="cki ${(B.genders||[]).includes(v)?'sel':''}" data-val="${v}" onclick="togCk(this)"><div class="ckb"><span class="ckt">✓</span></div><span class="ckl">${labels[v]||v}</span></div>`
  ).join('');
}
function bPopF(){document.getElementById('b-fabrics').innerHTML=mkCkList(FAB);}
function bPopD(){document.getElementById('b-design').innerHTML=mkCkList(DSV);}

function bInitItems(){
  const genders = (B.genders && B.genders.length) ? B.genders : [B.gender || ''];
  const garments = (B.garments && B.garments.length) ? B.garments : ['T-Shirts'];
  const items = [];
  let idx = 0;
  garments.forEach(g => {
    genders.forEach(gen => {
      const newIt = bNewItem(g, idx++);
      newIt.itemGender = gen;
      items.push(newIt);
    });
  });
  B.items = items;
  bRI();
}
function bOpenCategoryOnlyDD(itemId, anchorEl){
  const it = B.items.find(i=>i.id===itemId);
  if (!it) return;
  const cats = Object.keys(GD);
  let html = '<div style="padding:6px 0">';
  html += cats.map(c=>`<div style="padding:7px 14px;font-size:12px;cursor:pointer;color:${it.category===c?'var(--gold)':'var(--white)'}" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="bSetItemCategory(${itemId},'${c}')">${c}${it.category===c?' ✓':''}</div>`).join('');
  html += '</div>';
  bOpenSimpleDD(anchorEl, 'cat-dd-'+itemId, html);
}
function bOpenGenderOnlyDD(itemId, anchorEl){
  const it = B.items.find(i=>i.id===itemId);
  if (!it || !it.category) return;
  const genderOpts = it.category==='Kidswear' ? ['Boys','Girls','Unisex'] : ['Mens','Ladies','GenderNeutral'];
  const genderLabels = {GenderNeutral:'Gender Neutral',Unisex:'Unisex'};
  let html = '<div style="padding:6px 0">';
  html += genderOpts.map(g=>`<div style="padding:7px 14px;font-size:12px;cursor:pointer;color:${it.itemGender===g?'var(--gold)':'var(--white)'}" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="bSetItemGender(${itemId},'${g}')">${genderLabels[g]||g}${it.itemGender===g?' ✓':''}</div>`).join('');
  html += '</div>';
  bOpenSimpleDD(anchorEl, 'gender-dd-'+itemId, html);
}
function bOpenStyleOnlyDD(itemId, anchorEl){
  const it = B.items.find(i=>i.id===itemId);
  if (!it) return;
  const opts = GD[it.category||B.brand] || GD.Fashion;
  let html = '<div style="padding:6px 0">';
  html += opts.map(g=>`<div style="padding:7px 14px;font-size:12px;cursor:pointer;color:${it.gt===g?'var(--gold)':'var(--white)'}" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="bSetItemStyle(${itemId},'${g}')">${g}${it.gt===g?' ✓':''}</div>`).join('');
  html += '</div>';
  bOpenSimpleDD(anchorEl, 'style-dd-'+itemId, html);
}
function bSetItemStyle(itemId, newStyle){
  const it = B.items.find(i=>i.id===itemId);
  if (!it) return;
  it.gt = newStyle;
  bRIRender();
  setTimeout(bRI, 100);
}
// Small shared helper for both dropdowns above -- creates or reuses a
// positioned dropdown next to anchorEl, refreshes its content, and
// toggles visibility. Kept generic (keyed by a caller-supplied id) so
// Category and Gender each get their own independent dropdown element
// rather than fighting over one shared one.
function bOpenSimpleDD(anchorEl, ddKey, html){
  let dd = anchorEl.nextElementSibling;
  if (!dd || dd.getAttribute('data-dd-key') !== ddKey) {
    dd = document.createElement('div');
    dd.setAttribute('data-dd-key', ddKey);
    dd.style.cssText = 'position:absolute;top:100%;left:0;z-index:999;background:#1a1a18;border:1px solid rgba(255,255,255,0.15);border-radius:8px;min-width:170px;margin-top:4px;box-shadow:0 8px 24px rgba(0,0,0,0.5);max-height:240px;overflow-y:auto';
    anchorEl.parentNode.style.position='relative';
    anchorEl.parentNode.appendChild(dd);
  }
  // Wire into the same _openDD the global click-away listener checks --
  // without this, clicking outside never closed these dropdowns, since
  // the listener only ever knew about dropdowns opened via mvfaOpenDD().
  if (typeof _openDD !== 'undefined' && _openDD && _openDD !== dd) { _openDD.style.display = 'none'; }
  const wasOpen = dd.style.display==='block';
  dd.innerHTML = html;
  dd.style.display = wasOpen ? 'none' : 'block';
  if (typeof _openDD !== 'undefined') { _openDD = dd.style.display==='block' ? dd : null; }
}
function bSetItemCategory(itemId, newCategory){
  const it = B.items.find(i=>i.id===itemId);
  if (!it) return;
  const unchanged = it.category === newCategory;
  // Category is the top of the hierarchy -- everything below it
  // (gender, style/garment type, size scale) may not even be valid
  // combinations in the new category, so all three get forced blank
  // rather than silently carrying over something like "Fashion Ladies,
  // Size 3-6M". Fabric fields are untouched -- fibre/construction/
  // weight are generic across every category.
  it.category = newCategory;
  if (!unchanged) {
    it.itemGender = '';
    it.gt = '';
    it.sizeScale = [];
    it.szs = {};
  }
  bRIRender();
  setTimeout(bRI, 100);
}
function bSetItemGender(itemId, newGender){
  const it = B.items.find(i=>i.id===itemId);
  if (!it) return;
  it.itemGender = newGender;
  bRIRender();
  setTimeout(bRI, 100);

}
// Re-splits quantities evenly across all of an item's current sizes,
// preserving whatever total already existed (so a user's manual
// increase above 120 isn't silently reset when they add another size)
// -- except when the total is still 0, where 120 is the natural
// starting point for a size just added to an empty item.
// Removing a size always sends its units to a neighbor rather than
// discarding them -- the total is preserved exactly, which naturally
// keeps it at or above the 120 floor without needing separate logic,
// since a removal alone never actually reduces the total.
// Keeps sizeScale in canonical size order (matching SD.def/SD.Kidswear)
// regardless of the order sizes were actually added in -- so picking
// S, M, L then later adding XS shows as XS, S, M, L, not S, M, L, XS.
// Custom (non-standard) sizes have no defined position, so they're
// appended at the end, after every recognized size.
function bSortSizeScale(it){
  if (!it.sizeScale) return;
  const canonical = (it.category||B.brand)==='Kidswear' ? SD.Kidswear : SD.def;
  it.sizeScale.sort((a,b)=>{
    const ia = canonical.indexOf(a), ib = canonical.indexOf(b);
    if (ia===-1 && ib===-1) return 0; // both custom -- keep relative order
    if (ia===-1) return 1;  // a is custom -- goes after b
    if (ib===-1) return -1; // b is custom -- goes after a
    return ia - ib;
  });
}
function bRemoveSize(itemId, sz){
  const it = B.items.find(i=>i.id===itemId);
  if (!it || !it.sizeScale) return;
  const idx = it.sizeScale.indexOf(sz);
  if (idx < 0) return;
  if (it.sizeScale.length <= 1) return; // nowhere to transfer to -- last size can't be removed
  it.sizeScale.splice(idx, 1);
  if (it.szs) delete it.szs[sz];
  // Only transfer to a neighbor if the remaining total would actually
  // drop below the 120 floor -- if the other sizes already sum to 120
  // or more on their own, the removed size's units are simply
  // discarded and nothing else changes. This was the actual bug: the
  // old version always transferred the full removed amount regardless
  // of whether it was needed, so removing a size well above 120 (e.g.
  // 60/60/60=180) incorrectly pushed a neighbor to 120 instead of
  // leaving the remaining two sizes untouched at 60/60.
  // Admin can deliberately accept a below-MOQ order, so this transfer
  // is skipped entirely in admin mode -- the removed size's units are
  // simply discarded, whatever the resulting total ends up being.
  if (!window._adminMode) {
    const remainingTotal = (it.sizeScale||[]).reduce((s,k)=>s+((it.szs&&it.szs[k])||0),0);
    if (remainingTotal < 120) {
      const shortfall = 120 - remainingTotal;
      const neighborIdx = idx < it.sizeScale.length ? idx : idx - 1;
      const neighborSz = it.sizeScale[neighborIdx];
      if (neighborSz) { if(!it.szs) it.szs={}; it.szs[neighborSz] = (it.szs[neighborSz]||0) + shortfall; }
    }
  }
  bRI();
}
function bResplitSizes(it){
  const sizes = it.sizeScale || [];
  const n = sizes.length;
  if (n === 0) return;
  let total = sizes.reduce((s,sz)=>s+(it.szs[sz]||0),0);
  if (total === 0) total = 120;
  const base = Math.floor(total / n);
  const rem = total - (base * n);
  sizes.forEach((sz,idx) => { it.szs[sz] = idx===0 ? base+rem : base; });
}
function bNewItem(g,i,copyFrom){
  // Category/gender/size scale carry over from the previous item (or the
  // collection's original Step 1/2 choices for the very first item) as a
  // starting point -- changing category on an item later is what forces
  // these blank again (see bSetItemCategory), not creating a new item.
  const category = copyFrom ? copyFrom.category : B.brand;
  const itemGender = copyFrom ? copyFrom.itemGender : B.gender;
  const sizeScale = copyFrom ? copyFrom.sizeScale.slice() : B.sizes.slice();
  const szCount=sizeScale.length||1;
  const base=Math.floor(120/szCount);
  const rem=120-(base*szCount);
  const szs=Object.fromEntries(sizeScale.map((s,idx)=>[s, idx===0?base+rem:base]));
  // Pre-populate per-item design services from Step 5's selection (intersected
  // with the per-item-eligible list) so the customer doesn't have to re-pick
  // the same services on every single item card.
  const preDesign=(B.design||[]).filter(d=>DSV_ITEM.includes(d));
  return{id:Date.now()+i,gt:g,category,itemGender,sizeScale,useEx:false,exCode:'',fab:B.fabrics[0]||'Modal Jersey',wt:'mid',trims:[],trimQty:{},customTrims:[],lbls:['woven'],brand:[],design:[...preDesign],fin:true,szs,screenColours:1,embStitches:5000};}
function bAddItem(){
  const garmentType = (B.garments && B.garments.length) ? B.garments[B.items.length % B.garments.length] : 'T-Shirts';
  const prevItem = B.items.length ? B.items[B.items.length-1] : null;
  B.items.push(bNewItem(garmentType, B.items.length, prevItem));
  bRI();
}
function bQty(it){
  // Two different item shapes can end up in B.items: the real builder
  // shape (szs) used by Step 7, and the PO/invoice line shape
  // (sizeQtys or totalQty) used when an order was loaded via openOrd().
  // Handle both rather than assume — this was the real cause of "Add
  // another item" crashing on any order that had been viewed/saved
  // through the PO editor first.
  if (it.szs) return Object.values(it.szs).reduce((s,v)=>s+(parseInt(v)||0),0);
  if (it.sizeQtys) return Object.values(it.sizeQtys).reduce((s,v)=>s+(parseInt(v)||0),0);
  return it.totalQty || 0;
}
// Sample pricing for the blanks/Merch flow — unit prices there run far lower than a
// full custom collection, so a flat $1,000 sample doesn't make sense. Formula:
// max($250, 10x quoted unit price + $100), rounded to the nearest $50.
// Half the sample price is credited toward a production order over $1,500.
// Merch commercial terms (edit here): consultation is FREE for now; set MERCH_CONSULT_PRICE > 0 to bring a fee back.
// Sample is a flat, small fee so a low-quantity customer isn't priced out of testing the blank + decoration.
const MERCH_CONSULT_PRICE = 0;
const MERCH_SAMPLE_PRICE  = 250;
function merchSamplePrice(unitPrice){
  return MERCH_SAMPLE_PRICE;
}
function merchSampleCredit(samplePrice){ return samplePrice/2; }
// Picks the "middle" size from a sizeQtys breakdown for the auto-generated
// blank sample spec — e.g. {XS,S,M,L,XL} -> M. Falls back to whichever size
// has the highest quantity if the size names aren't in our known ordering,
// then to the first size present as a last resort.
const SIZE_ORDER = ['NB','0-3M','3-6M','6-12M','12-18M','18-24M','2T','3T','4T','5T',
  'XXS','XS','S','M','L','XL','XXL','XXXL','OS','One Size'];
function pickMiddleSize(sizeQtys){
  const present = Object.entries(sizeQtys||{}).filter(([,q])=>parseInt(q)>0).map(([sz])=>sz);
  if(!present.length) return null;
  const known = present.filter(sz=>SIZE_ORDER.includes(sz));
  if(known.length){
    known.sort((a,b)=>SIZE_ORDER.indexOf(a)-SIZE_ORDER.indexOf(b));
    return known[Math.floor((known.length-1)/2)];
  }
  // Unknown size naming — fall back to highest-quantity size, then first present
  const byQty=[...present].sort((a,b)=>(sizeQtys[b]||0)-(sizeQtys[a]||0));
  return byQty[0];
}
const BUDGET_VALS=['$1,000','$2,500','$5,000','$10,000','$15,000','$20,000','$25,000','$25,000+'];
function bUpdateBudget(v){
  const lbl=document.getElementById('budget-display');
  if(lbl)lbl.textContent=BUDGET_VALS[parseInt(v)]||'$2,500';
  B.budget=BUDGET_VALS[parseInt(v)];
}
function bSelRetail(el,val){
  document.querySelectorAll('#b-retail-pills .pill').forEach(p=>p.classList.remove('sel'));
  el.classList.add('sel');
  B.retail=val;
  const btn=document.getElementById('b-retail-next');
  if(btn)btn.removeAttribute('disabled');
}
// Multi-file picker for inquiry form
var lfFiles=[];
function lfAddFile(input){
  if(!input.files.length)return;
  var added=0,skipped=[];
  for(var fi=0;fi<input.files.length;fi++){
    var file=input.files[fi];
    if(lfFiles.length>=5){skipped.push(file.name+' (max 5 reached)');continue;}
    if(file.size>5*1024*1024){skipped.push(file.name+' (exceeds 5MB)');continue;}
    lfFiles.push(file);added++;
  }
  input.value=''; // reset so same file can be re-added if needed
  if(skipped.length)toast(skipped[0]);
  lfRenderFiles();
}
function lfRemoveFile(i){
  lfFiles.splice(i,1);
  lfRenderFiles();
}
function lfRenderFiles(){
  var el=document.getElementById('lf-file-list');
  if(!el)return;
  el.innerHTML=lfFiles.map(function(f,i){
    var isImg=f.type.startsWith('image/');
    var icon=isImg?'🖼':'📄';
    return '<div style="display:flex;align-items:center;gap:6px;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.12);border-radius:6px;padding:5px 9px;font-size:11px;color:var(--white);max-width:200px">'
      +'<span>'+icon+'</span>'
      +'<span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:120px">'+f.name+'</span>'
      +'<button onclick="lfRemoveFile('+i+')" style="background:none;border:none;color:var(--ink3);cursor:pointer;font-size:14px;padding:0;line-height:1;flex-shrink:0">×</button>'
      +'</div>';
  }).join('');
  var cnt=document.getElementById('lf-files-count');
  if(cnt)cnt.value=lfFiles.length;
}

var cfFiles=[];
function cfAddFile(input){
  if(!input.files.length)return;
  var added=0,skipped=[];
  for(var fi=0;fi<input.files.length;fi++){
    var file=input.files[fi];
    if(cfFiles.length>=5){skipped.push(file.name+' (max 5 reached)');continue;}
    if(file.size>5*1024*1024){skipped.push(file.name+' (exceeds 5MB)');continue;}
    cfFiles.push(file);added++;
  }
  input.value='';
  if(skipped.length)toast(skipped[0]);
  cfRenderFiles();
}
function cfRemoveFile(i){
  cfFiles.splice(i,1);
  cfRenderFiles();
}
function cfRenderFiles(){
  var el=document.getElementById('cf-file-list');
  if(!el)return;
  var savedHtml=(B.leadFiles||[]).map(function(f){
    return '<div style="display:flex;align-items:center;gap:6px;background:rgba(212,164,76,0.1);border:1px solid var(--gold);border-radius:6px;padding:5px 9px;font-size:11px;color:var(--white)"><span>'+(bLeadIsImg(f)?'🖼':'📄')+'</span><span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:120px">'+bCadEsc(bLeadName(f))+'</span><span style="color:var(--gold);font-size:10px">saved</span></div>';
  }).join('');
  el.innerHTML=savedHtml+cfFiles.map(function(f,i){
    var isImg=f.type.startsWith('image/');
    var icon=isImg?'🖼':'📄';
    return '<div style="display:flex;align-items:center;gap:6px;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.12);border-radius:6px;padding:5px 9px;font-size:11px;color:var(--white);max-width:200px">'
      +'<span>'+icon+'</span>'
      +'<span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:120px">'+f.name+'</span>'
      +'<button onclick="cfRemoveFile('+i+')" style="background:none;border:none;color:var(--ink3);cursor:pointer;font-size:14px;padding:0;line-height:1;flex-shrink:0">×</button>'
      +'</div>';
  }).join('');
}

function bTogDesign(id,v){
  const it=B.items.find(i=>i.id===id);
  if(!it)return;
  if(!it.design)it.design=[];
  const x=it.design.indexOf(v);
  if(x>=0)it.design.splice(x,1);else it.design.push(v);
  bRIRender();
}
function bTogCollapse(id){
  if(!B._collapsed) B._collapsed={};
  const wasCollapsed = B._collapsed[id];
  B._collapsed[id]=!B._collapsed[id];
  bRIRender();
  // Show the fabric-accuracy note the first time ANY item is expanded for
  // editing -- this is the actual moment of friction (adjusting fabrics
  // per item), not earlier in the flow before they've even seen pricing.
  if (wasCollapsed && !B._fabricWarningShown) {
    const stretchFibres = (B.fabrics||[]).filter(f => f === 'Spandex' || f === 'Elastane');
    const needsWarning = (B.fabrics||[]).length >= 3 || stretchFibres.length > 0;
    if (needsWarning) {
      B._fabricWarningShown = true;
      let msg = '';
      if (stretchFibres.length > 0) {
        msg += `<div style="margin-bottom:12px">${stretchFibres.join(' and ')} ${stretchFibres.length>1?'are':'is'} usually a small blend component (e.g. 10%) mixed into a main fabric, not a standalone fabric on its own. Use "+ Add Blend" below to mix ${stretchFibres.length>1?'them':'it'} into your main fabric for accurate pricing.</div>`;
      }
      if ((B.fabrics||[]).length >= 3) {
        msg += `<div>You've selected ${B.fabrics.length} fabrics for this collection. Each item can use its own specific fabric(s) below -- for the most accurate quote, only keep the fabric(s) this item actually uses, not every option.</div>`;
      }
      const modal = document.createElement('div');
      modal.id = 'fabric-warning-modal';
      modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.7);z-index:100005;display:flex;align-items:center;justify-content:center;padding:16px';
      modal.innerHTML = `<div style="background:#fff;border-radius:14px;padding:28px;max-width:420px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,0.4)">
        <div style="font-weight:700;font-size:16px;margin-bottom:12px;color:var(--ink)">A quick note on fabric accuracy</div>
        <div style="font-size:13px;color:var(--ink2);line-height:1.6;margin-bottom:20px">${msg}</div>
        <button onclick="document.getElementById('fabric-warning-modal').remove();" style="background:var(--gold);color:var(--ink);border:none;border-radius:7px;font-size:14px;font-weight:700;cursor:pointer;padding:13px 20px;width:100%">Got it, thanks →</button>
      </div>`;
      document.body.appendChild(modal);
    }
  }
}
function bTrimQty(id,key,delta){const it=B.items.find(i=>i.id===id);if(!it)return;if(!it.trimQty)it.trimQty={};it.trimQty[key]=Math.max(1,(it.trimQty[key]||1)+delta);bRI();}
function bScreenColourQty(id,delta){const it=B.items.find(i=>i.id===id);if(!it)return;it.screenColours=Math.max(1,Math.min(6,(it.screenColours||1)+delta));bRI();}
function bEmbStitchQty(id,delta){const it=B.items.find(i=>i.id===id);if(!it)return;it.embStitches=Math.max(1000,(it.embStitches||5000)+delta*1000);bRI();}
function bEmbStitchSelect(id,val){const it=B.items.find(i=>i.id===id);if(!it)return;it.embStitches=parseInt(val,10);bRI();}
function bAddCT(id,key,label){const it=B.items.find(i=>i.id===id);if(!it)return;if(!it.customTrims)it.customTrims=[];if(!it.customTrims.find(c=>c.key===key))it.customTrims.push({key,label});if(!it.trims.includes(key))it.trims.push(key);bRI();}
function bRemCT(id,key){const it=B.items.find(i=>i.id===id);if(!it)return;it.customTrims=(it.customTrims||[]).filter(c=>c.key!==key);it.trims=it.trims.filter(t=>t!==key);bRI();}

async function bCost(it, totalUnits){
  if(it.useEx&&it.exCode){
    const p=EP[it.exCode]||0;
    const up=p;
    return{unitPrice:up,lineTotal:Math.round(up*(totalUnits||120)*100)/100,
           deposit60:Math.round(up*(totalUnits||120)*0.60*100)/100,
           balance40:Math.round(up*(totalUnits||120)*0.40*100)/100,
           breakdown:[{label:'Existing MVFA style',detail:it.exCode,amount:p}]};
  }
  return await bCalcBoM(it, totalUnits||120);
}
// Listen for colour selection from Pantone picker (postMessage from iframe)
window.addEventListener('message',function(e){
  if(e.data&&(e.data.type==='pantoneSelect'||e.data.pantone||e.data.hex)){
    const hex=e.data.hex||e.data.color||'#cccccc';
    const name=e.data.name||e.data.pantone||e.data.label||'Custom';
    const pantoneC=e.data.pantoneC||'';
    const pantoneU=e.data.pantoneU||'';
    const approx=!!e.data.approx;

    // Garment colour target (TCX) — existing behaviour, unchanged
    if(window._pantoneTarget!=null){
      const id=window._pantoneTarget;
      const ov=document.getElementById('pantone-overlay-'+id);if(ov)ov.remove();
      bSetColour(id,hex,name);
      return;
    }

    // Decoration ink colour slot target (Pantone C/U) — Merch flow
    if(window._pantoneInkTarget!=null){
      const slot=window._pantoneInkTarget;
      const ov=document.getElementById('pantone-ink-overlay');if(ov)ov.remove();
      bSetInkColourFromPantone(slot,hex,pantoneC,pantoneU,approx);
      window._pantoneInkTarget=null;
    }

    // PO-view line colour target (Change Colour / Add Another Colour)
    if(window._pantonePOTarget!=null){
      const {lineId,mode}=window._pantonePOTarget;
      const ov=document.getElementById('po-pantone-overlay');if(ov)ov.remove();
      poApplyLineColour(lineId,hex,name,mode);
      window._pantonePOTarget=null;
    }
  }
});
// Per-item section collapse state: B._sec[itemId][secKey] = true (collapsed)
if(!B._sec)B._sec={};
function bTogSec(id,sec){
  if(!B._sec[id])B._sec[id]={};
  B._sec[id][sec]=!B._sec[id][sec];
  bRIRender();
}
function bSecOpen(id,sec){
  return !(B._sec[id]&&B._sec[id][sec]);
}
function bTA(id,k,v){
  const it=B.items.find(i=>i.id===id);if(!it)return;
  const x=it[k].indexOf(v);if(x>=0)it[k].splice(x,1);else it[k].push(v);
  // Always recalculate — silkscreen/embroidery ('brand' key) and label type
  // ('lbls' key) all genuinely affect server pricing (confirmed against
  // real quote_constants 'deco'/'lbls' data). The previous "just re-render,
  // no recalc" shortcut for these two keys was based on a false assumption
  // and silently left the displayed price stale whenever silkscreen,
  // embroidery, or label type was toggled — only a LATER, unrelated change
  // (e.g. adjusting screenprint colour count) would trigger the recalc
  // that finally picked it up.
  bRI();
}
// Independent decoration placements -- lets a garment have e.g. front
// silkscreen AND back embroidery, each with its own colour/stitch count,
// rather than a single flat toggle shared across the whole garment.
function bAddExtraCrest(id, type){
  const it=B.items.find(i=>i.id===id);if(!it)return;
  if(!it.extraCrests) it.extraCrests=[];
  it.extraCrests.push({id:Date.now()+Math.random(), type, value: type==='scr'?1:5000});
  bRI();
}
function bSetExtraCrest(id, crestId, val){
  const it=B.items.find(i=>i.id===id);if(!it||!it.extraCrests)return;
  const c=it.extraCrests.find(c=>c.id===crestId);if(!c)return;
  c.value = parseInt(val,10)||c.value;
  bRI();
}
function bStepExtraCrest(id, crestId, delta){
  const it=B.items.find(i=>i.id===id);if(!it||!it.extraCrests)return;
  const c=it.extraCrests.find(c=>c.id===crestId);if(!c)return;
  const floor = c.type==='emb' ? 1000 : 1;
  c.value = Math.max(floor, (c.value||floor)+delta);
  bRI();
}
function bRemoveExtraCrest(id, crestId){
  const it=B.items.find(i=>i.id===id);if(!it||!it.extraCrests)return;
  it.extraCrests = it.extraCrests.filter(c=>c.id!==crestId);
  bRI();
}
let _bUQTimer = null;
function bUQ(id,sz,val){
  const it=B.items.find(i=>i.id===id);
  if(!it) return;
  if(!it.szs) it.szs={};
  // Just record the raw value here -- no balancing logic on every
  // keystroke. Typing a multi-digit number like "163" fires this on
  // every character ("1", then "16", then "163"), and each of those
  // transient intermediate values would otherwise get compared against
  // the previous total as if it were the person's real, final intent --
  // "1" looks like a massive decrease from whatever the size was
  // before, incorrectly triggering a neighbor transfer based on a
  // number nobody actually meant to set. The floor check below is
  // deferred until typing has actually settled instead.
  it.szs[sz] = Math.max(0, parseInt(val)||0);
  clearTimeout(_bUQTimer);
  _bUQTimer = setTimeout(function(){
    bApplySizeFloor(id, sz);
    bRI();
  }, 1500);
}
// Applies the 120-unit floor -- deferred out of bUQ() so it only ever
// evaluates the settled, final value, not a mid-keystroke one.
function bApplySizeFloor(id, sz){
  // Admin can deliberately accept a below-MOQ order (e.g. 100 units)
  // when there's a business reason to -- the 120 floor is a customer-
  // facing rule, not a hard system limit. The MOQ indicator still shows
  // red below 120 either way; only the automatic enforcement is skipped.
  if (window._adminMode) return;
  const it=B.items.find(i=>i.id===id);
  if(!it || !it.szs) return;
  const sizes = it.sizeScale || Object.keys(it.szs);
  const total = sizes.reduce((s,k)=>s+(it.szs[k]||0),0);
  if (total >= 120) return;
  const shortfall = 120 - total;
  const idx = sizes.indexOf(sz);
  const neighborIdx = (idx >= 0 && idx < sizes.length-1) ? idx+1 : idx-1;
  if (neighborIdx >= 0 && sizes[neighborIdx] !== undefined) {
    const neighborSz = sizes[neighborIdx];
    it.szs[neighborSz] = (it.szs[neighborSz]||0) + shortfall;
  } else {
    // Only one size exists -- nowhere to transfer to, so bring this
    // size itself back up to the floor directly.
    it.szs[sz] = (it.szs[sz]||0) + shortfall;
  }
}
function bRm(id){B.items=B.items.filter(i=>i.id!==id);bRI();}
// ── Design Details (Pockets / Lining / Contrast) ─────────────────────────────
// One "+ Add Design Detail" dropdown, three details max. Each choice feeds the
// quote engine (designDetails + pockets) and keeps the fabric lines in sync:
// ticking a Lining/Contrast/Rib part auto-adds a Lining/Contrast/Rib fabric line
// (flagged auto:true) and removes it again when the last part is unticked, unless
// the customer has since edited that line themselves.
const DD_KINDS=['pockets','lining','contrast','rib'];
const DD_LABEL={pockets:'Pockets',lining:'Lining',contrast:'Contrast',rib:'Rib'};
const DD_PLACEHOLDER={lining:'Lining Panel(s)',contrast:'Contrast Panel(s)',rib:'Rib Trim(s)'};
function bDDRib(d){return Array.isArray(d&&d.rib)?d.rib:((d&&d.rib)?[d.rib]:[]);}
function bDDRearm(){const k=document.querySelector('[data-ddkeep]');if(k&&typeof _openDD!=='undefined')_openDD=k;}
const DD_BOTTOMS=['Trousers','Skirts','Joggers','Shorts','Sweat Shorts','Leggings','Denim Jeans','Work Pants','Scrub Bottoms'];
const DD_NONE=['Beanies','Caps','Hats','Tote Bags','Socks','Underwear','Bibs','Blankets','Sports Bras','Swimwear','Hi-Vis Vests','Aprons'];
const DD_HOODED=['Hoodies','Jackets','Fleece Jackets'];
function bDDGroup(it){
  const g=it&&it.gt;if(!g)return 'none';
  if(DD_NONE.includes(g))return 'none';
  return DD_BOTTOMS.includes(g)?'bottom':'top';
}
function bDDParts(it){
  const g=bDDGroup(it), gt=it.gt;
  if(g==='bottom'){
    return {
      lining:[['leg_half','Leg lining (half)'],['leg_full','Leg lining (full)'],['waist_curtain','Waistband curtain']],
      contrast:[['front','Front legs'],['back','Back legs'],['panels','Panels']],
      rib:[['waist','Waistband'],['pant_cuffs','Pant cuffs']]
    };
  }
  const lining=[['full_body','Full body'],['front','Front'],['back','Back'],['sleeves','Sleeves'],['cuffs','Cuffs']];
  if(DD_HOODED.includes(gt))lining.push(['hood','Hood']);
  return {
    lining,
    contrast:[['sleeves','Sleeves'],['front','Front'],['back','Back'],['cuffs','Cuffs'],['panels','Panels']],
    rib:[['neck','Neck'],['waist','Waistband'],['sleeve_cuffs','Sleeve cuffs']]
  };
}
function bDDPocketCount(it){return (it.pockets||[]).reduce((s,p)=>s+(p.qty||0),0);}
function bDDActive(it){
  const a=new Set(it.ddActive||[]);
  const d=it.dd||{};
  if(bDDPocketCount(it)>0)a.add('pockets');
  if(d.lining&&d.lining.length)a.add('lining');
  if(d.contrast&&d.contrast.length)a.add('contrast');
  if(bDDRib(d).length)a.add('rib');
  return DD_KINDS.filter(k=>a.has(k));
}
// Payload for the quote engine. Omitted (no change) when nothing is chosen.
function bDDPayload(it){
  const d=it.dd||{};
  const lining=(d.lining||[]), contrast=(d.contrast||[]), rib=bDDRib(d);
  const act=bDDActive(it).filter(k=>k!=='pockets');
  if(!lining.length&&!contrast.length&&!rib.length&&bDDPocketCount(it)===0&&!act.length)return undefined;
  return {lining, contrast, rib, active:act};
}
function bDDSyncFabrics(it){
  bEnsureFabrics(it);
  bFabricSuggest(it);
}
function bDDAdd(id,kind){
  const it=B.items.find(i=>i.id===id);if(!it)return;
  if(!it.ddActive)it.ddActive=[];
  if(!it.ddActive.includes(kind))it.ddActive.push(kind);
  if(kind==='pockets'&&bDDPocketCount(it)===0)it.pockets=[{id:Date.now()+Math.random(),type:'Pocket',qty:1}];
  bDDSyncFabrics(it);   // Lining / Contrast / Rib: the fabric row appears now, pre-filled
  it.frozenPrice=null;
  bRI();
}
function bDDRemoveKind(id,kind){
  const it=B.items.find(i=>i.id===id);if(!it)return;
  it.ddActive=(it.ddActive||[]).filter(k=>k!==kind);
  if(!it.dd)it.dd={lining:[],contrast:[],rib:[]};
  if(kind==='pockets')it.pockets=[];
  if(kind==='lining')it.dd.lining=[];
  if(kind==='contrast')it.dd.contrast=[];
  if(kind==='rib')it.dd.rib=[];
  if(window._ddKeep&&window._ddKeep.kind===kind)window._ddKeep=null;
  bDDSyncFabrics(it);
  it.frozenPrice=null;
  bRI();
}
function bDDToggle(id,kind,part){
  const it=B.items.find(i=>i.id===id);if(!it)return;
  if(!it.dd)it.dd={lining:[],contrast:[],rib:[]};
  if(kind==='rib')it.dd.rib=bDDRib(it.dd).slice();
  const arr=it.dd[kind]||(it.dd[kind]=[]);
  const x=arr.indexOf(part);
  if(x>=0)arr.splice(x,1);else arr.push(part);
  bDDSyncFabrics(it);
  it.frozenPrice=null;
  window._ddKeep={id,kind};   // keep this dropdown open so several areas can be ticked in a row
  bRI();
}
function bDDPocketStep(id,delta){
  const it=B.items.find(i=>i.id===id);if(!it)return;
  const n=Math.max(0,Math.min(8,bDDPocketCount(it)+delta));
  it.pockets=n>0?[{id:Date.now()+Math.random(),type:'Pocket',qty:n}]:[];
  if(n===0)it.ddActive=(it.ddActive||[]).filter(k=>k!=='pockets');
  it.frozenPrice=null;
  bRI();
}
// One inline row of pills (same feel as Labels & branding): Pockets is a
// Silkscreen-style pill with a +/- stepper; Lining / Contrast / Rib are
// Blend-style pills with a dropdown of areas; "+ Add Design Detail" adds more.
function bDesignDetailsHtml(it){
  if(it.useEx||!it.gt||bDDGroup(it)==='none')return '';
  const parts=bDDParts(it), d=it.dd||{}, active=bDDActive(it), id=it.id;
  const ddBox='display:none;position:absolute;top:100%;left:0;z-index:999;background:#1a1a18;border:1px solid rgba(255,255,255,0.15);border-radius:8px;padding:6px 0;min-width:210px;margin-top:4px;box-shadow:0 8px 24px rgba(0,0,0,0.5)';
  const pills=active.map(kind=>{
    if(kind==='pockets'){
      const n=bDDPocketCount(it);
      return `<div style="display:inline-flex;align-items:center;gap:0;margin-bottom:2px">
        <div class="pill" style="background:rgba(255,255,255,0.05);border:1px solid var(--gold);border-right:none;color:var(--white);border-radius:20px 0 0 20px;margin:0;height:32px;box-sizing:border-box;padding-top:0;padding-bottom:0;display:flex;align-items:center" onclick="bDDRemoveKind(${id},'pockets')">Pockets</div>
        <div style="display:flex;align-items:center;background:rgba(255,255,255,0.08);border:1px solid var(--gold);border-left:1px solid rgba(212,164,76,0.35);border-radius:0;overflow:hidden;height:32px;box-sizing:border-box">
          <button onclick="bDDPocketStep(${id},-1)" style="background:none;border:none;color:var(--white);padding:0 8px;cursor:pointer;font-size:15px;line-height:28px">−</button>
          <span style="font-size:11px;min-width:60px;text-align:center;font-family:'DM Mono',monospace">${n} pocket${n===1?'':'s'}</span>
          <button onclick="bDDPocketStep(${id},1)" style="background:none;border:none;color:var(--white);padding:0 8px;cursor:pointer;font-size:15px;line-height:28px">+</button>
        </div>
        <button onclick="bDDRemoveKind(${id},'pockets')" title="Remove" style="background:rgba(255,255,255,0.08);border:1px solid var(--gold);border-left:none;border-radius:0 20px 20px 0;color:var(--white);padding:0 10px;cursor:pointer;font-size:13px;height:32px;box-sizing:border-box">×</button>
      </div>`;
    }
    const opts=parts[kind]||[];
    const chosen=kind==='rib'?bDDRib(d):(d[kind]||[]);
    const keep=!!(window._ddKeep&&window._ddKeep.id===id&&window._ddKeep.kind===kind);
    const names=opts.filter(([k])=>chosen.includes(k)).map(([,l])=>l);
    const summary=names.length?names.join(', '):('+ '+DD_PLACEHOLDER[kind]);
    return `<div style="display:inline-flex;align-items:center;height:30px;margin-bottom:2px;background:rgba(255,255,255,0.07);border:1px solid var(--gold);border-radius:20px;position:relative">
      <span style="padding:0 6px 0 12px;font-size:12px;color:var(--gold);white-space:nowrap">${DD_LABEL[kind]}</span>
      <span style="color:rgba(255,255,255,0.25);font-size:12px;padding:0 1px">|</span>
      <div style="position:relative;height:100%">
        <div style="cursor:pointer;height:100%;display:flex;align-items:center;padding:0 8px 0 6px;font-size:12px;color:var(--white);white-space:nowrap;max-width:300px;overflow:hidden;text-overflow:ellipsis" onclick="mvfaOpenDD(this)">${summary} ▾</div>
        <div ${keep?'data-ddkeep="1" ':''}style="${keep?ddBox.replace('display:none','display:block'):ddBox}">
          ${opts.map(([k,l])=>`<div style="padding:7px 14px;font-size:12px;cursor:pointer;white-space:nowrap;color:${chosen.includes(k)?'var(--gold)':'var(--white)'}" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="bDDToggle(${id},'${kind}','${k}')">${chosen.includes(k)?'✓ ':''}${l}</div>`).join('')}
        </div>
      </div>
      <button onclick="bDDRemoveKind(${id},'${kind}')" title="Remove ${DD_LABEL[kind]}" style="background:none;border:none;border-left:1px solid rgba(255,255,255,0.12);color:rgba(255,255,255,0.55);cursor:pointer;font-size:13px;padding:0 10px;height:100%">×</button>
    </div>`;
  }).join('');
  const remaining=DD_KINDS.filter(k=>!active.includes(k));
  const ctaWord={contrast:'contrast',pockets:'pockets',lining:'lining',rib:'rib trim'};
  const ctaList=['contrast','pockets','lining','rib'].filter(k=>remaining.includes(k)).map(k=>ctaWord[k]);
  const cta=ctaList.length?('Add '+(ctaList.length>1?ctaList.slice(0,-1).join(', ')+', or '+ctaList[ctaList.length-1]:ctaList[0])):'';
  const addBtn=remaining.length?`<div style="position:relative;display:inline-block;margin-bottom:2px">
      <div class="pill" style="background:rgba(255,255,255,0.05);cursor:pointer" onclick="mvfaOpenDD(this)">+ Add Design Detail ▾</div>
      <div style="${ddBox};min-width:170px">
        ${remaining.map(k=>`<div style="padding:7px 14px;font-size:12px;cursor:pointer;color:var(--white);white-space:nowrap" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="bDDAdd(${id},'${k}');mvfaCloseDD(this.parentNode)">${DD_LABEL[k]}</div>`).join('')}
      </div></div>`:'';
  return `<div style="margin-top:12px;padding-top:10px;border-top:1px solid rgba(255,255,255,0.05)">
    <div style="font-size:9px;letter-spacing:.1em;text-transform:uppercase;color:var(--ink3);margin-bottom:6px">Design details${cta?` <span style="color:rgba(255,255,255,0.2);margin:0 4px">|</span> <span style="color:var(--gold);opacity:.85">${cta}</span>`:''}</div>
    <div class="pills" style="flex-wrap:wrap;gap:6px;align-items:center">${pills}${addBtn}</div>
  </div>`;
}
// Fabric-line colour swatch (the item colour stays the Self/Body default).
function bOpenPantoneFab(id,fi){
  bOpenPantone(id);
  window._pantoneFabIdx=fi;
}
function bSetColour(id,hex,name){
  const it=B.items.find(i=>i.id===id);if(!it)return;
  if(window._pantoneFabIdx!=null){
    const fi=window._pantoneFabIdx;window._pantoneFabIdx=null;
    if(it.fabrics&&it.fabrics[fi])it.fabrics[fi].colour={hex,name};
    if(window._pantonePopup&&!window._pantonePopup.closed){try{window._pantonePopup.close();}catch(e){}}
    window._pantonePopup=null;
    window._pantoneTarget=null;
    bRIRender();
    return;
  }
  it.colour={hex,name};
  // Close popup if open
  if(window._pantonePopup&&!window._pantonePopup.closed){try{window._pantonePopup.close();}catch(e){}}
  window._pantonePopup=null;
  window._pantoneTarget=null;
  bRIRender();
}
function bOpenPantone(id){
  const old=document.getElementById('pantone-overlay-'+id);if(old)old.remove();
  window._pantoneFabIdx=null;
  window._pantoneTarget=id;
  const ov=document.createElement('div');
  ov.id='pantone-overlay-'+id;
  ov.style.cssText='position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.82)';
  ov.innerHTML=`
    <div style="background:#1a1a18;border:1px solid rgba(255,255,255,0.18);border-radius:14px;overflow:hidden;width:min(780px,96vw);height:min(680px,90vh);display:flex;flex-direction:column;box-shadow:0 24px 80px rgba(0,0,0,0.7)">
      <div style="display:flex;justify-content:space-between;align-items:center;padding:11px 16px;border-bottom:1px solid rgba(255,255,255,0.08);flex-shrink:0">
        <span style="font-size:11px;font-weight:600;color:var(--gold);letter-spacing:.1em;text-transform:uppercase">Select Pantone Colour — click a swatch then press ✓ Select This Colour</span>
        <button onclick="document.getElementById('pantone-overlay-${id}').remove();window._pantoneTarget=null;" style="background:none;border:none;color:rgba(255,255,255,0.45);font-size:22px;cursor:pointer;line-height:1;padding:0 4px">×</button>
      </div>
      <iframe src="https://api.mvfa.ca/mvfa-pantone-picker.html?v=3&mode=fabric" style="flex:1;border:none;width:100%;min-height:0"></iframe>
    </div>`;
  ov.addEventListener('click',function(e){if(e.target===ov){ov.remove();window._pantoneTarget=null;}});
  document.body.appendChild(ov);
}
function bOpenPantoneManual(id){bOpenPantone(id);}

// ── Decoration ink colour picker (Pantone C/U) — Merch flow ──────────────
// Print shops mix against Pantone C (coated, most common for screenprint
// on apparel) or U (uncoated) rather than the TCX garment-dye standard,
// so this stores pantoneC/pantoneU rather than the TCX code.
function bOpenPantoneForInk(slotIndex){
  const old=document.getElementById('pantone-ink-overlay');if(old)old.remove();
  window._pantoneInkTarget=slotIndex;
  const ov=document.createElement('div');
  ov.id='pantone-ink-overlay';
  ov.style.cssText='position:fixed;inset:0;z-index:10010;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.82)';
  ov.innerHTML=`
    <div style="background:#1a1a18;border:1px solid rgba(255,255,255,0.18);border-radius:14px;overflow:hidden;width:min(780px,96vw);height:min(680px,90vh);display:flex;flex-direction:column;box-shadow:0 24px 80px rgba(0,0,0,0.7)">
      <div style="display:flex;justify-content:space-between;align-items:center;padding:11px 16px;border-bottom:1px solid rgba(255,255,255,0.08);flex-shrink:0">
        <span style="font-size:11px;font-weight:600;color:var(--gold);letter-spacing:.1em;text-transform:uppercase">Select Ink Colour — click a swatch then press ✓ Select This Colour</span>
        <button onclick="document.getElementById('pantone-ink-overlay').remove();window._pantoneInkTarget=null;" style="background:none;border:none;color:rgba(255,255,255,0.45);font-size:22px;cursor:pointer;line-height:1;padding:0 4px">×</button>
      </div>
      <iframe src="https://api.mvfa.ca/mvfa-pantone-picker.html?v=3&mode=fabric" style="flex:1;border:none;width:100%;min-height:0"></iframe>
    </div>`;
  ov.addEventListener('click',function(e){if(e.target===ov){ov.remove();window._pantoneInkTarget=null;}});
  document.body.appendChild(ov);
}

function bSetInkColourFromPantone(slotIndex, hex, pantoneC, pantoneU, approx){
  if(!window._lineInkColours) window._lineInkColours=[];
  // The picker tool returns codes already suffixed (e.g. "484 C" / "484 U") —
  // strip that here so we always store the bare number and add the C/U suffix
  // ourselves at render time, otherwise it doubles up as "484 U U".
  const bareC = (pantoneC||'').replace(/\s*[CU]\s*$/i,'').trim();
  const bareU = (pantoneU||'').replace(/\s*[CU]\s*$/i,'').trim();
  const existing = window._lineInkColours[slotIndex];
  window._lineInkColours[slotIndex] = {
    label: bareC ? `Pantone ${bareC}` : 'Custom',
    hex, pantoneC: bareC, pantoneU: bareU, approx,
    finish: (existing&&existing.finish) || 'U'
  };
  bMerchRenderInkSlot(slotIndex);
  bMerchUpdateLinePricePreview();
  // Restore scroll and focus after re-render so typing in size fields
  // is never interrupted — without this, bRIRender's innerHTML replacement
  // destroys the active input, loses focus, and resets scroll to top.
  window.scrollTo(0, scrollY);
  if (focusedId) {
    const el = document.getElementById(focusedId);
    if (el) { el.focus(); if(focusedVal!==null) el.value = focusedVal; }
  }
}


function bRI(){
  if(!B._costs) B._costs={};
  // Keep existing costs visible during recalc — don't wipe them
  bRIRender();
  Promise.all(B.items.map(async it=>{
    const fresh = await bCalcBoM(it, bQty(it)||120);
    if(fresh&&fresh.unitPrice>0) B._costs[it.id]=fresh;
  })).then(()=>bRIRender());
}
function bRIRender(){
  const scrollY = window.scrollY;
  const focused = document.activeElement;
  const focusedId = focused ? focused.id : null;
  const focusedVal = focused ? focused.value : null;
  // Clear the open dropdown reference — the DOM replacement below
  // detaches whatever was open, so _openDD would point to a ghost
  // node that click-away can never match. Reset it so the next open
  // registers cleanly.
  if(typeof _openDD !== 'undefined') { _openDD = null; }
  document.getElementById('b-items').innerHTML=B.items.map((it,i)=>{
    // Items loaded from a saved order via the PO editor have a different
    // shape (sizeQtys, no gt/fab/szs/trims) — their original builder detail
    // isn't recoverable, so render a simple, honest summary instead of
    // trying to show full edit controls for data that doesn't exist.
    if (!it.gt && !it.szs) {
      const q=bQty(it);
      return `<div class="icard">
        <div class="ich" style="display:grid;grid-template-columns:1fr auto 1fr;align-items:center;gap:8px">
          <div style="font-size:13px;font-weight:600;color:var(--gold)">${it.styleNum||it.name||'Existing item'}</div>
          <div style="text-align:center;font-size:11px;color:var(--ink3)">From original order</div>
          <div style="display:flex;gap:8px;align-items:center;justify-content:flex-end">
            <span style="font-family:'DM Mono',monospace;font-size:12px;font-weight:600;color:var(--gold)">$${(it.price||0).toFixed(2)}/unit</span>
            <button class="gb-danger" style="font-size:11px;padding:4px 10px" onclick="event.stopPropagation();bRm(${it.id})">Remove</button>
          </div>
        </div>
        <div style="padding:10px 14px;font-size:11px;color:var(--ink3)">${q} units · ${it.fabric||'—'} · ${it.colour||'TBD'}</div>
      </div>`;
    }
    const q=bQty(it);const c=B._costs&&B._costs[it.id]?B._costs[it.id]:{unitPrice:0,breakdown:[],lineTotal:0};const up=c.unitPrice||0;
    const upDisplay=up; // unitPrice from server already includes decoration cost
    if(B._collapsed[it.id]===undefined) B._collapsed[it.id] = true;
    const collapsed = B._collapsed[it.id];
    return`<div class="icard">
      <div class="ich" style="cursor:pointer;display:grid;grid-template-columns:1fr auto 1fr;align-items:center;gap:8px" onclick="bTogCollapse(${it.id})">
        <div style="font-size:13px;font-weight:600;color:var(--gold)">${poStyleNum(it,i)}</div>
        <div style="text-align:center;font-size:11px;color:var(--ink3);white-space:nowrap">
          Edit Item Details <span style="display:inline-block;transition:transform .2s;transform:rotate(${collapsed?'0':'180'}deg)">⌄</span>
        </div>
        <div style="display:flex;gap:8px;align-items:center;justify-content:flex-end">
          <span style="font-family:'DM Mono',monospace;font-size:14px;font-weight:700;color:var(--gold)">${q} Units</span>
          ${(()=>{
            const unlocked = window._adminMode || !!B.gateEmail || !!(B.customer && B.customer.email);
            if (unlocked) {
              return upDisplay>0?`<span style="font-family:'DM Mono',monospace;font-size:12px;font-weight:600;color:var(--gold)">$${upDisplay.toFixed(2)}/unit</span>`:'<span style="font-size:10px;color:var(--ink3)">pricing...</span>';
            }
            // Masked -- price updates behind the scenes as they configure the
            // item, but isn't revealed until they opt in. A brief pulse on
            // the button whenever the underlying price actually changes
            // shows their choices are having a real effect, without
            // showing the number itself.
            const changed = it._lastMaskedPrice !== undefined && it._lastMaskedPrice !== upDisplay;
            it._lastMaskedPrice = upDisplay;
            return `<button onclick="event.stopPropagation();bShowPricingGate()" class="${changed?'price-mask-btn':''}" style="background:rgba(184,146,42,0.12);border:1px solid var(--gold);border-radius:20px;color:var(--gold);font-size:11px;font-weight:600;padding:6px 12px;cursor:pointer;white-space:nowrap">🔒 Show Me My Price</button>`;
          })()}
          ${B.items.length>1?`<button class="gb-danger" onclick="event.stopPropagation();bRm(${it.id})">Remove</button>`:''}
        </div>
      </div>
      <div class="icb" style="display:${collapsed?'none':'block'}">
      <div class="bsec"><div class="bsh" onclick="bTogSec(${it.id},'igt')" style="cursor:pointer;display:flex;justify-content:space-between;align-items:center;user-select:none"><span class="bst">Item &amp; garment type</span>${bCadCardHtml(it)}<span style="font-size:9px;color:var(--ink3);transition:transform .2s;display:inline-block;transform:rotate(${bSecOpen(it.id,'igt')?'0':'180'}deg)">▲</span></div><div class="bsb" style="display:${bSecOpen(it.id,'igt')?'block':'none'}">
        <div class="igt-grid" style="display:flex;flex-wrap:wrap;gap:14px 22px;align-items:flex-start">
          <div>
            <div class="pills" style="gap:6px">
              <div>
                <div style="font-size:9px;letter-spacing:.1em;text-transform:uppercase;color:var(--ink3);margin-bottom:6px">Category</div>
                <div class="pill ${it.category?'sel':''}" id="cat-pill-${it.id}" style="cursor:pointer" onclick="event.stopPropagation();bOpenCategoryOnlyDD(${it.id}, this)">${it.category||'— select —'} &#9662;</div>
              </div>
              <div>
                <div style="font-size:9px;letter-spacing:.1em;text-transform:uppercase;color:var(--ink3);margin-bottom:6px">Gender</div>
                <div class="pill ${it.itemGender?'sel':''}" id="gender-pill-${it.id}" style="cursor:${it.category?'pointer':'default'};opacity:${it.category?'1':'0.4'}" onclick="${it.category?`event.stopPropagation();bOpenGenderOnlyDD(${it.id}, this)`:''}">${it.itemGender?(({GenderNeutral:'Gender Neutral',Unisex:'Unisex'})[it.itemGender]||it.itemGender):'— select —'} &#9662;</div>
              </div>
            </div>
            ${it.useEx?`<div style="margin-top:8px"><select style="width:100%;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.12);border-radius:6px;padding:8px 10px;color:var(--white);font-size:12px;outline:none" onchange="bSP(${it.id},'exCode',this.value);bRI()">
              <option value="">— select style —</option>
              ${Object.entries(EP).map(([k,v])=>`<option value="${k}" ${it.exCode===k?'selected':''}>${k} — ${ED[k]} ($${v})</option>`).join('')}
            </select></div>`:''}
          </div>
          ${!it.useEx?`<div>
            <div style="font-size:9px;letter-spacing:.1em;text-transform:uppercase;color:var(--ink3);margin-bottom:6px">Style</div>
            <div class="pills">
              <div class="pill ${it.gt?'sel':''}" id="style-pill-${it.id}" style="cursor:pointer" onclick="event.stopPropagation();bOpenStyleOnlyDD(${it.id}, this)">${it.gt||'— select —'} &#9662;</div>
            </div>
          </div>
          <div>
            <div style="font-size:9px;letter-spacing:.1em;text-transform:uppercase;color:var(--ink3);margin-bottom:6px">Colour</div>
            <div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap">
              ${it.colour?`<div style="display:flex;align-items:center;gap:6px;background:rgba(255,255,255,0.04);border:1px solid rgba(255,255,255,0.1);border-radius:20px;padding:4px 10px 4px 6px;cursor:pointer" onclick="bOpenPantone(${it.id})">
                <div style="width:16px;height:16px;border-radius:50%;background:${it.colour.hex};border:1px solid rgba(255,255,255,0.2);flex-shrink:0"></div>
                <span style="font-size:11px;color:var(--white);white-space:nowrap">${it.colour.name}</span>
              </div>`:`<div class="pill" style="background:rgba(212,164,76,0.1);cursor:pointer;border:1px dashed var(--gold);color:var(--gold)" onclick="bOpenPantone(${it.id})">Pick colour</div>`}
            </div>
          </div>
          <div>
            <div style="font-size:9px;letter-spacing:.1em;text-transform:uppercase;color:var(--ink3);margin-bottom:6px">Style CAD</div>
            ${bCadPillHtml(it)}
          </div>`:''}
        </div>
        ${bDesignDetailsHtml(it)}
      </div></div>
      ${!it.useEx?`
      <div class="bsec"><div class="bsh" onclick="bTogSec(${it.id},'fab')" style="cursor:pointer;display:flex;justify-content:space-between;align-items:center;user-select:none"><span class="bst">Fabric &amp; weight<span style="display:block;font-size:9px;font-weight:400;text-transform:none;color:var(--gold2);opacity:0.85;margin-top:2px">Add, remove, or adjust the yarn blend of this item's fabric</span></span><span style="font-size:9px;color:var(--ink3);transition:transform .2s;display:inline-block;transform:rotate(${bSecOpen(it.id,'fab')?'0':'180'}deg)">▲</span></div><div class="bsb" style="display:${bSecOpen(it.id,'fab')?'block':'none'}">
        ${(()=>{
          bEnsureFabrics(it);
          const iid=it.id;
          // Column header row
          const hdr=`<div class="fab-hdr" style="display:grid;grid-template-columns:minmax(max-content,1.4fr) minmax(0,1.2fr) minmax(0,0.85fr) minmax(0,0.95fr) 22px;gap:3px;align-items:center;padding:0 11px 5px 11px;margin-bottom:4px">
            <div style="font-size:8px;letter-spacing:.1em;text-transform:uppercase;color:var(--ink3);white-space:nowrap">Fabric / Colour</div>
            <div style="font-size:8px;letter-spacing:.1em;text-transform:uppercase;color:var(--ink3)">Yarn Content</div>
            <div style="font-size:8px;letter-spacing:.1em;text-transform:uppercase;color:var(--ink3)">Construction</div>
            <div style="font-size:8px;letter-spacing:.1em;text-transform:uppercase;color:var(--ink3)">Weight</div>
            <div></div>
          </div>`;
          // Group fabrics by usage -- a blend is ONE physical fabric (one
          // construction, one weight, milled as a single textile) that
          // happens to contain multiple fibre types, not multiple separate
          // fabrics each with their own construction/weight. Construction
          // and weight are shown/edited ONCE per group, on the header row.
          const usageOrder=[];
          it.fabrics.forEach(f=>{const u=f.usage||'Self / Body';if(!usageOrder.includes(u))usageOrder.push(u);});
          const groups=usageOrder.map((usage,gLabel)=>({
            usage, groupLabel: gLabel+1,
            members: it.fabrics.map((f,fi)=>({f,fi})).filter(x=>(x.f.usage||'Self / Body')===usage)
          }));
          const blendPicker=(usage,dd)=>{
            const inGroupIdx=it.fabrics.map((f,fi)=>({f,fi})).filter(x=>(x.f.usage||'Self / Body')===usage).map(x=>x.fi);
            const existing=it.fabrics.map((f,fi)=>({f,fi})).filter(x=>!inGroupIdx.includes(x.fi));
            const pickDD=(fn)=>`<div style="padding:6px 14px;font-size:12px;cursor:pointer;color:var(--white)" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="bAddBlendFabric(${iid},'${usage}','${fn}');mvfaCloseDD(this.parentNode)">${fn}</div>`;
            const inThis=it.fabrics.filter(f=>(f.usage||'Self / Body')===usage).map(f=>f.name);
            let quick=bFabPool(it).filter(n=>!inThis.includes(n));
            quick=[...quick.filter(n=>FAB_STRETCH.includes(n)),...quick.filter(n=>!FAB_STRETCH.includes(n))];
            if(!quick.some(n=>FAB_STRETCH.includes(n))&&!inThis.some(n=>FAB_STRETCH.includes(n)))quick.unshift('Spandex');
            const existingHtml = quick.length ? `<div style="padding:4px 14px 2px;font-size:9px;letter-spacing:.1em;text-transform:uppercase;color:var(--gold);margin-top:2px">Blend in</div>${quick.map(pickDD).join('')}` : '';
            const newHtml = Object.entries(FAB_GROUPS).map(([grp,itms])=>`<div style="padding:4px 14px 2px;font-size:9px;letter-spacing:.1em;text-transform:uppercase;color:var(--gold);border-top:1px solid rgba(255,255,255,0.06);margin-top:2px">${grp}</div>${itms.map(fn=>`<div style="padding:6px 14px;font-size:12px;cursor:pointer;color:var(--white)" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="bAddBlendFabric(${iid},'${usage}','${fn}');mvfaCloseDD(this.parentNode)">${fn}</div>`).join('')}`).join('');
            return `<div style="display:none;position:absolute;top:100%;left:0;z-index:999;background:#1a1a18;border:1px solid rgba(255,255,255,0.15);border-radius:8px;padding:6px 0;min-width:220px;margin-top:4px;box-shadow:0 8px 24px rgba(0,0,0,0.5);max-height:260px;overflow-y:auto">${existingHtml}${newHtml}</div>`;
          };
          const sameAsHtml=(usage)=>{
            const others=groups.filter(g=>g.usage!==usage);
            if(!others.length)return '';
            const label=g=>g.members.map(m=>m.f.name+((g.members.length>1&&m.f.blendPct!=null)?' '+m.f.blendPct:'')).join(' / ');
            return `<div style="padding:4px 14px 2px;font-size:9px;letter-spacing:.1em;text-transform:uppercase;color:var(--gold);margin-top:2px">Same blend as</div>`+others.map(g=>`<div style="padding:6px 14px;font-size:12px;cursor:pointer;color:var(--white)" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="bCopyBlend(${iid},'${g.usage}','${usage}');mvfaCloseDD(this.parentNode)">${label(g)} <span style="opacity:0.5">(${g.usage})</span></div>`).join('');
          };
          const groupsHtml = groups.map(g=>{
            const {usage, groupLabel, members} = g;
            const first = members[0].f, firstFi = members[0].fi;
            const isBlend = members.length>1;
            const atCap = members.length>=5;
            // Header row: name (+ Add Blend trigger if not blended yet),
            // used-for, construction, weight (shared across the group), remove.
            const nameCell = isBlend
              ? bBlendRefHtml(it,usage,members)
              : `<div style="display:flex;align-items:center;background:rgba(255,255,255,0.07);border-radius:20px;height:30px;overflow:visible">
                  <div style="position:relative;flex:1;min-width:0;height:100%">
                    <div style="cursor:pointer;height:100%;display:flex;align-items:center;padding:0 0 0 12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--white);font-size:12px" onclick="mvfaOpenDD(this)">${first.name} ▾</div>
                    <div style="display:none;position:absolute;top:100%;left:0;z-index:999;background:#1a1a18;border:1px solid rgba(255,255,255,0.15);border-radius:8px;padding:6px 0;min-width:200px;margin-top:4px;box-shadow:0 8px 24px rgba(0,0,0,0.5);max-height:240px;overflow-y:auto">
                      ${sameAsHtml(usage)}${Object.entries(FAB_GROUPS_SOLO).map(([grp,itms])=>`<div style="padding:4px 14px 2px;font-size:9px;letter-spacing:.1em;text-transform:uppercase;color:var(--gold);border-top:1px solid rgba(255,255,255,0.06);margin-top:2px">${grp}</div>${itms.map(fn=>`<div style="padding:6px 14px;font-size:12px;cursor:pointer;color:var(--white)" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="bSetFabric(${iid},${firstFi},'name','${fn}');mvfaCloseDD(this.parentNode)">${fn}</div>`).join('')}`).join('')}
                    </div>
                  </div>
                  <span style="color:rgba(255,255,255,0.25);font-size:12px;padding:0 1px;flex-shrink:0">|</span>
                  <div style="position:relative;flex-shrink:0;height:100%">
                    <div style="cursor:pointer;height:100%;display:flex;align-items:center;padding:0 12px 0 6px;white-space:nowrap;color:var(--white);font-size:12px" onclick="mvfaOpenDD(this)" title="Add a blend to ${usage}">+ Add Blend ▾</div>
                    ${blendPicker(usage)}
                  </div>
                </div>`;
            const useDD=`<div style="position:relative">
              <div class="pill" style="background:rgba(255,255,255,0.06);cursor:pointer;white-space:nowrap;width:100%;text-align:left;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box" onclick="mvfaOpenDD(this)">${usage} ▾</div>
              <div style="display:none;position:absolute;top:100%;left:0;z-index:999;background:#1a1a18;border:1px solid rgba(255,255,255,0.15);border-radius:8px;padding:6px 0;min-width:140px;margin-top:4px;box-shadow:0 8px 24px rgba(0,0,0,0.5)">
                ${FAB_USAGES.map(u=>`<div style="padding:7px 14px;font-size:12px;cursor:pointer;color:var(--white)" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="bSetFabric(${iid},${firstFi},'usage','${u}');mvfaCloseDD(this.parentNode)">${u}</div>`).join('')}
              </div>
            </div>`;
            const conDD=`<div style="position:relative" title="${isBlend?'Applies to the whole blend -- one physical fabric':''}">
              <div class="pill" style="background:rgba(255,255,255,0.06);cursor:pointer;white-space:nowrap;width:100%;text-align:left;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box" onclick="mvfaOpenDD(this)">${(first.construction&&first.construction!=='Construction')?first.construction:'Construction'} ▾</div>
              <div style="display:none;position:absolute;top:100%;left:0;z-index:999;background:#1a1a18;border:1px solid rgba(255,255,255,0.15);border-radius:8px;padding:6px 0;min-width:180px;margin-top:4px;box-shadow:0 8px 24px rgba(0,0,0,0.5)">
                <div style="padding:7px 14px;font-size:12px;cursor:pointer;color:rgba(255,255,255,0.35)" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="bSetFabric(${iid},${firstFi},'construction','Construction');mvfaCloseDD(this.parentNode)">Construction</div>
                ${FAB_CONSTRUCTIONS.map(c=>`<div style="padding:7px 14px;font-size:12px;cursor:pointer;color:var(--white)" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="bSetFabric(${iid},${firstFi},'construction','${c}');mvfaCloseDD(this.parentNode)">${c}</div>`).join('')}
              </div>
            </div>`;
            const wtDD=`<div style="position:relative" title="${isBlend?'Applies to the whole blend -- one physical fabric':''}">
              <div class="pill" style="background:rgba(255,255,255,0.06);cursor:pointer;white-space:nowrap;width:100%;text-align:left;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box" onclick="mvfaOpenDD(this)">${FAB_WEIGHTS.find(w=>w.k===(first.weight||'mid'))?.l||'Mid (160–200gsm)'} ▾</div>
              <div style="display:none;position:absolute;top:100%;right:0;z-index:999;background:#1a1a18;border:1px solid rgba(255,255,255,0.15);border-radius:8px;padding:6px 0;min-width:200px;margin-top:4px;box-shadow:0 8px 24px rgba(0,0,0,0.5)">
                ${FAB_WEIGHTS.map(w=>`<div style="padding:7px 14px;font-size:12px;cursor:pointer;color:var(--white)" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="bSetFabric(${iid},${firstFi},'weight','${w.k}');mvfaCloseDD(this.parentNode)">${w.l}</div>`).join('')}
              </div>
            </div>`;
            const canRemoveHeader = !isBlend && it.fabrics.length>1;
            const removeBtn=`<button onclick="bRemFabric(${iid},${firstFi})" style="background:none;border:none;color:${canRemoveHeader?'rgba(255,255,255,0.45)':'rgba(255,255,255,0.15)'};cursor:${canRemoveHeader?'pointer':'default'};font-size:14px;padding:0;line-height:1;text-align:center" ${canRemoveHeader?'title="Remove fabric"':'title="Use the sub-row × to remove a blend component"'} ${canRemoveHeader?'':'onclick="event.preventDefault()"'}>${canRemoveHeader?'×':'—'}</button>`;
            const headerRow=`<div class="fab-row-grid" style="display:grid;grid-template-columns:minmax(max-content,1.4fr) minmax(0,1.2fr) minmax(0,0.85fr) minmax(0,0.95fr) 22px;gap:3px;align-items:center;padding:5px 0">
              ${(()=>{
                const isBody=usage==='Self / Body';
                const sw=(first.colour&&first.colour.hex)?first.colour:(isBody&&it.colour&&it.colour.hex?it.colour:null);
                const click=isBody?`bOpenPantone(${iid})`:`bOpenPantoneFab(${iid},${firstFi})`;
                const hex=sw?String(sw.hex):'';
                const lum=sw&&/^#[0-9a-f]{6}$/i.test(hex)?(parseInt(hex.slice(1,3),16)*0.299+parseInt(hex.slice(3,5),16)*0.587+parseInt(hex.slice(5,7),16)*0.114):0;
                const fg=sw?(lum>150?'#1a1a18':'#ffffff'):'var(--gold)';
                const nm=sw?String(sw.name||sw.hex).replace(/"/g,'&quot;'):'Pick Colour';
                const ulab=u=>u==='Self / Body'?'Body/Self':u;
                return `<div style="position:relative;min-width:0">
                <div style="display:flex;align-items:stretch;height:30px;border-radius:20px;overflow:hidden;border:1px solid var(--gold);width:max-content;max-width:100%">
                  <span onclick="event.stopPropagation();mvfaOpenDD(this.parentNode)" title="Change what this fabric is used for" style="background:var(--gold);color:#1a1a18;font-size:12px;font-weight:600;font-family:inherit;white-space:nowrap;display:flex;align-items:center;padding:0 8px 0 12px;cursor:pointer">${ulab(usage)}: ▾</span>
                  <span onclick="event.stopPropagation();${click}" title="${sw?nm:'Pick fabric colour'+(isBody?'':' (defaults to body colour)')}" style="min-width:0;display:flex;align-items:center;padding:0 12px;font-size:12px;font-family:inherit;white-space:nowrap;cursor:pointer;background:${sw?hex:'rgba(255,255,255,0.06)'};color:${fg};${sw?'':'border-left:1px dashed var(--gold)'}">${nm}</span>
                </div>
                <div style="display:none;position:absolute;top:100%;left:0;z-index:999;background:#1a1a18;border:1px solid rgba(255,255,255,0.15);border-radius:8px;padding:6px 0;min-width:140px;margin-top:4px;box-shadow:0 8px 24px rgba(0,0,0,0.5)">
                  ${FAB_USAGES.map(u=>`<div style="padding:7px 14px;font-size:12px;cursor:pointer;color:var(--white)" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="bSetFabric(${iid},${firstFi},'usage','${u}');mvfaCloseDD(this.parentNode)">${ulab(u)}</div>`).join('')}
                </div></div>`;
              })()}
              ${nameCell}${conDD}${wtDD}${removeBtn}
            </div>`;
            // Sub-rows: only when actually blended -- one compact row per
            // component, just name + %, since construction/weight already
            // live on the header (shared, not per-component).
            let subRows='';
            if (isBlend) {
              const groupTotal = members.reduce((s,mm,gi)=>s+(mm.f.blendPct!=null?mm.f.blendPct:bDefaultBlendPct(members.length,gi)),0);
              const pillsHtml = members.map((m,mi)=>{
                const f=m.f, fi=m.fi;
                const pct = f.blendPct!=null ? f.blendPct : bDefaultBlendPct(members.length, mi);
                return `<div style="position:relative;display:flex;align-items:stretch;height:28px;flex-shrink:0">
                  <div class="pill" style="background:rgba(255,255,255,0.05);cursor:pointer;white-space:nowrap;text-align:left;display:flex;align-items:center;overflow:hidden;padding:0;border-radius:20px 0 0 20px;border:1px solid var(--gold);border-right:none;margin:0" onclick="if(!event.target.closest('button'))mvfaOpenDD(this)">
                    <span style="padding:0 4px 0 12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:12px">${f.name} ▾</span>
                  </div>
                  <div style="display:none;position:absolute;top:100%;left:0;z-index:999;background:#1a1a18;border:1px solid rgba(255,255,255,0.15);border-radius:8px;padding:6px 0;min-width:200px;margin-top:4px;box-shadow:0 8px 24px rgba(0,0,0,0.5);max-height:240px;overflow-y:auto">
                    ${Object.entries(FAB_GROUPS).map(([grp,itms])=>`<div style="padding:4px 14px 2px;font-size:9px;letter-spacing:.1em;text-transform:uppercase;color:var(--gold);border-top:1px solid rgba(255,255,255,0.06);margin-top:2px">${grp}</div>${itms.map(fn=>`<div style="padding:6px 14px;font-size:12px;cursor:pointer;color:var(--white)" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="bSetFabric(${iid},${fi},'name','${fn}');mvfaCloseDD(this.parentNode)">${fn}</div>`).join('')}`).join('')}
                  </div>
                  <div style="display:flex;align-items:center;background:rgba(255,255,255,0.08);border:1px solid var(--gold);border-left:none;height:100%">
                    <button onclick="event.stopPropagation();bStepBlendPct(${iid},${fi},-1)" style="background:none;border:none;color:var(--white);cursor:pointer;font-size:13px;padding:0 6px;line-height:1">−</button>
                    <input type="number" min="0" max="100" value="${pct}" onclick="event.stopPropagation()" onchange="bSetBlendPct(${iid},${fi},parseInt(this.value))" style="width:32px;background:none;border:none;color:var(--gold);font-size:11px;font-weight:600;font-family:'DM Mono',monospace;text-align:center;outline:none;padding:0;-moz-appearance:textfield">%
                    <button onclick="event.stopPropagation();bStepBlendPct(${iid},${fi},1)" style="background:none;border:none;color:var(--white);cursor:pointer;font-size:13px;padding:0 6px;line-height:1">+</button>
                  </div>
                  <button onclick="bRemFabric(${iid},${fi})" style="background:rgba(255,255,255,0.05);border:1px solid var(--gold);border-left:none;border-radius:0 20px 20px 0;color:rgba(255,255,255,0.5);cursor:pointer;font-size:12px;padding:0 8px;height:100%" title="Remove from blend">×</button>
                </div>`;
              }).join('');
              const trailingAdd = atCap ? '' : `<div style="position:relative;display:inline-block;flex-shrink:0">
                <div class="pill" style="background:rgba(212,164,76,0.1);cursor:pointer;border:1px dashed var(--gold);font-size:11px;white-space:nowrap" onclick="mvfaOpenDD(this)">+ Add Blend (${usage})</div>
                ${blendPicker(usage)}
              </div>`;
              const warn = groupTotal!==100 ? `<div style="font-size:9px;color:#e07a5f;margin-top:3px;padding-left:12px">⚠ ${usage} blend totals ${groupTotal}%, not 100%</div>` : '';
              subRows = `<div style="margin-top:6px;padding:8px 0 6px;border-top:1px dashed rgba(212,164,76,0.25)">${bBlendLineHtml(it,usage,members)}</div>${warn}`;
            }
            return `<div class="fab-card" style="background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.09);border-left:3px solid var(--gold);border-radius:10px;padding:6px 8px 4px;margin-bottom:10px">${headerRow}${subRows}</div>`;
          }).join('');
          const addFabBtn=`<div style="margin-top:10px">
            <div style="position:relative;display:inline-block">
              <div class="pill" style="background:rgba(255,255,255,0.05);cursor:pointer;border:1px dashed rgba(255,255,255,0.2)" onmouseover="this.style.borderColor='var(--gold)';this.style.color='var(--gold)'" onmouseout="this.style.borderColor='rgba(255,255,255,0.2)';this.style.color=''" onclick="mvfaOpenDD(this)">+ Add Fabric ▾</div>
              <div style="display:none;position:absolute;top:100%;left:0;z-index:999;background:#1a1a18;border:1px solid rgba(255,255,255,0.15);border-radius:8px;padding:6px 0;min-width:200px;margin-top:4px;box-shadow:0 8px 24px rgba(0,0,0,0.5);max-height:240px;overflow-y:auto">
                ${Object.entries(FAB_GROUPS_SOLO).map(([grp,itms])=>`<div style="padding:4px 14px 2px;font-size:9px;letter-spacing:.1em;text-transform:uppercase;color:var(--gold);border-top:1px solid rgba(255,255,255,0.06);margin-top:2px">${grp}</div>${itms.map(fn=>`<div style="padding:6px 14px;font-size:12px;cursor:pointer;color:var(--white)" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="bAddNewUsageFabric(${it.id},'${fn}');this.parentNode.parentNode.style.display='none'">${fn}</div>`).join('')}`).join('')}
              </div>
            </div>
          </div>`;
          return hdr + groupsHtml + addFabBtn;
        })()}
      </div></div>
      <div class="bsec"><div class="bsh" onclick="bTogSec(${it.id},'trm')" style="cursor:pointer;display:flex;justify-content:space-between;align-items:center;user-select:none"><span class="bst">Trims &amp; notions</span><span style="font-size:9px;color:var(--ink3);transition:transform .2s;display:inline-block;transform:rotate(${bSecOpen(it.id,'trm')?'0':'180'}deg)">▲</span></div><div class="bsb" style="display:${bSecOpen(it.id,'trm')?'block':'none'}">
        <div class="pills" style="flex-wrap:wrap;gap:6px;align-items:center">
          ${[{k:'frontZipper',l:'Front Zipper',qty:true},{k:'pocketZipper',l:'Pocket Zipper',qty:true},{k:'snaps',l:'Snaps',qty:true},{k:'buttons',l:'Buttons',qty:true},{k:'drawcord',l:'Drawcord',qty:false},{k:'grommets',l:'Grommets',qty:true},{k:'aglets',l:'Aglets',qty:true},{k:'elastic',l:'Elastic',qty:false}].map(t=>{
            const sel=it.trims.includes(t.k);
            const tqty=it.trimQty&&it.trimQty[t.k]?it.trimQty[t.k]:1;
            return `<div style="display:inline-flex;align-items:center;gap:0;margin-bottom:2px">
              <div class="pill ${sel&&!t.qty?'sel':''}" style="${t.qty&&sel?'background:rgba(255,255,255,0.05);border:1px solid var(--gold);border-right:none;color:var(--white);border-radius:20px 0 0 20px;margin:0;height:32px;box-sizing:border-box;padding-top:0;padding-bottom:0;display:flex;align-items:center':'border-radius:20px;margin:0'}" onclick="bTA(${it.id},'trims','${t.k}')">${t.l}</div>
              ${t.qty&&sel?`<div style="display:flex;align-items:center;background:rgba(255,255,255,0.08);border:1px solid var(--gold);border-left:1px solid rgba(212,164,76,0.35);border-radius:0;overflow:hidden;height:32px;box-sizing:border-box">
                <button onclick="bTrimQty(${it.id},'${t.k}',-1)" style="background:none;border:none;color:var(--white);padding:0 8px;cursor:pointer;font-size:15px;line-height:28px">−</button>
                <span style="font-size:11px;min-width:20px;text-align:center;font-family:'DM Mono',monospace">${tqty}</span>
                <button onclick="bTrimQty(${it.id},'${t.k}',1)" style="background:none;border:none;color:var(--white);padding:0 8px;cursor:pointer;font-size:15px;line-height:28px">+</button>
              </div><button onclick="bTA(${it.id},'trims','${t.k}')" title="Remove" style="background:rgba(255,255,255,0.08);border:1px solid var(--gold);border-left:none;border-radius:0 20px 20px 0;color:var(--white);padding:0 10px;cursor:pointer;font-size:13px;height:32px;box-sizing:border-box">×</button>`:''}
            </div>`;
          }).join('')}
          ${(it.customTrims&&it.customTrims.length)?it.customTrims.map(ct=>{
            const needsQty=['BUTTON','ZIPPER','HOOKS','GROMMETS','STUDS','SNAPS','RIVETS','HOOK AND EYE','BUCKLES','CLIPS'].includes(ct.label);
            const tqty=it.trimQty&&it.trimQty[ct.key]?it.trimQty[ct.key]:1;
            return `<div style="display:inline-flex;align-items:center;gap:0;margin-bottom:2px">
              <div class="pill ${needsQty?'':'sel'}" style="${needsQty?'background:rgba(255,255,255,0.05);border:1px solid var(--gold);border-right:none;color:var(--white);border-radius:20px 0 0 20px;margin:0;height:32px;box-sizing:border-box;padding-top:0;padding-bottom:0;display:flex;align-items:center':'border-radius:20px;margin:0'}" onclick="bRemCT(${it.id},'${ct.key}')">${ct.label}${needsQty?'':' ×'}</div>
              ${needsQty?`<div style="display:flex;align-items:center;background:rgba(255,255,255,0.08);border:1px solid var(--gold);border-left:1px solid rgba(212,164,76,0.35);border-radius:0;overflow:hidden;height:32px;box-sizing:border-box">
                <button onclick="bTrimQty(${it.id},'${ct.key}',-1)" style="background:none;border:none;color:var(--white);padding:0 8px;cursor:pointer;font-size:15px;line-height:28px">−</button>
                <span style="font-size:11px;min-width:20px;text-align:center;font-family:'DM Mono',monospace">${tqty}</span>
                <button onclick="bTrimQty(${it.id},'${ct.key}',1)" style="background:none;border:none;color:var(--white);padding:0 8px;cursor:pointer;font-size:15px;line-height:28px">+</button>
              </div><button onclick="bRemCT(${it.id},'${ct.key}')" title="Remove" style="background:rgba(255,255,255,0.08);border:1px solid var(--gold);border-left:none;border-radius:0 20px 20px 0;color:var(--white);padding:0 10px;cursor:pointer;font-size:13px;height:32px;box-sizing:border-box">×</button>`:''}
            </div>`;
          }).join(''):''}
          <div style="position:relative;display:inline-block;margin-bottom:2px">
            <div class="pill" style="cursor:pointer;background:rgba(255,255,255,0.05)" onclick="mvfaOpenDD(this)">+ Add trim ▾</div>
            <div style="display:none;position:absolute;top:100%;left:0;z-index:999;background:#1a1a18;border:1px solid rgba(255,255,255,0.15);border-radius:8px;padding:6px 0;min-width:180px;margin-top:4px;box-shadow:0 8px 24px rgba(0,0,0,0.5);max-height:220px;overflow-y:auto;overscroll-behavior:contain">
              ${['DRAWCORD','TWILL TAPE','WEBBING','BIAS TAPE','LACE','RIBBON','TAPE','BUTTON','ZIPPER','ELASTIC','MOBILON','RUBBER ELASTIC','HOOKS','GROMMETS','STUDS','SNAPS','RIVETS','HOOK AND EYE','BUCKLES','CLIPS'].map(opt=>{
                const k='ct_'+opt.toLowerCase().replace(/[^a-z]/g,'_');
                return `<div style="padding:7px 14px;font-size:12px;cursor:pointer;white-space:nowrap;color:var(--white)" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="bAddCT(${it.id},'${k}','${opt}');mvfaCloseDD(this.parentNode)">${opt}</div>`;
              }).join('')}
            </div>
          </div>
        </div>
      </div></div>
      <div class="bsec"><div class="bsh" onclick="bTogSec(${it.id},'lbl')" style="cursor:pointer;display:flex;justify-content:space-between;align-items:center;user-select:none"><span class="bst">Labels &amp; branding</span><span style="font-size:9px;color:var(--ink3);transition:transform .2s;display:inline-block;transform:rotate(${bSecOpen(it.id,'lbl')?'0':'180'}deg)">▲</span></div><div class="bsb" style="display:${bSecOpen(it.id,'lbl')?'block':'none'}">
        <div class="pills" style="flex-wrap:wrap;gap:6px">
          ${[{k:'woven',l:'Woven label'},{k:'heatTransfer',l:'Heat transfer'},{k:'hangtag',l:'Hang tag'},{k:'polyBag',l:'Poly bag'}].map(lb=>`<div class="pill ${it.lbls.includes(lb.k)?'sel':''}" onclick="bTA(${it.id},'lbls','${lb.k}')">${lb.l}</div>`).join('')}
          <div style="display:inline-flex;align-items:center;gap:0;margin-bottom:2px">
            <div class="pill" style="${it.brand.includes('emb')?'background:rgba(255,255,255,0.05);border:1px solid var(--gold);border-right:none;color:var(--white);border-radius:20px 0 0 20px;margin:0;height:32px;box-sizing:border-box;padding-top:0;padding-bottom:0;display:flex;align-items:center':'border-radius:20px;margin:0'}" onclick="bTA(${it.id},'brand','emb')">Embroidery</div>
            ${it.brand.includes('emb')?`<div style="display:flex;align-items:center;background:rgba(255,255,255,0.08);border:1px solid var(--gold);border-left:1px solid rgba(212,164,76,0.35);border-radius:0;overflow:hidden;height:32px;box-sizing:border-box">
              <button onclick="bEmbStitchQty(${it.id},-1)" style="background:none;border:none;color:var(--white);padding:0 8px;cursor:pointer;font-size:15px;line-height:28px">−</button>
              <input type="number" value="${it.embStitches}" min="1000" step="1000" onchange="bEmbStitchSelect(${it.id},this.value)" style="width:72px;background:none;border:none;color:var(--white);font-size:11px;font-family:'DM Mono',monospace;text-align:center;outline:none" title="Stitch count -- type directly or use +/-, adjusts by 1,000">
              <span style="font-size:11px;padding-right:8px;white-space:nowrap">Stitches</span>
              <button onclick="bEmbStitchQty(${it.id},1)" style="background:none;border:none;color:var(--white);padding:0 8px;cursor:pointer;font-size:15px;line-height:28px">+</button>
            </div><button onclick="bTA(${it.id},'brand','emb')" title="Remove" style="background:rgba(255,255,255,0.08);border:1px solid var(--gold);border-left:none;border-radius:0 20px 20px 0;color:var(--white);padding:0 10px;cursor:pointer;font-size:13px;height:32px;box-sizing:border-box">×</button>`:''}
          </div>
          <div style="display:inline-flex;align-items:center;gap:0;margin-bottom:2px">
            <div class="pill" style="${it.brand.includes('scr')?'background:rgba(255,255,255,0.05);border:1px solid var(--gold);border-right:none;color:var(--white);border-radius:20px 0 0 20px;margin:0;height:32px;box-sizing:border-box;padding-top:0;padding-bottom:0;display:flex;align-items:center':'border-radius:20px;margin:0'}" onclick="bTA(${it.id},'brand','scr')">Silkscreen</div>
            ${it.brand.includes('scr')?`<div style="display:flex;align-items:center;background:rgba(255,255,255,0.08);border:1px solid var(--gold);border-left:1px solid rgba(212,164,76,0.35);border-radius:0;overflow:hidden;height:32px;box-sizing:border-box">
              <button onclick="bScreenColourQty(${it.id},-1)" style="background:none;border:none;color:var(--white);padding:0 8px;cursor:pointer;font-size:15px;line-height:28px">−</button>
              <span style="font-size:11px;min-width:60px;text-align:center;font-family:'DM Mono',monospace">${it.screenColours||1} colour${(it.screenColours||1)>1?'s':''}</span>
              <button onclick="bScreenColourQty(${it.id},1)" style="background:none;border:none;color:var(--white);padding:0 8px;cursor:pointer;font-size:15px;line-height:28px">+</button>
            </div><button onclick="bTA(${it.id},'brand','scr')" title="Remove" style="background:rgba(255,255,255,0.08);border:1px solid var(--gold);border-left:none;border-radius:0 20px 20px 0;color:var(--white);padding:0 10px;cursor:pointer;font-size:13px;height:32px;box-sizing:border-box">×</button>`:''}
          </div>
          ${(it.brand||[]).filter(b=>b.startsWith('lbl_')||b.startsWith('crest_')).map(b=>{
            const isCrest=b.startsWith('crest_');
            const raw=b.replace(/^lbl_|^crest_/,'').replace(/_/g,' ');
            const label=raw.split(' ').map(w=>w.charAt(0).toUpperCase()+w.slice(1)).join(' ');
            return `<div class="pill sel" style="border-radius:20px" onclick="bTA(${it.id},'brand','${b}')">${isCrest?'🔰 ':'🏷️ '}${label} ×</div>`;
          }).join('')}
          <div style="position:relative;display:inline-block">
            <div class="pill" style="background:rgba(255,255,255,0.05);cursor:pointer" onclick="mvfaOpenDD(this)">+ Add Label ▾</div>
            <div style="display:none;position:absolute;top:100%;left:0;z-index:999;background:#1a1a18;border:1px solid rgba(255,255,255,0.15);border-radius:8px;padding:6px 0;min-width:210px;margin-top:4px;box-shadow:0 8px 24px rgba(0,0,0,0.5);max-height:260px;overflow-y:auto">
              ${['MAIN LABEL','BRAND LABEL','SIZE LABEL','CARE CONTENT LABEL','FLAG LABEL','MANUFACTURER CODE','LOT NUMBER LABEL','SPECIAL LABEL','BARCODE TICKET','MANHATTAN FOLD LABEL','MITRE LABEL','LOOP LABEL','END FOLD LABEL'].map(opt=>{const k='lbl_'+opt.toLowerCase().replace(/[^a-z]/g,'_');return `<div style="padding:7px 14px;font-size:12px;cursor:pointer;color:var(--white);white-space:nowrap" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="bTA(${it.id},'brand','${k}');mvfaCloseDD(this.parentNode);">${opt}</div>`;}).join('')}
            </div>
          </div>
          <div style="position:relative;display:inline-block">
            <div class="pill" style="background:rgba(255,255,255,0.05);cursor:pointer" onclick="mvfaOpenDD(this)">+ Add Crest ▾</div>
            <div style="display:none;position:absolute;top:100%;left:0;z-index:999;background:#1a1a18;border:1px solid rgba(255,255,255,0.15);border-radius:8px;padding:6px 0;min-width:220px;margin-top:4px;box-shadow:0 8px 24px rgba(0,0,0,0.5);max-height:260px;overflow-y:auto">
              ${['SILK SCREEN','EMBROIDERY','HEAT TRANSFER','DIRECT TO GARMENT','SUBLIMATION','CHENILLE CREST','TACKLE TWILL','SONIC WELD','EMBOSSING','DEBOSSING','DIE STRUCK LOGOS','ETCHING','HOT STAMPING','PAD PRINTING','LASER ENGRAVING','ATTACHED PEWTER MEDALLIONS'].map(opt=>{
                const k='crest_'+opt.toLowerCase().replace(/[^a-z]/g,'_');
                // Silk Screen / Embroidery need their own colour-count or stitch-count
                // config (same as the main toggles) since a second placement (e.g. back
                // print) can have a different colour/stitch count than the front --
                // everything else is a flat per-unit rate, a plain pill is fine.
                const isMultiPlacement = (opt==='SILK SCREEN' || opt==='EMBROIDERY');
                const onclickAction = isMultiPlacement
                  ? `bAddExtraCrest(${it.id},'${opt==='SILK SCREEN'?'scr':'emb'}')`
                  : `bTA(${it.id},'brand','${k}')`;
                return `<div style="padding:7px 14px;font-size:12px;cursor:pointer;color:var(--white);white-space:nowrap" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="${onclickAction};mvfaCloseDD(this.parentNode);">${opt}</div>`;
              }).join('')}
            </div>
          </div>
        </div>
        ${(it.extraCrests||[]).length?`<div style="display:flex;flex-wrap:wrap;gap:0 8px;margin-top:6px">
          ${it.extraCrests.map((c,idx)=>c.type==='scr'?`
            <div style="display:inline-flex;align-items:center;gap:0;margin-bottom:2px">
              <div class="pill sel" style="border-radius:20px 0 0 20px;margin:0">Silkscreen #${idx+2}</div>
              <div style="display:flex;align-items:center;background:rgba(255,255,255,0.08);border:1px solid var(--gold);border-left:1px solid rgba(212,164,76,0.35);overflow:hidden;height:32px;box-sizing:border-box">
                <button onclick="bStepExtraCrest(${it.id},${c.id},-1)" style="background:none;border:none;color:var(--white);padding:0 8px;cursor:pointer;font-size:15px;line-height:28px">−</button>
                <span style="font-size:11px;min-width:60px;text-align:center;font-family:'DM Mono',monospace">${c.value} colour${c.value>1?'s':''}</span>
                <button onclick="bStepExtraCrest(${it.id},${c.id},1)" style="background:none;border:none;color:var(--white);padding:0 8px;cursor:pointer;font-size:15px;line-height:28px">+</button>
              </div>
              <button onclick="bRemoveExtraCrest(${it.id},${c.id})" style="background:rgba(255,255,255,0.08);border:1px solid var(--gold);border-left:none;border-radius:0 20px 20px 0;color:var(--white);padding:0 10px;cursor:pointer;font-size:13px;height:32px;box-sizing:border-box">×</button>
            </div>` : `
            <div style="display:inline-flex;align-items:center;gap:0;margin-bottom:2px">
              <div class="pill" style="background:rgba(255,255,255,0.05);border:1px solid var(--gold);border-right:none;color:var(--white);border-radius:20px 0 0 20px;margin:0;height:32px;box-sizing:border-box;padding-top:0;padding-bottom:0;display:flex;align-items:center">Embroidery #${idx+2}</div>
              <div style="display:flex;align-items:center;background:rgba(255,255,255,0.08);border:1px solid var(--gold);border-left:1px solid rgba(212,164,76,0.35);overflow:hidden;height:32px;box-sizing:border-box">
                <button onclick="bStepExtraCrest(${it.id},${c.id},-1000)" style="background:none;border:none;color:var(--white);padding:0 8px;cursor:pointer;font-size:15px;line-height:28px">−</button>
                <input type="number" value="${c.value}" min="1000" step="1000" onchange="bSetExtraCrest(${it.id},${c.id},this.value)" style="width:72px;background:none;border:none;color:var(--white);font-size:11px;font-family:'DM Mono',monospace;text-align:center;outline:none" title="Stitch count -- type directly or use +/-, adjusts by 1,000">
                <span style="font-size:11px;padding-right:8px;white-space:nowrap">Stitches</span>
                <button onclick="bStepExtraCrest(${it.id},${c.id},1000)" style="background:none;border:none;color:var(--white);padding:0 8px;cursor:pointer;font-size:15px;line-height:28px">+</button>
              </div>
              <button onclick="bRemoveExtraCrest(${it.id},${c.id})" style="background:rgba(255,255,255,0.08);border:1px solid var(--gold);border-left:none;border-radius:0 20px 20px 0;color:var(--white);padding:0 10px;cursor:pointer;font-size:13px;height:32px;box-sizing:border-box">×</button>
            </div>`).join('')}
        </div>`:''}
      </div></div>`:``}
      <div class="bsec"><div class="bsh" onclick="bTogSec(${it.id},'qty')" style="cursor:pointer;display:flex;justify-content:space-between;align-items:center;user-select:none"><span class="bst">Quantities by size</span><span style="font-size:10px;font-weight:600;color:${q<120?'#c0392b':'#2d9d5f'};transition:color .3s">MOQ 120${q>=120?' ✓':''}</span><span style="font-size:9px;color:var(--ink3);transition:transform .2s;display:inline-block;transform:rotate(${bSecOpen(it.id,'qty')?'0':'180'}deg)">▲</span></div><div class="bsb" style="display:${bSecOpen(it.id,'qty')?'block':'none'}">
      <div style="font-size:10px;color:var(--ink3);padding:8px 0;line-height:1.5">Quantities auto-balance to keep the total at or above the 120-unit minimum — reducing one size below what the minimum allows shifts the difference to a neighboring size rather than letting the total drop.</div>
        <div style="display:flex;flex-wrap:wrap;gap:10px">
          ${(it.sizeScale||B.sizes).map(sz=>{const sid='sqf_'+it.id+'_'+sz.replace(/[^a-zA-Z0-9]/g,'_');const canRemove=(it.sizeScale||B.sizes).length>1;return `<div style="display:flex;flex-direction:column;align-items:center;gap:4px" ${canRemove?`onmouseover="this.querySelector('.sz-remove-x').style.opacity='1'" onmouseout="this.querySelector('.sz-remove-x').style.opacity='0'"`:''}>
            <span style="font-size:10px;letter-spacing:.06em;color:var(--ink3);position:relative;display:inline-flex;align-items:center;gap:4px">${sz}${canRemove?`<span class="sz-remove-x" title="Remove ${sz} — its units transfer to a neighboring size" style="opacity:0;transition:opacity .15s;cursor:pointer;color:#c0392b;font-weight:700;font-size:11px" onclick="bRemoveSize(${it.id},'${sz}')">&times;</span>`:''}</span>
            <div style="display:flex;align-items:center;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.12);border-radius:6px;overflow:hidden">
              <button onclick="bUQ(${it.id},'${sz}',Math.max(0,(parseInt(document.getElementById('${sid}').value)||0)-10));document.getElementById('${sid}').value=Math.max(0,(parseInt(document.getElementById('${sid}').value)||0)-10)" style="background:none;border:none;border-right:1px solid rgba(255,255,255,0.1);color:var(--white);padding:5px 9px;cursor:pointer;font-size:15px;line-height:1">−</button>
              <input id="${sid}" type="number" min="0" step="10" value="${it.szs[sz]||0}" style="width:52px;background:none;border:none;color:var(--white);font-size:13px;font-family:'DM Mono',monospace;text-align:center;outline:none;padding:5px 0" oninput="bUQ(${it.id},'${sz}',this.value)">
              <button onclick="bUQ(${it.id},'${sz}',(parseInt(document.getElementById('${sid}').value)||0)+10);document.getElementById('${sid}').value=(parseInt(document.getElementById('${sid}').value)||0)+10" style="background:none;border:none;border-left:1px solid rgba(255,255,255,0.1);color:var(--white);padding:5px 9px;cursor:pointer;font-size:15px;line-height:1">+</button>
            </div>
          </div>`}).join('')}
          <div style="display:flex;flex-direction:column;align-items:center;gap:4px">
            <span style="font-size:10px;letter-spacing:.06em;color:var(--ink3)">Total</span>
            <div style="display:flex;align-items:center;justify-content:center;background:rgba(184,146,42,0.1);border:1px solid var(--gold);border-radius:6px;padding:5px 14px;min-height:33px">
              <span style="font-size:13px;font-weight:700;color:var(--gold);font-family:'DM Mono',monospace">${q} Units</span>
            </div>
          </div>
          <div style="position:relative;display:inline-flex;flex-direction:column;align-items:center;gap:4px">
            <span style="font-size:10px;color:transparent;letter-spacing:.06em">+sz</span>
            <div style="position:relative">
              <div style="display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,0.04);border:1px dashed rgba(255,255,255,0.22);border-radius:6px;padding:5px 12px;font-size:11px;color:var(--ink3);cursor:pointer;white-space:nowrap;min-height:33px" onmouseover="this.style.borderColor='var(--gold)';this.style.color='var(--gold)'" onmouseout="this.style.borderColor='rgba(255,255,255,0.22)';this.style.color='var(--ink3)'" onclick="mvfaOpenDD(this)">+ Add Size &#9662;</div>
              <div style="display:none;position:absolute;top:100%;left:0;z-index:999;background:#1a1a18;border:1px solid rgba(255,255,255,0.15);border-radius:8px;padding:6px 0;min-width:140px;margin-top:4px;box-shadow:0 8px 24px rgba(0,0,0,0.5)">
                ${((it.category||B.brand)==='Kidswear'?SD.Kidswear:SD.def).filter(sz=>!(it.sizeScale||B.sizes).includes(sz)).map(sz=>`<div style="padding:7px 14px;font-size:12px;cursor:pointer;color:var(--white)" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="(function(){var it2=B.items.find(function(i){return i.id===${it.id};});if(!it2)return;if(!it2.sizeScale)it2.sizeScale=(B.sizes||[]).slice();it2.sizeScale.push('${sz}');bSortSizeScale(it2);bResplitSizes(it2);bRI();})();mvfaCloseDD(this.parentNode)">${sz}</div>`).join('')}
                <div style="padding:7px 14px;font-size:12px;cursor:pointer;color:var(--ink3)" onmouseover="this.style.background='rgba(255,255,255,0.08)'" onmouseout="this.style.background=''" onclick="var s=prompt('Enter custom size:');if(s&&s.trim()){(function(){var it2=B.items.find(function(i){return i.id===${it.id};});if(!it2)return;if(!it2.sizeScale)it2.sizeScale=(B.sizes||[]).slice();it2.sizeScale.push(s.trim());bSortSizeScale(it2);bResplitSizes(it2);bRI();})();}mvfaCloseDD(this.parentNode)">+ Custom size...</div>
              </div>
            </div>
          </div>
        </div>
      </div></div>
      <div class="bsec"><div class="bsh" onclick="bTogSec(${it.id},'dsv')" style="cursor:pointer;display:flex;justify-content:space-between;align-items:center;user-select:none"><span class="bst">Design services</span><span style="font-size:9px;color:var(--ink3);transition:transform .2s;display:inline-block;transform:rotate(${bSecOpen(it.id,'dsv')?'0':'180'}deg)">▲</span></div><div class="bsb" style="display:${bSecOpen(it.id,'dsv')?'block':'none'}">
        <div class="pills" style="flex-wrap:wrap;gap:6px">
          ${DSV_ITEM.map(v=>`<div class="pill ${(it.design||[]).includes(v)?'sel':''}" onclick="bTogDesign(${it.id},'${v}')">${v}</div>`).join('')}
        </div>
      </div></div>
      ${(()=>{
        const itDesign=(it.design||[]);
        const unitPriceDisplay=up; // server unitPrice already includes decoration cost
        const designSvcTotal=itDesign.reduce((s,d)=>s+(DSP[d]||0),0);
        const lineTotal=(unitPriceDisplay*q)+DESIGN_FEE+designSvcTotal;
        const priceUnlockedTop = window._adminMode || !!B.gateEmail || !!(B.customer && B.customer.email);
        return up>0?`<div class="ccrd"><div class="ctit" onclick="bTogSec(${it.id},'bom')" style="cursor:pointer;display:flex;justify-content:space-between;align-items:center;user-select:none"><span>${(window._showBom||window._adminMode)?'Live BoM':'Item Summary'} · ${q} units</span><span style="font-size:9px;opacity:0.6;transition:transform .2s;display:inline-block;transform:rotate(${bSecOpen(it.id,'bom')?'0':'180'}deg)">▲</span></div><div style="display:${bSecOpen(it.id,'bom')?'block':'none'}">
          ${(c.breakdown||[]).map(b=>{
            const priceUnlocked = window._adminMode || !!B.gateEmail || !!(B.customer && B.customer.email);
            const showAmount = (window._showBom||window._adminMode) && priceUnlocked;
            return `<div class="crow"><span>${b.label}<span style="opacity:0.45;font-size:10px;margin-left:5px">${(b.detail||'').replace(/\s*×\s*[\d.]+m/,'')}</span></span><span class="cv">${showAmount?'$'+(b.amount||0).toFixed(2):''}</span></div>`;
          }).join('')}
          <div class="crow price" style="border-top:1px solid rgba(255,255,255,0.1);margin-top:6px;padding-top:8px"><span>Unit Price</span><span class="cv">${priceUnlockedTop?'$'+unitPriceDisplay.toFixed(2):'<span onclick=\'event.stopPropagation();bShowPricingGate()\' style=\'cursor:pointer;color:var(--gold)\'>🔒 Show Me My Price</span>'}</span></div>
          <div style="border-top:1px solid rgba(255,255,255,0.07);margin:8px 0 4px;font-size:9px;letter-spacing:.12em;text-transform:uppercase;color:var(--ink3);padding-top:6px">Item Design Services</div>
          <div class="crow" style="color:var(--gold2)"><span>Design Fee <span style="opacity:0.55;font-size:10px">Includes Tech Pack</span></span><span class="cv">${priceUnlockedTop?'$'+DESIGN_FEE.toFixed(2):''}</span></div>
          ${itDesign.length?itDesign.map(d=>`<div class="crow"><span style="color:rgba(255,255,255,0.65);font-size:11px">${d}</span><span class="cv" style="color:rgba(255,255,255,0.65)">${priceUnlockedTop?'$'+(DSP[d]||0).toFixed(2):''}</span></div>`).join(''):''}
          <div class="crow" style="color:var(--gold3);margin-top:4px"><span>Line total (${q} units)</span><span class="cv">${priceUnlockedTop?'$'+lineTotal.toFixed(2):'—'}</span></div>
        </div></div>`:'';
      })()}
    </div></div>`;
  }).join('');
  try{bDDRearm();}catch(e){}
  try{bYarnRestore();}catch(e){}
}

function bBuildQP(){
  const ref=`MVFA-${new Date().getFullYear()}-${String(Math.floor(Math.random()*9000)+1000)}`;
  B.ref=ref;let sub=0;
  const _buildQPSeenStyles = new Set();
  const rows=B.items.map((it,i)=>{
    const cv=B._costs&&B._costs[it.id]?B._costs[it.id]:{unitPrice:0,lineTotal:0};const up=cv.unitPrice||0;const q=bQty(it);
    const itDesign=(it.design||[]);
    const unitDisplay=up; // server unitPrice already includes decoration cost
    const designSvcTotal=itDesign.reduce((s,d)=>s+(DSP[d]||0),0);
    // Design fee is charged once per unique style (garment+fabric+weight)
    // across the whole collection, not once per item -- same rule as
    // everywhere else this gets calculated (itemLines, poComputeOrderPricing).
    const _styleKey = poStyleKey(it);
    const _chargeDesignFee = !_buildQPSeenStyles.has(_styleKey);
    _buildQPSeenStyles.add(_styleKey);
    const thisDesignFee = _chargeDesignFee ? DESIGN_FEE : 0;
    const lt=(unitDisplay*q)+thisDesignFee+designSvcTotal;
    sub+=lt;
    const nm=it.useEx&&it.exCode?it.exCode:(it.gt||it.styleDesc||it.name||'Item');
    const szS=Object.entries(it.szs||it.sizeQtys||{}).filter(([,v])=>v>0).map(([k,v])=>`${k}:${v}`).join(' · ');
    const colourObj = (it.colour && typeof it.colour === 'object') ? it.colour : null;
    const colourDisplay = colourObj ? colourObj.name : (it.colour || 'TBD');
    const colourHex = colourObj ? colourObj.hex : (it.colourHex || null);
    const itemRow=`<tr>
      <td style="color:var(--ink3);font-size:11px">${i+1}</td>
      <td><strong>${nm}</strong>${!it.useEx?`<br><small style="color:var(--ink3)">${it.fab||it.fabric||''}${colourHex?` · <span style="display:inline-flex;align-items:center;gap:3px"><span style="width:8px;height:8px;border-radius:50%;background:${colourHex};display:inline-block;border:1px solid rgba(0,0,0,0.2)"></span>${colourDisplay}</span>`:` · ${colourDisplay}`}</small>`:''}</td>
      <td style="font-size:10px;color:var(--ink3)">${szS||'—'}</td>
      <td class="r qm">${q}</td>
      <td class="r qm">$${unitDisplay.toFixed(2)}</td>
      <td class="r qm">$${fmt(unitDisplay*q)}</td>
    </tr>`;
    // Per-item design service sub-rows
    const designRows=[
      thisDesignFee>0?`<tr style="background:rgba(184,146,42,0.04)"><td colspan="4" style="padding:3px 12px;font-size:10px;color:var(--ink3);padding-left:20px">Design Fee (Includes Tech Pack)</td><td class="r qm" style="font-size:10px;color:var(--gold2)">$${thisDesignFee.toFixed(2)}</td><td class="r qm" style="font-size:10px;color:var(--ink3)"></td></tr>`:'',
      ...itDesign.map(d=>`<tr style="background:rgba(184,146,42,0.04)"><td colspan="4" style="padding:3px 12px;font-size:10px;color:var(--ink3);padding-left:20px">${d}</td><td class="r qm" style="font-size:10px;color:var(--gold2)">$${(DSP[d]||0).toFixed(2)}</td><td class="r qm" style="font-size:10px;color:var(--ink3)"></td></tr>`),
      `<tr style="background:rgba(184,146,42,0.08)"><td colspan="4" style="padding:4px 12px;font-size:10px;font-weight:600;color:var(--ink2);padding-left:20px">Line total (garment + design)</td><td colspan="2" class="r qm" style="font-size:11px;font-weight:700;color:var(--ink)">$${fmt(lt)}</td></tr>`,
    ].join('');
    return itemRow+designRows;
  }).join('');
  // Additional Design Services rows
  let adsTot=0;
  let adsRows='';
  if(B.ads&&B.ads.length){
    B.ads.forEach(d=>{adsTot+=(ADS_P[d]||0);});
    adsRows=B.ads.map(d=>`<tr><td colspan="4" style="color:var(--green2);font-size:11px">Design Service: ${d}</td><td class="r qm" colspan="2" style="color:var(--green2)"><strong>$${(ADS_P[d]||0).toLocaleString()}</strong></td></tr>`).join('');
    sub+=adsTot;
  }
  const qpProv=B._quoteProvince||'ON';
  const tax=sub*provTaxRate(qpProv),total=sub+tax,dep=total*.6,bal=total*.4;
  document.getElementById('b-qpreview').innerHTML=`<div class="qswrap">
    <div class="qsh"><div><div class="qslogo">MVFA Design House</div><div style="font-size:10px;color:rgba(255,255,255,0.4);margin-top:3px">${new Date().toLocaleDateString('en-CA',{year:'numeric',month:'long',day:'numeric'})}</div></div>
      <div style="text-align:right"><div class="qsbadge">QUOTATION</div><div style="font-family:'DM Mono',monospace;font-size:11px;color:rgba(255,255,255,0.5);margin-top:5px">${ref}</div></div></div>
    <table class="qtbl"><thead><tr><th>#</th><th>Item</th><th>Sizes</th><th class="r">Qty</th><th class="r">Unit price</th><th class="r">Total</th></tr></thead><tbody>${rows}${adsRows}</tbody></table>
    <div style="display:flex;justify-content:flex-end;align-items:center;gap:8px;margin:10px 0 -4px;font-size:11px;color:rgba(255,255,255,0.5)">
      <span>Tax province/territory:</span>
      <select id="qp-province" onchange="B._quoteProvince=this.value;bBuildQP();" style="padding:5px 8px;border-radius:5px;border:1px solid rgba(255,255,255,0.15);background:#1e1d1b;color:var(--white);font-size:11px">
        ${Object.keys(PROV_TAX).map(code=>`<option value="${code}" ${code===qpProv?'selected':''}>${PROV_TAX[code].label} — ${PROV_TAX[code].name} ${(PROV_TAX[code].rate*100).toFixed(PROV_TAX[code].rate*100%1===0?0:3)}%</option>`).join('')}
      </select>
    </div>
    <div class="qtots">
      <div class="qtr"><span>Subtotal</span><span class="qm">CAD$ ${fmt(sub)}</span></div>
      <div class="qtr"><span>${provTaxLabel(qpProv)}</span><span class="qm">CAD$ ${fmt(tax)}</span></div>
      <div class="qtr big"><span>Order Total</span><span class="qm">CAD$ ${fmt(total)}</span></div>
      <div class="qtr dep"><span>60% Deposit to start production</span><span class="qm">CAD$ ${fmt(dep)}</span></div>
      <div class="qtr" style="color:#4a9e78"><span>40% Balance on delivery</span><span class="qm">CAD$ ${fmt(bal)}</span></div>
    </div></div>`;
}

function bTogApprove(){B.approved=!B.approved;document.getElementById('b-apbox').classList.toggle('on',B.approved);document.getElementById('b-appbtn').disabled=!B.approved;}
function bTogLC(){B.lc=!B.lc;document.getElementById('b-lcbox').classList.toggle('on',B.lc);}

// ── SAMPLE ORDER FLOW ──────────────────────────────────────────────────────
function bStartSample(){
  const isMerch = B._poSource==='merch' && poLines && poLines.length;
  let html;

  if(isMerch){
    // Blank merch sample = same style + same colour as the first quoted line,
    // just one unit, at the middle size from that line's breakdown.
    const line = poLines[0];
    const midSize = pickMiddleSize(line.sizeQtys) || Object.keys(line.sizeQtys||{})[0] || '—';
    const specs = [
      {k:'Style', v: line.styleDesc||line.styleNum},
      {k:'Colour', v: line.colour||'TBD'},
      {k:'Decoration', v: (line.fabric&&line.fabric!=='Blanks Only')?line.fabric:'Blank — no decoration'},
      {k:'Sample size', v: `${midSize} × 1 unit`},
    ];
    html = specs.map(s =>
      `<div style="display:flex;justify-content:space-between;font-size:12px;padding:5px 0;border-bottom:1px solid rgba(255,255,255,0.05)">
        <span style="color:var(--ink3)">${s.k}</span>
        <span style="font-weight:500">${s.v}</span>
      </div>`
    ).join('');
  } else {
    // Build sample spec display from current builder state
    const specs = [];
    if(B.garments.length) specs.push({k:'Garment', v: B.garments.slice(0,2).join(', ')});
    if(B.fabrics.length)  specs.push({k:'Fabric',  v: B.fabrics[0]});
    if(B.sizes.length)    specs.push({k:'Size range', v: B.sizes.join(' · ')});
    if(B.design.length)   specs.push({k:'Decoration', v: B.design.join(', ')});
    if(B.items.length > 1){
      // FIX: previously only ever showed B.items[0] here, silently hiding
      // that a sample order actually covers multiple styles (and, before
      // the pricing fix above, was silently only charging for one of them).
      specs.push({k:'Styles in this sample order', v: `${B.items.length} styles — one sample fee each`});
      B.items.forEach((it, idx) => {
        specs.push({k:`Style ${idx+1}`, v: `${it.gt} — $${sampleTierPrice(it.gt)}`});
      });
    } else if(B.items.length){
      const it = B.items[0];
      specs.push({k:'Primary item', v: it.gt});
      specs.push({k:'Sample fabric', v: it.fab});
      specs.push({k:'Colourway', v: 'TBD — confirmed post-order'});
    }
    html = specs.map(s =>
      `<div style="display:flex;justify-content:space-between;font-size:12px;padding:5px 0;border-bottom:1px solid rgba(255,255,255,0.05)">
        <span style="color:var(--ink3)">${s.k}</span>
        <span style="font-weight:500">${s.v}</span>
      </div>`
    ).join('');
  }

  document.getElementById('sample-spec-display').innerHTML = html ||
    '<div style="font-size:12px;color:var(--ink3)">Complete builder steps to populate spec</div>';

  // Pre-fill email if customer already entered it
  const em = document.getElementById('cf-email');
  if(em && em.value) document.getElementById('sample-email').value = em.value;
  const addr = document.getElementById('cf-addr');
  if(addr && addr.value) document.getElementById('sample-addr').value = addr.value;

  bUpdateSamplePricing();
  bShow(13);
}

// Sample-order tiering for full-production (non-merch) quotes: simple,
// flat-construction garments sample cheaper than multi-panel/tailored
// garments. Based on the first item in the built collection (B.items[0].gt),
// since that's what a sample order is always built against. Marcus should
// review/adjust this list -- it's a reasonable manufacturing-complexity
// default, not a definitive classification, and a few (Hoodies, Shorts)
// are genuinely borderline depending on construction detail.
//
// PLANNED: these two flat values ($500/$1000) are meant to eventually be
// managed through the CMT Rate Editor / quote_constants system (varying
// $250-$1250 by complexity), the same backend fetchItemPrice() already
// reads from for regular bulk pricing -- letting Marcus adjust sample
// pricing the same way he adjusts everything else, without touching
// this file. Seeded here at the current flat values in the meantime,
// since that integration needs the actual CMT backend/schema to build
// correctly rather than guessing at it.
const SIMPLE_SAMPLE_GARMENTS = ['T-Shirts','Tank Tops','Long Sleeves','Polo Shirts',
  'Sweatshirts','Hoodies','Beanies','Caps','Hats','Socks','Underwear','Tote Bags',
  'Bibs','Blankets','Sleep Sacks','Scrub Tops'];
function sampleTierPrice(garmentType){
  return SIMPLE_SAMPLE_GARMENTS.includes(garmentType) ? 500 : 1000;
}

// Blanks/Merch orders run at much lower unit prices than a full custom collection,
// so the sample fee scales down with a floor — see merchSamplePrice(). Custom
// collection orders now tier by garment complexity — see sampleTierPrice().
function bUpdateSamplePricing(){
  const isMerch = B._poSource==='merch' && poLines && poLines.length;
  B._sampleIsMerch = !!isMerch;
  let price=1000, credit=500;
  let perStyleLines = []; // [{garmentType, price}] -- one entry per style, used by bSubmitSample for real per-style line items
  if(isMerch){
    const avgUnit = poLines.reduce((s,l)=>s+(parseFloat(l.price)||0),0)/poLines.length;
    price = merchSamplePrice(avgUnit);
    credit = merchSampleCredit(price);
  } else {
    // FIX: this used to only ever look at B.items[0], so a collection with
    // 2-3 different garment styles still only ever charged for ONE sample
    // regardless of how many styles were actually being sampled. Now
    // charges one line per style, matching what a real sample order should
    // be -- confirmed as a real undercharging bug, not just a display issue.
    if (B.items && B.items.length) {
      perStyleLines = B.items.map(it => ({ garmentType: it.gt, price: sampleTierPrice(it.gt) }));
    } else if (B.garments && B.garments.length) {
      perStyleLines = B.garments.map(g => ({ garmentType: g, price: sampleTierPrice(g) }));
    } else {
      perStyleLines = [{ garmentType: '', price: 1000 }];
    }
    price = perStyleLines.reduce((s, l) => s + l.price, 0);
    credit = price/2;
  }
  B._samplePrice = price; B._sampleCredit = credit; B._samplePerStyleLines = perStyleLines;
  const set=(id,v)=>{const el=document.getElementById(id);if(el)el.textContent=v;};
  if (!isMerch && perStyleLines.length > 1) {
    set('sample-line1-label', `Sample production + tech pack (${perStyleLines.length} styles)`);
  } else {
    set('sample-line1-label', isMerch ? 'Blank sample + setup' : 'Sample production + tech pack');
  }
  set('sample-line1-amt', `$${price.toFixed(2)}`);
  set('sample-credit-amt', `−$${credit.toFixed(2)}`);
  set('sample-total-amt', `$${price.toFixed(2)} CAD`);
  const btn=document.getElementById('sample-submit-btn');
  if(btn)btn.textContent=`Proceed to Payment — $${price.toLocaleString()} →`;
  const note=document.getElementById('sample-credit-note');
  if(note){
    note.style.display='block';
    if(isMerch){
      note.textContent=`$${credit.toFixed(2)} credited toward a production order over $1,500.`;
    } else {
      // Confirmed: 50% credit, conditional on the resulting bulk order
      // (sample or full production) being $2,500+ within 90 days.
      note.textContent=`$${credit.toFixed(2)} credited toward your order — applies to bulk orders of $2,500 or more, placed within 90 days.`;
    }
  }
}

function bSubmitSample(){
  const addr  = document.getElementById('sample-addr').value.trim();
  const email = document.getElementById('sample-email').value.trim();
  if(!addr)  { toast('Please enter your shipping address'); return; }
  if(!email || !email.includes('@')) { toast('Please enter a valid email'); return; }
  B.shipTo = addr; B.customer = Object.assign({}, B.customer||{}, {addr: addr});
  bMktRecord('mkt-sample', email, (B.customer&&B.customer.contact)||'', 'sample_order');
  const sampleRef = `SMPL-${new Date().getFullYear()}-${String(Math.floor(Math.random()*9000)+1000)}`;
  // FIX: was previously declared below (after sampleStyleNum, which already
  // referenced it) — a temporal-dead-zone ReferenceError that crashed this
  // function on every single call, before any draft order was ever created.
  const isMerch = B._sampleIsMerch;
  // The sample order itself still gets its own SMPL- reference for tracking,
  // but the line item's Style # should carry the REAL quote-derived style
  // number (e.g. ACME-TROUSERS-001) when this sample is for an existing
  // quote item, not a second generic placeholder — otherwise there's no
  // way to trace the sample back to the actual style it's a sample of.
  const sampleStyleNum = (!isMerch && B.items[0] && B.items[0].gt) ? poStyleNum(B.items[0], 0) : sampleRef;
  document.getElementById('b-sampleref').textContent = `Sample Ref: ${sampleRef}`;
  const price = B._samplePrice||1000;
  const credit = B._sampleCredit||500;
  const garment = isMerch
    ? (poLines&&poLines.length?poLines.map(l=>l.styleDesc).slice(0,2).join(', '):'Blank styles')
    : (B.garments.slice(0,2).join(', ') || 'TBD');
  const fabric  = isMerch ? '' : ((B.items[0]&&B.items[0].fabrics&&B.items[0].fabrics[0])?B.items[0].fabrics[0].name:(B.items[0]||{}).fab||B.fabrics[0]||'TBD');
  const creditNote = isMerch
    ? `$${credit.toFixed(2)} credited toward a production order over $1,500.`
    : `$${credit.toFixed(2)} bulk credit on conversion.`;

  // FIX: previously always sent exactly one hardcoded line item (built
  // from B.items[0] alone), so a sample order covering 2-3 different
  // styles still only ever charged for one -- a real undercharging bug.
  // Now builds one real line per style, matching bUpdateSamplePricing's
  // per-style total above.
  let sampleItems;
  if (isMerch) {
    sampleItems = [{
      styleNum: sampleStyleNum,
      styleDesc: `Sample — ${garment}`,
      fabric: fabric,
      colour: (B.items[0]&&B.items[0].colour)?B.items[0].colour.name:'TBD',
      price: price,
      totalQty: 1,
      sizeQtys: {'Sample':1}
    }];
  } else {
    const perStyle = (B._samplePerStyleLines && B._samplePerStyleLines.length) ? B._samplePerStyleLines : [{ garmentType: garment, price: price }];
    sampleItems = perStyle.map((line, idx) => {
      const it = (B.items && B.items[idx]) ? B.items[idx] : null;
      const styleNum = it ? poStyleNum(it, idx) : `${sampleRef}-${idx+1}`;
      const itemFabric = it ? ((it.fabrics && it.fabrics[0]) ? it.fabrics[0].name : (it.fab || fabric)) : fabric;
      return {
        styleNum: styleNum,
        styleDesc: `Sample — ${line.garmentType || (it ? it.gt : garment)}`,
        fabric: itemFabric,
        colour: (it && it.colour) ? it.colour.name : 'TBD',
        price: line.price,
        totalQty: 1,
        sizeQtys: {'M':1} // default Medium, matching real size vocabulary -- customer can request a different size by reply
      };
    });
  }

  // Trigger Shopify draft order for the sample via proxy
  if(window.MVFA_SHOPIFY){
    MVFA_SHOPIFY.handleQuoteApproval({
      ref: sampleRef,
      isSample: true,
      items: sampleItems,
      customer:{name:'',email,contact:'',phone:'',addr,city:'',country:'CA',province:'ON'},
      meta:{season:'',delivDate:'',terms:'prepaid',notes:`Sample order. Ship to: ${addr}. ${creditNote}`},
      totals:{sub:price,tax:price*provTaxRate('ON'),total:price*(1+provTaxRate('ON')),deposit:price*(1+provTaxRate('ON')),balance:0},
      notes:`Sample. Garment: ${garment}. ${fabric?'Fabric: '+fabric+'. ':''}Ship to: ${addr}. ${creditNote}`
    }).then(function(r){
      if(r&&r.success){
        toast('Sample order created — invoice sent to '+email);
      }
    });
  }

  // FIX: previously never saved to mvfa-quote-save.php at all -- a sample
  // created a Shopify draft order but no tracked saved_quotes record,
  // which is why it never showed up as "a new MVFA quote" in the admin
  // dashboard the way a regular quote submission does. Same quote, with
  // each item's quantity/price overridden to reflect the sample terms
  // (qty 1 @ Medium, sample-tier price instead of bulk price) -- matches
  // the actual quote structure rather than a separate generic order type.
  const sampleStateItems = (B.items || []).map((it, idx) => {
    const line = (B._samplePerStyleLines && B._samplePerStyleLines[idx]) ? B._samplePerStyleLines[idx] : { price: price };
    return Object.assign({}, it, { szs: {'M': 1}, frozenPrice: line.price });
  });
  fetch('https://api.mvfa.ca/mvfa-quote-save.php?action=save', {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({
      token: window._quoteResumeToken || '',
      state: Object.assign({}, B, {
        ref: sampleRef,
        // Keep who this customer is AND where to ship: this save reuses the quote's
        // token, so a bare customer here wiped the name and address from My Collections.
        customer: Object.assign({}, B.customer||{}, {email: email, addr: addr, brand: B.brandName || (B.customer&&B.customer.brand) || ''}),
        shipTo: addr,
        items: sampleStateItems,
        notes: `Sample order. Ship to: ${addr}. ${creditNote}`,
      }),
      step: 'sample-submitted',
      itemCount: sampleStateItems.length,
      estimatedTotal: price,
    })
  }).then(function(r){ return r.json(); }).then(function(saveData){
    _cachedQuotes = null;
    if (saveData && saveData.success && saveData.token) {
      window._quoteResumeToken = saveData.token;
      _rememberToken(saveData.token);
    }
  }).catch(function(){ /* Shopify order + email are the real backstop if this save fails */ });

  // Always notify via email as well
  fetch('https://api.mvfa.ca/mvfa-notify.php',{
    method:'POST', headers:{'Content-Type':'application/json'}, mode:'cors',
    body:JSON.stringify({type:'sample',ref:sampleRef,customer:{email,shipTo:addr},garment,fabric,sizes:B.sizes,amount:price,credit:credit,isMerch:isMerch})
  }).catch(()=>{});

  bShow(14);
  const msgEl=document.getElementById('b-sample-success-msg');
  if(msgEl){
    msgEl.textContent = isMerch
      ? `Your blank sample is in the queue and will ship within 1–2 weeks. $${credit.toFixed(2)} has been noted and will be applied automatically to a production order over $1,500.`
      : `Your sample is in the queue. Marcus will confirm within 1 business day and your garment will ship within 3–4 weeks. Your $${credit.toFixed(2)} bulk credit has been noted and will be applied to your bulk production order.`;
  }
}

function bTogConsent(){B.consent=!B.consent;document.getElementById('b-conbox').classList.toggle('on',B.consent);}
async function bSubmit(){
  const fn=document.getElementById('cf-fn').value.trim(),ln=document.getElementById('cf-ln').value.trim();
  const em=document.getElementById('cf-email').value.trim(),br=document.getElementById('cf-brand').value.trim();
  if(!fn||!ln){toast('Please enter your name');return;}
  if(!em||!em.includes('@')){toast('Please enter a valid email');return;}
  if(!br){toast('Please enter your brand name');return;}
  if(!B.consent){toast('Please confirm consent');return;}
  bMktRecord('mkt-cf', em, fn, 'quote_submit');
  // Previously these fields were only ever read into local variables for
  // the submission payload -- never written back onto B.customer, so no
  // save (regardless of when it fired) could ever persist them. This is
  // why saved_quotes.builder_state.customer was always empty even after
  // fixing the step-4-only save issue.
  B.customer = {name:br, contact:`${fn} ${ln}`, email:em, phone:document.getElementById('cf-phone').value};
  B.notes = document.getElementById('cf-notes') ? document.getElementById('cf-notes').value : '';
  // Freeze price at submission -- once a quote is actually sent, its price
  // should never silently drift if quote_constants changes later (e.g. a
  // CMT rate fix meant for a different customer's quote). From here on,
  // this exact number is what gets shown on reload, until an admin
  // explicitly chooses to refresh it via Admin Edit.
  B.items.forEach(it => {
    const c = B._costs && B._costs[it.id];
    if (c) it.frozenPrice = parseFloat((c.unitPrice||0).toFixed(2));
  });
  bSaveQuoteProgress();
  const _submitSeenStyles = new Set();
  const itemLines=B.items.map((it,i)=>{
    const c=B._costs&&B._costs[it.id]?B._costs[it.id]:{unitPrice:0,lineTotal:0};const up=parseFloat((c.unitPrice||0).toFixed(2));const q=bQty(it);
    const sn=poStyleNum(it, i);
    const sd=it.gt ? it.gt.toUpperCase() : (it.name || 'EXISTING ITEM');
    // Per-item design services (Design Fee + any selected service add-ons) are charged
    // once per line, not per unit — fold into an effective per-unit price so the PO
    // total still reconciles, same total math as bBuildQP()'s quote PDF.
    // The flat Design Fee itself is only charged once per STYLE (garment +
    // fabric + weight) across the whole order — see poStyleKey/
    // poComputeOrderPricing, same rule applied consistently everywhere
    // else pricing gets calculated.
    const _styleKey = poStyleKey(it);
    const _chargeDesignFee = !_submitSeenStyles.has(_styleKey);
    _submitSeenStyles.add(_styleKey);
    const itDesign=(it.design||[]);
    const designSvcTotal=itDesign.reduce((s,d)=>s+(DSP[d]||0),0);
    const thisDesignFee=_chargeDesignFee?DESIGN_FEE:0;
    // it.fabrics only gets created if the customer opens the advanced
    // multi-fabric UI (bEnsureFabrics) — a simple single-fabric pick via
    // the basic Step 4 dropdown never populates it. Confirmed via a real
    // test order: it.fabrics was undefined, silently dropping fabric
    // content/weight from the checkout payload entirely. Fall back to
    // it.fab/it.wt (the simple picker's own fields) so this always has
    // a real value regardless of which picker the customer used.
    const primaryFabric = (it.fabrics && it.fabrics[0]) ? it.fabrics[0] : { name: it.fab || '', weight: it.wt || 'mid' };
    const fabricGSMLabel = FAB_WEIGHTS.find(w=>w.k===(primaryFabric.weight||'mid'))?.l || '';
    // price is purely the raw per-unit garment cost -- design fee and
    // design services are never blended in here. They're added as their
    // own explicit lines below instead (perItemDesignLines), matching
    // the same architecture already used for collection-level services
    // (adsLines) and the PO editor's own pricing (poComputeOrderPricing).
    return{id:Date.now()+Math.random(),styleNum:sn,styleDesc:sd,fabric:it.fab||'',fabricContent:primaryFabric.name||it.fab||'',fabricGSM:fabricGSMLabel,colour:it.colour?it.colour.name:'TBD',colourHex:it.colour?it.colour.hex:null,price:up,msrp:parseFloat((up*1.8).toFixed(2)),sizeQtys:{...it.szs},totalQty:q,fromBuilder:true,designServices:itDesign,designFee:thisDesignFee,designSvcTotal:designSvcTotal,_itemId:it.id};
  });
  // Per-item design fee and design services, each as their own explicit
  // line -- never blended into the garment's per-unit price. One line
  // per item that actually has a fee/service, so the customer sees
  // exactly what's being charged for design work, separate from the
  // garment cost itself.
  const perItemDesignLines = itemLines.filter(l => (l.designFee||0) > 0 || (l.designSvcTotal||0) > 0).map(l => {
    const parts = [];
    if (l.designFee > 0) parts.push('Design Fee');
    (l.designServices||[]).forEach(d => parts.push(d));
    return {
      id:Date.now()+Math.random(),
      styleNum:'DESIGN-FEE',
      styleDesc:`Design: ${parts.join(', ')} (${l.styleNum})`,
      fabric:'',colour:'—',colourHex:null,
      price:(l.designFee||0)+(l.designSvcTotal||0),
      msrp:0,
      sizeQtys:{'Service':1},
      totalQty:1,
      fromBuilder:true,
      isDesignService:true,
    };
  });
  // Additional Design Services (collection-level — Full Collection, Full Branding,
  // Brand Profile, Design Direction) were previously only ever shown in the Step 8
  // quote preview and silently dropped when the order was saved. Add them as their
  // own explicit PO lines so they're visible in My Collections and actually counted
  // in the order total, instead of vanishing after submission.
  const adsLines=(B.ads||[]).map(d=>({
    id:Date.now()+Math.random(),
    styleNum:'DESIGN-SVC',
    styleDesc:`Design Service: ${d}`,
    fabric:'',colour:'—',colourHex:null,
    price:ADS_P[d]||0,
    msrp:0,
    sizeQtys:{'Service':1},
    totalQty:1,
    fromBuilder:true,
    isDesignService:true,
  }));
  const lines=[...itemLines,...perItemDesignLines,...adsLines];
  const submitProv=document.getElementById('cf-province')?document.getElementById('cf-province').value:'ON';
  const sub=lines.reduce((s,l)=>s+l.price*l.totalQty,0);const tax=sub*provTaxRate(submitProv);const total=sub+tax;
  const order={id:Date.now(),ref:B.ref,status:'quote_sent',source:'builder',
    customer:{name:br,contact:`${fn} ${ln}`,email:em,phone:document.getElementById('cf-phone').value,addr:((document.getElementById('cf-addr')||{}).value||(B.customer&&B.customer.addr)||B.shipTo||''),city:((document.getElementById('cf-city')||{}).value||(B.customer&&B.customer.city)||''),country:(B.customer&&B.customer.country)||'CA',province:(B.customer&&B.customer.province&&B.customer.province!=='ON'&&!document.getElementById('cf-province'))?B.customer.province:submitProv},
    meta:{orderDate:new Date().toISOString().split('T')[0],delivDate:'',season:'FALL',terms:'60/40',currency:'CAD$',poRef:B.ref},
    lines,notes:document.getElementById('cf-notes').value,
    totals:{sub,tax,freight:0,total,deposit:total*.6,balance:total*.4},
    createdAt:new Date().toISOString()};
  B.designLines = poComputeDesignLines();
  // TEMP DIAGNOSTIC -- shows exactly what's about to be saved at the
  // ORIGINAL submission, for direct comparison against what Admin Edit
  // later loads back. If this already shows the blend/labels/trims
  // missing, the bug is upstream of any save -- something during
  // building never wrote these onto B.items in the first place, and
  // the correct-looking Preview/Email views must be reading from a
  // different, cached source (like B._costs) rather than B.items
  // itself. Remove once found and fixed.
  console.log('[MVFA DIAGNOSTIC] bSubmit about to save (ORIGINAL). Item detail:\n' + JSON.stringify((B.items||[]).map(it => ({
    id: it.id, gt: it.gt, category: it.category, itemGender: it.itemGender, fab: it.fab, fabrics: it.fabrics, colour: it.colour, lbls: it.lbls, brand: it.brand, trims: it.trims, trimQty: it.trimQty, customTrims: it.customTrims,
  })), null, 2));
  try {
    const saveR = await fetch('https://api.mvfa.ca/mvfa-quote-save.php?action=save', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({
        token: window._quoteResumeToken || '',
        // items must be raw BUILDER shape (B.items, untouched by the
        // itemLines/lines mapping above) — not PO-line shape — matching
        // every other save path. Saving PO-line shape here previously
        // corrupted the next reload (garment type/colour/design detail
        // all lost, since PO-line shape doesn't carry them).
        state: Object.assign({}, B, {ref: order.ref, customer: order.customer, items: B.items, meta: order.meta, notes: order.notes}),
        step: 'consult-submitted',
        itemCount: (lines||[]).length,
        estimatedTotal: total,
      })
    });
    _cachedQuotes = null; // same cache-bust as the other two save paths
    const saveData = await saveR.json();
    if (saveData.success && saveData.token) {
      window._quoteResumeToken = saveData.token;
      _rememberToken(saveData.token);
    }
  } catch(e) { /* if save genuinely fails, customer still sees confirmation below — email notify is the real backstop */ }
  // Upload inspiration images/links, if any were provided
  const cfLinksVal = document.getElementById('cf-links') ? document.getElementById('cf-links').value : '';
  let cfSavedFiles = [];
  if (cfFiles.length) {
    const cfd = new FormData();
    cfd.append('quote_ref', B.ref);
    cfd.append('email', em);
    cfd.append('source', 'quote');
    cfd.append('notes', document.getElementById('cf-notes').value || '');
    cfd.append('ref_links', cfLinksVal);
    for (let i=0; i<Math.min(cfFiles.length,5); i++) cfd.append('files[]', cfFiles[i]);
    try {
      const cr = await fetch('https://api.mvfa.ca/mvfa-upload.php', {method:'POST', mode:'cors', body:cfd});
      const cd = await cr.json();
      if (cd.files) cfSavedFiles = cd.files;
      else toast('Reference images could not be saved — please try again');
    } catch(e) { console.warn('Upload failed:', e); toast('Reference images could not be uploaded — please try again'); }
  }
  // mvfa-upload.php now returns files and links as separate arrays.
  // The earlier bSaveQuoteProgress() call fired before this upload
  // finished, so files/links were never actually persisted into
  // builder_state -- only emailed. Store them on B and save again now
  // that they're available, so they show up in the dashboard too.
  if (cfSavedFiles.length || cfLinksVal.trim() || (B.leadFiles||[]).length) {
    // MERGE with anything already saved on an earlier pass -- a second trip
    // through Step 9 (add item -> back to Step 7 -> resubmit) previously
    // had nothing in cfFiles, so earlier uploads were never carried forward.
    B.leadFiles = bLeadMerge(B.leadFiles, cfSavedFiles);
    B.leadRefLinks = bLeadMerge(B.leadRefLinks, cfLinksVal.split('\n').filter(l=>l.trim()));
    bSaveQuoteProgress();
  }
  // Send via server — no mailto, no mail app
  fetch('https://api.mvfa.ca/mvfa-notify.php',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    mode:'cors',
    body:JSON.stringify({
      type:'quote',
      ref:B.ref,
      customer:{name:`${fn} ${ln}`,brand:br,email:em,phone:document.getElementById('cf-phone').value},
      items:lines.map(l=>`${l.styleNum} — Qty:${l.totalQty} — $${l.price}/unit — Total:$${(l.price*l.totalQty).toFixed(2)}`),
      total:`CAD$ ${fmt(total)}`,
      deposit:`CAD$ ${fmt(total*.6)}`,
      notes:document.getElementById('cf-notes').value,
      delivDate:'',
      resumeToken:window._quoteResumeToken||'',
      files:B.leadFiles||cfSavedFiles,
      ref_links:B.leadRefLinks||cfLinksVal.split('\n').filter(l=>l.trim())
    })
  }).catch(()=>{});// silent fail — order is saved locally regardless
  cfFiles=[];cfRenderFiles();
  document.getElementById('b-succref').textContent=`Quote Reference: ${B.ref}`;
  bShow(11);updBadge();
  // Do NOT trigger Shopify payment here — customer reviews in My Collections first
}

async function viewGenPO(){B._poSource=null;const all=await getCollections();const o=all.find(x=>x.quote_ref===B.ref);if(o){openOrd(o.resume_token);}goView('po');}

function bShowConsultNudge(){
  // Basic validation first — same checks bSubmitLead would do
  var fn=document.getElementById('lf-fn')&&document.getElementById('lf-fn').value.trim();
  var ln=document.getElementById('lf-ln')&&document.getElementById('lf-ln').value.trim();
  var em=document.getElementById('lf-email')&&document.getElementById('lf-email').value.trim();
  if(!fn||!ln){toast('Please enter your name');return;}
  if(!em||!em.includes('@')){toast('Please enter a valid email');return;}
  if(!B.lc){toast('Please confirm you agree to be contacted');return;}
  var ov=document.getElementById('consult-nudge-overlay');
  if(ov){ov.style.display='flex';}
}
function bSubmitLeadDirect(){
  var fn=document.getElementById("lf-fn")&&document.getElementById("lf-fn").value.trim();
  var ln=document.getElementById("lf-ln")&&document.getElementById("lf-ln").value.trim();
  var em=document.getElementById("lf-email")&&document.getElementById("lf-email").value.trim();
  if(!fn||!ln){toast("Please enter your name");return;}
  if(!em||!em.includes("@")){toast("Please enter a valid email");return;}
  if(!B.lc){toast("Please confirm you agree to be contacted");return;}
  bSubmitLead();
}
async function bSubmitLead(){
  const fn=document.getElementById('lf-fn').value.trim(),em=document.getElementById('lf-email').value.trim();
  if(!fn){toast('Please enter your name');return;}
  if(!em||!em.includes('@')){toast('Please enter a valid email');return;}
  if(!B.lc){toast('Please confirm consent');return;}
  bMktRecord('mkt-lf', em, fn, 'inquiry_form');
  const ref=`MVFA-INQ-${new Date().getFullYear()}-${String(Math.floor(Math.random()*9000)+1000)}`;
  const ln=document.getElementById('lf-ln').value.trim();
  const br=document.getElementById('lf-brand').value||'';
  const phone=document.getElementById('lf-phone').value||'';
  const notes=document.getElementById('lf-notes')&&document.getElementById('lf-notes').value||'';
  const links=document.getElementById('lf-links')&&document.getElementById('lf-links').value||'';
  const retail=document.getElementById('lf-retail')&&document.getElementById('lf-retail').value||B.retail||'';
  const budget=document.getElementById('lf-budget')&&document.getElementById('lf-budget').value||B.budget||'';

  let savedFiles=[];

  // Upload files first if any
  if(lfFiles.length){
    const fd=new FormData();
    fd.append('quote_ref',ref);
    fd.append('email',em);
    fd.append('source','inquiry');
    fd.append('notes',notes);
    fd.append('ref_links',links);
    for(let i=0;i<Math.min(lfFiles.length,5);i++)fd.append('files[]',lfFiles[i]);
    try{
      const r=await fetch('https://api.mvfa.ca/mvfa-upload.php',{method:'POST',mode:'cors',body:fd});
      const d=await r.json();
      if(d.files)savedFiles=d.files;
    }catch(e){console.warn('Upload failed:',e);}
  }
  // mvfa-upload.php now returns files and links as separate arrays at the
  // source, so no filtering is needed here anymore.

  // Save as a real, trackable lead in saved_quotes -- previously this
  // path only ever sent an email, with zero record in the dashboard.
  // Treated as a "consultation/inquiry" lead, not a priced quote --
  // flagged via B.leadType, which lives in the JSON state blob, so no
  // schema change is needed for this to work.
  B.ref = ref;
  B.leadType = 'inquiry';
  B.customer = {name: br || (fn+' '+ln), contact: `${fn} ${ln}`, email: em, phone, brand: br};
  B.notes = notes;
  B.leadFiles = bLeadMerge(B.leadFiles, savedFiles);
  B.leadRefLinks = bLeadMerge(B.leadRefLinks, links.split('\n').filter(l=>l.trim()));
  B.designLines = poComputeDesignLines();
  try {
    const saveR = await fetch('https://api.mvfa.ca/mvfa-quote-save.php?action=save', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({
        token: window._quoteResumeToken || '',
        state: B,
        step: 'inquiry',
        itemCount: 0,
        estimatedTotal: 0,
      })
    });
    const saveData = await saveR.json();
    if (saveData.success && saveData.token) {
      window._quoteResumeToken = saveData.token;
      _rememberToken(saveData.token);
    }
  } catch(e) { /* if save fails, the email notification below is still the backstop */ }

  // Send notification with file links
  fetch('https://api.mvfa.ca/mvfa-notify.php',{
    method:'POST',headers:{'Content-Type':'application/json'},mode:'cors',
    body:JSON.stringify({
      type:'lead',ref,
      customer:{name:`${fn} ${document.getElementById('lf-ln').value||''}`,brand:br,email:em,phone:document.getElementById('lf-phone').value||''},
      brandType:B.brand,garments:B.garments,sizes:B.sizes,fabrics:B.fabrics,
      notes,budget,retail,
      files:savedFiles,
      ref_links:links.split('\n').filter(l=>l.trim())
    })
  }).catch(()=>{});

  document.getElementById('b-leadref').textContent=`Reference: ${ref}`;
  lfFiles=[];lfRenderFiles();
  bShow(12);
}

// ── PO MODULE ──
let poLines=[],poDepR=.6,poBalR=.4,poCtr=1,curOID=null,poSelGarment=null;

function poRenderGarmentPills(){
  const el=document.getElementById('po-garment-pills');
  if(!el)return;
  // Draw from builder's collection garments, fallback to GD.Fashion
  const garments=(B.garments&&B.garments.length)?B.garments:(GD[B.brand]||GD.Fashion);
  el.innerHTML=garments.map(g=>`<div class="pill${poSelGarment===g?' sel':''}" onclick="poSelectGarment('${g}')" style="cursor:pointer">${g}</div>`).join('')+
    `<div class="pill" style="cursor:pointer;background:rgba(0,0,0,0.05);border:1px dashed var(--border)" onclick="(function(){var g=prompt('Enter garment type:');if(g&&g.trim())poSelectGarment(g.trim());})()">+ Custom</div>`;
}

function poSelectGarment(g){
  poSelGarment=g;
  // Auto-fill style number and description
  const sn=poStyleNum({gt:g}, poLines.filter(l=>!l.isDesignService).length);
  document.getElementById('po-astyle').value=sn;
  document.getElementById('po-customdesc').value=g;
  // Auto-set size group
  const szgrp=document.getElementById('po-szgrp');
  if(szgrp){
    if(B.brand==='Kidswear')szgrp.value='baby';
    else szgrp.value='adult';
    poRenderSzs();
  }
  poRenderGarmentPills();
}

function poInit(){
  const t=new Date();document.getElementById('po-odate').value=t.toISOString().split('T')[0];
  const d=new Date(t);d.setDate(d.getDate()+90);document.getElementById('po-ddate').value=d.toISOString().split('T')[0];
  poRenderSzs();poUpd();poRenderGarmentPills();poRenderNextSteps();poUpdateBackButton();
}

function poUpdateBackButton(){
  const btn = document.getElementById('po-modify-btn');
  if(btn){
    const sub = btn.querySelector('span');
    if(B._poSource==='merch'){
      if(sub) sub.textContent = 'Pick more blanks or change colours/sizes';
    } else {
      if(sub) sub.textContent = 'Add items or change details';
    }
  }
  poUpdateCtaDetails();
}

function poUpdateCtaDetails(){
  const isMerch = B._poSource==='merch';
  const consultEl = document.getElementById('cta-consult-detail');
  if(consultEl){
    consultEl.innerHTML = isMerch
      ? (MERCH_CONSULT_PRICE>0 ? '$'+MERCH_CONSULT_PRICE+' · 30min · credited toward production' : '<strong style="font-size:1.15em">Free</strong> · 30-min call, no obligation')
      : '$100 · 1hr · <strong style="font-size:1.15em">100% credit</strong> within 90 days';
    const cb = consultEl.parentElement;
    if(cb && cb.firstChild && cb.firstChild.nodeType===3) cb.firstChild.nodeValue = isMerch ? '\n            Talk it through' : '\n            Book Consultation';
  }
  const sampleEl = document.getElementById('cta-sample-detail');
  if(sampleEl){
    // Simplified per explicit decision: this summary badge doesn't try to
    // show exact pricing (which varies by style count/type) -- the real,
    // detailed breakdown is shown on the actual sample-creation screen
    // (bStartSample/bUpdateSamplePricing) where it can be accurate.
    sampleEl.textContent = isMerch ? '$'+MERCH_SAMPLE_PRICE+' · half credited toward production' : '$500–$1,000 per style · some conditions apply';
  }
}

function poRenderNextSteps(){
  // The bottom row is back to a fixed 3 buttons (Approve & Produce,
  // Book Consultation, Order Sample) regardless of draft/paid status.
  // Order modification now lives directly on the PO itself (Add
  // Colour / Edit / Add New Item per line), not as a 4th button here.
  const container = document.getElementById('po-next-steps');
  if (!container) return;
  const existing = document.getElementById('po-modify-btn');
  if (existing) existing.remove();
  container.style.gridTemplateColumns = window.innerWidth<700 ? '1fr' : '1.3fr 1fr 1fr';
}

function poBackToSource(){
  if(B._poSource==='merch'){
    goView('builder');bShow('Merch');bMerchInit();
  } else {
    goView('builder');bShow(7);
  }
}

function loadPO(o){
  curOID=o.id;poLines=(o.lines||[]).map(l=>({...l}));
  // Merch lines saved before the style-number alignment carry the S&S id as their style number:
  // move it to the vendor reference and give the line the customer-style number (BRAND-CATEGORY-001)
  (function(){
    let seq=0;
    poLines.forEach((l,i)=>{
      if(l.isDesignService) return;
      if(l.styleDesc) l.styleDesc=String(l.styleDesc).replace(/\s*\(SS-\d+\)/i,'');
      if(/^SS-\d+/i.test(l.styleNum||'') || (l.merchImg && !l.vendorStyle)){
        const it=(B.items||[]).find(x=>x.id===l.id);
        const cat=(it&&it.merch&&it.merch.catLabel)||'Blank';
        if(/^SS-\d+/i.test(l.styleNum||'')) l.vendorStyle=l.styleNum;
        l.styleNum=poStyleNum({gt:cat}, i);
        if(!l.fabric||/^(TBD|)$/i.test(l.fabric)) l.fabric=merchBlankFabricGuess(cat);
      }
      seq++;
    });
  })();
  const sv=(id,v)=>{const el=document.getElementById(id);if(el){el.value=v||'';if(v)el.classList.add('imp');}};
  sv('po-cname',o.customer?.name);sv('po-addr',o.customer?.addr||B.shipTo);sv('po-city',o.customer?.city);
  const countryEl=document.getElementById('po-country');if(countryEl)countryEl.value=o.customer?.country||'CA';
  bUpdateProvinceOptions(o.customer?.province||'ON');
  sv('po-contact',o.customer?.contact);sv('po-phone',o.customer?.phone);sv('po-email',o.customer?.email);
  sv('po-ref',o.meta?.poRef||o.ref);sv('po-odate',o.meta?.orderDate);sv('po-ddate',o.meta?.delivDate);sv('po-notes',o.notes);
  document.getElementById('po-impbanner').style.display='block';
  window._poClickedApprove=false;
  if(!B.ship) B.ship={same:true};
  window._poConfirmShip=(o.meta&&o.meta.confirmedShip)||'';
  (function(){ const te=document.getElementById('po-terms'); if(!te) return;
    const want=(window._adminMode&&o.meta&&o.meta.terms)?o.meta.terms:'60/40';
    te.value=[].some.call(te.options,x=>x.value===want)?want:'60/40'; poUpdTerms(); })();
  const sb=document.getElementById('po-docstatus');sb.textContent='APPROVED → PO';sb.className='posb posb-approved';
  poRenderLines();poUpd();
  try{poRenderRefs();}catch(e){}
}

function poOnStyle(){
  const s=document.getElementById('po-astyle').value;
  document.getElementById('po-customrow').style.display=s==='CUSTOM'?'block':'none';
  if(EP[s]){document.getElementById('po-aprice').value=EP[s];document.getElementById('po-amsrp').value=(EP[s]*2).toFixed(2);document.getElementById('po-szgrp').value='baby';}
  poRenderSzs();
}
function poRenderSzs(){
  const g=document.getElementById('po-szgrp').value,szs=PSG[g];
  document.getElementById('po-szinputs').innerHTML=`<div style="display:grid;grid-template-columns:repeat(${szs.length},1fr);gap:3px;margin-bottom:8px">
    ${szs.map(s=>`<div class="pszh">${s}</div>`).join('')}
    ${szs.map(s=>`<input type="number" class="pszin" id="psz-${s.replace(/[^a-z0-9]/gi,'_')}" placeholder="0" min="0">`).join('')}
  </div>`;
}
function poGetSzs(){
  const g=document.getElementById('po-szgrp').value,szs=PSG[g],r={};
  szs.forEach(s=>{const el=document.getElementById(`psz-${s.replace(/[^a-z0-9]/gi,'_')}`);r[s]=el?parseInt(el.value)||0:0;});return r;
}
function poAddLine(){
  const sv=(document.getElementById('po-astyle').value||'').trim();
  const cv=(document.getElementById('po-acolour-text')?.value||'').trim()||'TBD';
  const pv=parseFloat(document.getElementById('po-aprice').value)||0;
  if(pv<=0){toast('Enter a price greater than 0');return;}
  const sn=sv||'CUSTOM';
  const sd=(document.getElementById('po-customdesc').value||'').trim()||sn;
  const sq=poGetSzs(),tq=Object.values(sq).reduce((a,b)=>a+b,0);
  if(tq===0){toast('Enter at least one size quantity');return;}
  poLines.push({id:Date.now(),styleNum:sn,styleDesc:sd,fabric:'',colour:cv,price:pv,msrp:parseFloat(document.getElementById('po-amsrp').value)||0,sizeQtys:sq,totalQty:tq,fromBuilder:false});
  poRenderLines();poUpd();toast(`Added ${sn} — ${cv} (${tq} units)`);
  document.querySelectorAll('.pszin').forEach(e=>e.value='');
  document.getElementById('po-aprice').value='';
  document.getElementById('po-amsrp').value='';
}
// Free-consultation confirmation: a real on-screen confirmation instead of a 3-second toast.
function mvfaConsultThanks(email){
  const old=document.getElementById('consult-thanks-modal'); if(old) old.remove();
  const m=document.createElement('div'); m.id='consult-thanks-modal';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,0.7);z-index:100004;display:flex;align-items:center;justify-content:center;padding:16px';
  m.innerHTML=`<div style="background:#fff;border-radius:14px;padding:28px 26px;max-width:400px;width:100%;text-align:center;box-shadow:0 12px 40px rgba(0,0,0,0.4)">
    <div style="font-size:34px;margin-bottom:8px">✅</div>
    <div style="font-weight:700;font-size:19px;color:var(--ink);margin-bottom:8px">Request received</div>
    <div style="font-size:13px;color:var(--ink2);line-height:1.6;margin-bottom:18px">We\u2019ve emailed <strong>${bCadEsc(email)}</strong> a link to pick a time for your free 30-minute call. Nothing to pay, and your draft stays saved in My Collections. (Check spam if it doesn\u2019t arrive in a minute or two.)</div>
    <button onclick="document.getElementById('consult-thanks-modal').remove()" style="background:var(--gold);color:var(--ink);border:none;border-radius:7px;font-size:14px;font-weight:700;cursor:pointer;padding:12px 20px;width:100%">Got it</button>
  </div>`;
  document.body.appendChild(m);
}
function mvfaBookConsultation(viaBuilderPriceGate){
  // Robust fallback chain -- this function is called from four different
  // pages with four different field ID sets (PO module, consult-nudge
  // modal shown from Step 10 lead form, Step 12 post-inquiry success
  // screen, and B.customer once already captured). Previously only
  // checked po-email/cf-email, so calls from the Step 10/12 nudge paths
  // were silently creating consultation invoices with a BLANK email.
  const _byId = id => { const el = document.getElementById(id); return el ? el.value.trim() : ''; };
  const email = _byId('po-email') || _byId('cf-email') || _byId('lf-email') || (B.customer && B.customer.email) || B.gateEmail || '';
  const lfName = (_byId('lf-fn') + ' ' + _byId('lf-ln')).trim();
  const name = _byId('po-cname') || _byId('cf-brand') || lfName || (B.customer && (B.customer.name || B.customer.contact)) || '';
  if(!email || !email.includes('@')){ toast('Please enter a valid email first'); return; }
  const ref=document.getElementById('po-ref')&&document.getElementById('po-ref').value||B.ref||
            ('CONSULT-'+new Date().getFullYear()+'-'+String(Math.floor(Math.random()*9000)+1000));
  const consultRef='CONSULT-'+ref;

  // Blanks/Merch orders keep their own separate, unchanged terms.
  const isMerch = B._poSource==='merch';
  // Full-production terms now split on HOW this was reached, not on
  // merch/non-merch: reaching this via the price-unlocked builder path
  // (Flow 1) gets the cheaper/shorter/fuller-credit terms; skipping the
  // price reveal entirely (Flow 3 -- Step 10 lead form, Step 12 nudge,
  // or the new Step 7 "skip email" button) costs more, runs longer, and
  // credits less, as a deliberate incentive to give email/see pricing
  // for free instead of paying more to skip that step.
  const price = isMerch ? MERCH_CONSULT_PRICE : (viaBuilderPriceGate ? 50 : 100);
  const duration = isMerch ? '30min' : (viaBuilderPriceGate ? '30min' : '1hr');
  const durationLabel = isMerch ? '30-Minute' : (viaBuilderPriceGate ? '30-Minute' : '1-Hour');
  const creditPct = 100; // flat 100% credit on consultations, for now -- simplified per explicit decision, previously tiered by an unreachable flow flag
  const creditAmt = price * (creditPct/100);
  const creditNote = `$${creditAmt.toFixed(0)} (${creditPct}%) credited toward your production order if placed within 90 days of this consultation.`;
  const styleDesc = `Design Consultation — ${duration} · ${creditNote}`;
  // One request per consultation ref: repeat clicks must not create repeat invoices / emails.
  window._consultSent = window._consultSent || {};
  if(window._consultSent[consultRef]){ if(price>0) toast('Consultation already requested \u2014 check your email'); else mvfaConsultThanks(email); return; }
  window._consultSent[consultRef] = true;

  if(window.MVFA_SHOPIFY && price>0){
    // Create consultation draft order — booking link follows by email on payment
    MVFA_SHOPIFY.handleQuoteApproval({
      ref: consultRef,
      isConsultation: true,
      items:[{
        styleNum: consultRef,
        styleDesc: styleDesc,
        fabric:'',colour:'',
        price: price,
        totalQty: 1,
        sizeQtys:{'Consultation':1}
      }],
      customer:{name,email,contact:name,phone:'',addr:'',city:'',country:'CA',province:'ON'},
      meta:{season:'',delivDate:'',terms:'prepaid',notes:`Consultation ref: ${consultRef}. ${creditNote}`},
      totals:{sub:price,tax:price*provTaxRate('ON'),total:price*(1+provTaxRate('ON')),deposit:price*(1+provTaxRate('ON')),balance:0},
      notes:`${durationLabel} design consultation. ${creditNote}`
    }).then(function(r){
      if(r&&r.success)toast('✓ Invoice sent — your booking link will arrive by email once payment is received');
    });
  } else {
    // No Shopify proxy available — no invoice was actually created, so
    // there's nothing to gate payment on. Notify Marcus for manual
    // follow-up rather than opening a booking link with no charge behind it.
    fetch('https://api.mvfa.ca/mvfa-notify.php',{
      method:'POST',headers:{'Content-Type':'application/json'},mode:'cors',
      body:JSON.stringify({type:'lead',ref:consultRef,
        customer:{name,email,phone:'',brand:name},
        brandType:'Consultation',garments:[],sizes:[],fabrics:[],
        consultPrice:price,consultDuration:duration})
    }).catch(()=>{});
    if(price>0) toast('Request received — we\u2019ll email you an invoice and booking link shortly');
    else mvfaConsultThanks(email);
  }
}

// Flow 3 entry point from Step 7: lets a customer skip the free price
// reveal and instead pay for a longer consultation without ever giving
// an email through the price gate. Collects just enough contact info
// to create the invoice, WITHOUT setting B.gateEmail -- pricing stays
// masked, matching "did not give email" being the whole point of this path.
function bShowConsultGate(){
  const old=document.getElementById('consult-gate-modal');if(old)old.remove();
  const modal=document.createElement('div');
  modal.id='consult-gate-modal';
  modal.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,0.7);z-index:100004;display:flex;align-items:center;justify-content:center;padding:16px';
  modal.innerHTML=`<div style="background:#fff;border-radius:14px;padding:32px 28px;max-width:400px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,0.4);text-align:center">
    <div style="font-size:32px;margin-bottom:12px">📞</div>
    <div style="font-weight:700;font-size:19px;margin-bottom:8px;color:var(--ink)">Skip the price reveal — book a call instead</div>
    <div style="font-size:13px;color:var(--ink2);margin-bottom:22px;line-height:1.5">A 1-hour design consultation — $100, 50% ($50) credited toward your production order if you place it within 90 days.</div>
    <input type="text" id="cg-name" placeholder="Your name" style="width:100%;box-sizing:border-box;padding:12px 14px;border-radius:7px;border:1px solid var(--border);font-size:14px;margin-bottom:10px">
    <input type="email" id="cg-email" placeholder="you@yourbrand.com" style="width:100%;box-sizing:border-box;padding:12px 14px;border-radius:7px;border:1px solid var(--border);font-size:14px;margin-bottom:14px" onkeydown="if(event.key==='Enter')bSubmitConsultGate()">
    ${bMktBoxHTML('mkt-consult')}
    <button onclick="bSubmitConsultGate()" style="background:var(--gold);color:var(--ink);border:none;border-radius:7px;font-size:14px;font-weight:700;cursor:pointer;padding:13px 20px;width:100%;margin-bottom:10px">Book Consultation — $100 →</button>
    <button onclick="document.getElementById('consult-gate-modal').remove()" style="background:none;border:none;color:var(--ink3);font-size:12px;cursor:pointer;padding:6px">← Back</button>
  </div>`;
  document.body.appendChild(modal);
  setTimeout(()=>{const el=document.getElementById('cg-name');if(el)el.focus();},50);
}
function bSubmitConsultGate(){
  const name = document.getElementById('cg-name').value.trim();
  const email = document.getElementById('cg-email').value.trim();
  if(!name){ toast('Please enter your name'); return; }
  if(!email || !email.includes('@')){ toast('Please enter a valid email'); return; }
  // Deliberately does NOT set B.gateEmail -- price stays masked, since
  // paying for this consultation is an alternative to unlocking pricing
  // for free, not a way to unlock it.
  B.customer = Object.assign({}, B.customer||{}, {name:name, contact:name, email:email});
  bMktRecord('mkt-consult', email, name, 'consult_gate');
  const modal = document.getElementById('consult-gate-modal');
  if (modal) modal.remove();
  mvfaBookConsultation(false);
}

function poApproveProduction(){
  if(!poLines.length){toast('No lines on this order yet');return;}
  const name=document.getElementById('po-cname').value||'your brand';
  const email=document.getElementById('po-email').value||'';
  const ref=document.getElementById('po-ref').value||B.ref||'N/A';
  // TEMP DIAGNOSTIC -- confirms whether #po-email actually has a value
  // at the exact moment of approval, before anything is handed off to
  // the external MVFA_SHOPIFY script. If this shows a real email but
  // Shopify still says "No email provided", the bug is downstream of
  // this file. If this already shows blank, the bug is upstream --
  // #po-email never got populated from B.customer.email in the first
  // place. Remove once the Shopify missing-email issue is resolved.
  console.log('[MVFA DIAGNOSTIC] poApproveProduction. #po-email field value:', JSON.stringify(email), 'B.customer:', JSON.stringify(B.customer));
  if(!confirm(`Approve this collection for production?\n\nA 60% deposit invoice will be sent to ${email||'your email'} to begin production.`))return;
  const sb=document.getElementById('po-docstatus');
  if(sb){sb.textContent='APPROVED → PO';sb.className='posb posb-po';}
  window._poClickedApprove=true;
  poSave();
  // Trigger Shopify deposit order via proxy
  if(window.MVFA_SHOPIFY){
    // Design fee as its own explicit line -- without this, Shopify's
    // actual draft order only ever reflected the garment price (poLines'
    // own l.price is deliberately raw, never blended), silently
    // undercharging the customer by the full design fee amount even
    // though the displayed totals below were already correct. Uses the
    // exact same poDesignFeeSubtotal() the totals calculation already
    // relies on, so the line item and the total can never disagree.
    const designFeeAmount = poDesignFeeSubtotal(poLines);
    const shopifyItems = poLines.map(l=>({styleNum:l.styleNum,styleDesc:l.styleDesc,fabric:l.fabric,colour:l.colour,price:l.price,totalQty:l.totalQty,sizeQtys:l.sizeQtys}));
    if (designFeeAmount > 0) {
      shopifyItems.push({styleNum:'DESIGN-FEE',styleDesc:'Design Fee & Services',fabric:'',colour:'',price:designFeeAmount,totalQty:1,sizeQtys:{}});
    }
    const order={customer:{name,email},meta:{},totals:{},items:poLines,notes:''};
    const country=document.getElementById('po-country')?document.getElementById('po-country').value:'CA';
    const prov=document.getElementById('po-province')?document.getElementById('po-province').value:'ON';
    MVFA_SHOPIFY.handleQuoteApproval({
      ref,
      items:shopifyItems,
      customer:Object.assign({name,email,contact:name,phone:document.getElementById('po-phone').value||'',addr:document.getElementById('po-addr').value||'',city:document.getElementById('po-city').value||'',country,province:prov}, poShipForShopify()),
      meta:{season:document.getElementById('po-season').value,delivDate:document.getElementById('po-ddate').value,terms:'60/40',brandName:B.brandName||name,brandType:B.brand||''},
      totals:(function(){const sub=poLines.reduce((s,l)=>s+l.price*l.totalQty,0)+poDesignFeeSubtotal(poLines);const _tg=poTaxGeo();const tax=sub*provTaxRate(_tg.prov,_tg.country);const total=sub+tax;return{sub,tax,total,deposit:total*.6,balance:total*.4};}()),
      notes:document.getElementById('po-notes').value||''
    }).then(function(r){
      if(r&&r.success)toast('Production approved — deposit invoice sent!');
    });
  } else {
    // Notify via email fallback
    fetch('https://api.mvfa.ca/mvfa-notify.php',{method:'POST',headers:{'Content-Type':'application/json'},mode:'cors',
      body:JSON.stringify({type:'production_approval',ref,customer:{name,email},lines:poLines.map(l=>`${l.styleNum} × ${l.totalQty} @ $${l.price}`)})
    }).catch(()=>{});
    toast('Production approved — MVFA will be in touch within 1 business day to arrange your deposit.');
  }
}

function poStartSample(){
  // Navigate to sample flow in builder
  goView('builder');
  setTimeout(function(){bStartSample();},100);
}
function poRemLine(id){poLines=poLines.filter(l=>l.id!==id);poRenderLines();poUpd();}

// ── EDIT (PO line -> Step 7, one item open, all others collapsed) ─────────
// A poLines entry may not have full original builder detail (trims,
// construction) if it was a legacy/restored line — converts what real
// data IS available (fabric, colour, sizes) into a genuine B.items entry,
// defaulting anything missing to sensible blanks, rather than pretending
// detail exists that was never actually saved.
// Global context for the Edit flow — tracks which PO line is being
// edited so we can write changes back to poLines after Step 7,
// rather than creating a new quote submission from scratch.
window._poEditContext = null;
window._poAddContext = null;

// Edit a merch line in the same picker modal the customer used, pre-filled (colour, sizes, decorations).
async function poMerchEditLine(lineId){
  const it = (B.items||[]).find(x=>x && x.id===lineId && x.merch);
  if(!it){ toast('Could not find this line to edit'); return; }
  const m = it.merch;
  goView('builder'); bShow('Merch'); bMerchInit();
  _merchCatID = m.catID || null;
  window._mEditCatLabel = m.catLabel || '';
  window._mEditPrevArt = (m.artworkUrls||[]).slice();
  _merchStyles = [{styleID:m.styleID, styleName:m.styleName, brandName:'', garmentType:m.catLabel||''}];
  window._merchEditItemId = it.id;
  await bMerchOpenStyle(0);
  const cols = window._mModalColours||[];
  if(!cols.length){ toast('Could not load this style \u2014 please try again'); bMerchModalCancel(); return; }
  let ci = cols.findIndex(c=>c.colorName===m.colorName); if(ci<0) ci=0;
  bMerchSelColour(ci);
  const sizes = window._mSelColourSizes||[];
  Object.keys(it.szs||{}).forEach(sz=>{
    const si = sizes.findIndex(s=>s.size===sz); const q = parseInt(it.szs[sz])||0;
    const inp = document.getElementById('msizeqty-'+si);
    if(si>=0 && inp && q>0){ inp.value = q; bMerchSizeQtyChange(si, sz, q); }
  });
  window._mDecos = (m.decos||[]).map(d=>Object.assign({files:[], artworkNames:d.artworkNames||[], priceType: d.type==='label' ? 'label_'+(d.labelKind||'printed') : d.type}, d));
  bMerchRenderSavedDecos();
  bMerchSetPhase(window._mDecos.length ? 'saved' : 'edit');
  const fab = document.getElementById('merch-admin-fabric'); if(fab) fab.value = m.blankFabric || merchBlankFabricGuess(m.catLabel);
  const pr = document.getElementById('merch-add-btn'); if(pr){ pr.firstChild.nodeValue = '\n        Update this item \u2014 '; }
  bMerchUpdateLinePricePreview();
}
function bMerchModalCancel(){
  const mo = document.getElementById('merch-modal'); if(mo) mo.style.display='none';
  if(window._merchEditItemId){
    window._merchEditItemId = null; window._mEditPrevArt = [];
    if(window._quoteResumeToken) openOrd(window._quoteResumeToken);
  }
}
function poMerchRoute(msg){
  goView('builder'); bShow('Merch'); bMerchInit();
  toast(msg||'Pick more blanks \u2014 your current lines stay on the order');
}
function poEditLine(lineId){
  const line = poLines.find(l=>l.id===lineId);
  if (!line) { toast('Line not found'); return; }
  if (line.merchImg || line.vendorStyle) { poMerchEditLine(lineId); return; }

  // Use the real original item (full decoration detail intact) if one
  // exists, rather than reconstructing from poLines -- that shape never
  // carried brand/trims/labels to begin with, so reconstructing from it
  // silently produced an item with silkscreen/embroidery/trims already
  // stripped before the person had even opened the edit screen.
  const original = (window._poFullItems||[]).find(x => x.id === lineId);
  const garmentType = line.styleDesc || line.styleNum || 'Jacket';
  const item = original ? Object.assign({}, original, {
    id: Date.now()+Math.random(),
    _poLineId: lineId,
    szs: Object.assign({}, line.sizeQtys||original.szs||{}),
  }) : {
    id: Date.now()+Math.random(),
    _poLineId: lineId,
    gt: garmentType,
    useEx:false, exCode:'',
    fab: line.fabric || (B.fabrics && B.fabrics[0]) || 'Modal Jersey',
    wt:'mid',
    fabrics: [{name: line.fabric || 'Modal Jersey', usage:'Self / Body', weight:'mid', construction:'Jersey'}],
    trims:[], trimQty:{}, customTrims:[], lbls:['woven'], brand:[], design:[],
    fin:true,
    szs: Object.assign({}, line.sizeQtys||{}),
    screenColours:1, embStitches:5000,
    colour: line.colour ? (typeof line.colour==='object' ? line.colour : {name:line.colour, hex:line.colourHex||'#999'}) : null,
    colourHex: line.colourHex || null,
  };

  // Store edit context — used by poFinishEdit() to write back
  window._poEditContext = { lineId, originalPoLines: [...poLines] };

  // Set B so the builder sees exactly one item to edit
  B.items = [item];
  B.garments = [garmentType]; // so the garment pill shows correctly
  // Narrow B.fabrics to just what this specific line had — without this,
  // all 3 base fabrics from the original Step 4 selection appear in the
  // picker, which is confusing when editing a colourway that only has one.
  B.fabrics = [item.fab || 'Modal Jersey'];
  B.sizes = Object.keys(item.szs).length ? Object.keys(item.szs) : (B.sizes||['XS','S','M','L','XL']);
  B._collapsed = {};
  B._collapsed[item.id] = false; // this item is open

  goView('builder'); bShow(7);
  // Re-populate the garment and fabric pickers with the narrowed state
  // so the pill highlights correctly and the fabric list isn't cluttered
  bPopG(); bPopF();
  bRI();
}

// Called when the customer finishes editing and hits Review Quote.
// Instead of the normal bSubmit() new-quote flow, this writes the
// edited item back to poLines and returns to My Collections.
// Save-and-close: returns to My Collections instead of reopening the same
// PO view. Matches the same show/hide + refresh pattern poClear() already
// uses for its own "close and return to list" behavior.
function poCloseToCollections(){
  window._currentOrderIsPaid = false;
  window._quoteResumeToken = null;
  document.getElementById('collections-list-wrap').style.display='';
  document.getElementById('po-editor-wrap').style.display='none';
  renderCollections();
}
async function poFinishEdit(){
  if (!window._poEditContext || !B.items.length) return false;
  const { lineId } = window._poEditContext;
  const editedItem = B.items[0];
  if (!editedItem) return false;

  // Write the edited item's non-price fields back to the correct poLines
  // entry — price gets set below, once for the whole order together.
  const lineIdx = poLines.findIndex(l=>l.id===lineId);
  if (lineIdx >= 0) {
    const q = bQty(editedItem);
    poLines[lineIdx] = Object.assign({}, poLines[lineIdx], {
      styleDesc: editedItem.gt || poLines[lineIdx].styleDesc,
      fabric: editedItem.fab || poLines[lineIdx].fabric,
      colour: editedItem.colour ? (typeof editedItem.colour==='object' ? editedItem.colour.name : editedItem.colour) : poLines[lineIdx].colour,
      colourHex: editedItem.colour && typeof editedItem.colour==='object' ? editedItem.colour.hex : (editedItem.colourHex || poLines[lineIdx].colourHex),
      sizeQtys: Object.assign({}, editedItem.szs||{}),
      totalQty: q,
    });
  }

  // Merge the edited item back into the preserved full-detail array --
  // every OTHER item keeps its real brand/trims/labels/fabric-blend data
  // completely untouched. This replaces the old approach of rebuilding
  // every item from the lossy poLines shape, which had no decoration
  // detail to rebuild FROM and silently wiped it on every single save.
  if (!window._poFullItems) window._poFullItems = [];
  const fullIdx = window._poFullItems.findIndex(x => x.id === lineId);
  const mergedItem = Object.assign({}, editedItem, { id: lineId, _poLineId: undefined });
  if (fullIdx >= 0) {
    window._poFullItems[fullIdx] = mergedItem;
  } else {
    // No original on file (e.g. a manually-added PO line with no
    // builder history) -- add it as a new full item.
    window._poFullItems.push(mergedItem);
  }
  B.items = window._poFullItems;

  // Recompute pricing for the WHOLE order together — design-fee dedup
  // (see poComputeOrderPricing) needs to see every line at once, not
  // just the one that was edited, since editing one line can change
  // which line is the "first" occurrence of a shared style.
  if (!B._costs) B._costs = {};
  await Promise.all(B.items.map(async it => {
    const fresh = await bCalcBoM(it, bQty(it)||120);
    if (fresh && fresh.unitPrice > 0) B._costs[it.id] = fresh;
  }));
  const pricing = poComputeOrderPricing(B.items, B._costs);
  poLines.filter(l=>!l.isDesignService).forEach(l => {
    const p = pricing.get(l.id);
    if (p) { l.price = p.price; l.designFee = p.designFee; l.designSvcTotal = p.designSvcTotal; }
  });

  // Clear edit context
  window._poEditContext = null;

  // Await the save before reopening — without await, openOrd() fetches
  // the old state from the server before the save has written the new one,
  // causing the PO to appear empty on reload (the race condition bug).
  toast('Saving changes…');
  const token = window._quoteResumeToken;
  if (token) {
    const estSub = poLines.reduce((s,l)=>s+(l.price||0)*(l.totalQty||0),0)+poDesignFeeSubtotal(poLines);
    const estTotal = estSub + estSub * provTaxRate((B.customer && B.customer.province) || 'ON');
    B.designLines = poComputeDesignLines();
    try {
      await fetch('https://api.mvfa.ca/mvfa-quote-save.php?action=save', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({
          token,
          state: B,
          step: 'po-edited',
          itemCount: poLines.filter(l=>!l.isDesignService).length,
          estimatedTotal: estTotal,
        })
      });
      _cachedQuotes = null; // bust the collections-list cache — without this,
                             // My Collections keeps showing whatever total it
                             // fetched earlier this session until a hard refresh
    } catch(e) { /* silent — proceed anyway */ }
  }

  toast('✓ Changes saved');
  poCloseToCollections();
  return true;
}

// Called when finishing an "add new item" to an already-saved order.
// Unlike poFinishEdit(), B.items already holds full, correct detail for
// EVERY item (existing items were never touched — poConfirmAddNewItem()
// only pushed the new one onto B.items) so there's nothing to reconstruct
// from poLines, and no lossy round-trip through the minimal PO-line shape.
// Saves B.items as-is, which is actually higher-fidelity than
// poFinishEdit()'s rebuild (keeps real trims/design/fabrics detail
// instead of resetting them to blanks).
async function poFinishAdd(){
  if (!B.items || !B.items.length) return false;
  if (!B._costs) B._costs = {};
  await Promise.all(B.items.map(async it => {
    const fresh = await bCalcBoM(it, bQty(it)||120);
    if (fresh && fresh.unitPrice > 0) B._costs[it.id] = fresh;
  }));
  const estTotal = bComputeFullOrderTotal(B.items, B._costs);
  window._poAddContext = null;
  toast('Saving changes…');
  const token = window._quoteResumeToken;
  if (token) {
    B.designLines = poComputeDesignLines();
    try {
      await fetch('https://api.mvfa.ca/mvfa-quote-save.php?action=save', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({
          token,
          state: B,
          step: 'po-edited',
          itemCount: B.items.length,
          estimatedTotal: estTotal,
        })
      });
      _cachedQuotes = null; // same cache-bust as poFinishEdit/poSave
    } catch(e) { /* silent — proceed anyway */ }
  }
  toast('✓ Changes saved');
  poCloseToCollections();
  return true;
}
// ── ADD COLOUR (PO-level, no Step 7 involved) ──────────────────────────────
// Duplicates the source line exactly — same fabric, trims, size scale and
// quantities — only the colour changes. Per the locked design: a new
// colourway is presumed to want the SAME size breakdown as the original,
// not a fresh guess; if the customer wants different quantities per
// colour, that's what the separate "Edit" button (-> Step 7) is for.
// ── ADD NEW ITEM (blank row -> garment picker -> Step 7, new item open) ───
function poRenderAddItemRow(){
  const tb = document.getElementById('po-tbody');
  if (!tb || window._currentOrderIsPaid) return; // draft-only, same rule as Add Colour/Edit
  const row = document.createElement('tr');
  row.innerHTML = `<td colspan="9" style="padding:10px;text-align:center">
    <button onclick="poOpenAddNewItem()" style="background:none;border:1px dashed var(--border);border-radius:8px;color:var(--ink2);font-size:12px;font-weight:600;padding:9px 16px;cursor:pointer;width:100%">+ Add a new item to this order</button>
  </td>`;
  tb.appendChild(row);
}

function poOpenAddNewItem(){
  if (B.brand==='Merch' || B._poSource==='merch') { poMerchRoute(); return; }
  const brand = B.brand || 'Fashion';
  const options = GD[brand] || GD.Fashion;
  let modal = document.createElement('div');
  modal.id = 'add-style-modal';
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:100002;display:flex;align-items:center;justify-content:center;padding:16px';
  modal.innerHTML = `<div style="background:#fff;border-radius:12px;padding:22px;max-width:380px;width:100%;box-shadow:0 8px 30px rgba(0,0,0,0.3)">
    <div style="font-weight:700;font-size:15px;margin-bottom:4px;color:var(--ink)">Add a new item</div>
    <div style="font-size:12px;color:var(--ink2);margin-bottom:14px">Pick a style from your ${brand} category:</div>
    <select id="add-style-select" style="width:100%;padding:10px;border-radius:6px;border:1px solid var(--border);font-size:13px;margin-bottom:16px">
      <option value="">— Select a style —</option>
      ${options.map(g=>`<option value="${g}">${g}</option>`).join('')}
    </select>
    <div style="display:flex;gap:8px;justify-content:flex-end">
      <button onclick="document.getElementById('add-style-modal').remove()" style="background:none;border:none;color:var(--ink3);font-size:12px;cursor:pointer;padding:8px 10px">Cancel</button>
      <button onclick="poConfirmAddNewItem()" style="background:var(--gold);color:var(--ink);border:none;border-radius:6px;font-size:12px;font-weight:600;cursor:pointer;padding:9px 18px">Add &amp; Edit →</button>
    </div>
  </div>`;
  document.body.appendChild(modal);
}

function poConfirmAddNewItem(){
  const sel = document.getElementById('add-style-select');
  const garment = sel.value;
  if (!garment) { toast('Please pick a style'); return; }
  document.getElementById('add-style-modal').remove();

  // Seed B.sizes from existing PO lines if it's empty — when arriving
  // via the PO edit path, the customer never passed through Step 3, so
  // B.sizes may be stale or blank, causing bNewItem to produce zero quantities.
  if (!B.sizes || !B.sizes.length) {
    const existingSizes = new Set();
    (poLines||[]).forEach(l => {
      Object.keys(l.sizeQtys||{}).forEach(s => existingSizes.add(s));
    });
    if (existingSizes.size) B.sizes = Array.from(existingSizes);
  }

  // Build a real, fully-editable builder item with brand-typical
  // defaults (same defaults bNewItem already uses for a fresh pick).
  const newItem = bNewItem(garment, (B.items||[]).length);
  if (!B.items) B.items = [];
  // Add to B.garments so the Step 7 garment pill shows this type selected
  if (!B.garments) B.garments = [];
  if (!B.garments.includes(garment)) B.garments.push(garment);
  B.items.push(newItem);

  // Collapse every existing item, leave only the new one open.
  if (!B._collapsed) B._collapsed = {};
  B.items.forEach(it => { B._collapsed[it.id] = (it.id !== newItem.id); });

  // If this is an already-saved order (has a resume token), short-circuit
  // to the same fast save path as editing a line — B.items already has
  // full, correct detail for every item at this point (existing items
  // untouched, new one appended), so there's no need to route through
  // the full new-quote bSubmit() flow (step 8/9 customer info re-ask,
  // a fresh independent design-fee calculation causing duplicates, and
  // a PO-line-shape save that doesn't match what openOrd() expects on
  // reload). A brand-new, never-saved manual PO still goes through the
  // normal flow since there's no existing order to update in place.
  if (window._quoteResumeToken) {
    window._poAddContext = true;
  }

  goView('builder'); bShow(7);
  bRI();
  toast(`✓ ${garment} added — fully editable below`);
}

function poOpenAddColour(lineId){
  const line = poLines.find(l=>l.id===lineId);
  if (!line) { toast('Line not found'); return; }
  if (line.merchImg || line.vendorStyle) { poMerchRoute('Pick the same style in another colour \u2014 it will be added as a new line'); return; }
  const old=document.getElementById('add-colour-fork');if(old)old.remove();
  const modal = document.createElement('div');
  modal.id = 'add-colour-fork';
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:100002;display:flex;align-items:center;justify-content:center;padding:16px';
  modal.innerHTML = `<div style="background:#fff;border-radius:12px;padding:22px;max-width:340px;width:100%;box-shadow:0 8px 30px rgba(0,0,0,0.3)">
    <div style="font-weight:700;font-size:15px;margin-bottom:4px;color:var(--ink)">${line.styleDesc}</div>
    <div style="font-size:12px;color:var(--ink2);margin-bottom:16px">Currently: ${line.colour||'TBD'}</div>
    <div style="display:flex;flex-direction:column;gap:8px">
      <button onclick="document.getElementById('add-colour-fork').remove();poOpenPantoneForLine(${lineId},'change')" style="background:var(--gold);color:var(--ink);border:none;border-radius:6px;font-size:13px;font-weight:600;cursor:pointer;padding:11px">Change Colour</button>
      <button onclick="document.getElementById('add-colour-fork').remove();poOpenPantoneForLine(${lineId},'add')" style="background:none;border:1px solid var(--border);color:var(--ink);border-radius:6px;font-size:13px;font-weight:600;cursor:pointer;padding:11px">Add Another Colour</button>
      <button onclick="document.getElementById('add-colour-fork').remove()" style="background:none;border:none;color:var(--ink3);font-size:12px;cursor:pointer;padding:6px">Cancel</button>
    </div>
  </div>`;
  document.body.appendChild(modal);
}
// Opens the SAME real Pantone TCX picker Step 7 uses -- was previously a
// separate, hardcoded 7-colour grid (CS) with no curation, unrelated to the
// actual Pantone system used everywhere else in the builder.
function poOpenPantoneForLine(lineId, mode){
  const old=document.getElementById('po-pantone-overlay');if(old)old.remove();
  window._pantonePOTarget={lineId,mode};
  const ov=document.createElement('div');
  ov.id='po-pantone-overlay';
  ov.style.cssText='position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.82)';
  ov.innerHTML=`
    <div style="background:#1a1a18;border:1px solid rgba(255,255,255,0.18);border-radius:14px;overflow:hidden;width:min(780px,96vw);height:min(680px,90vh);display:flex;flex-direction:column;box-shadow:0 24px 80px rgba(0,0,0,0.7)">
      <div style="display:flex;justify-content:space-between;align-items:center;padding:11px 16px;border-bottom:1px solid rgba(255,255,255,0.08);flex-shrink:0">
        <span style="font-size:11px;font-weight:600;color:var(--gold);letter-spacing:.1em;text-transform:uppercase">Select Pantone Colour — click a swatch then press ✓ Select This Colour</span>
        <button onclick="document.getElementById('po-pantone-overlay').remove();window._pantonePOTarget=null;" style="background:none;border:none;color:rgba(255,255,255,0.45);font-size:22px;cursor:pointer;line-height:1;padding:0 4px">×</button>
      </div>
      <iframe src="https://api.mvfa.ca/mvfa-pantone-picker.html?v=3&mode=fabric" style="flex:1;border:none;width:100%;min-height:0"></iframe>
    </div>`;
  ov.addEventListener('click',function(e){if(e.target===ov){ov.remove();window._pantonePOTarget=null;}});
  document.body.appendChild(ov);
}
function poApplyLineColour(lineId, hex, name, mode){
  const line = poLines.find(l=>l.id===lineId);
  if (!line) return;
  if (mode==='change') {
    line.colour = name;
    line.colourHex = hex;
    toast('✓ Colour updated');
  } else {
    const newLine = Object.assign({}, line, {
      id: Date.now()+Math.random(),
      colour: name,
      colourHex: hex,
      sizeQtys: Object.assign({}, line.sizeQtys),
      // Design is a one-time cost per STYLE, not per colourway --
      // zero these out on the duplicate so the quote total stays honest.
      designFee: 0,
      designSvcTotal: 0,
      designServices: [],
    });
    const idx = poLines.findIndex(l=>l.id===lineId);
    poLines.splice(idx+1, 0, newLine);
    toast('✓ Colour added');
  }
  poRenderLines(); poUpd();
}
function poRenderLines(){
  const tb=document.getElementById('po-tbody');
  if(!poLines.length){tb.innerHTML=`<tr><td colspan="9"><div class="empty-st"><div class="empty-icon">📋</div><div>No lines yet — add a product from the left panel</div></div></td></tr>`;poRenderAddItemRow();return;}
  tb.innerHTML=poLines.map((l,i)=>{
    if(l.isDesignService){
      return`<tr style="background:rgba(45,92,67,0.06)">
        <td style="color:var(--ink3);font-family:'DM Mono',monospace;font-size:10px">${i+1}</td>
        <td style="font-family:'DM Mono',monospace;font-size:11px;font-weight:600;color:var(--green2)">${l.styleNum}</td>
        <td style="font-size:11px;color:var(--green2)" colspan="3">${l.styleDesc}</td>
        <td class="num" style="font-family:'DM Mono',monospace;font-weight:600;color:var(--green2)">1</td>
        <td class="num" style="font-size:11px;color:var(--green2)">—</td>
        <td class="num" style="font-weight:600;color:var(--green2)">$${l.price.toFixed(2)}</td>
        <td><button class="rl" onclick="poRemLine(${l.id})">×</button></td>
      </tr>`;
    }
    const ss=Object.entries(l.sizeQtys).filter(([,v])=>v>0).map(([k,v])=>`${k}:${v}`).join(' · ');
    const dot=CS[l.colour]||'#999';
    const canModify = !window._currentOrderIsPaid;
    return`<tr>
      <td style="color:var(--ink3);font-family:'DM Mono',monospace;font-size:10px">${i+1}</td>
      <td style="font-family:'DM Mono',monospace;font-size:11px;font-weight:600"><div style="display:flex;align-items:center;gap:8px">${l.merchImg?`<img src="${bCadEsc(l.merchImg)}" alt="" style="width:46px;height:56px;object-fit:contain;background:#fff;border:1px solid rgba(0,0,0,0.15);border-radius:5px;flex-shrink:0">`:''}${(l.cad&&l.cad.thumb)?`<img src="${bCadEsc(l.cad.thumb)}" alt="" title="${bCadEsc(l.cad.name||'Style CAD')}" style="width:38px;height:46px;object-fit:contain;background:#fff;border:1px solid rgba(0,0,0,0.15);border-radius:5px;flex-shrink:0">`:''}<span>${l.styleNum}${l.fromBuilder?'<span class="auto-tag">auto</span>':''}${(l.vendorStyle&&window._adminMode)?'<br><span style="font-size:9px;font-weight:400;color:var(--ink3)" title="Vendor style (admin only)">'+l.vendorStyle+'</span>':''}</span></div></td>
      <td style="font-size:11px;color:var(--ink2)">${l.styleDesc}<br><span style="font-size:9px;color:var(--ink3)">${l.fabric}${l.fabricGSM?', '+l.fabricGSM+' Weight':''}</span>${l.needsQuote?'<br><span style="font-size:9px;color:var(--gold2)">Hang tags / extras: price confirmed on your quote</span>':''}${(l.designFee||l.designSvcTotal)?`<br><span style="font-size:9px;color:var(--gold2)">+ Design Fee${l.designSvcTotal?' & services':''}: $${((l.designFee||0)+(l.designSvcTotal||0)).toFixed(2)} (this line)</span>`:''}</td>
      <td><span ${(l.merchImg||l.vendorStyle)?'':`onclick="poOpenPantoneForLine(${l.id},'change')"`} style="${(l.merchImg||l.vendorStyle)?'':'cursor:pointer;'}display:inline-flex;align-items:center;gap:5px;font-size:11px" title="Click to update colour"><span style="width:9px;height:9px;border-radius:50%;background:${l.colourHex||CS[l.colour]||'#999'};border:1px solid var(--border);flex-shrink:0;display:inline-block"></span>${l.colour}</span></td>
      <td style="font-family:'DM Mono',monospace;font-size:10px;color:var(--ink2)">${ss}</td>
      <td class="num" style="font-family:'DM Mono',monospace;font-weight:600">${l.totalQty}</td>
      <td class="num" style="font-size:11px">$${l.price.toFixed(2)}</td>
      <td class="num" style="font-weight:600">$${(l.price*l.totalQty+(l.designFee||0)+(l.designSvcTotal||0)).toFixed(2)}</td>
      <td style="white-space:nowrap">${canModify?`<button class="rl" style="background:none;border:1px solid var(--border);border-radius:4px;color:var(--ink2);font-size:9px;padding:3px 6px;cursor:pointer;margin-right:4px" onclick="poOpenAddColour(${l.id})">+ Colour</button><button class="rl" style="background:none;border:1px solid var(--border);border-radius:4px;color:var(--ink2);font-size:9px;padding:3px 6px;cursor:pointer;margin-right:4px" onclick="poEditLine(${l.id})">Edit</button>`:''}<button class="rl" onclick="poRemLine(${l.id})">×</button></td>
    </tr>`;
  }).join('');
  poRenderAddItemRow();
}
function poUpd(){
  const name=document.getElementById('po-cname').value||'—';
  const addr=document.getElementById('po-addr').value,city=document.getElementById('po-city').value;
  const contact=document.getElementById('po-contact').value,phone=document.getElementById('po-phone').value,email=document.getElementById('po-email').value;
  const poRef=document.getElementById('po-ref').value,season=document.getElementById('po-season').value,cur=document.getElementById('po-currency').value;
  const od=document.getElementById('po-odate').value,dd=document.getElementById('po-ddate').value,notes=document.getElementById('po-notes').value;
  document.getElementById('po-d-bname').textContent=name;
  document.getElementById('po-d-bdet').innerHTML=[addr,city,contact,phone,email].filter(Boolean).join('<br>');
  document.getElementById('po-d-od').textContent=fmtD(od);document.getElementById('po-d-dd').textContent=fmtD(dd);
  document.getElementById('po-d-season').textContent=`${season} / Toronto`;
  const d=new Date(od||Date.now());
  const num=`MVFA-${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}${String(poCtr).padStart(3,'0')}`;
  document.getElementById('po-docnum').textContent=num+(poRef?` · ${poRef}`:'');
  const sb=document.getElementById('po-docstatus');
  if(!sb.textContent.includes('APPROVED')){sb.textContent=poLines.length?'PURCHASE ORDER':'DRAFT';sb.className='posb '+(poLines.length?'posb-po':'posb-draft');}
  const sub=poLines.reduce((s,l)=>s+l.price*l.totalQty,0)+poDesignFeeSubtotal(poLines);
  const countryEl=document.getElementById('po-country');const country=countryEl?countryEl.value:'CA';
  const provEl=document.getElementById('po-province');const prov=provEl?provEl.value:'ON';
  const _g=poTaxGeo();
  const taxRate=provTaxRate(_g.prov,_g.country);
  const tax=sub*taxRate,total=sub+tax;
  const taxLbl=document.getElementById('po-t-taxlbl');
  if(taxLbl)taxLbl.textContent=provTaxLabel(_g.prov);
  document.getElementById('po-t-sub').textContent=`${cur} ${fmt(sub)}`;
  document.getElementById('po-t-tax').textContent=`${cur} ${fmt(tax)}`;
  document.getElementById('po-t-total').textContent=`${cur} ${fmt(total)}`;
  document.getElementById('po-t-dep').textContent=`${cur} ${fmt(total*poDepR)}`;
  document.getElementById('po-t-bal').textContent=`${cur} ${fmt(total*poBalR)}`;
  const nr=document.getElementById('po-notesrow');
  if(notes.trim()){nr.style.display='block';document.getElementById('po-notestxt').textContent=notes;}else nr.style.display='none';
  document.getElementById('po-lcount').textContent=`${poLines.length} line${poLines.length!==1?'s':''} · ${poLines.filter(l=>!l.isDesignService).reduce((s,l)=>s+l.totalQty,0)} units`;
}
function poUpdTerms(){
  const t=document.getElementById('po-terms').value;
  const m={'60/40':{l:'60% Dep / 40% COD',d:.6,b:.4,dl:'60% Deposit due',bl:'40% Balance on delivery'},'net30':{l:'Net 30',d:0,b:1,dl:'',bl:'Full balance Net 30'},'net60':{l:'Net 60',d:0,b:1,dl:'',bl:'Full balance Net 60'},'cod':{l:'Full COD',d:0,b:1,dl:'',bl:'Full balance on delivery'},'prepaid':{l:'Pre-paid',d:1,b:0,dl:'Full pre-payment',bl:''}};
  const tm=m[t];document.getElementById('po-d-terms').textContent=tm.l;poDepR=tm.d;poBalR=tm.b;
  document.getElementById('po-deplbl').textContent=tm.dl;document.getElementById('po-ballbl').textContent=tm.bl;
  document.getElementById('po-deprow').style.display=tm.d>0?'':'none';
  document.getElementById('po-balrow').style.display=tm.b>0?'':'none';
  poUpd();
}
function poSave(){
  if(!poLines.length){toast('Add at least one line first');return;}
  const country=document.getElementById('po-country')?document.getElementById('po-country').value:'CA';
  const prov=document.getElementById('po-province')?document.getElementById('po-province').value:'ON';
  const sub=poLines.reduce((s,l)=>s+l.price*l.totalQty,0)+poDesignFeeSubtotal(poLines),tax=sub*provTaxRate(poTaxGeo().prov,poTaxGeo().country),total=sub+tax;
  const order={id:curOID||Date.now(),ref:B.ref||document.getElementById('po-docnum').textContent.split(' · ')[0],status:'po',source:'manual',
    customer:{name:document.getElementById('po-cname').value,contact:document.getElementById('po-contact').value,email:document.getElementById('po-email').value,phone:document.getElementById('po-phone').value,addr:document.getElementById('po-addr').value,city:document.getElementById('po-city').value,country,province:prov},
    ship:(B.ship||{same:true}),
    meta:{confirmedShip:window._poConfirmShip||'',orderDate:document.getElementById('po-odate').value,delivDate:document.getElementById('po-ddate').value,season:document.getElementById('po-season').value,terms:document.getElementById('po-terms').value,currency:document.getElementById('po-currency').value,poRef:document.getElementById('po-ref').value},
    lines:poLines,notes:document.getElementById('po-notes').value,
    totals:{sub,tax,freight:0,total,deposit:total*poDepR,balance:total*poBalR},
    createdAt:new Date().toISOString()};
  B.designLines = poComputeDesignLines();
  const _poSavePromise = fetch('https://api.mvfa.ca/mvfa-quote-save.php?action=save', {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({
      token: window._quoteResumeToken || '',
      // items must be raw BUILDER shape (gt/wt/fab/szs/colour:{hex,name}) —
      // matching what poFinishEdit() persists — not PO-line shape
      // (styleNum/sizeQtys/price). Saving PO-line shape here previously
      // corrupted the next reload's price recalculation, since bCalcBoM()
      // reads item.gt/item.fab, neither of which exist on a PO-line-shaped
      // object.
      state: Object.assign({}, B, {
        ref: order.ref, customer: order.customer, meta: order.meta, ship: order.ship, notes: order.notes,
        items: poLines.filter(l=>!l.isDesignService).map(l=>{
          // Use the preserved full-detail item as the basis whenever one
          // exists for this line -- this is the actual fix for data loss
          // that's been reported repeatedly this session (fabric blends,
          // trims, labels, category, gender all vanishing after a customer
          // approves their quote). window._poFullItems is populated at
          // load time (openOrd()) with the complete, untouched builder
          // items; only qty/price actually come from poLines, which may
          // reflect live edits made through the PO editor.
          const full = (window._poFullItems||[]).find(fi => fi.id === l.id);
          if (full) {
            return Object.assign({}, full, {
              szs: Object.assign({}, l.sizeQtys||{}),
              colour: {name: l.colour||'TBD', hex: l.colourHex||'#999'},
            });
          }
          // Fallback for lines with no builder origin (e.g. manually
          // added via the old Add Product Line panel) -- no rich detail
          // ever existed for these, so there's nothing to preserve.
          return {
            id: l.id,
            gt: l.styleDesc || l.styleNum || 'Item',
            fab: l.fabric || '',
            wt: 'mid',
            szs: Object.assign({}, l.sizeQtys||{}),
            colour: {name: l.colour||'TBD', hex: l.colourHex||'#999'},
            trims:[], trimQty:{}, customTrims:[], lbls:['woven'], brand:[], design:[],
            fin:true, useEx:false, exCode:'', screenColours:1, embStitches:5000,
            _fromPoLine: true,
          };
        }),
      }),
      step: (B._poSource==='merch' ? 'merch-po' : 'po-manual'),
      itemCount: (order.lines||[]).length,
      estimatedTotal: total,
    })
  }).then(r=>r.json()).then(data=>{
    if(data.success && data.token){ window._quoteResumeToken = data.token; _rememberToken(data.token); }
    _cachedQuotes = null; // same cache-bust as poFinishEdit — this save path was missing it
  }).catch(()=>{});
  poCtr++;poUpd();updBadge();toast(B._poSource==='merch' ? '✓ Draft quote saved' : '✓ Purchase Order saved');
  return _poSavePromise;
}
function poClear(silent){
  // If this is a saved order (has a resume token), "Clear" should
  // just close and return to the list — not destroy the saved data.
  // Clear is only truly destructive for manual, unsaved POs.
  if (!silent && window._quoteResumeToken) {
    window._currentOrderIsPaid = false;
    window._quoteResumeToken = null;
    document.getElementById('collections-list-wrap').style.display='';
    document.getElementById('po-editor-wrap').style.display='none';
    renderCollections();
    return;
  }
  if(!silent && poLines.length && !confirm('Clear this PO?'))return;
  window._currentOrderIsPaid = false;
  poLines=[];curOID=null;
  ['po-cname','po-addr','po-city','po-contact','po-phone','po-email','po-ref','po-notes'].forEach(id=>{const el=document.getElementById(id);if(el){el.value='';el.classList.remove('imp');}});
  const countryEl=document.getElementById('po-country');if(countryEl)countryEl.value='CA';
  bUpdateProvinceOptions('ON');
  document.getElementById('po-impbanner').style.display='none';
  const sb=document.getElementById('po-docstatus');sb.textContent='DRAFT';sb.className='posb posb-draft';
  poRenderLines();poUpd();toast('PO cleared');
}

// ══ ORDERS ══
// Tracks which resume tokens belong to THIS browser (localStorage survives
// tab close, unlike sessionStorage which was the old, fragile mechanism).
// The actual quote DATA always lives server-side now — this is just the
// browser's own memory of "which quotes are mine."
function _myTokens(){
  try { return JSON.parse(localStorage.getItem('mvfa_my_tokens')||'[]'); }
  catch(e){ return []; }
}
function _rememberToken(token){
  if(!token) return;
  let t = _myTokens();
  if(!t.includes(token)){ t.unshift(token); localStorage.setItem('mvfa_my_tokens', JSON.stringify(t)); }
}

// Who is asking, for mvfa-quote-save.php action=list. The server only shows a quote that has
// a confirmed contact email to a caller presenting that same email, so this MUST be sent.
// Order: the logged-in Shopify customer (set by the page template), else the email entered at
// the pricing gate (remembered on this browser), else whatever is on the quote in progress.
function _myEmail(){
  let e = '';
  try { e = window.MVFA_CUSTOMER_EMAIL || ''; } catch(x){}
  if(!e){ try { e = localStorage.getItem('mvfa_my_email') || ''; } catch(x){} }
  if(!e && typeof B !== 'undefined' && B){ e = B.gateEmail || (B.customer && B.customer.email) || ''; }
  return String(e || '').trim().toLowerCase();
}
let _cachedQuotes = null;
async function _fetchMyQuotes(forceRefresh){
  if(_cachedQuotes && !forceRefresh) return _cachedQuotes;
  const tokens = _myTokens();
  if(!tokens.length){ _cachedQuotes = []; return []; }
  try {
    const r = await fetch('https://api.mvfa.ca/mvfa-quote-save.php?action=list', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({tokens, email: _myEmail()})
    });
    const data = await r.json();
    _cachedQuotes = data.success ? data.quotes : [];
  } catch(e) { _cachedQuotes = []; }
  return _cachedQuotes;
}

// "My Collections" = drafts/in-progress (converted_to_order = 0)
async function getCollections(){
  // Full history — every quote the customer has ever started, draft
  // or paid. "Orders" (getOrds) is just a filtered VIEW of this same
  // list, not a separate bucket — this avoids ever showing two
  // different, possibly-disagreeing copies of the same record.
  return await _fetchMyQuotes();
}
// "Orders" = genuinely paid orders only (converted_to_order = 1, set
// server-side by mvfa-webhook.php once Shopify confirms payment — never
// just a client-side "approved" click).
async function getOrds(){
  const all = await _fetchMyQuotes();
  return all.filter(q => Number(q.converted_to_order) === 1);
}
async function delOrd(token){
  if(!confirm('Delete this draft?')) return;
  try {
    await fetch('https://api.mvfa.ca/mvfa-quote-save.php?action=delete', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({token})
    });
  } catch(e) {}
  let t = _myTokens().filter(x=>x!==token);
  localStorage.setItem('mvfa_my_tokens', JSON.stringify(t));
  await _fetchMyQuotes(true);
  renderOrds(); renderCollections(); updBadge();
}
async function updBadge(){
  const orders = await getOrds();
  document.getElementById('obadge').textContent = orders.length;
}
// Saved quote state (B.items) is always persisted in raw BUILDER shape
// (gt, wt, fab, szs, colour:{hex,name}) — never PO-line shape. poRenderLines()
// expects PO-line shape (styleNum, styleDesc, fabric, colour as a plain
// string, sizeQtys, totalQty, price). Without converting here, poRenderLines()
// throws mid-render on undefined l.sizeQtys/l.price and the whole PO table
// silently ends up empty — even though B.items itself is fully populated.
// costs = B._costs, keyed by item.id, populated by bCalcBoM() just before
// this runs (price is never persisted on the item itself).
// A "style" for design-fee purposes = garment type + fabric + weight.
// Two lines that share all three (e.g. two colourways of the same Tencel
// underwear style) are the same style and should only be charged the
// flat design fee once between them. Extra selected services (screenprint
// colours etc.) still apply per line since those can genuinely differ
// between colourways of the same style.
// Fixes a specific PHP/JSON round-trip corruption: PHP's json_decode()
// can't distinguish an empty JSON object {} from an empty JSON array [],
// and always re-encodes an empty PHP array as []. So the first time an
// item's szs is ever empty at save time, it comes back from every future
// load as a genuine JS array instead of an object -- and JSON.stringify()
// silently drops string-keyed properties on arrays (confirmed: sizes
// added via szs['S']=20 on a poisoned array vanish on the very next
// save, with no error, no warning). Must run immediately after every
// state load, before any UI code touches B.items, so a poisoned item
// never survives to be edited.
function bNormalizeLoadedItems(items){
  (items||[]).forEach(it => {
    if (Array.isArray(it.szs)) {
      const fixed = {};
      // Preserve any string-keyed values the array happened to carry in
      // memory (won't exist after a real save/reload, but safe either way).
      Object.keys(it.szs).forEach(k => { if (isNaN(k)) fixed[k] = it.szs[k]; });
      it.szs = fixed;
    }
    if (Array.isArray(it.trimQty)) {
      const fixed = {};
      Object.keys(it.trimQty).forEach(k => { if (isNaN(k)) fixed[k] = it.trimQty[k]; });
      it.trimQty = fixed;
    }
    if (Array.isArray(it.pocketQty)) {
      const fixed = {};
      Object.keys(it.pocketQty).forEach(k => { if (isNaN(k)) fixed[k] = it.pocketQty[k]; });
      it.pocketQty = fixed;
    }
  });
}
function poStyleKey(it){
  return [(it.gt||'').trim().toLowerCase(), (it.fab||'').trim().toLowerCase(), (it.wt||'').trim().toLowerCase()].join('|');
}
// Referenced in mvfa-quote-save.php's own syncPoLines() comment as the
// single place that decides which style owes a design fee -- built here
// to close that gap. Every unique style (garment+fabric+weight) across
// B.items owes the flat design fee exactly once, matching the same rule
// already applied consistently everywhere else pricing gets calculated
// (poComputeOrderPricing, bBuildQP, bSubmit's itemLines).
function poComputeDesignLines(){
  const seenStyles = new Set();
  const perStyle = [];
  (B.items||[]).forEach(it => {
    if (it.merch) return; // blanks + decoration: no design fee, nothing for the server to add
    const key = poStyleKey(it);
    if (seenStyles.has(key)) return;
    seenStyles.add(key);
    perStyle.push({ appliesTo: key, label: 'Design Fee (Includes Tech Pack)', amount: DESIGN_FEE });
  });
  const general = (B.ads||[]).map(d => ({ label: `Design Service: ${d}`, amount: ADS_P[d]||0 }));
  return { perStyle, general };
}
// Computes effective per-item pricing across a FULL set of items at once —
// design fee dedup requires knowing about every sibling item, not just the
// one being priced in isolation. Returns a Map from item.id -> {price,
// designFee, designSvcTotal}. Mirrors bSubmit()'s original per-item math,
// but the flat DESIGN_FEE is only charged on each style's first
// occurrence in `items` (in array order); every later item of the same
// style gets designFee:0.
function poComputeOrderPricing(items, costs){
  const seenStyles = new Set();
  const result = new Map();
  (items||[]).forEach(it => {
    const key = poStyleKey(it);
    const chargeDesignFee = !seenStyles.has(key);
    seenStyles.add(key);
    const cost = costs && costs[it.id];
    const up = cost ? (cost.unitPrice||0) : 0;
    const itDesign = it.design || [];
    const designSvcTotal = itDesign.reduce((s,d)=>s+(DSP[d]||0),0);
    const designFee = (chargeDesignFee && !it.merch) ? DESIGN_FEE : 0;
    // price is PURELY the per-unit garment cost -- labour + fabric
    // consumption, exactly what mvfa-quote-engine.php returns as
    // unitPrice. Design fee is a one-time, order-level charge and must
    // never be part of any per-unit number, blended or otherwise --
    // callers needing an order total add designFee/designSvcTotal
    // separately (once per style, not divided across quantity).
    result.set(it.id, {price: up, designFee, designSvcTotal});
  });
  return result;
}
// Sums design fees across all lines for a real order total -- design
// fee is charged once per unique style (not per unit, not divided by
// quantity), so this is always a separate addition, never folded into
// a per-unit price anywhere.
function poDesignFeeSubtotal(lines){
  return (lines||[]).reduce((s,l)=>s+(l.designFee||0)+(l.designSvcTotal||0),0);
}
// Real, full order total -- garment cost + design fee/services + tax --
// for persisting as estimated_total. Previously several save paths
// (bSaveQuoteProgress, bAdminSaveState) computed only the raw garment
// subtotal with no design fee and no tax at all, which is a different,
// smaller number than what the customer's own quote/email/PO view
// shows. Whichever save fired LAST determined what the Saved Quotes
// dashboard displayed, so an admin save after submission could silently
// overwrite a correct total with this incomplete one. Reuses
// poComputeOrderPricing()'s existing per-style dedup logic, so this can
// never compute the design fee differently than everywhere else does.
function bComputeFullOrderTotal(items, costs){
  const pricing = poComputeOrderPricing(items||[], costs||{});
  let sub = 0;
  (items||[]).forEach(it => {
    const p = pricing.get(it.id);
    if (!p) return;
    sub += p.price * bQty(it) + p.designFee + p.designSvcTotal;
  });
  const prov = (B.customer && B.customer.province) || 'ON';
  const tax = sub * provTaxRate(prov);
  return sub + tax;
}
// Customer-facing style numbers now use the brand name they entered in
// Step 1, not a generic "MVFA-" prefix — e.g. ACME-JOGGERS-002. Falls back
// to 'MVFA' only for old saved quotes from before this field existed.
function poBrandPrefix(){
  const raw = (B.brandName||'').trim();
  const clean = raw.replace(/[^a-zA-Z0-9]/g,'').toUpperCase().slice(0,12);
  return clean || 'MVFA';
}
// idx = the item's position in the full order (0-based) — sequence number
// is order-wide and increments per item regardless of garment type, e.g.
// ACME-JOGGERS-002, ACME-JOGGERS-003, ACME-TSHIRTS-004. This is a generic
// quote-stage placeholder; existing Invoice-2-stage logic already replaces
// it with a real style number at time of order — confirm that logic
// doesn't specifically hard-match the old "MVFA-" prefix now that this
// varies per customer.
function poStyleNum(it, idx){
  const garment = it.gt ? String(it.gt).replace(/[^a-zA-Z0-9]/g,'').toUpperCase() : 'ITEM';
  const seq = String(idx+1).padStart(3,'0');
  return `${poBrandPrefix()}-${garment}-${seq}`;
}
function poNormalizeLine(it, priceInfo, idx){
  const q = bQty(it);
  if (it.merch) {
    const m = it.merch;
    return {
      id: it.id,
      // Same scheme as custom styles (BRAND-GARMENT-001); the S&S style is kept as the vendor reference
      styleNum: poStyleNum({gt: m.catLabel||'Blank'}, idx||0),
      vendorStyle: 'SS-'+(m.styleID||''),
      styleDesc: (m.styleName||it.gt||'Blank garment')+' \u2014 '+(m.decoDesc||'Blanks Only'),
      fabric: m.blankFabric || merchBlankFabricGuess(m.catLabel),
      fabricGSM: '',
      colour: m.colorName || (it.colour&&it.colour.name) || 'TBD',
      colourHex: (it.colour&&it.colour.hex)||'#999',
      sizeQtys: Object.assign({}, it.szs||{}),
      totalQty: q,
      price: priceInfo ? priceInfo.price : (parseFloat(m.unitPrice)||0),
      msrp: 0,
      fromBuilder: true,
      merchImg: m.frontImg||'',
      artworkNotes: m.artworkNotes||'',
      artworkFiles: m.artworkFiles||[],
      inkColours: m.inkColours||[],
      needsQuote: !!m.needsQuote,
      designFee: 0,
      designSvcTotal: 0,
    };
  }
  const price = priceInfo ? priceInfo.price : 0;
  const colourName = it.colour ? (typeof it.colour==='object' ? (it.colour.name||'TBD') : it.colour) : 'TBD';
  const colourHex  = it.colour && typeof it.colour==='object' ? (it.colour.hex||'#999') : (it.colourHex||'#999');
  const fabricGSM = FAB_WEIGHTS.find(w=>w.k===(it.wt||'mid'))?.l || '';
  return {
    id: it.id,
    styleNum: poStyleNum(it, idx||0),
    styleDesc: it.gt || it.styleDesc || it.name || 'Existing item',
    fabric: it.fab || (it.fabrics && it.fabrics[0] && it.fabrics[0].name) || '',
    fabricGSM: fabricGSM,
    colour: colourName,
    colourHex: colourHex,
    sizeQtys: Object.assign({}, it.szs || it.sizeQtys || {}),
    totalQty: q,
    price: price,
    msrp: it.msrp || parseFloat((price*1.8).toFixed(2)),
    fromBuilder: true,
    cad: it.cad || null,
    designFee: priceInfo ? priceInfo.designFee : 0,
    designSvcTotal: priceInfo ? priceInfo.designSvcTotal : 0,
  };
}
async function openOrd(token){
  try {
    const r = await fetch('https://api.mvfa.ca/mvfa-quote-save.php?action=load&token=' + encodeURIComponent(token));
    const data = await r.json();
    if (!data.success || !data.state) { toast('Not found'); return; }
    delete B.ship;
    Object.assign(B, data.state);
    bNormalizeLoadedItems(B.items);
    window._quoteResumeToken = token;
    // Preserve full-detail items BEFORE anything narrows B.items down
    // for single-line editing. poLines (built from these via
    // poNormalizeLine) drops decoration detail entirely -- no brand
    // (silkscreen/embroidery), trims, or labels, since those were never
    // included in that shape. Without this preserved copy, editing a
    // single line and saving would reconstruct every OTHER line from
    // that lossy shape, permanently wiping their decoration selections.
    // This is what poEditLine() and poFinishEdit() read from/write back
    // to, so a real item's full detail survives being edited alongside
    // its unedited siblings.
    window._poFullItems = JSON.parse(JSON.stringify(data.state.items || []));
    // Switch to the My Collections / PO view itself FIRST — this view
    // is hidden by default (.view{display:none}) and only the active
    // tab gets .act applied. Without this, toggling display on the
    // inner collections-list-wrap/po-editor-wrap elements had no
    // visible effect at all when clicked from a DIFFERENT tab (e.g.
    // Orders), since the whole parent container stayed hidden by CSS
    // regardless of its children's own display properties.
    document.querySelectorAll('.view').forEach(e=>e.classList.remove('act'));
    document.querySelectorAll('.ntab').forEach(e=>e.classList.remove('act'));
    document.getElementById('vpo').classList.add('act');
    document.getElementById('nb-po').classList.add('act');
    document.getElementById('collections-list-wrap').style.display='none';
    document.getElementById('po-editor-wrap').style.display='';
    // Show a real loading state immediately — without this, the table is
    // still showing whatever poLines held before this call (usually
    // empty), which falls through to poRenderLines()'s "No lines yet —
    // add a product" empty state. That reads as a genuinely empty/broken
    // order rather than "still loading," even though it resolves correctly
    // a moment later once the pricing recompute below finishes.
    const tbLoading = document.getElementById('po-tbody');
    if (tbLoading) tbLoading.innerHTML = `<tr><td colspan="9"><div class="empty-st"><div class="empty-icon">⏳</div><div>Loading order…</div></div></td></tr>`;
    // Recompute pricing for every item — raw items loaded from saved state
    // never carry price on themselves; it only ever lived in B._costs
    // (keyed by item id) and is never part of what gets persisted.
    //
    // EXCEPTION: paid/converted orders use their FROZEN price (captured at
    // bSubmit() time) instead of live-recalculating. A quote_constants
    // change made to fix ONE customer's quote must never silently ripple
    // into every other order using the same rate -- especially not a
    // PAID one. Only an explicit admin refresh (Admin Edit's "Refresh to
    // Current Rates") can change a paid order's price after the fact.
    if (!B._costs) B._costs = {};
    window._pricingIsFrozen = !!data.converted_to_order;
    if (data.converted_to_order) {
      const needsLiveCalc = [];
      (B.items||[]).forEach(it => {
        if (it.frozenPrice != null) {
          B._costs[it.id] = { unitPrice: it.frozenPrice };
        } else {
          // Legacy paid order from before price-freezing existed --
          // nothing frozen to show, so fall back to a one-time live calc
          // rather than displaying $0.
          needsLiveCalc.push(it);
        }
      });
      if (needsLiveCalc.length) {
        await Promise.all(needsLiveCalc.map(async it => {
          const fresh = await bCalcBoM(it, bQty(it)||120);
          if (fresh && fresh.unitPrice > 0) B._costs[it.id] = fresh;
        }));
      }
    } else {
      await Promise.all((B.items||[]).map(async it => {
        const fresh = await bCalcBoM(it, bQty(it)||120);
        if (fresh && fresh.unitPrice > 0) B._costs[it.id] = fresh;
      }));
    }
    const pricing = poComputeOrderPricing(B.items||[], B._costs);
    const lines = (B.items||[]).map((it,idx) => poNormalizeLine(it, pricing.get(it.id), idx));
    // Collection-level design services (B.ads, e.g. "Design Direction",
    // "Full Collection") were never included in this live-recalculated
    // view at all -- only per-item pricing was. bSubmit() and
    // syncPoLines() both correctly add these as their own lines; this
    // view just never did, which is why a service added via Admin Edit
    // showed correctly in the updated email (reading from po_lines) but
    // vanished the instant the customer viewed My Collections (reading
    // from this live recalc instead).
    (B.ads||[]).forEach(d => {
      lines.push({
        id: 'ads-' + d.replace(/\s+/g,'-'),
        styleNum: 'DESIGN-SVC',
        styleDesc: `Design Service: ${d}`,
        fabric: '', fabricGSM: '', colour: '—', colourHex: null,
        sizeQtys: {}, totalQty: 1,
        price: ADS_P[d]||0, msrp: 0,
        fromBuilder: true, isDesignService: true,
        designFee: 0, designSvcTotal: 0,
      });
    });
    const o={ref:B.ref, customer:B.customer||{}, lines, totals:{}, meta:B.meta||{}, notes:B.notes||''};
    poClear(true);
    // Set AFTER poClear — poClear resets this flag to false as a safety
    // default for brand-new manual orders, so it must be set for real
    // here, after that reset, not before it.
    window._currentOrderIsPaid = Number(data.converted_to_order) === 1;
    loadPO(o);
    poRenderNextSteps();
  } catch(e) { console.error('openOrd failed:', e); toast('Could not load — try again'); }
}

async function renderOrds(){
  const a=await getOrds(),el=document.getElementById('ords-list');
  if(!a.length){el.innerHTML=`<div class="empty-st"><div class="empty-icon">📁</div><div style="font-size:14px">No orders yet</div><div style="font-size:12px;margin-top:6px">Once a quote is paid, it will appear here</div></div>`;return;}
  el.innerHTML=a.map(o=>`<div class="ocard">
    <div>
      <div class="ocref">${o.quote_ref||'—'}<span class="schip sc-p">Deposit Paid</span></div>
      <div class="ocname">${o.builder_state?.customer?.name||'—'}</div>
      <div class="ocmeta">${o.item_count||0} items · ${o.furthest_step||''}</div>
      <div class="ocacts">
        <button class="ocbtn ocbtn-gold" onclick="openOrd('${o.resume_token}')">📋 View</button>
      </div>
    </div>
    <div><div class="octotal">CAD$ ${fmt(o.estimated_total||0)}</div><div class="ocdate">${o.updated_at?new Date(o.updated_at).toLocaleDateString('en-CA',{month:'short',day:'numeric',year:'numeric'}):''}</div></div>
  </div>`).join('');
}

// "My Collections" — drafts/in-progress quotes, never-paid. Same card
// style as Orders, but Delete is allowed here (server refuses to delete
// anything already converted_to_order=1, as a safety backstop).
async function renderCollections(){
  const a=await getCollections(),el=document.getElementById('collections-list');
  if(!el) return;
  if(!a.length){el.innerHTML=`<div class="empty-st"><div class="empty-icon">📁</div><div style="font-size:14px">No saved collections yet</div><div style="font-size:12px;margin-top:6px">Start building in Design — your progress saves automatically from Step 4 onward</div></div>`;return;}
  el.innerHTML=a.map(o=>{
    const isPaid = Number(o.converted_to_order)===1;
    const _its = (o.builder_state && o.builder_state.items) || [];
    const _tf = _its.find(x=>x&&x.merch&&x.merch.frontImg) || _its.find(x=>x&&x.cad&&x.cad.thumb);
    const _thumb = _tf ? (_tf.merch ? _tf.merch.frontImg : _tf.cad.thumb) : '';
    return `<div class="ocard">
    <div>
      <div class="ocref">${_thumb?`<img src="${bCadEsc(_thumb)}" alt="" style="width:30px;height:36px;object-fit:contain;background:#fff;border-radius:3px;vertical-align:middle;margin-right:8px">`:''}${o.quote_ref||'—'}<span class="schip ${isPaid?'sc-p':'sc-d'}">${isPaid?'Deposit Paid':'Draft'}</span></div>
      <div class="ocname">${o.builder_state?.customer?.name||'—'}</div>
      <div class="ocmeta">${o.item_count||0} items · ${isPaid?'paid':'last edited'} ${o.furthest_step||''}</div>
      <div class="ocacts">
        <button class="ocbtn ocbtn-gold" onclick="openOrd('${o.resume_token}')">📋 ${isPaid?'View':'Edit'}</button>
        ${isPaid?'':`<button class="ocbtn ocbtn-del" onclick="delOrd('${o.resume_token}')">Delete</button>`}
      </div>
    </div>
    <div><div class="octotal">CAD$ ${fmt(o.estimated_total||0)}</div><div class="ocdate">${o.updated_at?new Date(o.updated_at).toLocaleDateString('en-CA',{month:'short',day:'numeric',year:'numeric'}):''}</div></div>
  </div>`;
  }).join('');
}


// ── PDF / PRINT GENERATOR ─────────────────────────────────────────
function mvfaPrintPDF() {
  var orders = getOrds();
  var order  = B.ref ? orders.find(function(o){ return o.ref === B.ref; }) : null;
  var items  = order ? order.lines : B.items;

  if (!items || !items.length) { toast('No items to print'); return; }

  var customer = order ? order.customer : {
    name:    (document.getElementById('cf-brand')  ||{}).value||'',
    contact: ((document.getElementById('cf-fn')||{}).value||'')+' '+((document.getElementById('cf-ln')||{}).value||''),
    email:   (document.getElementById('cf-email')  ||{}).value||'',
    phone:   (document.getElementById('cf-phone')  ||{}).value||'',
    addr:    (document.getElementById('cf-addr')   ||{}).value||'',
    city:    (document.getElementById('cf-city')   ||{}).value||'',
  };
  var meta = order ? order.meta : {
    season:    'FALL',
    delivDate: (document.getElementById('cf-delivery')||{}).value||'TBD',
  };
  var totals = order ? order.totals : null;
  var sub = 0;
  items.forEach(function(it) {
    var sizes = it.sizeQtys||it.szs||{};
    var qty   = it.totalQty||it.qty||Object.values(sizes).reduce(function(a,b){return a+parseInt(b||0);},0);
    sub += parseFloat(it.price||it.unitPrice||0) * qty;
  });
  if (totals && totals.sub) sub = parseFloat(totals.sub);
  var pdfProv = (order && order.customer && order.customer.province) || (document.getElementById('cf-province')||{}).value || 'ON';
  var tax     = (totals && typeof totals.tax==='number') ? totals.tax : sub * provTaxRate(pdfProv);
  var taxLabel = provTaxLabel(pdfProv);
  var total   = sub + tax;
  var deposit = total * 0.60;
  var balance = total * 0.40;
  var docRef  = B.ref||(order&&order.ref)||('MVFA-'+Date.now());
  var today   = new Date().toLocaleDateString('en-CA',{year:'numeric',month:'long',day:'numeric'});

  var rows = items.map(function(it,i) {
    var sizes    = it.sizeQtys||it.szs||{};
    var sizeStr  = Object.entries(sizes).filter(function(e){return parseInt(e[1])>0;}).map(function(e){return '<span style="margin-right:6px"><b>'+e[0]+'</b> '+e[1]+'</span>';}).join('');
    var qty      = it.totalQty||it.qty||Object.values(sizes).reduce(function(a,b){return a+parseInt(b||0);},0);
    var price    = parseFloat(it.price||it.unitPrice||0);
    var lineTot  = price*qty;
    var bg       = i%2===0?'#fff':'#f9f8f6';
    return '<tr style="background:'+bg+'">'+
      '<td style="padding:8px;border-bottom:1px solid #eee;color:#999">'+(i+1)+'</td>'+
      '<td style="padding:8px;border-bottom:1px solid #eee">'+
        '<b style="color:#1a2a4a">'+(it.name||it.styleDesc||'Custom Item')+'</b>'+
        (it.styleNum?'<br><span style="color:#888;font-size:10px">SKU: '+it.styleNum+'</span>':'')+
        (it.fabric?'<br><span style="color:#666;font-size:10px">'+it.fabric+(it.colour?' · '+it.colour:'')+'</span>':'')+
        (it.labelStyle?'<br><span style="color:#888;font-size:10px">Label: '+it.labelStyle+'</span>':'')+
      '</td>'+
      '<td style="padding:8px;border-bottom:1px solid #eee;font-size:10px;line-height:2">'+sizeStr+'</td>'+
      '<td style="padding:8px;border-bottom:1px solid #eee;text-align:center;font-weight:700">'+qty+'</td>'+
      '<td style="padding:8px;border-bottom:1px solid #eee;text-align:right">$'+price.toFixed(2)+'</td>'+
      '<td style="padding:8px;border-bottom:1px solid #eee;text-align:right;font-weight:700;color:#1a2a4a">$'+lineTot.toFixed(2)+'</td>'+
    '</tr>';
  }).join('');

  var html =
    '<!DOCTYPE html><html><head><meta charset="UTF-8">'+
    '<title>MVFA QUOTATION \u2014 '+docRef+'</title>'+
    '<style>*{margin:0;padding:0;box-sizing:border-box}body{font-family:Arial,sans-serif;font-size:12px;color:#222}'+
    '@page{margin:0.75in;size:letter}@media print{.noprint{display:none!important}}</style></head><body>'+

    '<div style="background:#111111;color:#fff;padding:20px 28px;display:flex;justify-content:space-between;align-items:flex-start">'+
      '<div><div style="font-size:26px;font-weight:900;letter-spacing:3px">MVFA</div>'+
      '<div style="font-size:9px;letter-spacing:4px;color:#b8922a;margin-top:2px">DESIGN HOUSE</div>'+
      '<div style="font-size:9px;color:rgba(255,255,255,0.5);margin-top:10px;line-height:1.7">231 Annette Street, Toronto ON M6P 1P9<br>(416) 827-3848 \xb7 mvfa.ca</div></div>'+
      '<div style="text-align:right">'+
        '<div style="font-size:18px;font-weight:700;color:#b8922a;letter-spacing:2px">QUOTATION</div>'+
        '<div style="font-size:11px;color:rgba(255,255,255,0.7);margin-top:4px">Ref: '+docRef+'</div>'+
        '<div style="font-size:10px;color:rgba(255,255,255,0.5);margin-top:2px">'+today+'</div>'+
        (meta.season?'<div style="font-size:10px;color:rgba(255,255,255,0.5)">Season: '+meta.season+'</div>':'')+
        (meta.delivDate?'<div style="font-size:10px;color:rgba(255,255,255,0.5)">Delivery: '+meta.delivDate+'</div>':'')+
      '</div>'+
    '</div>'+

    '<div style="display:flex;border-bottom:2px solid #1a2a4a">'+
      '<div style="flex:1;padding:12px 16px;border-right:1px solid #eee">'+
        '<div style="font-size:8px;letter-spacing:2px;color:#b8922a;text-transform:uppercase;margin-bottom:6px">BUYER</div>'+
        '<div style="line-height:1.7"><b>'+(customer.name||customer.brand||'')+'</b><br>'+(customer.contact||'')+'<br>'+(customer.email||'')+'<br>'+(customer.phone||'')+'</div>'+
      '</div>'+
      '<div style="flex:1;padding:12px 16px;border-right:1px solid #eee">'+
        '<div style="font-size:8px;letter-spacing:2px;color:#b8922a;text-transform:uppercase;margin-bottom:6px">SHIP TO</div>'+
        '<div style="line-height:1.7">'+(customer.addr||'')+'<br>'+(customer.city||'')+'</div>'+
      '</div>'+
      '<div style="flex:1;padding:12px 16px">'+
        '<div style="font-size:8px;letter-spacing:2px;color:#b8922a;text-transform:uppercase;margin-bottom:6px">PAYMENT TERMS</div>'+
        '<div style="line-height:1.7">60% deposit to begin production<br>40% balance due on delivery<br>Currency: CAD</div>'+
      '</div>'+
    '</div>'+

    '<table style="width:100%;border-collapse:collapse">'+
      '<thead><tr style="background:#1a2a4a;color:#fff">'+
        '<th style="padding:9px 8px;text-align:left;font-size:10px;width:25px">#</th>'+
        '<th style="padding:9px 8px;text-align:left;font-size:10px">Item / Description</th>'+
        '<th style="padding:9px 8px;text-align:left;font-size:10px">Size Breakdown</th>'+
        '<th style="padding:9px 8px;text-align:center;font-size:10px;width:50px">Qty</th>'+
        '<th style="padding:9px 8px;text-align:right;font-size:10px;width:80px">Unit Price</th>'+
        '<th style="padding:9px 8px;text-align:right;font-size:10px;width:90px">Total</th>'+
      '</tr></thead>'+
      '<tbody>'+rows+'</tbody>'+
    '</table>'+

    '<div style="display:flex;justify-content:flex-end;margin:12px 0">'+
      '<div style="width:260px;padding:0 16px">'+
        '<div style="display:flex;justify-content:space-between;padding:5px 0;border-bottom:1px solid #eee"><span>Subtotal</span><span>CAD$ '+sub.toFixed(2)+'</span></div>'+
        '<div style="display:flex;justify-content:space-between;padding:5px 0;border-bottom:1px solid #eee"><span>'+taxLabel+'</span><span>CAD$ '+tax.toFixed(2)+'</span></div>'+
        '<div style="display:flex;justify-content:space-between;padding:8px 0;border-bottom:2px solid #1a2a4a;font-size:14px;font-weight:700;color:#1a2a4a"><span>ORDER TOTAL</span><span>CAD$ '+total.toFixed(2)+'</span></div>'+
        '<div style="display:flex;justify-content:space-between;padding:6px 0;font-weight:600;color:#b8922a"><span>60% Deposit Due</span><span>CAD$ '+deposit.toFixed(2)+'</span></div>'+
        '<div style="display:flex;justify-content:space-between;padding:4px 0;color:#888"><span>40% Balance on Delivery</span><span>CAD$ '+balance.toFixed(2)+'</span></div>'+
      '</div>'+
    '</div>'+

    '<div style="padding:10px 14px;background:#fff8f0;border-left:3px solid #b8922a;margin:8px 0;font-size:10px;color:#666;line-height:1.6">'+
      '<b>Payment Terms:</b> A non-refundable 60% deposit is required to initiate tech packs, samples and bulk production. The remaining 40% balance plus freight is due prior to shipment.<br>Prices are subject to final confirmed trims and materials. Prices quoted include Basic Trims and are subject to change based on finalized trims and packaging.<br>Prices include up to 2 (two) Pre-Production / Fit Samples to be supplied prior to bulk production for approval.<br>Pre-Production Colour, Fabric, and Trims Submissions to be supplied prior to bulk production for approval.<br>Prices Quoted are Landed Duty Paid, FOB Toronto; domestic freight will be charged at time of shipping.<br>Please examine goods upon receipt. No claims made 5 days after receipt of goods will be honoured. Delivery which does not vary more than ten percent (10%) of the quantities contracted, and delivery of substituted sizes or colours, shall constitute compliance under this contract.<br>Title of goods shall remain with 15219523 Canada Inc. / MVFA Design House until paid in full.<br>Approving this quotation confirms you have read, signed, and agree to our Terms and Conditions of Sale. The receipt by the SELLER of any payment by the BUYER shall constitute the BUYER&#39;s full acceptance of the terms specified herein and of the MVFA Terms and Conditions of Sale Agreement: mvfa.ca/pages/terms-conditions-mvfa-design-house</div>'+

    '<div style="background:#f5f0e8;padding:10px 16px;display:flex;justify-content:space-between;font-size:9px;color:#888;margin-top:8px">'+
      '<div>SELLER: MVFA Design House \xb7 15219523 Canada Inc. \xb7 231 Annette Street Toronto ON M6P 1P9 \xb7 (416) 827-3848 \xb7 mvfa.ca</div>'+
      '<div>'+docRef+' \xb7 '+today+'</div>'+
    '</div>'+

    '<div class="noprint" style="position:fixed;bottom:20px;right:20px;display:flex;gap:8px">'+
      '<button onclick="window.print()" style="background:#1a2a4a;color:#fff;border:none;padding:12px 24px;border-radius:6px;cursor:pointer;font-size:13px;font-weight:600">\uD83D\uDDA8 Print / Save PDF</button>'+
      '<button onclick="window.close()" style="background:#888;color:#fff;border:none;padding:12px 16px;border-radius:6px;cursor:pointer;font-size:13px">\u2715 Close</button>'+
    '</div>'+

    '<script>setTimeout(function(){window.print();},500);<\/script>'+
    '</body></html>';

  var w = window.open('','_blank','width=960,height=750,scrollbars=yes');
  if (!w) { toast('Please allow popups to print'); return; }
  w.document.open();
  w.document.write(html);
  w.document.close();
}

// ── PO MODULE PRINT ───────────────────────────────────────────────
function mvfaPrintPO() {
  // Get the rendered PO document HTML
  var podoc = document.querySelector('.podoc');
  if (!podoc) { toast('No PO document to print'); return; }

  var w = window.open('', '_blank', 'width=960,height=750,scrollbars=yes');
  if (!w) { toast('Please allow popups to print'); return; }

  // Gather all styles from the page
  var styles = Array.from(document.styleSheets).map(function(ss) {
    try {
      return Array.from(ss.cssRules).map(function(r){ return r.cssText; }).join('\n');
    } catch(e) { return ''; }
  }).join('\n');

  var html =
    '<!DOCTYPE html><html><head><meta charset="UTF-8">'+
    '<title>MVFA Purchase Order</title>'+
    '<style>'+
      styles +
      '@page{size:letter;margin:0.5in}'+
      'body{background:#fff;padding:20px}'+
      '.podoc{box-shadow:none!important;border:none!important;max-width:100%!important;margin:0!important}'+
      '.noprint,.poabtn,.poab{display:none!important}'+
      '*{-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important}'+
    '</style></head><body>'+
    podoc.outerHTML+
    '<div style="position:fixed;bottom:20px;right:20px;display:flex;gap:8px" class="noprint">'+
      '<button onclick="window.print()" style="background:#111;color:#fff;border:none;padding:12px 24px;border-radius:6px;cursor:pointer;font-size:13px;font-weight:600">🖨 Print / Save PDF</button>'+
      '<button onclick="window.close()" style="background:#888;color:#fff;border:none;padding:12px 16px;border-radius:6px;cursor:pointer;font-size:13px">✕ Close</button>'+
    '</div>'+
    '<script>setTimeout(function(){window.print();},600);<\/script>'+
    '</body></html>';

  w.document.open();
  w.document.write(html);
  w.document.close();
}


// Dropdown manager — tracks open dropdown, closes on outside click.
// MUST be global scope: every "+ Add Fabric/Trim/Label/Crest/Size" button
// and every dropdown option uses inline onclick="mvfaOpenDD(this)" /
// onclick="...;mvfaCloseDD(this.parentNode)", which only resolves against
// global functions — they cannot see functions declared inside window.onload.
var _openDD=null;
function mvfaOpenDD(el){
  var dd=el.nextElementSibling;
  if(!dd)return;
  if(_openDD&&_openDD!==dd){_openDD.style.display='none';}
  dd.style.display=dd.style.display==='block'?'none':'block';
  if(dd.style.display==='block'&&el.closest&&el.closest('.yarn-scroll')){
    var r=el.getBoundingClientRect();
    dd.style.position='fixed';dd.style.top=(r.bottom+4)+'px';dd.style.margin='0';
    dd.style.left=Math.max(8,Math.min(r.left,window.innerWidth-232))+'px';
  }
  _openDD=dd.style.display==='block'?dd:null;
  if(dd.style.display!=='block')window._ddKeep=null;
}
(function(){try{if(document.getElementById('mvfa-mobile-css'))return;var st=document.createElement('style');st.id='mvfa-mobile-css';
st.textContent='.igt-grid .pill{white-space:nowrap}@media(max-width:600px){.igt-grid>div{flex:1 1 100%}.igt-grid .pills{flex-wrap:wrap}.fab-hdr{display:none!important}.blend-pop{position:fixed!important;left:0!important;right:0!important;bottom:0!important;top:auto!important;width:auto!important;border-radius:16px 16px 0 0!important;margin:0!important;padding:16px 16px 24px!important;max-height:75vh;overflow-y:auto;box-shadow:0 -8px 32px rgba(0,0,0,0.6)!important}}';
document.head.appendChild(st);}catch(e){}})();
window._ys=window._ys||{};
function bYarnScroll(el){window._ys[el.dataset.ys]=el.scrollLeft;if(_openDD){_openDD.style.display='none';_openDD=null;}}
function bYarnRestore(){document.querySelectorAll('.yarn-scroll').forEach(function(e){var v=window._ys[e.dataset.ys];if(v)e.scrollLeft=v;});}
function mvfaCloseDD(dd){if(dd)dd.style.display='none';if(_openDD===dd)_openDD=null;}

window.addEventListener('load', ()=>{
  // addEventListener rather than window.onload= -- a direct assignment can
  // be silently overwritten by any other script on the page (confirmed:
  // this was the actual cause of Admin Edit / resume links appearing to
  // do nothing -- window.onload was being clobbered by something else in
  // the Shopify theme, with zero error shown anywhere). addEventListener
  // coexists safely with whatever else runs on load.
  try { poInit(); } catch(e) { console.error('poInit failed:', e); }
  try { bUpdateProvinceOptions('ON'); } catch(e) { console.error('bUpdateProvinceOptions failed:', e); }
  try { updBadge(); } catch(e) { console.error('updBadge failed:', e); }
  try { adsInit(); } catch(e) { console.error('adsInit failed:', e); }
  try { bCheckResumeToken(); } catch(e) { console.error('bCheckResumeToken failed:', e); }
  try { bCheckAdminEdit(); } catch(e) { console.error('bCheckAdminEdit failed:', e); }
  try { bCheckMerchLink(); } catch(e) { console.error('bCheckMerchLink failed:', e); }
  document.addEventListener('click',function(e){
    if(!_openDD)return;
    // A click on an element a re-render just detached (e.g. a ticked option) is not a click-away
    if(!e.target.isConnected)return;
    // If click is inside the open dropdown or its trigger, do nothing
    if(_openDD.contains(e.target))return;
    if(_openDD.previousElementSibling&&_openDD.previousElementSibling.contains(e.target))return;
    _openDD.style.display='none';
    _openDD=null;
    window._ddKeep=null;
  });
  // Default delivery date to 60 days from today
  var d = new Date();
  d.setDate(d.getDate()+60);
  var dd2 = d.toISOString().split('T')[0];
  var dlv = document.getElementById('cf-delivery');
  if(dlv && !dlv.value) dlv.value = dd2;
  var poddate = document.getElementById('po-ddate');
  if(poddate && !poddate.value) poddate.value = dd2;
});

// ══════════════════════════════════════════════════
// MERCH FLOW — S&S Canada Blank Browser
// ══════════════════════════════════════════════════
const SS_PROXY = 'https://api.mvfa.ca/mvfa-ss-proxy.php';

const MERCH_CATS = [
  {id:21,   label:'T-Shirts',       icon:'👕'},
  {id:1161, label:'Hoodies',        icon:'🧥'},
  {id:8,    label:'Crewnecks',      icon:'👔'},
  {id:38,   label:'Full-Zips',      icon:'🤐'},
  {id:64,   label:'Tank Tops',      icon:'🎽'},
  {id:56,   label:'Long Sleeves',   icon:'👕'},
  {id:52,   label:'Polos',          icon:'👔'},
  {id:106,  label:'Joggers',        icon:'👖'},
  {id:43,   label:'Shorts',         icon:'🩳'},
  {id:11,   label:'Headwear',       icon:'🧢'},
  {id:186,  label:'Tote Bags',      icon:'👜'},
];

// Placement options are garment-aware — chest/sleeve placements don't apply to
// bottoms, and bottoms need their own reference points (hip, leg) that don't
// apply to tops. Keyed by MERCH_CATS category id.
const MERCH_PLACEMENTS = {
  _default: ['Front Centre','Left Chest','Back','Sleeve'],
  106: ['Left Hip','Front Leg','Back Leg'],          // Joggers
  43:  ['Left Hip','Front Leg','Back Leg'],           // Shorts
  11:  ['Front','Side'],                              // Headwear
  186: ['Front Centre','Back'],                       // Tote Bags
};
function merchPlacementsFor(catID){ return MERCH_PLACEMENTS[catID] || MERCH_PLACEMENTS._default; }

// Default blank fabric content per garment category. It feeds the fabric segment of the MVFA style number,
// so custom and merch styles are numbered by the same scheme. Admin can override it on a line.
function merchBlankFabricGuess(label){
  const l = String(label||'').toLowerCase();
  if(/hood|crew|zip|jogger|short|fleece/.test(l)) return '50% Cotton 50% Polyester';
  if(/polo/.test(l)) return '60% Cotton 40% Polyester';
  return '100% Cotton';
}
let _merchCart = [];     // [{style, colorName, frontImageUrl, skuID, size, qty, price, sku}]
let _merchStyles = [];   // current loaded styles
let _merchCatID = null;
let _merchOpenStyleIdx = null; // which style card is currently selected/open
let _styleCache = {};    // catID => styles array

// Rebuilds the merch stage markup from JS so the theme/liquid file doesn't need to change.
// Layout: sticky draft-order bar on top -> compact category tiles -> draft order list.
// Picking a category opens a full-screen style browser (bMerchOpenBrowser) with its own pinned bar.
function bMerchBuildStage(){
  const st = document.getElementById('bsMerch');
  if(!st || st.dataset.v2) return;
  st.dataset.v2 = '1';
  st.innerHTML = `
    <style>
      #merch-cats .btype-card{aspect-ratio:4/3}
      #merch-cats .btype-label{font-size:12px}
      @keyframes merchFlash{0%{box-shadow:0 0 0 0 rgba(184,146,42,.9)}100%{box-shadow:0 0 0 14px rgba(184,146,42,0)}}
      .merch-flash{animation:merchFlash .9s ease-out}
    </style>
    <div id="merch-topbar"></div>
    <div style="display:flex;align-items:baseline;justify-content:space-between;gap:12px;margin:14px 0 6px">
      <div class="stitle" style="margin:0">Pick your <em>blanks.</em></div>
      <button class="gb gb-ghost" onclick="bShow(1)" style="padding:6px 12px;font-size:11px;white-space:nowrap">← Back</button>
    </div>
    <div class="ssub" style="margin-bottom:14px"><strong style="color:var(--gold)">1</strong> Choose a garment type &nbsp;·&nbsp; <strong style="color:var(--gold)">2</strong> Pick a style, colours &amp; sizes &nbsp;·&nbsp; <strong style="color:var(--gold)">3</strong> Add decoration &nbsp;·&nbsp; <strong style="color:var(--gold)">4</strong> Draft your quote</div>
    <div style="display:flex;gap:10px;align-items:flex-start;background:rgba(184,146,42,0.08);border:1px solid rgba(184,146,42,0.3);border-radius:10px;padding:10px 12px;margin-bottom:16px;font-size:12px;color:var(--ink2);line-height:1.5"><span>📝</span><span><strong style="color:var(--white)">This is a draft, not an order.</strong> Build your selection and we\u2019ll email it to you. You can edit it, ask us questions (free) or order a sample before anything is approved. Blanks have no minimum.</span></div>
    <div id="merch-cats" class="btype-grid" style="grid-template-columns:repeat(auto-fill,minmax(104px,1fr));gap:8px;margin-bottom:22px"></div>
    <div id="merch-cart" style="display:none;margin-bottom:24px">
      <div style="font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:var(--gold);margin-bottom:12px">Your draft order</div>
      <div id="merch-cart-items" style="display:flex;flex-direction:column;gap:8px"></div>
      <div class="brow" style="margin-top:14px"><button class="gb gb-gold" onclick="bMerchAllToPO()" id="merch-next-btn" style="opacity:.4;pointer-events:none">Draft Quote →</button></div>
    </div>`;
  let ov = document.getElementById('merch-browser');
  if(!ov){
    ov = document.createElement('div');
    ov.id = 'merch-browser';
    ov.style.cssText = 'display:none;position:fixed;inset:0;z-index:10000;background:#181715;overflow-y:auto;-webkit-overflow-scrolling:touch';
    ov.innerHTML = `
      <div style="position:sticky;top:0;z-index:2;background:#181715;border-bottom:1px solid rgba(255,255,255,0.1);padding:12px 16px">
        <div style="max-width:1100px;margin:0 auto">
          <div style="display:flex;align-items:center;gap:12px;margin-bottom:10px">
            <button class="gb gb-ghost" onclick="bMerchCloseBrowser()" style="padding:6px 12px;font-size:12px;white-space:nowrap">← Categories</button>
            <div id="merch-ov-title" style="font-size:16px;font-weight:700;color:var(--white)"></div>
            <div style="margin-left:auto;font-size:11px;color:var(--ink3)">Tap a style to choose colours &amp; sizes</div>
          </div>
          <div id="merch-ov-bar"></div>
        </div>
      </div>
      <div style="max-width:1100px;margin:0 auto;padding:16px">
        <div id="merch-styles" style="display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:12px;min-height:160px"></div>
      </div>`;
    document.body.appendChild(ov);
  }
}

function bMerchOpenBrowser(catID){
  const ov = document.getElementById('merch-browser'); if(!ov) return;
  const cat = MERCH_CATS.find(c=>c.id===catID);
  const t = document.getElementById('merch-ov-title'); if(t) t.textContent = cat?cat.label:'Styles';
  ov.style.display = 'block';
  ov.scrollTop = 0;
  document.body.style.overflow = 'hidden';
  bMerchRenderBar();
}
function bMerchCloseBrowser(){
  const ov = document.getElementById('merch-browser'); if(ov) ov.style.display = 'none';
  document.body.style.overflow = '';
  bMerchRenderBar();
}
function bMerchReview(){
  bMerchCloseBrowser();
  const c = document.getElementById('merch-cart');
  if(c) c.scrollIntoView({behavior:'smooth',block:'start'});
}
function bMerchFlashBars(){
  ['merch-topbar','merch-ov-bar'].forEach(id=>{
    const el = document.getElementById(id); if(!el) return;
    const inner = el.firstElementChild; if(!inner) return;
    inner.classList.remove('merch-flash'); void inner.offsetWidth; inner.classList.add('merch-flash');
  });
}

function bMerchInit(){
  bMerchBuildStage();
  bMerchCloseBrowser();
  _merchCart = [];
  _merchCatID = null;
  bMerchRenderCats();
  bMerchRenderCart();
  document.getElementById('merch-styles').innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:40px 0;color:var(--ink3);font-size:13px">Select a garment type above</div>';
}

function bMerchRenderCats(){
  const el = document.getElementById('merch-cats');
  if(!el) return;
  el.innerHTML = MERCH_CATS.map(c=>{
    const img = (window.MERCH_CAT_IMGS||{})[c.id] || '';
    return `<div class="btype-card${_merchCatID===c.id?' sel':''}" data-catid="${c.id}" onclick="bMerchLoadCat(${c.id},this)">
      ${img?`<img src="${img}" alt="${c.label}" loading="lazy">`:'<div style="width:100%;height:100%;background:rgba(255,255,255,0.05)"></div>'}
      <div class="btype-overlay"></div>
      <div class="btype-text"><span class="btype-label">${c.label}</span></div>
      <div class="btype-check">✓</div>
    </div>`;
  }).join('');
}

async function bMerchLoadCat(catID, btn){
  if(_merchCatID===catID && _merchStyles.length){ bMerchOpenBrowser(catID); return; }
  _merchCatID = catID;
  _merchOpenStyleIdx = null;  // old index doesn't apply to the new category's list
  bMerchOpenBrowser(catID);

  // Highlight active tab
  document.querySelectorAll('#merch-cats .btype-card').forEach(b=>{
    b.classList.toggle('sel', b.dataset.catid==catID);
  });

  const grid = document.getElementById('merch-styles');
  grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:40px 0;color:var(--ink3);font-size:13px">Loading styles…</div>';

  // Check cache
  if(_styleCache[catID]){
    _merchStyles = _styleCache[catID];
    bMerchRenderStyles();
    return;
  }

  try {
    const r = await fetch(SS_PROXY, {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({action:'styles_by_category', categoryID:catID, limit:60})
    });
    const data = await r.json();
    if(!data.success || !data.styles) throw new Error(data.error||'No styles returned');
    _styleCache[catID] = data.styles;
    _merchStyles = data.styles;
    bMerchRenderStyles();
  } catch(e) {
    grid.innerHTML = `<div style="grid-column:1/-1;text-align:center;padding:40px 0;color:var(--accent);font-size:13px">Could not load styles: ${e.message}</div>`;
  }
}

function bMerchRenderStyles(){
  const grid = document.getElementById('merch-styles');
  if(!_merchStyles.length){
    grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:40px 0;color:var(--ink3)">No styles found</div>';
    return;
  }
  grid.innerHTML = _merchStyles.map((s,i)=>{
    const img = s.styleImageUrl || s.colorFrontImageUrl || '';
    const name = s.brandName ? s.brandName+' '+s.styleName : s.title||s.styleName||'Style';
    const price = s.basePrice ? '$'+parseFloat(s.basePrice).toFixed(2) : '';
    const isSel = _merchOpenStyleIdx === i;
    const inOrder = _merchCart.filter(c=>String(c.styleID)===String(s.styleID)).reduce((a,c)=>a+(c.totalQty||0),0);
    return `
      <div class="btype-card style-card${isSel?' sel':''}" onclick="bMerchOpenStyle(${i})"
        style="aspect-ratio:auto;background:rgba(255,255,255,0.04);border-radius:10px;display:flex;flex-direction:column;position:relative">
        ${inOrder?`<div style="position:absolute;top:8px;left:8px;z-index:2;background:var(--gold);color:#181715;font-size:10px;font-weight:700;padding:3px 8px;border-radius:99px">✓ ${inOrder} in order</div>`:''}
        ${img ? `<img src="${img}" alt="${name}" style="width:100%;aspect-ratio:1;object-fit:cover;display:block">` 
              : `<div style="width:100%;aspect-ratio:1;background:rgba(255,255,255,0.06);display:flex;align-items:center;justify-content:center;font-size:32px">👕</div>`}
        <div class="btype-check">✓</div>
        <div style="padding:10px">
          <div style="font-size:11px;font-weight:600;line-height:1.3;color:var(--white)">${name}</div>
          ${price ? `<div style="font-size:11px;color:var(--gold);margin-top:3px">from ${price}</div>` : ''}
        </div>
      </div>`;
  }).join('');
}

// Opens a style — fetches colours, shows picker modal
async function bMerchOpenStyle(idx){
  const style = _merchStyles[idx];
  if(!style) return;
  window._mCurrentGarmentType = style.garmentType || style.category || '';  // for margin lookup
  _merchOpenStyleIdx = idx;
  bMerchRenderStyles();  // re-render so the clicked card shows the gold frame + checkmark

  // Show modal
  let modal = document.getElementById('merch-modal');
  if(!modal){
    modal = document.createElement('div');
    modal.id = 'merch-modal';
    modal.style.cssText = 'position:fixed;inset:0;background:rgba(24,23,21,0.92);z-index:10001;display:flex;align-items:center;justify-content:center;padding:16px';
    document.body.appendChild(modal);
  }
  modal.innerHTML = `<div style="background:#1e1d1b;border:1px solid rgba(184,146,42,0.3);border-radius:14px;max-width:520px;width:100%;max-height:90vh;overflow-y:auto;padding:24px;position:relative">
    <button onclick="bMerchModalCancel()" style="position:absolute;top:12px;right:14px;background:none;border:none;color:rgba(255,255,255,0.4);font-size:20px;cursor:pointer">×</button>
    <div style="font-size:11px;color:var(--gold);letter-spacing:.1em;text-transform:uppercase;margin-bottom:6px">${style.brandName||''}</div>
    <div style="font-size:18px;font-weight:600;margin-bottom:16px">${style.styleName||style.title}</div>
    <div id="merch-modal-body" style="text-align:center;color:var(--ink3);padding:24px 0">Loading colours…</div>
  </div>`;
  modal.style.display = 'flex';

  try {
    const r = await fetch(SS_PROXY,{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({action:'products', styleID: style.styleID})
    });
    const data = await r.json();
    if(!data.success) throw new Error(data.error||'Failed');
    bMerchRenderColours(style, data.colours);
  } catch(e){
    document.getElementById('merch-modal-body').innerHTML = `<div style="color:var(--accent)">${e.message}</div>`;
  }
}

function bMerchRenderColours(style, colours){
  const body = document.getElementById('merch-modal-body');
  if(!colours||!colours.length){body.innerHTML='No colours available';return;}

  body.innerHTML = `
    <div style="margin-bottom:14px">
      <div style="font-size:11px;color:var(--ink3);text-transform:uppercase;letter-spacing:.1em;margin-bottom:8px">Colour</div>
      <div style="display:flex;flex-wrap:wrap;gap:6px" id="merch-colour-swatches">
        ${colours.map((c,i)=>`
          <div onclick="bMerchSelColour(${i})" id="mswatch-${i}"
            title="${c.colorName}"
            style="width:28px;height:28px;border-radius:50%;cursor:pointer;border:2px solid rgba(255,255,255,0.2);
                   background:${c.colorCode?'#'+c.colorCode:'rgba(255,255,255,0.15)'};
                   overflow:hidden;transition:all .15s">
            ${c.swatchImageUrl?`<img src="${c.swatchImageUrl}" style="width:100%;height:100%;object-fit:cover">`:''}
          </div>`).join('')}
      </div>
    </div>
    <div id="merch-colour-detail" style="text-align:left"></div>
    ${window._adminMode?`<div id="merch-admin-panel" style="margin-top:14px;padding:10px 12px;border:1px dashed rgba(184,146,42,0.5);border-radius:8px">
      <div style="font-size:10px;letter-spacing:.1em;text-transform:uppercase;color:var(--gold);margin-bottom:8px">Admin</div>
      <div style="display:flex;gap:8px;flex-wrap:wrap">
        <label style="flex:1;min-width:150px;font-size:11px;color:var(--ink3)">Unit price override ($)<input id="merch-admin-price" type="number" step="0.01" min="0" placeholder="blank = calculated" style="width:100%;margin-top:3px;padding:6px 8px;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.15);border-radius:6px;color:var(--white);font-family:inherit"></label>
        <label style="flex:1;min-width:150px;font-size:11px;color:var(--ink3)">Blank fabric content<input id="merch-admin-fabric" type="text" placeholder="e.g. 100% Cotton" style="width:100%;margin-top:3px;padding:6px 8px;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.15);border-radius:6px;color:var(--white);font-family:inherit"></label>
      </div></div>`:''}
    <div style="margin-top:16px;display:flex;gap:10px">
      <button onclick="bMerchAddToCart()" id="merch-add-btn"
        style="flex:1;padding:11px 16px;background:var(--gold);color:var(--ink);border:none;border-radius:var(--r);font-size:13px;font-weight:700;cursor:pointer;font-family:inherit;opacity:.4;pointer-events:none">
        Add to my draft — <span id="merch-add-total">0 units</span>
      </button>
      <button onclick="bMerchModalCancel()"
        style="padding:11px 16px;background:none;color:rgba(255,255,255,0.4);border:1px solid rgba(255,255,255,0.15);border-radius:var(--r);font-size:12px;cursor:pointer;font-family:inherit">
        Cancel
      </button>
    </div>`;

  // Store for add-to-cart
  window._mModalStyle   = style;
  window._mModalColours = colours;
  window._mSelColour    = null;
  window._mSizeQtys     = {}; // {size: qty}
}

function bMerchSelColour(idx){
  const colours = window._mModalColours;
  const c = colours[idx];
  window._mSelColour = c;
  window._mSizeQtys  = {};

  // Update swatch borders
  colours.forEach((_,i)=>{
    const el = document.getElementById('mswatch-'+i);
    if(el) el.style.borderColor = i===idx ? 'var(--gold)' : 'rgba(255,255,255,0.2)';
  });

  const detail = document.getElementById('merch-colour-detail');
  detail.innerHTML = `
    <div style="display:flex;gap:12px;margin-bottom:12px">
      ${c.frontImageUrl?`<img src="${c.frontImageUrl}" style="width:80px;height:80px;object-fit:cover;border-radius:6px;border:1px solid rgba(255,255,255,0.1)">`:''}
      ${c.backImageUrl ?`<img src="${c.backImageUrl}"  style="width:80px;height:80px;object-fit:cover;border-radius:6px;border:1px solid rgba(255,255,255,0.1)">`:''}
    </div>
    <div style="font-size:12px;font-weight:600;margin-bottom:8px">${c.colorName}</div>
    <div style="font-size:11px;color:var(--ink3);text-transform:uppercase;letter-spacing:.1em;margin-bottom:8px">Quantity per size</div>
    <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(64px,1fr));gap:8px">
      ${c.sizes.map((s,si)=>`
        <div style="text-align:center;opacity:${s.qty>0?1:0.35}">
          <div style="font-size:11px;color:var(--ink3);margin-bottom:4px">${s.size}${s.qty===0?' (OOS)':''}</div>
          <input type="number" min="0" step="1" value="0" id="msizeqty-${si}"
            ${s.qty===0?'disabled':''}
            oninput="bMerchSizeQtyChange(${si},'${s.size}',this.value)"
            style="width:100%;padding:6px 4px;text-align:center;background:rgba(255,255,255,0.06);
                   border:1px solid rgba(255,255,255,0.15);border-radius:6px;color:var(--white);
                   font-size:13px;font-family:inherit">
        </div>`).join('')}
    </div>
    <div id="merch-price-line" style="margin-top:12px;font-size:12px;color:var(--ink3)"></div>

    <div id="merch-line-deco-section" style="display:none;margin-top:20px;padding-top:18px;border-top:1px solid rgba(255,255,255,0.1)">
      <div style="font-size:11px;color:var(--ink3);text-transform:uppercase;letter-spacing:.1em;margin-bottom:10px"><span id="merch-deco-hdr">Decoration 1 — how should we decorate?</span></div>
      <div id="merch-saved-decos" style="display:none;flex-direction:column;gap:8px;margin-bottom:12px"></div>
      <div id="merch-deco-form">
      <div id="merch-line-deco-grid" style="display:grid;grid-template-columns:1fr 1fr;gap:6px;margin-bottom:14px">
        <div class="card" data-val="screenprint" onclick="lineDecoSelOne(this,'screenprint')" style="padding:8px 12px;display:flex;align-items:center;gap:8px">
          <img src="" data-deco-icon="screenprint" alt="" style="width:32px;height:20px;object-fit:contain;border-radius:3px;flex-shrink:0"><span style="font-size:12px;font-weight:600">Screenprint</span>
        </div>
        <div class="card" data-val="embroidery" onclick="lineDecoSelOne(this,'embroidery')" style="padding:8px 12px;display:flex;align-items:center;gap:8px">
          <img src="" data-deco-icon="embroidery" alt="" style="width:32px;height:20px;object-fit:contain;border-radius:3px;flex-shrink:0"><span style="font-size:12px;font-weight:600">Embroidery</span>
        </div>
        <div class="card" data-val="dtf" onclick="lineDecoSelOne(this,'dtf')" style="padding:8px 12px;display:flex;align-items:center;gap:8px">
          <img src="" data-deco-icon="dtf" alt="" style="width:32px;height:20px;object-fit:contain;border-radius:3px;flex-shrink:0"><span style="font-size:12px;font-weight:600">DTF Transfer</span>
        </div>
        <div class="card" data-val="patch" onclick="lineDecoSelOne(this,'patch')" style="padding:8px 12px;display:flex;align-items:center;gap:8px">
          <img src="" data-deco-icon="patch" alt="" style="width:32px;height:20px;object-fit:contain;border-radius:3px;flex-shrink:0"><span style="font-size:12px;font-weight:600">Woven Patch</span>
        </div>
        <div class="card" data-val="label" onclick="lineDecoSelOne(this,'label')" style="padding:8px 12px;display:flex;align-items:center;gap:8px">
          <img src="" data-deco-icon="label" alt="" style="width:32px;height:20px;object-fit:contain;border-radius:3px;flex-shrink:0"><span style="font-size:12px;font-weight:600">Custom Label</span>
        </div>
        <div class="card" data-val="hangtag" onclick="lineDecoSelOne(this,'hangtag')" style="padding:8px 12px;display:flex;align-items:center;gap:8px">
          <img src="" data-deco-icon="hangtag" alt="" style="width:32px;height:20px;object-fit:contain;border-radius:3px;flex-shrink:0"><span style="font-size:12px;font-weight:600">Hang Tags</span>
        </div>
        <div class="card" data-val="blank" onclick="lineDecoSelOne(this,'blank')" style="padding:8px 12px;display:flex;align-items:center;gap:8px">
          <img src="" data-deco-icon="blank" alt="" style="width:32px;height:20px;object-fit:contain;border-radius:3px;flex-shrink:0"><span style="font-size:12px;font-weight:600">Blanks Only</span>
        </div>
      </div>

      <div id="merch-line-labelkind-wrap" style="display:none;margin-bottom:14px">
        <div class="flbl" style="margin-bottom:6px">What kind of label?</div>
        <div id="merch-line-labelkind-grid" style="display:grid;grid-template-columns:1fr 1fr;gap:6px">
          <div class="card" data-val="printed" onclick="lineLabelKindSel(this,'printed')" style="padding:9px 12px"><div style="font-size:12px;font-weight:600">Printed label</div><div style="font-size:10px;color:var(--ink3);margin-top:2px">Printed / heat-transfer inside neck</div></div>
          <div class="card" data-val="woven" onclick="lineLabelKindSel(this,'woven')" style="padding:9px 12px"><div style="font-size:12px;font-weight:600">Woven label</div><div style="font-size:10px;color:var(--ink3);margin-top:2px">Woven fabric label, sewn in</div></div>
        </div>
      </div>

      <div id="merch-line-colourcount-wrap" style="display:none;margin-bottom:14px">
        <div class="flbl" id="merch-line-colourcount-lbl" style="margin-bottom:6px">Number of print colours</div>
        <div id="merch-line-colourcount-grid" style="display:flex;gap:6px">
          <div class="card" style="padding:7px 14px;text-align:center" data-val="1" onclick="lineColourSelOne(this,1)"><span style="font-size:12px;font-weight:600">1</span></div>
          <div class="card" style="padding:7px 14px;text-align:center" data-val="2" onclick="lineColourSelOne(this,2)"><span style="font-size:12px;font-weight:600">2</span></div>
          <div class="card" style="padding:7px 14px;text-align:center" data-val="3" onclick="lineColourSelOne(this,3)"><span style="font-size:12px;font-weight:600">3</span></div>
          <div class="card" style="padding:7px 14px;text-align:center" data-val="4" onclick="lineColourSelOne(this,4)"><span style="font-size:12px;font-weight:600">4</span></div>
          <div class="card" style="padding:7px 14px;text-align:center" data-val="5" onclick="lineColourSelOne(this,5)"><span style="font-size:12px;font-weight:600">5</span></div>
          <div class="card" style="padding:7px 14px;text-align:center" data-val="6" onclick="lineColourSelOne(this,6)"><span style="font-size:12px;font-weight:600">6</span></div>
        </div>
        <div id="merch-line-colour-swatches-wrap" style="display:none;margin-top:12px">
          <div class="flbl" style="margin-bottom:6px">Ink colour for each</div>
          <div id="merch-line-colour-swatches" style="display:flex;flex-direction:column;gap:8px"></div>
        </div>
      </div>

      <div id="merch-line-stitchcount-wrap" style="display:none;margin-bottom:14px">
        <div class="flbl" style="margin-bottom:6px">Approx. stitch count</div>
        <select id="merch-line-stitchcount-select" class="pi" onchange="lineStitchSelect(this.value)" style="width:100%">
          <option value="5000">5,000 stitches</option>
          <option value="10000">10,000 stitches</option>
          <option value="15000">15,000 stitches</option>
          <option value="20000">20,000 stitches</option>
          <option value="25000">25,000 stitches</option>
          <option value="30000">30,000 stitches</option>
          <option value="35000">35,000 stitches</option>
          <option value="40000">40,000 stitches</option>
          <option value="45000">45,000 stitches</option>
          <option value="50000">50,000 stitches</option>
        </select>
      </div>

      <div id="merch-line-placement-wrap" style="margin-bottom:14px">
        <div class="flbl" style="margin-bottom:6px">Placement</div>
        <div id="merch-line-placement-grid" style="display:flex;flex-wrap:wrap;gap:6px"></div>
      </div>

      <div style="margin-bottom:14px">
        <input type="file" id="merch-line-artwork-trigger" accept="image/*,.pdf,.ai,.eps" multiple style="display:none" onchange="bMerchAddArtwork(this)">
        <button type="button" onclick="document.getElementById('merch-line-artwork-trigger').click()"
          style="padding:8px 14px;background:rgba(255,255,255,0.08);color:var(--white);border:1px solid rgba(255,255,255,0.15);border-radius:var(--r);font-size:11px;cursor:pointer;font-family:inherit">
          📎 Upload artwork / logo
        </button>
        <span style="font-size:10px;color:var(--ink3);margin-left:6px">up to 5 files, 5MB each</span>
        <div id="merch-line-artwork-list" style="display:flex;flex-direction:column;gap:5px;margin-top:8px"></div>
      </div>

      <div style="margin-bottom:14px">
        <div class="flbl" style="margin-bottom:6px">Description / notes</div>
        <textarea class="pi" id="merch-line-artwork-notes" rows="2" placeholder="e.g. Logo in white ink, approx 4&quot; wide, centred on chest." style="width:100%;min-height:50px;resize:vertical"></textarea>
      </div>

      <button type="button" id="merch-deco-save-btn" onclick="bMerchSaveDeco()" style="width:100%;padding:11px 14px;background:var(--gold);color:var(--ink);border:none;border-radius:var(--r);font-size:13px;font-weight:700;cursor:pointer;font-family:inherit;margin-bottom:14px">Save decoration ✓</button>
      </div>
      <div id="merch-deco-after" style="display:none;margin-bottom:14px">
        <div style="font-size:11px;color:var(--ink3);margin-bottom:8px">Want more on this garment — a back print, sleeve print, label or hang tags?</div>
        <button type="button" onclick="bMerchAddAnotherDeco()" style="width:100%;padding:10px 14px;background:none;color:var(--gold);border:1px dashed var(--gold);border-radius:var(--r);font-size:12px;font-weight:600;cursor:pointer;font-family:inherit">＋ Add another decoration</button>
      </div>
      <div id="merch-line-price-preview" style="display:none;background:rgba(184,146,42,0.08);border:1px solid rgba(184,146,42,0.25);border-radius:8px;padding:12px 14px;font-size:12px;color:var(--white);line-height:1.6"></div>
    </div>`;

  window._mSelColourSizes = c.sizes; // keep full size->price map for accurate cart pricing
  bMerchRenderPlacements();
  bMerchPopulateDecoIcons();
  bMerchRenderPriceLine();
  bMerchResetLineDeco();
}

function bMerchPopulateDecoIcons(){
  document.querySelectorAll('#merch-line-deco-grid img[data-deco-icon]').forEach(img=>{
    const key = img.getAttribute('data-deco-icon');
    const url = (window.MERCH_DECO_IMGS||{})[key];
    if(url) img.src = url; else img.style.display='none';
  });
}

function bMerchRenderPlacements(){
  const grid = document.getElementById('merch-line-placement-grid');
  if(!grid) return;
  const opts = merchPlacementsFor(_merchCatID);
  grid.innerHTML = opts.map(p=>
    `<div class="cki" data-val="${p}" onclick="togCk(this)"><div class="ckb"><span class="ckt">✓</span></div><span class="ckl">${p}</span></div>`
  ).join('');
}

async function bMerchRenderPriceLine(){
  const priceEl = document.getElementById('merch-price-line');
  if(!priceEl) return;
  const sizes = window._mSelColourSizes||[];
  const costs = sizes.map(s=>parseFloat(s.price)||0).filter(p=>p>0);
  if(!costs.length){ priceEl.textContent = 'Price unavailable for this style — Marcus will confirm'; return; }

  priceEl.textContent = 'Calculating price…';

  // This is the vendor's raw cost to MVFA — never show it directly. Route each
  // distinct cost through the same merch_price server action used at checkout
  // (deco:'blank' = no decoration cost added, just margin) so the customer
  // always sees the real marked-up price, even before quantities/colours/
  // decoration are chosen.
  const uniqueCosts = [...new Set(costs)];
  const markedUp = [];
  for(const cost of uniqueCosts){
    const result = await bMerchFetchLinePrice('blank', 1, 1, cost, window._mCurrentGarmentType||'');
    if(result && typeof result.unitPrice === 'number') markedUp.push(result.unitPrice);
  }

  if(!markedUp.length){ priceEl.textContent = 'Price unavailable for this style — Marcus will confirm'; return; }
  const min = Math.min(...markedUp), max = Math.max(...markedUp);
  priceEl.textContent = min===max ? `$${min.toFixed(2)} CAD / unit` : `$${min.toFixed(2)}–$${max.toFixed(2)} CAD / unit (varies by size)`;
}

// ── Per-line decoration state (reset every time a colour is selected / modal reopened) ──
function bMerchResetLineDeco(keepSaved){
  if(!keepSaved){ window._mDecos = []; window._mEditIdx = null; }
  window._lineDeco = null;
  window._lineColours = null;
  window._lineInkColours = [];
  window._lineStitch = 5000;
  _merchArtworkFiles = [];
  document.querySelectorAll('#merch-line-deco-grid .card').forEach(c=>c.classList.remove('sel'));
  document.querySelectorAll('#merch-line-colourcount-grid .card').forEach(c=>c.classList.remove('sel'));
  const stitchSel = document.getElementById('merch-line-stitchcount-select');
  if(stitchSel) stitchSel.value = '5000';
  document.querySelectorAll('#merch-line-placement-grid .cki').forEach(c=>c.classList.remove('sel'));
  const swatchWrap = document.getElementById('merch-line-colour-swatches-wrap');
  if(swatchWrap) swatchWrap.style.display='none';
  const notesEl = document.getElementById('merch-line-artwork-notes');
  if(notesEl) notesEl.value='';
  const listEl = document.getElementById('merch-line-artwork-list');
  if(listEl) listEl.innerHTML='';
  const preview = document.getElementById('merch-line-price-preview');
  if(preview) preview.style.display='none';
  const pw = document.getElementById('merch-line-placement-wrap'); if(pw) pw.style.display='';
  const cw = document.getElementById('merch-line-colourcount-wrap'); if(cw) cw.style.display='none';
  const sw = document.getElementById('merch-line-stitchcount-wrap'); if(sw) sw.style.display='none';
  const lw = document.getElementById('merch-line-labelkind-wrap'); if(lw) lw.style.display='none';
  document.querySelectorAll('#merch-line-labelkind-grid .card').forEach(c=>c.classList.remove('sel'));
  window._lineLabelKind = null; window._lastDecoSel = null;
  bMerchRenderSavedDecos();
  bMerchSetPhase(keepSaved && (window._mDecos||[]).length ? 'saved' : 'edit');
}

function lineDecoSelOne(el, val){
  selOne(el,'merch-line-deco-grid');
  window._lineDeco = val;
  const show=(id,on)=>{const e=document.getElementById(id); if(e) e.style.display=on?'block':'none';};
  const isSP = val==='screenprint', isLB = val==='label';
  if(window._lastDecoSel!==val){
    // switching method: clear colour / label state from the previous method
    window._lineColours = null; window._lineInkColours = []; window._lineLabelKind = null;
    document.querySelectorAll('#merch-line-colourcount-grid .card, #merch-line-labelkind-grid .card').forEach(c=>c.classList.remove('sel'));
    const sw=document.getElementById('merch-line-colour-swatches-wrap'); if(sw) sw.style.display='none';
    window._lastDecoSel = val;
  }
  show('merch-line-labelkind-wrap', isLB);
  show('merch-line-colourcount-wrap', isSP || (isLB && !!window._lineLabelKind));
  show('merch-line-stitchcount-wrap', val==='embroidery');
  const lbl=document.getElementById('merch-line-colourcount-lbl'); if(lbl) lbl.textContent = isLB ? 'Number of colours in the label' : 'Number of print colours';
  const pw = document.getElementById('merch-line-placement-wrap');
  if(pw) pw.style.display = (val==='hangtag'||isLB) ? 'none' : '';
  bMerchUpdateLinePricePreview();
}
function lineLabelKindSel(el, kind){
  selOne(el,'merch-line-labelkind-grid');
  window._lineLabelKind = kind;
  const cw=document.getElementById('merch-line-colourcount-wrap'); if(cw) cw.style.display='block';
  bMerchUpdateLinePricePreview();
}
function lineColourSelOne(el, val){
  selOne(el,'merch-line-colourcount-grid');
  window._lineColours = val;
  // Default each slot to White until the customer picks a real Pantone match
  window._lineInkColours = Array.from({length:val},()=>({label:'White',hex:'#FFFFFF',pantoneC:'',pantoneU:'',approx:false,finish:'U'}));
  bMerchRenderColourSwatches(val);
  bMerchUpdateLinePricePreview();
}

function bMerchRenderColourSwatches(count){
  const wrap = document.getElementById('merch-line-colour-swatches-wrap');
  const list = document.getElementById('merch-line-colour-swatches');
  if(!wrap||!list) return;
  wrap.style.display = 'block';
  // Horizontal grid, 2 per row — gives each pill enough width for a full Pantone
  // number plus the C/U toggle without truncating (e.g. 6 colours = 3 rows of 2)
  list.style.cssText = 'display:flex;flex-wrap:wrap;gap:8px';
  list.innerHTML = Array.from({length:count},(_,i)=>`<div id="ink-slot-${i}" style="flex:0 0 calc(50% - 4px);min-width:200px"></div>`).join('');
  for(let i=0;i<count;i++) bMerchRenderInkSlot(i);
}

function bMerchRenderInkSlot(i){
  const slot = document.getElementById('ink-slot-'+i);
  if(!slot) return;
  const ink = (window._lineInkColours&&window._lineInkColours[i]) || {label:'White',hex:'#FFFFFF',pantoneC:'',pantoneU:'',finish:'U'};
  // Pantone codes are stored bare (e.g. "484"), with C/U being which finish was matched.
  // finish defaults to 'U' (uncoated) since that's the more common print reference,
  // but the customer can toggle a given slot to 'C' (coated) if needed.
  const finish = ink.finish || 'U';
  const code = finish==='C' ? ink.pantoneC : ink.pantoneU;
  const hasCode = !!(ink.pantoneC || ink.pantoneU);
  const label = hasCode ? `PANTONE ${(code||ink.pantoneU||ink.pantoneC||'').toUpperCase()}` : 'PICK COLOUR';

  slot.innerHTML = hasCode
    ? `<div style="display:inline-flex;align-items:stretch;width:100%;border-radius:20px;overflow:hidden;border:1px solid rgba(255,255,255,0.1);background:rgba(255,255,255,0.04)">
        <div style="display:flex;align-items:center;gap:6px;padding:4px 10px 4px 6px;cursor:pointer;min-width:0;overflow:hidden" onclick="bOpenPantoneForInk(${i})">
          <div style="width:16px;height:16px;border-radius:50%;background:${ink.hex||'#FFFFFF'};border:1px solid rgba(255,255,255,0.2);flex-shrink:0"></div>
          <span style="font-size:11px;font-weight:600;letter-spacing:.02em;color:var(--white);white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${label}</span>
        </div>
        <div style="display:flex;flex-shrink:0;margin-left:auto">
          <button type="button" onclick="bMerchSetInkFinish(${i},'C')" title="Coated"
            style="padding:0 11px;font-size:10px;font-weight:700;border:none;cursor:pointer;font-family:inherit;background:${finish==='C'?'var(--gold)':'rgba(0,0,0,0.25)'};color:${finish==='C'?'var(--ink)':'var(--ink3)'}">C</button>
          <button type="button" onclick="bMerchSetInkFinish(${i},'U')" title="Uncoated"
            style="padding:0 11px;font-size:10px;font-weight:700;border:none;cursor:pointer;font-family:inherit;background:${finish==='U'?'var(--gold)':'rgba(0,0,0,0.25)'};color:${finish==='U'?'var(--ink)':'var(--ink3)'}">U</button>
        </div>
      </div>`
    : `<div class="pill" style="background:rgba(255,255,255,0.05);cursor:pointer;border:1px dashed rgba(255,255,255,0.2);width:100%;text-align:center;font-weight:600;letter-spacing:.02em" onclick="bOpenPantoneForInk(${i})">PICK COLOUR ${i+1}</div>`;
}

function bMerchSetInkFinish(i, finish){
  if(!window._lineInkColours||!window._lineInkColours[i]) return;
  window._lineInkColours[i].finish = finish;
  bMerchRenderInkSlot(i);
}

function lineStitchSelect(val){
  window._lineStitch = parseInt(val, 10);
  bMerchUpdateLinePricePreview();
}

// ── Multiple decorations per garment ───────────────────────────────
// _mDecos holds decorations already saved for the item being configured; the form below
// edits the "current" one. A line is priced as: blank + first decoration (via merch_price),
// then each extra decoration priced on its own with the blank cost left out.
function bMerchCurrentDeco(){
  const type = window._lineDeco;
  if(!type) return null;
  const hasCol = (type==='screenprint' || type==='label');
  return {
    type,
    labelKind: type==='label' ? (window._lineLabelKind||'') : '',
    colours: hasCol ? (window._lineColours||0) : 1,
    inkColours: hasCol ? (window._lineInkColours||[]).map(x=>Object.assign({},x)) : [],
    stitches: type==='embroidery' ? (window._lineStitch||5000) : 0,
    placements: (type==='hangtag'||type==='label') ? [] : bGM('merch-line-placement-grid'),
    notes: ((document.getElementById('merch-line-artwork-notes')||{}).value||'').trim(),
    files: _merchArtworkFiles.slice(),
    artworkNames: _merchArtworkFiles.map(f=>f.name),
    priceType: type==='label' ? ('label_'+(window._lineLabelKind||'printed')) : type,
  };
}
// Returns '' when the decoration being edited is complete, otherwise what's missing.
function bMerchDecoValid(d){
  if(!d) return 'Choose how to decorate';
  if(d.type==='label' && !d.labelKind) return 'Choose a printed or woven label';
  if((d.type==='screenprint'||d.type==='label') && !d.colours) return 'Choose the number of colours';
  if(['screenprint','embroidery','dtf','patch'].indexOf(d.type)>-1 && !d.placements.length) return 'Choose where it goes on the garment';
  return '';
}
function bMerchDecoDesc(d){
  let t = d.type==='label' ? ((d.labelKind==='woven'?'Woven':'Printed')+' Label') : (DECO_LABELS[d.type] || d.type);
  if((d.type==='screenprint'||d.type==='label') && d.colours){
    const inks = (d.inkColours||[]).map(ink=>{
      const finish = ink.finish||'U';
      const code = finish==='C' ? ink.pantoneC : ink.pantoneU;
      return code ? `Pantone ${code} ${finish}` : (d.type==='label' ? '' : (ink.label||'White'));
    }).filter(Boolean).join(', ');
    t += ` (${d.colours} colour${d.colours>1?'s':''}${inks?': '+inks:''})`;
  }
  if(d.type==='embroidery' && d.stitches) t += ` (~${d.stitches.toLocaleString()} stitches)`;
  if(d.placements && d.placements.length) t += ' — '+d.placements.join(', ');
  return t;
}
function bMerchAllDecos(){
  const saved = (window._mDecos||[]).slice();
  const cur = bMerchCurrentDeco();
  const all = (cur && !bMerchDecoValid(cur)) ? saved.concat([cur]) : saved;
  return all.length>1 ? all.filter(d=>d.type!=='blank') : all;
}
// Two phases per decoration: 'edit' (the form) and 'saved' (collapsed ✓ cards + "add another").
function bMerchSetPhase(ph){
  window._mPhase = ph;
  const form=document.getElementById('merch-deco-form'), after=document.getElementById('merch-deco-after');
  if(form) form.style.display = ph==='edit' ? '' : 'none';
  if(after) after.style.display = ph==='saved' ? 'block' : 'none';
  const hdr=document.getElementById('merch-deco-hdr');
  if(hdr){ const n=(window._mDecos||[]).length; hdr.textContent = ph==='edit' ? `Decoration ${n+1} — how should we decorate?` : 'Decorations on this item'; }
}
function bMerchRenderSavedDecos(){
  const el = document.getElementById('merch-saved-decos');
  if(!el) return;
  const list = window._mDecos||[];
  if(!list.length){ el.style.display='none'; el.innerHTML=''; return; }
  el.style.display='flex';
  el.innerHTML = list.map((d,i)=>`<div style="display:flex;align-items:flex-start;gap:10px;background:rgba(76,175,122,0.10);border:1px solid rgba(110,190,130,0.45);border-radius:10px;padding:10px 12px">
      <span style="flex:0 0 22px;height:22px;border-radius:50%;background:#4caf7a;color:#0d2217;font-weight:800;display:flex;align-items:center;justify-content:center;font-size:13px">✓</span>
      <div style="flex:1;min-width:0">
        <div style="font-size:10px;text-transform:uppercase;letter-spacing:.1em;color:#7fd1a0;margin-bottom:2px">Decoration ${i+1} saved</div>
        <div style="font-size:12px;color:var(--white);line-height:1.4">${bCadEsc(bMerchDecoDesc(d))}</div>
        ${(d.artworkNames&&d.artworkNames.length)?`<div style="font-size:10px;color:var(--ink3);margin-top:2px">📎 ${d.artworkNames.length} file${d.artworkNames.length>1?'s':''}</div>`:''}
        ${d.notes?`<div style="font-size:10px;color:var(--ink3);margin-top:2px">${bCadEsc(d.notes)}</div>`:''}
      </div>
      <button type="button" onclick="bMerchEditSavedDeco(${i})" style="background:none;border:none;color:var(--gold);cursor:pointer;font-size:11px;font-weight:600;padding:2px 4px">Edit</button>
      <button type="button" onclick="bMerchRemoveSavedDeco(${i})" title="Remove" style="background:none;border:none;color:var(--ink3);cursor:pointer;font-size:16px;padding:0 4px">×</button>
    </div>`).join('');
}
function bMerchRemoveSavedDeco(i){
  (window._mDecos||[]).splice(i,1);
  window._mEditIdx = null;
  bMerchRenderSavedDecos();
  bMerchSetPhase((window._mDecos||[]).length ? (window._mPhase||'saved') : 'edit');
  bMerchUpdateLinePricePreview();
}
function bMerchSaveDeco(){
  const cur = bMerchCurrentDeco();
  const err = bMerchDecoValid(cur);
  if(err){ toast(err); return; }
  const _ei = window._mEditIdx; window._mEditIdx = null;
  if(_ei!=null && _ei<=(window._mDecos||[]).length) window._mDecos.splice(_ei,0,cur); else window._mDecos = (window._mDecos||[]).concat([cur]);
  bMerchResetLineDeco(true);
  bMerchUpdateLinePricePreview();
  toast('Decoration '+window._mDecos.length+' saved ✓');
  const el=document.getElementById('merch-saved-decos'); if(el&&el.scrollIntoView) el.scrollIntoView({block:'nearest',behavior:'smooth'});
}
function bMerchAddAnotherDeco(){
  bMerchSetPhase('edit');
  const f=document.getElementById('merch-deco-form'); if(f&&f.scrollIntoView) f.scrollIntoView({block:'nearest',behavior:'smooth'});
}
function bMerchEditSavedDeco(i){
  const d=(window._mDecos||[])[i]; if(!d) return;
  window._mDecos.splice(i,1);
  window._mEditIdx = i;
  bMerchResetLineDeco(true);
  const q=(sel)=>document.querySelector(sel);
  const card=q('#merch-line-deco-grid .card[data-val="'+d.type+'"]'); if(card) lineDecoSelOne(card,d.type);
  if(d.type==='label' && d.labelKind){ const k=q('#merch-line-labelkind-grid .card[data-val="'+d.labelKind+'"]'); if(k) lineLabelKindSel(k,d.labelKind); }
  if((d.type==='screenprint'||d.type==='label') && d.colours){
    const c=q('#merch-line-colourcount-grid .card[data-val="'+d.colours+'"]');
    if(c){ lineColourSelOne(c,d.colours); window._lineInkColours=(d.inkColours||[]).map(x=>Object.assign({},x)); bMerchRenderColourSwatches(d.colours); }
  }
  if(d.type==='embroidery'){ window._lineStitch=d.stitches||5000; const sel=document.getElementById('merch-line-stitchcount-select'); if(sel) sel.value=String(d.stitches||5000); }
  document.querySelectorAll('#merch-line-placement-grid .cki').forEach(c=>{ if((d.placements||[]).indexOf(c.dataset.val)>-1) c.classList.add('sel'); });
  const n=document.getElementById('merch-line-artwork-notes'); if(n) n.value=d.notes||'';
  _merchArtworkFiles=(d.files||[]).slice(); bMerchRenderArtwork();
  bMerchRenderSavedDecos();
  bMerchSetPhase('edit');
  bMerchUpdateLinePricePreview();
}
async function bMerchPriceDecos(decos, qty, blankCost, garmentType){
  let unit = 0, needsQuote = false; const parts = [];
  for(let i=0;i<decos.length;i++){
    const d = decos[i];
    const r = await bMerchFetchLinePrice(d.priceType||d.type, qty, d.colours||1, i===0 ? blankCost : 0, garmentType, d.stitches||5000);
    if(!r) return null;
    unit += r.unitPrice;
    if(r.needsQuote) needsQuote = true;
    parts.push({type:d.type, label:r.decoLabel||DECO_LABELS[d.type]||d.type, unit:r.unitPrice, needsQuote:!!r.needsQuote});
  }
  return {unitPrice: Math.round(unit*100)/100, lineTotal: Math.round(unit*qty*100)/100, parts, needsQuote};
}

async function bMerchUpdateLinePricePreview(){
  const preview = document.getElementById('merch-line-price-preview');
  if(!preview) return;
  const decos = bMerchAllDecos();
  if(!decos.length){ preview.style.display='none'; return; }

  const totalQty = Object.values(window._mSizeQtys||{}).reduce((a,b)=>a+b,0);
  if(totalQty===0){ preview.style.display='none'; return; }

  const sizes = window._mSelColourSizes||[];
  let weightedCost = 0;
  Object.entries(window._mSizeQtys).forEach(([sizeName, qty])=>{
    const sizeInfo = sizes.find(s=>s.size===sizeName);
    weightedCost += (sizeInfo?parseFloat(sizeInfo.price)||0:0)*qty;
  });
  const blankCost = totalQty>0 ? weightedCost/totalQty : 0;

  preview.style.display='block';
  preview.innerHTML = '<div style="color:var(--ink3)">Calculating price…</div>';

  const result = await bMerchPriceDecos(decos, totalQty, blankCost, window._mCurrentGarmentType||"");
  if(!result){
    preview.innerHTML = '<div style="color:var(--accent)">Could not reach pricing server — try again.</div>';
    return;
  }
  const lines = result.parts.map(p=>`<div style="display:flex;justify-content:space-between;font-size:11px;color:var(--ink3)"><span>${bCadEsc(p.label)}</span><span>${p.needsQuote?'priced on confirmation':'+ $'+p.unit.toFixed(2)+'/unit'}</span></div>`).join('');
  preview.innerHTML = `
    <div>${decos.length>1?decos.length+' decorations':bCadEsc(result.parts[0].label)} · ${totalQty} units</div>
    ${decos.length>1||result.needsQuote?lines:''}
    <div style="margin-top:4px;font-size:15px"><strong style="color:var(--gold)">$${result.unitPrice.toFixed(2)}/unit</strong>
    <span style="font-size:15px;font-weight:600;color:var(--white)"> · $${result.lineTotal.toFixed(2)} total</span></div>
    ${result.needsQuote?'<div style="margin-top:4px;font-size:11px;color:var(--ink3)">Hang tags / extras without a fixed rate are confirmed on your quote.</div>':''}`;
}

function bMerchSizeQtyChange(si, sizeName, val){
  const qty = Math.max(0, parseInt(val)||0);
  if(qty>0) window._mSizeQtys[sizeName] = qty;
  else delete window._mSizeQtys[sizeName];

  const total = Object.values(window._mSizeQtys).reduce((a,b)=>a+b,0);
  const totalEl = document.getElementById('merch-add-total');
  if(totalEl) totalEl.textContent = total+' unit'+(total!==1?'s':'');

  const deco = document.getElementById('merch-line-deco-section');
  if(deco) deco.style.display = total>0 ? 'block' : 'none';

  const btn = document.getElementById('merch-add-btn');
  if(btn){
    if(total>0){btn.style.opacity='1';btn.style.pointerEvents='auto';}
    else{btn.style.opacity='.4';btn.style.pointerEvents='none';}
  }
  bMerchUpdateLinePricePreview();
}

async function bMerchAddToCart(){
  const style  = window._mModalStyle;
  const colour = window._mSelColour;
  const sizeQtys = {...window._mSizeQtys};
  const totalQty = Object.values(sizeQtys).reduce((a,b)=>a+b,0);
  if(!style||!colour||totalQty===0) return;

  const cur = bMerchCurrentDeco();
  if(cur){ const err = bMerchDecoValid(cur); if(err){ toast('Finish or save the decoration you\u2019re editing: '+err.charAt(0).toLowerCase()+err.slice(1)); return; } }
  const decos = bMerchAllDecos();
  if(!decos.length){ toast('Please choose a decoration (or Blanks Only) and save it'); return; }

  const addBtn = document.getElementById('merch-add-btn');
  const addBtnOrigText = addBtn ? addBtn.innerHTML : '';
  if(addBtn){addBtn.textContent='Pricing your item…';addBtn.style.pointerEvents='none';addBtn.style.opacity='0.6';}

  try{
    // Weighted-average blank cost across the sizes actually selected
    const sizes = window._mSelColourSizes||[];
    let weightedCost = 0;
    Object.entries(sizeQtys).forEach(([sizeName, qty])=>{
      const sizeInfo = sizes.find(s=>s.size===sizeName);
      weightedCost += (sizeInfo?parseFloat(sizeInfo.price)||0:0)*qty;
    });
    const blankCost = totalQty>0 ? weightedCost/totalQty : 0;

    const result = await bMerchPriceDecos(decos, totalQty, blankCost, window._mCurrentGarmentType||"");
    if(!result){
      toast('Could not reach pricing server — please try again');
      if(addBtn){addBtn.innerHTML=addBtnOrigText;addBtn.style.pointerEvents='auto';addBtn.style.opacity='1';}
      return;
    }

    if(window._adminMode){
      const ov = parseFloat((document.getElementById('merch-admin-price')||{}).value);
      if(ov>0){ result.unitPrice = Math.round(ov*100)/100; result.needsQuote = false; }
    }
    const decoDesc = decos.map(bMerchDecoDesc).join(' + ');
    const noteParts = decos.filter(d=>d.notes).map(d=>(decos.length>1?(DECO_LABELS[d.type]||d.type)+': ':'')+d.notes);

    _merchCart.push({
      styleID:      style.styleID,
      styleName:    (style.brandName||'')+' '+style.styleName,
      colorName:    colour.colorName,
      frontImg:     colour.frontImageUrl||'',
      price:        result.unitPrice,
      sizeQtys:     sizeQtys,
      totalQty:     totalQty,
      decoType:     decos.length>1 ? 'multi' : decos[0].type,
      decoDesc:     decoDesc,
      decos:        decos.map(d=>({type:d.type,labelKind:d.labelKind,colours:d.colours,inkColours:d.inkColours,stitches:d.stitches,placements:d.placements,notes:d.notes,artworkNames:d.artworkNames})),
      needsQuote:   result.needsQuote,
      inkColours:   decos.reduce((acc,d)=>acc.concat(d.inkColours||[]),[]),
      artworkNotes: noteParts.join(' | '),
      artworkFiles: decos.reduce((acc,d)=>acc.concat(d.artworkNames||[]),[]),
      artworkFileObjs: decos.reduce((acc,d)=>acc.concat(d.files||[]),[]),
      colorHex:     colour.hex||colour.colorHex||colour.color1||'',
      catID:        _merchCatID,
      catLabel:     (MERCH_CATS.find(c=>c.id===_merchCatID)||{}).label || (window._mEditCatLabel||''),
      blankFabric:  ((document.getElementById('merch-admin-fabric')||{}).value||'').trim(),
      replaceId:    window._merchEditItemId||null,
      prevArtworkUrls: window._mEditPrevArt||[],
    });

    window._mDecos = [];
    document.getElementById('merch-modal').style.display='none';
    bMerchRenderCart();
    if(window._merchEditItemId){ bMerchAllToPO(); return; }
    bMerchFlashBars();
    toast(colour.colorName+' added to your draft — '+totalQty+' units');
  } catch(err){
    console.error('bMerchAddToCart failed:', err);
    toast('Something went wrong adding this item — please try again');
    if(addBtn){addBtn.innerHTML=addBtnOrigText;addBtn.style.pointerEvents='auto';addBtn.style.opacity='1';}
  }
}

function bMerchBarHTML(){
  const n = _merchCart.length;
  const units = _merchCart.reduce((a,i)=>a+(i.totalQty||0),0);
  const sub = _merchCart.reduce((a,i)=>a+(parseFloat(i.price)||0)*(i.totalQty||0),0);
  const on = n>0;
  return `<div style="display:flex;align-items:center;gap:12px;justify-content:space-between;padding:10px 14px;background:#1b1a17;border:1px solid ${on?'var(--gold)':'rgba(255,255,255,0.15)'};border-radius:12px">
    <div ${on?'onclick="bMerchReview()" style="cursor:pointer;min-width:0"':'style="min-width:0"'}>
      <div style="font-size:13px;font-weight:700;color:var(--white)">🛒 ${on?n+' item'+(n>1?'s':'')+' · '+units+' units · tap to review':'Your draft is empty'}</div>
      <div style="font-size:11px;color:var(--ink3)">${on?'$'+fmt(sub)+' before tax · draft only, nothing ordered':'Pick a garment type to start your draft'}</div>
    </div>
    <button class="gb gb-gold" ${on?'':'disabled'} onclick="bMerchAllToPO()" style="white-space:nowrap;${on?'':'opacity:.4;pointer-events:none'}">Draft Quote →</button>
  </div>`;
}
function bMerchRenderBar(){
  const top = document.getElementById('merch-topbar');
  if(top){
    // stay below a sticky/fixed theme header if there is one
    let off = 0;
    const h = document.querySelector('#shopify-section-header, .shopify-section-group-header-group, header');
    try{ if(h){ const cs=getComputedStyle(h); if(cs.position==='sticky'||cs.position==='fixed') off = Math.round(h.getBoundingClientRect().height); } }catch(e){}
    top.style.cssText = 'position:sticky;top:'+off+'px;z-index:50;padding:8px 0;background:var(--bg,#181715)';
    top.innerHTML = bMerchBarHTML();
  }
  const ov = document.getElementById('merch-ov-bar');
  if(ov) ov.innerHTML = bMerchBarHTML();
  const bar = document.getElementById('merch-bar'); if(bar) bar.style.display='none';
}

function bMerchRenderCart(){
  bMerchRenderBar();
  if(_merchStyles.length && document.getElementById('merch-styles')) bMerchRenderStyles();
  const cart    = document.getElementById('merch-cart');
  const items   = document.getElementById('merch-cart-items');
  const nextBtn = document.getElementById('merch-next-btn');
  if(!cart||!items) return;

  if(!_merchCart.length){
    cart.style.display='none';
    if(nextBtn){nextBtn.style.opacity='.4';nextBtn.style.pointerEvents='none';}
    return;
  }

  cart.style.display='block';
  if(nextBtn){nextBtn.style.opacity='1';nextBtn.style.pointerEvents='auto';}

  items.innerHTML = _merchCart.map((item,i)=>{
    const sizeStr = Object.entries(item.sizeQtys||{}).map(([sz,q])=>sz+':'+q).join('  ·  ');
    return `
    <div style="display:flex;align-items:center;gap:12px;background:rgba(255,255,255,0.04);
                border:1px solid rgba(255,255,255,0.1);border-radius:8px;padding:10px 12px">
      ${item.frontImg?`<img src="${item.frontImg}" style="width:44px;height:44px;object-fit:cover;border-radius:4px">`
                     :`<div style="width:44px;height:44px;border-radius:4px;background:rgba(255,255,255,0.08);display:flex;align-items:center;justify-content:center">👕</div>`}
      <div style="flex:1;min-width:0">
        <div style="font-size:12px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${item.styleName}</div>
        <div style="font-size:11px;color:var(--ink3)">${item.colorName} · $${parseFloat(item.price||0).toFixed(2)}/unit</div>
        <div style="font-size:10px;color:var(--gold);margin-top:2px">${sizeStr}</div>
        ${item.decoDesc?`<div style="font-size:10px;color:var(--ink2);margin-top:2px">🎨 ${item.decoDesc}</div>`:''}
      </div>
      <div style="display:flex;align-items:center;gap:8px">
        <span style="font-size:13px;font-weight:600;color:var(--gold)">${item.totalQty} units</span>
        <button onclick="bMerchRemove(${i})" style="margin-left:4px;background:none;border:none;color:var(--ink3);cursor:pointer;font-size:16px;padding:0 4px">×</button>
      </div>
    </div>`;
  }).join('');
}

function bMerchRemove(i){
  _merchCart.splice(i,1);
  bMerchRenderCart();
}

// Each cart line already has its own decoration + final marked-up price
// (set when it was added via bMerchAddToCart). This just pushes everything
// straight to the PO module — no shared decoration step, so no stuck-state
// risk across multiple passes through the picker.
function bMerchContactModal(){
  const old=document.getElementById('merch-contact-modal'); if(old) old.remove();
  const c=B.customer||{};
  const inp='width:100%;box-sizing:border-box;padding:12px 14px;border-radius:7px;border:1px solid var(--border);font-size:14px;margin-bottom:10px';
  const m=document.createElement('div');
  m.id='merch-contact-modal';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,0.7);z-index:100004;display:flex;align-items:center;justify-content:center;padding:16px';
  m.innerHTML=`<div style="background:#fff;border-radius:14px;padding:28px 26px;max-width:400px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,0.4)">
    <div style="font-weight:700;font-size:19px;margin-bottom:6px;color:var(--ink)">Where should we email your draft quote?</div>
    <div style="font-size:13px;color:var(--ink2);margin-bottom:18px;line-height:1.5">We’ll save your draft and email you a copy. <strong>Nothing is ordered or charged</strong> — you can edit it, ask us questions (free) or order a sample before anything is approved.</div>
    <input id="mc-name" placeholder="Your name" value="${bCadEsc(c.contact||B.gateName||'')}" style="${inp}">
    <input id="mc-brand" placeholder="Brand / company" value="${bCadEsc(c.name||c.brand||B.brandName||'')}" style="${inp}">
    <input id="mc-email" type="email" placeholder="you@yourbrand.com" value="${bCadEsc(c.email||B.gateEmail||'')}" style="${inp}">
    <input id="mc-phone" type="tel" placeholder="Phone (optional)" value="${bCadEsc(c.phone||'')}" style="${inp}">
    <label style="display:flex;align-items:flex-start;gap:8px;font-size:12px;color:var(--ink2);line-height:1.4;margin:4px 0 18px;cursor:pointer"><input id="mc-consent" type="checkbox" style="margin-top:2px"> Yes, MVFA can email me this draft and follow up about it.</label>
    ${bMktBoxHTML('mkt-merch')}
    <button onclick="bMerchContactGo()" style="background:var(--gold);color:var(--ink);border:none;border-radius:7px;font-size:14px;font-weight:700;cursor:pointer;padding:13px 20px;width:100%;margin-bottom:10px">Email me my draft →</button>
    <button onclick="document.getElementById('merch-contact-modal').remove()" style="background:none;border:none;color:var(--ink3);font-size:12px;cursor:pointer;padding:6px">← Back</button>
  </div>`;
  document.body.appendChild(m);
  setTimeout(()=>{const e=document.getElementById(c.contact||B.gateName?'mc-email':'mc-name');if(e)e.focus();},50);
}
function bMerchContactGo(){
  const g=id=>(document.getElementById(id)||{}).value||'';
  const name=g('mc-name').trim(), brand=g('mc-brand').trim(), email=g('mc-email').trim(), phone=g('mc-phone').trim();
  if(!name){toast('Please enter your name');return;}
  if(!email||!email.includes('@')){toast('Please enter a valid email');return;}
  if(!(document.getElementById('mc-consent')||{}).checked){toast('Please confirm you’re okay being contacted');return;}
  B.gateEmail=email; B.gateName=name; B.gateConsent=true; B.brandName=B.brandName||brand;
  bMktRecord('mkt-merch', email, name, 'merch_draft');
  B.customer=Object.assign({}, B.customer||{}, {name:brand||name, contact:name, email, phone, brand:brand||name});
  try{localStorage.setItem('mvfa_my_email', email.toLowerCase());}catch(e){}
  const m=document.getElementById('merch-contact-modal'); if(m) m.remove();
  bMerchAllToPO();
}

// Merch cart -> a REAL saved quote -> the PO editor, same path the category
// builder uses (save -> token -> openOrd). Previously this only pushed lines
// into the in-memory PO and opened the empty collections list, so nothing was
// ever saved and no PO appeared.
async function bMerchAllToPO(){
  if(window._merchBusy) return;
  if(!_merchCart.length){toast('Add at least one item');return;}
  bMerchCloseBrowser();
  const c0=B.customer||{};
  if(!window._merchEditItemId && (!(c0.email||B.gateEmail) || !(c0.contact||B.gateName))){ bMerchContactModal(); return; }
  window._merchBusy=true;
  let saved=false;
  const btn=document.getElementById('merch-next-btn');
  const btnTxt=btn?btn.textContent:'';
  if(btn){btn.textContent='Creating your purchase order…';btn.style.pointerEvents='none';}
  try{
    const cust=Object.assign({}, B.customer||{});
    cust.email=cust.email||B.gateEmail; cust.contact=cust.contact||B.gateName;
    cust.name=cust.name||B.brandName||cust.contact;
    B.customer=cust;
    if(!B.ref) B.ref=`MVFA-${new Date().getFullYear()}-${String(Math.floor(Math.random()*9000)+1000)}`;

    // 1) Upload artwork (names alone were never enough -- the files themselves must reach us)
    let artFailed=0;
    const stamp=Date.now();
    const newItems=[];
    for(let i=0;i<_merchCart.length;i++){
      const c=_merchCart[i];
      let artUrls=[];
      const allObjs=(c.artworkFileObjs||[]).slice(0,15);
      for(let k=0;k<allObjs.length;k+=5){
        const objs=allObjs.slice(k,k+5);
        const fd=new FormData();
        fd.append('quote_ref',B.ref); fd.append('email',cust.email); fd.append('source','merch');
        fd.append('notes',c.artworkNotes||''); fd.append('ref_links','');
        objs.forEach(f=>fd.append('files[]',f));
        try{
          const r=await fetch('https://api.mvfa.ca/mvfa-upload.php',{method:'POST',mode:'cors',body:fd});
          const d=await r.json();
          if(d.files&&d.files.length){ artUrls=artUrls.concat(d.files); B.leadFiles=bLeadMerge(B.leadFiles,d.files); }
          if(!d.files||d.files.length<objs.length) artFailed+=objs.length-((d.files||[]).length);
        }catch(e){ artFailed+=objs.length; }
      }
      if(c.prevArtworkUrls&&c.prevArtworkUrls.length) artUrls=(c.prevArtworkUrls).concat(artUrls);
      const unit=parseFloat(c.price)||0;
      newItems.push({
        id: c.replaceId || (stamp+i+Math.random()),
        gt: c.styleName+' — '+((c.decos&&c.decos.length>1)?c.decos.map(d=>DECO_LABELS[d.type]||d.type).join(' + '):(DECO_LABELS[c.decoType]||c.decoType||'Blanks Only')),
        category:'Merch', itemGender:'', wt:'mid',
        fab: c.decoDesc||'Blanks Only',
        colour:{name:c.colorName, hex:c.colorHex||'#999'},
        szs:Object.assign({}, c.sizeQtys),
        frozenPrice:unit,
        merch:{styleID:c.styleID, styleName:c.styleName, colorName:c.colorName, frontImg:c.frontImg||'', catID:c.catID||null, catLabel:c.catLabel||'', blankFabric:c.blankFabric||merchBlankFabricGuess(c.catLabel),
               decoType:c.decoType, decoDesc:c.decoDesc||'', decos:c.decos||[], needsQuote:!!c.needsQuote, inkColours:c.inkColours||[],
               artworkNotes:c.artworkNotes||'', artworkFiles:c.artworkFiles||[], artworkUrls:artUrls, unitPrice:unit},
      });
    }

    // 2) Merge into the quote (keep merch lines from an earlier pass)
    const _ex=(B.items||[]).filter(it=>it&&it.merch);
    newItems.forEach(n=>{ const ix=_ex.findIndex(e=>e.id===n.id); if(ix>=0) _ex[ix]=n; else _ex.push(n); });
    B.items=_ex;
    const _isEdit = !!window._merchEditItemId;
    window._merchEditItemId=null; window._mEditPrevArt=[]; window._mEditCatLabel='';
    B._costs=B._costs||{};
    newItems.forEach(it=>{B._costs[it.id]={unitPrice:it.frozenPrice,lineTotal:it.frozenPrice*bQty(it),breakdown:[]};});
    B._poSource='merch';
    B.leadSource='merch';
    B.brandName=B.brandName||cust.name||cust.brand||'';
    B.meta=Object.assign({orderDate:new Date().toISOString().split('T')[0],delivDate:'',season:'FALL',terms:'60/40',currency:'CAD$',poRef:B.ref}, B.meta||{});
    const total=bComputeFullOrderTotal(B.items,B._costs);

    // 3) Save -> token
    const sr=await fetch('https://api.mvfa.ca/mvfa-quote-save.php?action=save',{
      method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({token:window._quoteResumeToken||'',state:B,step:'merch-po',itemCount:B.items.length,estimatedTotal:total})
    });
    const sd=await sr.json();
    if(!sd.success||!sd.token) throw new Error('save failed');
    window._quoteResumeToken=sd.token; _rememberToken(sd.token); _cachedQuotes=null;

    // Record the contact on the saved quote so it shows up properly in Saved Quotes (name, email, phone, brand, summary)
    try{
      const nm=(cust.contact||cust.name||'').trim().split(/\s+/);
      const noteTxt=('MERCH / BLANKS DRAFT — '+B.items.map(it=>`${it.merch.styleName} ${it.merch.colorName} x${bQty(it)} — ${it.merch.decoDesc}${it.merch.artworkNotes?' ['+it.merch.artworkNotes+']':''}`).join(' | ')).slice(0,1800);
      fetch('https://api.mvfa.ca/mvfa-quote-save.php?action=optin',{method:'POST',headers:{'Content-Type':'application/json'},mode:'cors',
        body:JSON.stringify({token:sd.token,email:cust.email,phone:cust.phone||'',firstName:nm[0]||'',lastName:nm.slice(1).join(' '),brand:cust.name||cust.brand||B.brandName||'',notes:noteTxt})}).catch(()=>{});
    }catch(e){}

    // 4) Notify MVFA (same endpoint/shape as the category quote) -- not on edits: admin resends explicitly
    const lineTxt=B.items.map(it=>`SS-${it.merch.styleID} ${it.merch.styleName} / ${it.merch.colorName} — Qty:${bQty(it)} — $${it.merch.unitPrice}/unit — ${it.merch.decoDesc}`);
    if(!_isEdit) fetch('https://api.mvfa.ca/mvfa-notify.php',{
      method:'POST',headers:{'Content-Type':'application/json'},mode:'cors',
      body:JSON.stringify({type:'quote',source:'merch',ref:B.ref,
        customer:{name:`${cust.contact}`,brand:cust.name,email:cust.email,phone:cust.phone||''},
        items:lineTxt,total:`CAD$ ${fmt(total)}`,deposit:`CAD$ ${fmt(total*.6)}`,
        notes:'MERCH / BLANKS ORDER — '+B.items.map(it=>it.merch.artworkNotes).filter(Boolean).join(' | '),
        delivDate:'',resumeToken:window._quoteResumeToken||'',files:B.leadFiles||[],ref_links:[]})
    }).catch(()=>{});

    _merchCart=[];
    saved=true;
    const qty=B.items.reduce((s,it)=>s+bQty(it),0);
    await openOrd(window._quoteResumeToken);
    // Safety net: if the reload path left the editor empty for any reason, build the PO
    // straight from the quote we just saved so the customer still lands on their order.
    if(!poLines.length){
      console.warn('openOrd left the PO empty -- rendering from memory');
      const pricing=poComputeOrderPricing(B.items,B._costs);
      const lines=B.items.map((it,idx)=>poNormalizeLine(it,pricing.get(it.id),idx));
      const tok=window._quoteResumeToken;
      poClear(true);
      window._quoteResumeToken=tok;
      window._poFullItems=JSON.parse(JSON.stringify(B.items));
      loadPO({ref:B.ref,customer:B.customer||{},lines,totals:{},meta:B.meta||{},notes:B.notes||''});
      document.querySelectorAll('.view').forEach(e=>e.classList.remove('act'));
      document.querySelectorAll('.ntab').forEach(e=>e.classList.remove('act'));
      document.getElementById('vpo').classList.add('act');
      document.getElementById('nb-po').classList.add('act');
      document.getElementById('collections-list-wrap').style.display='none';
      document.getElementById('po-editor-wrap').style.display='';
    }
    toast('Purchase order ready — '+qty+' units'+(artFailed?' · '+artFailed+' artwork file(s) could not be uploaded (use PDF/PNG/JPG, under 10MB)':''));
  }catch(e){
    console.error('bMerchAllToPO failed:',e);
    toast(saved?'Your quote '+B.ref+' was saved — open it from My Collections':'Could not create your purchase order — please try again');
  }finally{
    window._merchBusy=false;
    if(btn){btn.textContent=btnTxt||'Draft Quote →';btn.style.pointerEvents='auto';}
  }
}

const DECO_LABELS = {
  screenprint:'Screenprint', embroidery:'Embroidery', dtf:'DTF Transfer',
  patch:'Woven Patch', label:'Custom Label', hangtag:'Hang Tags', blank:'Blanks Only'
};

// ══════════════════════════════════════════════════
// MERCH PRICING — server-side via quote engine, margin included.
// Each cart line (one style+colour+decoration) is priced independently
// through the merch_price action. NO client-side fallback price.
// ══════════════════════════════════════════════════
let _linePriceCache = {}; // avoid refetching identical decoType/qty/colours/blankCost combos

async function bMerchFetchLinePrice(decoType, qty, colours, blankCost, garmentType='', stitches=0){
  const cacheKey = `${decoType}|${qty}|${colours}|${blankCost.toFixed(2)}|${garmentType}|${stitches}`;
  if(_linePriceCache[cacheKey]) return _linePriceCache[cacheKey];
  try{
    const r = await fetch('https://api.mvfa.ca/mvfa-quote-engine.php?action=merch_price', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({decoType, qty, colours, blankCost, garmentType, stitches})
    });
    const data = await r.json();
    if(!data.success) throw new Error(data.error||'merch_price failed');
    _linePriceCache[cacheKey] = data;
    return data;
  } catch(e){
    return null; // caller must handle null — no invented fallback price
  }
}

// ── Artwork upload ──────────────────────────────────────────────────
let _merchArtworkFiles = [];


function bMerchAddArtwork(input){
  if(!input.files.length) return;
  let skipped = [];
  for(let i=0;i<input.files.length;i++){
    const file = input.files[i];
    if(_merchArtworkFiles.length>=5){ skipped.push(file.name+' (max 5 reached)'); continue; }
    if(file.size>5*1024*1024){ skipped.push(file.name+' (exceeds 5MB)'); continue; }
    _merchArtworkFiles.push(file);
  }
  input.value='';
  if(skipped.length) toast(skipped[0]);
  bMerchRenderArtwork();
}

function bMerchRenderArtwork(){
  const list = document.getElementById('merch-line-artwork-list');
  if(!list) return;
  list.innerHTML = _merchArtworkFiles.map((f,i)=>`
    <div style="display:flex;align-items:center;gap:8px;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:6px;padding:7px 10px">
      <span style="font-size:12px;flex:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">📄 ${f.name}</span>
      <span style="font-size:10px;color:var(--ink3)">${(f.size/1024).toFixed(0)}KB</span>
      <button onclick="bMerchRemoveArtwork(${i})" style="background:none;border:none;color:var(--ink3);cursor:pointer;font-size:14px;padding:0 4px">×</button>
    </div>`).join('');
}

function bMerchRemoveArtwork(i){
  _merchArtworkFiles.splice(i,1);
  bMerchRenderArtwork();
}

// Pushes the merch cart into the PO module as real PO lines, then opens My Collections
// ══ end Merch flow ══



// ══ PO page: collapsible customer card + merch "draft" framing ══
function poCustCollapse(){
  const left = document.querySelector('.po-left'); if(!left) return;
  const sec = left.querySelector('.psec'); if(!sec || sec.dataset.cc) return;
  sec.dataset.cc = '1';
  const lbl = sec.querySelector('.plbl'); if(lbl) lbl.textContent = 'Customer & delivery';
  const body = document.createElement('div'); body.id = 'po-cust-body'; body.style.display = 'none';
  [...sec.children].filter(el=>!el.classList.contains('plbl') && el.id!=='po-impbanner').forEach(k=>body.appendChild(k));
  const sum = document.createElement('div'); sum.id = 'po-cust-sum';
  sum.style.cssText = 'display:flex;align-items:center;justify-content:space-between;gap:10px;cursor:pointer;padding:10px 12px;border:1px solid var(--border);border-radius:8px;background:var(--cream2,#f6f2ea);font-size:12px;color:var(--ink2)';
  sum.onclick = poToggleCust;
  sec.appendChild(sum); sec.appendChild(body);
}
function poToggleCust(){
  const b = document.getElementById('po-cust-body'); if(!b) return;
  b.style.display = b.style.display==='none' ? 'block' : 'none';
  poUpdCustSummary();
}
function poUpdCustSummary(){
  const sum = document.getElementById('po-cust-sum'), b = document.getElementById('po-cust-body'); if(!sum||!b) return;
  const v = id => ((document.getElementById(id)||{}).value||'').trim();
  const open = b.style.display!=='none';
  const bits = [v('po-cname'), v('po-email'), v('po-city')].filter(Boolean);
  const missing = !v('po-email') || !v('po-addr');
  sum.innerHTML = `<span style="min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${bits.length?bCadEsc(bits.join(' · ')):'Add your details'}${missing?' <span style="color:#b8922a;font-weight:600">· add email &amp; address</span>':''}</span><span style="color:var(--gold);font-weight:700;white-space:nowrap">${open?'Hide ▴':'Edit ▾'}</span>`;
}
function poMerchDraftUI(){
  const isMerch = B._poSource==='merch';
  const ns = document.getElementById('po-next-steps'); if(!ns) return;
  const draft = isMerch && !window._currentOrderIsPaid && !window._poClickedApprove && !window._adminMode;
  let bn = document.getElementById('po-draft-banner');
  if(!draft){ if(bn) bn.remove(); const t=document.getElementById('po-draft-top'); if(t) t.remove(); return; }
  const ib = document.getElementById('po-impbanner'); if(ib) ib.style.display='none';
  const dt = document.getElementById('po-doctype'); if(dt && dt.textContent==='Purchase Order') dt.textContent = 'Draft Quote';
  const sbd = document.getElementById('po-docstatus'); if(sbd && sbd.textContent!=='DRAFT QUOTE'){ sbd.textContent='DRAFT QUOTE'; sbd.className='posb posb-draft'; }
  if(!bn){
    bn = document.createElement('div'); bn.id = 'po-draft-banner';
    bn.style.cssText = 'margin-bottom:12px;padding:10px 12px;background:#fdf8ec;border:1px solid #e3cf95;border-radius:8px;font-size:12px;color:#5b4a14;line-height:1.5';
    bn.innerHTML = '<strong>Nothing is ordered yet.</strong> This is a draft. Edit any line, talk it through with us (free), order a sample, or approve when you’re ready.';
    ns.parentNode.insertBefore(bn, ns.previousElementSibling || ns);
  }
  const right = document.querySelector('.po-right');
  if(right && !document.getElementById('po-draft-top')){
    const t = document.createElement('div'); t.id = 'po-draft-top';
    t.style.cssText = 'margin:12px 18px 0;padding:10px 14px;background:#fdf8ec;border:1px solid #e3cf95;border-radius:8px;font-size:12px;color:#5b4a14;line-height:1.5;display:flex;justify-content:space-between;gap:12px;align-items:center;flex-wrap:wrap';
    t.innerHTML = '<span>📝 <strong>Your draft quote</strong> — a copy is in your inbox. Nothing is ordered or charged yet.</span><a href="#" onclick="var n=document.getElementById(\'po-next-steps\');if(n)n.scrollIntoView({behavior:\'smooth\',block:\'center\'});return false" style="color:#8a6a17;font-weight:700;white-space:nowrap">See next steps ↓</a>';
    right.insertBefore(t, right.firstChild);
  }
  const sub = ns.querySelector('button span'); if(sub && /Start production now/.test(sub.textContent)) sub.textContent = 'When you’re ready — deposit invoice follows';
}
(function(){
  const _u = poUpd;
  poUpd = function(){
    const r = _u.apply(this, arguments);
    try{ poCustCollapse(); poUpdCustSummary(); poMerchDraftUI(); poUpdateCtaDetails(); poRenderNextSteps(); }catch(e){ console.error('po ui', e); }
    return r;
  };
})();


// ══ Admin: work a merch quote from the PO view (same Save / Save & Send as Step 7 admin) ══
async function poSaveAndSendQuote(send){
  if(send===undefined || send===null || typeof send==='object') send = true;
  if(!window._quoteResumeToken){ toast('No saved quote to update'); return; }
  toast(send ? 'Saving and sending…' : 'Saving…');
  try{ await poSave(); }catch(e){}
  B._hasUnsentChanges = !send;
  if(!send){
    // persist the unsent flag too (poSave already ran; one more light save keeps the flag on the record)
    try{ await bAdminSaveState(); }catch(e){}
    bShowAdminSaveConfirmation('✓ Saved — not sent to customer yet'); return;
  }
  const v = id => ((document.getElementById(id)||{}).value||'').trim();
  const email = v('po-email'), name = v('po-contact')||v('po-cname')||'there';
  try{
    const r = await fetch('https://api.mvfa.ca/mvfa-notify.php?action=send_corrected_quote&key=mvfa-quotes-2026',{
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ref:B.ref||'', to:email, name, resumeToken:window._quoteResumeToken})
    });
    const d = await r.json();
    if(d.success) bShowAdminSaveConfirmation('✓ Saved and sent'+(email?' to '+email:' to the customer'));
    else toast('✓ Saved, but the email failed: '+(d.error||'unknown error'));
  }catch(e){ toast('✓ Saved, but the email failed to send'); }
}

// ═══ PO: inline buyer / ship-to / dates / terms (replaces the left-hand customer panel) ═══
function poTaxGeo(){
  const s=B.ship;
  if(s && s.same===false && s.country) return {country:s.country, prov:s.province||''};
  const c=document.getElementById('po-country'), p=document.getElementById('po-province');
  return {country:c?c.value:'CA', prov:p?p.value:'ON'};
}
function poShipForShopify(){
  const s=B.ship;
  if(!s || s.same!==false) return {};
  return {shipping:{name:s.name||'',contact:s.contact||'',phone:s.phone||'',addr:s.addr||'',city:s.city||'',country:s.country||'CA',province:s.province||''}};
}
function poGeoOpts(country){
  if(country==='CA') return Object.keys(PROV_TAX).map(c=>{const p=PROV_TAX[c];return `<option value="${c}">${p.label} — ${p.name} ${(p.rate*100).toFixed(p.rate*100%1===0?0:3)}%</option>`;}).join('');
  if(country==='US') return Object.keys(US_STATES).map(c=>`<option value="${c}">${US_STATES[c]}</option>`).join('');
  return '<option value="">— not applicable —</option>';
}
const PO_BMAP={name:'po-cname',contact:'po-contact',phone:'po-phone',email:'po-email',addr:'po-addr',city:'po-city'};
window._poEd = window._poEd || {buyer:false, ship:false};
function poSyncToB(){
  const g=id=>{const e=document.getElementById(id);return e?e.value:'';};
  B.customer=Object.assign({},B.customer||{},{name:g('po-cname'),contact:g('po-contact'),email:g('po-email'),phone:g('po-phone'),addr:g('po-addr'),city:g('po-city'),country:g('po-country')||'CA',province:g('po-province')});
  B.meta=Object.assign({},B.meta||{},{terms:g('po-terms')||'60/40',delivDate:g('po-ddate'),confirmedShip:window._poConfirmShip||'',season:g('po-season'),poRef:g('po-ref'),currency:g('po-currency')});
}
function poInlineIn(kind,key,val){
  if(kind==='b'){ const el=document.getElementById(PO_BMAP[key]); if(el) el.value=val; }
  else { B.ship=B.ship||{same:true}; B.ship[key]=val; }
  poSyncToB(); poUpd();
}
function poInlineGeo(kind,val){
  if(kind==='b'){
    const c=document.getElementById('po-country'); if(c) c.value=val;
    bUpdateProvinceOptions(); const pe=document.getElementById('po-province');
    const ed=document.getElementById('pi-b-province'); if(ed&&pe){ ed.innerHTML=pe.innerHTML; ed.value=pe.value; }
  } else {
    B.ship=B.ship||{same:false}; B.ship.country=val;
    const ed=document.getElementById('pi-s-province'); if(ed){ ed.innerHTML=poGeoOpts(val); B.ship.province=ed.value; }
  }
  poSyncToB(); poUpd();
}
function poInlineProv(kind,val){
  if(kind==='b'){ const pe=document.getElementById('po-province'); if(pe) pe.value=val; }
  else { B.ship=B.ship||{same:false}; B.ship.province=val; }
  poSyncToB(); poUpd();
}
function poToggleEd(which){ window._poEd[which]=!window._poEd[which]; poInlineRefresh(); }
function poShipSame(chk){
  B.ship=B.ship||{}; B.ship.same=!!chk;
  if(!chk){ if(!B.ship.country){ B.ship.country=(document.getElementById('po-country')||{}).value||'CA'; B.ship.province=(document.getElementById('po-province')||{}).value||'ON'; } window._poEd.ship=true; }
  else window._poEd.ship=false;
  poSyncToB(); poUpd();
}
function poTgtDate(v){ const el=document.getElementById('po-ddate'); if(el) el.value=v; poSyncToB(); poUpd(); }
function poConfirmDate(v){ window._poConfirmShip=v; poSyncToB(); poUpd(); }
function poAdminTerms(v){ const te=document.getElementById('po-terms'); if(te){ te.value=v; poUpdTerms(); } poSyncToB(); }
function poAdminHidden(id,v){ const e=document.getElementById(id); if(e){ e.value=v; } poSyncToB(); poUpd(); }
function poInlineBuild(){
  if(document.getElementById('po-inl-built')) return;
  const bn=document.getElementById('po-d-bname'); if(!bn) return;
  const cn=document.getElementById('po-cname'); const sec=cn&&cn.closest('.psec'); if(sec) sec.style.display='none';
  if(!document.getElementById('po-inl-css')){
    const st=document.createElement('style'); st.id='po-inl-css';
    st.textContent='.po-ied{margin-left:8px;font-size:9px;font-weight:600;font-family:inherit;line-height:1;letter-spacing:.08em;text-transform:uppercase;color:var(--gold2);background:none;border:1px solid var(--gold2);border-radius:10px;padding:3px 8px;cursor:pointer}'
      +'.po-ig{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:8px;margin-top:8px}'
      +'.po-ig label{display:block;font-size:8px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:var(--ink3);margin-bottom:2px}'
      +'.po-ig input,.po-ig select,.po-adm input,.po-adm select{width:100%;box-sizing:border-box;font-size:12px;padding:7px 8px;border:1px solid var(--border);border-radius:6px;background:#fff;color:var(--ink)}'
      +'.po-ig .wide{grid-column:1/-1}'
      +'.po-adm{display:none;padding:10px 14px;background:#181715;color:#f4efe2;border-bottom:1px solid var(--border);grid-template-columns:repeat(auto-fit,minmax(130px,1fr));gap:8px}'
      +'.po-adm label{display:block;font-size:8px;letter-spacing:.1em;text-transform:uppercase;color:#bfb7a3;margin-bottom:2px}'
      +'@media(max-width:600px){.popty{grid-template-columns:1fr !important}.popty .party{border-right:none !important;border-bottom:1px solid var(--border)}}'
      +'#po-tgt-date{width:100%;box-sizing:border-box;font-size:12px;padding:4px 6px;border:1px solid var(--border);border-radius:6px;background:#fff}';
    document.head.appendChild(st);
  }
  const mk=(kind,key,label,type,extra)=>`<div${extra==='wide'?' class="wide"':''}><label>${label}</label><input type="${type||'text'}" id="pi-${kind}-${key}" oninput="poInlineIn('${kind}','${key}',this.value)"></div>`;
  const geo=(kind)=>`<div><label>Country</label><select id="pi-${kind}-country" onchange="poInlineGeo('${kind}',this.value)"><option value="CA">Canada</option><option value="US">United States</option><option value="OTHER">Other / International</option></select></div><div><label>Province / State</label><select id="pi-${kind}-province" onchange="poInlineProv('${kind}',this.value)"></select></div>`;
  // Buyer editor
  const bp=bn.closest('.party'); const bt=bp&&bp.querySelector('.ptag');
  if(bt) bt.insertAdjacentHTML('beforeend','<button type="button" class="po-ied" id="po-buyer-btn" onclick="poToggleEd(\'buyer\')">Edit</button>');
  if(bp) bp.insertAdjacentHTML('beforeend',`<div id="po-buyer-ed" style="display:none"><div class="po-ig">${mk('b','name','Brand / company','text','wide')}${mk('b','contact','Contact name')}${mk('b','phone','Phone')}${mk('b','email','Email','email','wide')}${mk('b','addr','Billing address','text','wide')}${mk('b','city','City / postal')}${geo('b')}</div></div>`);
  // Ship-to block
  const parties=bp&&bp.parentNode;
  if(parties){
    const blk=document.createElement('div'); blk.id='po-shipto'; blk.className='party'; blk.style.cssText='border-top:1px solid var(--border);border-right:none';
    blk.innerHTML=`<div class="ptag">Ship to<button type="button" class="po-ied" id="po-ship-btn" onclick="poToggleEd('ship')" style="display:none">Edit</button></div>
      <label style="display:flex;align-items:center;gap:7px;font-size:12px;cursor:pointer"><input type="checkbox" id="po-ship-same" checked onchange="poShipSame(this.checked)"> Same as buyer address</label>
      <div class="pdet" id="po-ship-sum" style="margin-top:6px;display:none"></div>
      <div id="po-ship-ed" style="display:none"><div class="po-ig">${mk('s','name','Ship-to name / company','text','wide')}${mk('s','contact','Receiver')}${mk('s','phone','Phone')}${mk('s','addr','Street address','text','wide')}${mk('s','city','City / postal')}${geo('s')}</div></div>`;
    parties.parentNode.insertBefore(blk, parties.nextSibling);
  }
  // Target ship date (customer) + confirmed (admin)
  const dd=document.getElementById('po-d-dd'); const ddc=dd&&dd.closest('.pomc');
  if(ddc){
    const k=ddc.querySelector('.pomk'); if(k) k.textContent='Target ship date';
    dd.style.display='none';
    dd.insertAdjacentHTML('afterend','<input type="date" id="po-tgt-date" oninput="poTgtDate(this.value)"><div id="po-d-confirm" style="font-size:10px;color:var(--ink3);margin-top:3px"></div>');
  }
  // Admin-only controls
  const meta=document.querySelector('.pometa');
  if(meta){
    const adm=document.createElement('div'); adm.id='po-adm'; adm.className='po-adm';
    adm.innerHTML=`<div><label>Confirmed ship date</label><input type="date" id="pa-confirm" oninput="poConfirmDate(this.value)"></div>
      <div><label>Terms (admin)</label><select id="pa-terms" onchange="poAdminTerms(this.value)"><option value="60/40">60% Dep / 40% COD</option><option value="net30">Net 30</option><option value="net60">Net 60</option><option value="cod">Full COD</option><option value="prepaid">Pre-paid</option></select></div>
      <div><label>PO reference</label><input type="text" id="pa-ref" oninput="poAdminHidden('po-ref',this.value)"></div>
      <div><label>Season</label><select id="pa-season" onchange="poAdminHidden('po-season',this.value)"><option>FALL</option><option>SPRING</option><option>SUMMER</option><option>WINTER</option><option>HOLIDAY</option></select></div>
      <div><label>Currency</label><select id="pa-cur" onchange="poAdminHidden('po-currency',this.value)"><option>CAD$</option><option>USD$</option></select></div>`;
    meta.parentNode.insertBefore(adm, meta.nextSibling);
  }
  const flag=document.createElement('span'); flag.id='po-inl-built'; flag.style.display='none'; document.body.appendChild(flag);
}
function poInlineRefresh(){
  poInlineBuild();
  if(!document.getElementById('po-inl-built')) return;
  const admin=!!window._adminMode, locked=!!window._currentOrderIsPaid && !admin;
  const val=(id,v)=>{const e=document.getElementById(id); if(e && document.activeElement!==e && e.value!==(v||'')) e.value=v||'';};
  const hv=id=>{const e=document.getElementById(id);return e?e.value:'';};
  // buyer
  Object.keys(PO_BMAP).forEach(k=>val('pi-b-'+k, hv(PO_BMAP[k])));
  val('pi-b-country', hv('po-country'));
  const bpe=document.getElementById('pi-b-province'), hp=document.getElementById('po-province');
  if(bpe&&hp){ if(bpe.innerHTML!==hp.innerHTML) bpe.innerHTML=hp.innerHTML; bpe.value=hp.value; }
  const be=document.getElementById('po-buyer-ed'), bb=document.getElementById('po-buyer-btn');
  if(be) be.style.display=(window._poEd.buyer&&!locked)?'block':'none';
  if(bb){ bb.style.display=locked?'none':''; bb.textContent=window._poEd.buyer?'Done':'Edit'; }
  // ship-to
  const sh=B.ship||{same:true}; const same=sh.same!==false;
  const chk=document.getElementById('po-ship-same'); if(chk){ chk.checked=same; chk.disabled=locked; }
  const se=document.getElementById('po-ship-ed'), ss=document.getElementById('po-ship-sum'), sb=document.getElementById('po-ship-btn');
  if(!same){
    ['name','contact','phone','addr','city'].forEach(k=>val('pi-s-'+k, sh[k]));
    val('pi-s-country', sh.country||'CA');
    const sp=document.getElementById('pi-s-province'); if(sp){ const o=poGeoOpts(sh.country||'CA'); if(sp.innerHTML!==o) sp.innerHTML=o; if(sh.province) sp.value=sh.province; }
  }
  if(se) se.style.display=(!same&&window._poEd.ship&&!locked)?'block':'none';
  if(sb){ sb.style.display=(!same&&!locked)?'':'none'; sb.textContent=window._poEd.ship?'Done':'Edit'; }
  if(ss){
    const esc=bCadEsc;
    if(same){ ss.style.display='none'; }
    else { ss.style.display=window._poEd.ship&&!locked?'none':'block'; ss.innerHTML=[sh.name,sh.contact,sh.phone,sh.addr,sh.city,(sh.province?sh.province+', ':'')+(sh.country||'')].filter(Boolean).map(esc).join('<br>')||'<em>Add a ship-to address</em>'; }
  }
  // dates
  const tgt=document.getElementById('po-tgt-date'); if(tgt){ val('po-tgt-date', hv('po-ddate')); tgt.disabled=locked; }
  const cf=document.getElementById('po-d-confirm');
  if(cf) cf.textContent=window._poConfirmShip?('Confirmed by MVFA: '+fmtD(window._poConfirmShip)):'Target only — MVFA confirms the ship date';
  // admin row
  const adm=document.getElementById('po-adm');
  if(adm){
    adm.style.display=admin?'grid':'none';
    if(admin){ val('pa-confirm', window._poConfirmShip||''); val('pa-terms', hv('po-terms')); val('pa-ref', hv('po-ref')); val('pa-season', hv('po-season')); val('pa-cur', hv('po-currency')); }
  }
}
function poAdminUI(){
  try{ poInlineRefresh(); }catch(e){ console.error('po inline ui',e); }
  const wrap = document.getElementById('po-savesend-wrap');
  const isAdmin = !!window._adminMode && B._poSource==='merch';
  if(wrap){
    wrap.style.display = isAdmin ? 'block' : 'none';
    if(isAdmin && !document.getElementById('po-saveonly-btn')){
      const b = document.createElement('button'); b.id='po-saveonly-btn'; b.textContent='Save without sending';
      b.style.cssText='width:100%;margin-top:8px;background:none;border:1px solid var(--border);border-radius:8px;font-size:12px;font-weight:600;padding:10px;cursor:pointer;color:var(--ink2)';
      b.onclick=function(){ poSaveAndSendQuote(false); };
      wrap.appendChild(b);
    }
  }
  let strip = document.getElementById('po-admin-strip');
  if(!isAdmin){ if(strip) strip.remove(); return; }
  const right = document.querySelector('.po-right');
  if(right && !strip){
    strip = document.createElement('div'); strip.id='po-admin-strip';
    strip.style.cssText='margin:12px 18px 0;padding:10px 14px;background:#181715;color:#f4efe2;border-radius:8px;font-size:12px;line-height:1.5';
    strip.innerHTML='🛠 <strong>Admin</strong> — editing this merch quote. Use <strong>Edit</strong> on a line to change colour, sizes, decorations or price; then <strong>Save &amp; Send Updated Quote</strong> at the bottom of the order.';
    right.insertBefore(strip, right.firstChild);
  }
  // customer-facing draft banners don't belong in admin view
  ['po-draft-top'].forEach(id=>{ const e=document.getElementById(id); if(e) e.remove(); });
}
(function(){
  const _u2 = poUpd;
  poUpd = function(){ const r=_u2.apply(this,arguments); try{ poAdminUI(); }catch(e){ console.error('po admin ui',e); } return r; };
})();
